webpackJsonp([12],{

/***/ "+eyU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__ = __webpack_require__("TO51");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__log_service__ = __webpack_require__("B1/m");



var TabService = (function () {
    function TabService(authService, log) {
        // this.reviewerOnlySource.asObservable()
        // 	.subscribe((reviewerOnlyChecked) => {
        // 		console.log('from tab servcie! reviewerOnlyChecked');
        // 		console.log(reviewerOnlyChecked);
        // 		this.reviewerOnly = reviewerOnlyChecked;
        // 		this.buildTabs();
        // 	});
        var _this = this;
        this.authService = authService;
        this.log = log;
        this.permissionsString = '';
        // reviewerOnly = true;
        // reviewerOnlySource = new Subject<any>();
        this.pinMenuBar = false;
        this.pinMenuBarSource = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["b" /* Subject */]();
        this.showTwoRowMenuBar = false;
        this.showTwoRowMenuBarSource = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["b" /* Subject */]();
        this.newTabsSource = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["b" /* Subject */]();
        this.pinSideNav = true;
        this.pinSearch = true;
        this.pinScrollToTop = true;
        this.showWebsiteTabs = true;
        this.submissionsAutoLogin = true;
        this.siteIndex = null;
        this.reviewerIndex = null;
        this.reviewerProfileIndex = null;
        this.volunteerIndex = null;
        this.volunteerApplicationIndex = null;
        this.navTabsFullSet = {
            firstIndex: 0,
            firstTabs: [{
                    name: 'SITE',
                    secondTab: {
                        index: 0,
                        tabs: [
                            { name: 'HOME', link: 'site/home' },
                            // {name: 'STORY', link: 'site/story'},
                            // {name: 'FEATURES', link: 'site/features'},
                            // {name: 'PRICING', link: 'site/pricing'},
                            { name: 'GET STARTED', link: 'site/getstarted' },
                        ]
                    }
                }, {
                    name: 'ORGANIZATION',
                    secondTab: {
                        index: 0,
                        tabs: [
                            // {name: 'SUMMARY', link: 'dashboard/summary'},
                            // {name: 'SEARCH', link: 'dashboard/search'},
                            // {name: 'CONTACT', link: 'dashboard/contact'},
                            // {name: 'COMPANY', link: 'dashboard/company'},
                            // {name: 'FILM', link: 'dashboard/film'}
                            // {name: 'STORY', link: 'site/story'},
                            // {name: 'FEATURES', link: 'site/features'},
                            // {name: 'PRICING', link: 'site/pricing'},
                            // {name: 'GET STARTED', link: 'site/getstarted'},
                            { name: 'SETTINGS', link: 'organization/settings' }
                        ]
                    }
                }, {
                    name: 'DASHBOARD',
                    secondTab: {
                        index: 0,
                        tabs: [
                            { name: 'SUMMARY', link: 'dashboard/summary' },
                            { name: 'SEARCH', link: 'dashboard/search' },
                            { name: 'CONTACT', link: 'dashboard/contact' },
                            { name: 'COMPANY', link: 'dashboard/company' },
                            { name: 'FILM', link: 'dashboard/film' }
                            // {name: 'STORY', link: 'site/story'},
                            // {name: 'FEATURES', link: 'site/features'},
                            // {name: 'PRICING', link: 'site/pricing'},
                            // {name: 'GET STARTED', link: 'site/getstarted'},
                            // {name: 'CONTACT', link: 'site/contact'}
                        ]
                    }
                }, {
                    name: 'FESTIVAL',
                    secondTab: {
                        index: 0,
                        tabs: [
                            // {name: 'NEXT UP', link: 'festival/nextup'},
                            // {name: 'TICKETS', link: 'festival/tickets'},
                            { name: '', link: 'festival/nextup' },
                            { name: '', link: 'festival/tickets' },
                            // {name: 'ROSE THEATER', link: 'festival/venues'},
                            { name: 'CONCIERGE', link: 'festival/concierge' },
                            { name: 'BALLOTS', link: 'festival/ballots' },
                            { name: 'PROGRAM', link: 'festival/program' },
                            { name: 'FILMS', link: 'festival/films' },
                            { name: 'FAVORITES', link: 'festival/favorites' },
                        ]
                    }
                }, {
                    name: 'PROGRAM',
                    secondTab: {
                        index: 0,
                        tabs: [
                            { name: 'LINEUP', link: 'program/lineup' },
                            { name: 'LETTER', link: 'program/letter' },
                            { name: 'BLOCK', link: 'program/block' },
                            { name: 'GRID', link: 'program/grid' },
                            { name: 'BALLOT', link: 'program/ballot' }
                        ]
                    }
                }, {
                    name: 'REVIEWER',
                    secondTab: {
                        index: 0,
                        tabs: [
                            { name: 'RESULTS', link: 'reviewer/results' },
                            { name: 'TEAM', link: 'reviewer/team' },
                            { name: 'CONTENT', link: 'reviewer/content' },
                            { name: 'AVAILABLE', link: 'reviewer/available' },
                            { name: 'REVIEWING', link: 'reviewer/reviewing' },
                            { name: 'REVIEWED', link: 'reviewer/reviewed' },
                            { name: 'ALL', link: 'reviewer/all' },
                            { name: 'CONTACTS', link: 'common/contacts' },
                            // {name: 'SETTINGS', link: 'common/settings'},
                            { name: 'PROFILE', link: 'common/profile' },
                            { name: 'DEV', link: 'reviewer/dev' }
                        ]
                    }
                }, {
                    name: 'VOLUNTEER',
                    secondTab: {
                        index: 0,
                        tabs: [
                            { name: 'VOLUNTEER APPLICATION', link: 'volunteer/application' }
                        ]
                    }
                }, {
                    name: 'DONATION',
                    secondTab: {
                        index: 0,
                        tabs: [
                            { name: 'CONTACT', link: 'donation/contact' },
                            { name: 'COMPANY', link: 'donation/company' },
                            { name: 'CAMPAIGN', link: 'donation/campaign' }
                        ]
                    }
                },
                // {name: 'PASSES', link: 'reviewer/availalbe'},
                // {name: 'VOLUNTEER', link: 'reviewer/reviewing'},
                // {name: 'SPONSOR', link: 'reviewer/reviewed'},
                // {name: 'DONATION', link: 'reviewer/all'},
                // {name: 'SETTINGS', link: 'profile'},
                {
                    name: 'SYSTEM',
                    secondTab: {
                        index: 0,
                        tabs: [
                            { name: 'ORGANIZATION', link: 'system/organization' },
                            { name: 'EVENT', link: 'system/event' },
                            { name: 'EMAIL', link: 'system/email' },
                            { name: 'PRECONTENT', link: 'system/precontent' }
                        ]
                    }
                }]
        };
        this.navTabsSiteOnly = {
            firstIndex: 0,
            firstTabs: [{
                    name: 'SITE',
                    secondTab: {
                        index: 0,
                        tabs: [
                            { name: 'HOME', link: 'site/home' },
                            // {name: 'STORY', link: 'site/story'},
                            // {name: 'FEATURES', link: 'site/features'},
                            // {name: 'PRICING', link: 'site/pricing'},
                            { name: 'GET STARTED', link: 'site/getstarted' },
                        ]
                    }
                }, {
                    name: 'FESTIVAL',
                    secondTab: {
                        index: 0,
                        tabs: [
                            // {name: 'NEXT UP', link: 'festival/nextup'}
                            { name: '', link: 'festival/nextup' }
                        ]
                    }
                }, {
                    name: 'VOLUNTEER',
                    secondTab: {
                        index: 0,
                        tabs: [
                            { name: 'VOLUNTEER APPLICATION', link: 'volunteer/application' }
                        ]
                    }
                }
            ]
        };
        /*
            navTabsReviewerOnly = {
                firstIndex: 0,
                firstTabs: [{
                    name: 'REVIEWER',
                    secondTab: {
                        index: 0,
                        tabs: [
                            {name: 'AVAILABLE', link: 'reviewer/available'},
                            {name: 'REVIEWING', link: 'reviewer/reviewing'},
                            {name: 'REVIEWED', link: 'reviewer/reviewed'},
                            {name: 'ALL', link: 'reviewer/all'},
                            {name: 'PROFILE', link: 'common/profile'}
                        ]
                    }
                }],
            };
        
        
            navTabsReviewerOnlyWithoutAll = {
                firstIndex: 0,
                firstTabs: [{
                    name: 'REVIEWER',
                    secondTab: {
                        index: 0,
                        tabs: [
                            {name: 'AVAILABLE', link: 'reviewer/available'},
                            {name: 'REVIEWING', link: 'reviewer/reviewing'},
                            {name: 'REVIEWED', link: 'reviewer/reviewed'},
                            {name: 'PROFILE', link: 'common/profile'}
                        ]
                    }
                }]
            };
        */
        this.navTabs = {};
        this.pinMenuBarSource.asObservable()
            .subscribe(function (pinMenuBarChecked) {
            console.log('from tab servcie! pinMenuBarChecked');
            console.log(pinMenuBarChecked);
            _this.pinMenuBar = pinMenuBarChecked;
        });
        this.showTwoRowMenuBarSource.asObservable()
            .subscribe(function (showTwoRowMenuBarChecked) {
            // console.log('from tab servcie! showTwoRowMenuBarChecked');
            // console.log(showTwoRowMenuBarChecked);
            _this.showTwoRowMenuBar = showTwoRowMenuBarChecked;
        });
        // console.log('start ctor');
        this.buildTabs();
        // console.log('end ctor');
    }
    /*
        navTabs = {
            firstIndex: 3,
            firstTabs: [
                {name: 'SITE'},
                {name: 'FESTIVAL'},
                {name: 'PROGRAM'},
                {name: 'REVIEWER'},
                // {name: 'PASSES', link: 'reviewer/availalbe'},
                // {name: 'VOLUNTEER', link: 'reviewer/reviewing'},
                // {name: 'SPONSOR', link: 'reviewer/reviewed'},
                // {name: 'DONATION', link: 'reviewer/all'},
                // {name: 'SETTINGS', link: 'profile'},
                {name: 'SYSTEM'}
            ],
            secondTabs: [
                {
                    index: 0,
                    tabs: [
                        {name: 'HOME', link: 'site/home'},
                        {name: 'STORY', link: 'site/story'},
                        {name: 'FEATURES', link: 'site/features'},
                        {name: 'PRICING', link: 'site/pricing'},
                        {name: 'GET STARTED', link: 'site/getstarted'},
                        {name: 'CONTACT', link: 'site/contact'}
                    ]
                },
                {
                    index: 0,
                    tabs: [
                        // {name: 'ROSE THEATER', link: 'festival/venues'},
                        {name: 'CONCIERGE', link: 'festival/concierge'},
                        {name: 'BALLOTS', link: 'festival/ballots'},
                        {name: 'NEXT UP', link: 'festival/nextup'},
                        {name: 'PROGRAM', link: 'festival/program'},
                        {name: 'FILMS', link: 'festival/films'},
                        {name: 'FAVORITES', link: 'festival/favorites'},
                        {name: 'TICKETS', link: 'festival/tickets'}
                    ]
                },
                {
                    index: 0,
                    tabs: [
                        {name: 'LINEUP', link: 'program/lineup'},
                        {name: 'LETTER', link: 'program/letter'},
                        {name: 'BLOCK', link: 'program/block'},
                        {name: 'GRID', link: 'program/grid'},
                        {name: 'BALLOT', link: 'program/ballot'}
                    ]
                },
                {
                    index: 0,
                    tabs: [
                        {name: 'RESULTS', link: 'reviewer/results'},
                        {name: 'TEAM', link: 'reviewer/team'},
                        {name: 'CONTENT', link: 'reviewer/content'},
                        {name: 'AVAILABLE', link: 'reviewer/available'},
                        {name: 'REVIEWING', link: 'reviewer/reviewing'},
                        {name: 'REVIEWED', link: 'reviewer/reviewed'},
                        {name: 'ALL', link: 'reviewer/all'},
                        {name: 'CONTACTS', link: 'common/contacts'},
                        // {name: 'SETTINGS', link: 'common/settings'},
                        {name: 'PROFILE', link: 'common/profile'},
                        {name: 'DEV', link: 'reviewer/dev'}
                    ]
                },
                {
                    index: 0,
                    tabs: [
                        {name: 'ORGANIZATION', link: 'system/organization'},
                        {name: 'EVENT', link: 'system/event'},
                        {name: 'EMAIL', link: 'system/email'},
                        {name: 'PRECONTENT', link: 'system/precontent'}
                    ]
                }
            ]
        };
    */
    /*
        navTabsFullSet = {
            firstIndex: 3,
            firstTabs: [
                {name: 'SITE'},
                {name: 'FESTIVAL'},
                {name: 'PROGRAM'},
                {name: 'REVIEWER'},
                // {name: 'PASSES', link: 'reviewer/availalbe'},
                // {name: 'VOLUNTEER', link: 'reviewer/reviewing'},
                // {name: 'SPONSOR', link: 'reviewer/reviewed'},
                // {name: 'DONATION', link: 'reviewer/all'},
                // {name: 'SETTINGS', link: 'profile'},
                {name: 'SYSTEM'}
            ],
            secondTabs: [
                {
                    index: 0,
                    tabs: [
                        {name: 'HOME', link: 'site/home'},
                        {name: 'STORY', link: 'site/story'},
                        {name: 'FEATURES', link: 'site/features'},
                        {name: 'PRICING', link: 'site/pricing'},
                        {name: 'GET STARTED', link: 'site/getstarted'},
                        {name: 'CONTACT', link: 'site/contact'}
                    ]
                },
                {
                    index: 0,
                    tabs: [
                        // {name: 'ROSE THEATER', link: 'festival/venues'},
                        {name: 'CONCIERGE', link: 'festival/concierge'},
                        {name: 'BALLOTS', link: 'festival/ballots'},
                        {name: 'NEXT UP', link: 'festival/nextup'},
                        {name: 'PROGRAM', link: 'festival/program'},
                        {name: 'FILMS', link: 'festival/films'},
                        {name: 'FAVORITES', link: 'festival/favorites'},
                        {name: 'TICKETS', link: 'festival/tickets'}
                    ]
                },
                {
                    index: 0,
                    tabs: [
                        {name: 'LINEUP', link: 'program/lineup'},
                        {name: 'LETTER', link: 'program/letter'},
                        {name: 'BLOCK', link: 'program/block'},
                        {name: 'GRID', link: 'program/grid'},
                        {name: 'BALLOT', link: 'program/ballot'}
                    ]
                },
                {
                    index: 0,
                    tabs: [
                        {name: 'RESULTS', link: 'reviewer/results'},
                        {name: 'TEAM', link: 'reviewer/team'},
                        {name: 'CONTENT', link: 'reviewer/content'},
                        {name: 'AVAILABLE', link: 'reviewer/available'},
                        {name: 'REVIEWING', link: 'reviewer/reviewing'},
                        {name: 'REVIEWED', link: 'reviewer/reviewed'},
                        {name: 'ALL', link: 'reviewer/all'},
                        {name: 'CONTACTS', link: 'common/contacts'},
                        // {name: 'SETTINGS', link: 'common/settings'},
                        {name: 'PROFILE', link: 'common/profile'},
                        {name: 'DEV', link: 'reviewer/dev'}
                    ]
                },
                {
                    index: 0,
                    tabs: [
                        {name: 'ORGANIZATION', link: 'system/organization'},
                        {name: 'EVENT', link: 'system/event'},
                        {name: 'EMAIL', link: 'system/email'},
                        {name: 'PRECONTENT', link: 'system/precontent'}
                    ]
                }
            ]
        };
    
    
    
        navTabsReviewerOnly = {
            firstIndex: 0,
            firstTabs: [
                {name: 'REVIEWER'}
            ],
            secondTabs: [
                {
                    index: 0,
                    tabs: [
                        {name: 'AVAILABLE', link: 'reviewer/available'},
                        {name: 'REVIEWING', link: 'reviewer/reviewing'},
                        {name: 'REVIEWED', link: 'reviewer/reviewed'},
                        {name: 'ALL', link: 'reviewer/all'},
                        {name: 'PROFILE', link: 'common/profile'}
                    ]
                }
            ]
        };
    
    
        navTabsReviewerOnlyWithoutAll = {
            firstIndex: 0,
            firstTabs: [
                {name: 'REVIEWER'}
            ],
            secondTabs: [
                {
                    index: 0,
                    tabs: [
                        {name: 'AVAILABLE', link: 'reviewer/available'},
                        {name: 'REVIEWING', link: 'reviewer/reviewing'},
                        {name: 'REVIEWED', link: 'reviewer/reviewed'},
    // !!! TODO - PUT THIS BACK !!!
                        // {name: 'ALL', link: 'reviewer/all'},
                        {name: 'PROFILE', link: 'common/profile'}
                    ]
                }
            ]
        };
    
    
    
    
        navTabs = {
            firstIndex: 3,
            firstTabs: [
                {name: 'SITE'},
                {name: 'FESTIVAL'},
                {name: 'PROGRAM'},
                {name: 'REVIEWER'},
                // {name: 'PASSES', link: 'reviewer/availalbe'},
                // {name: 'VOLUNTEER', link: 'reviewer/reviewing'},
                // {name: 'SPONSOR', link: 'reviewer/reviewed'},
                // {name: 'DONATION', link: 'reviewer/all'},
                // {name: 'SETTINGS', link: 'profile'},
                {name: 'SYSTEM'}
            ],
            secondTabs: [
                {
                    index: 0,
                    tabs: [
                        {name: 'HOME', link: 'site/home'},
                        {name: 'STORY', link: 'site/story'},
                        {name: 'FEATURES', link: 'site/features'},
                        {name: 'PRICING', link: 'site/pricing'},
                        {name: 'GET STARTED', link: 'site/getstarted'},
                        {name: 'CONTACT', link: 'site/contact'}
                    ]
                },
                {
                    index: 0,
                    tabs: [
                        // {name: 'ROSE THEATER', link: 'festival/venues'},
                        {name: 'CONCIERGE', link: 'festival/concierge'},
                        {name: 'BALLOTS', link: 'festival/ballots'},
                        {name: 'NEXT UP', link: 'festival/nextup'},
                        {name: 'PROGRAM', link: 'festival/program'},
                        {name: 'FILMS', link: 'festival/films'},
                        {name: 'FAVORITES', link: 'festival/favorites'},
                        {name: 'TICKETS', link: 'festival/tickets'}
                    ]
                },
                {
                    index: 0,
                    tabs: [
                        {name: 'LINEUP', link: 'program/lineup'},
                        {name: 'LETTER', link: 'program/letter'},
                        {name: 'BLOCK', link: 'program/block'},
                        {name: 'GRID', link: 'program/grid'},
                        {name: 'BALLOT', link: 'program/ballot'}
                    ]
                },
                {
                    index: 0,
                    tabs: [
                        {name: 'RESULTS', link: 'reviewer/results'},
                        {name: 'TEAM', link: 'reviewer/team'},
                        {name: 'CONTENT', link: 'reviewer/content'},
                        {name: 'AVAILABLE', link: 'reviewer/available'},
                        {name: 'REVIEWING', link: 'reviewer/reviewing'},
                        {name: 'REVIEWED', link: 'reviewer/reviewed'},
                        {name: 'ALL', link: 'reviewer/all'},
                        {name: 'CONTACTS', link: 'common/contacts'},
                        // {name: 'SETTINGS', link: 'common/settings'},
                        {name: 'PROFILE', link: 'common/profile'},
                        {name: 'DEV', link: 'reviewer/dev'}
                    ]
                },
                {
                    index: 0,
                    tabs: [
                        {name: 'ORGANIZATION', link: 'system/organization'},
                        {name: 'EVENT', link: 'system/event'},
                        {name: 'EMAIL', link: 'system/email'},
                        {name: 'PRECONTENT', link: 'system/precontent'}
                    ]
                }
            ]
        };
    */
    // isLoaded = false;
    /*
        tabs = {
            'app.contacts': {
                name: 'Contacts',
                isVisible: true
            },
            'app.companies': {
                name: 'Companies',
                isVisible: true
            },
            'app.films': {
                name: 'Films',
                isVisible: true
            },
    
    
            'app.program.lineup': {
                name: 'Lineup',
                isVisible: true
            },
            'app.program.letter': {
                name: 'Letter',
                isVisible: true
            },
            'app.program.block': {
                name: 'Block',
                isVisible: true
            },
            'app.program.grid': {
                name: 'Grid',
                isVisible: true
            },
            'app.program.ballot': {
                name: 'Ballot',
                isVisible: true
            },
    
    
    
    
    
            'app.reviewer.program': {
                name: 'Lineup',
                isVisible: true
            },
            'app.reviewer.letter': {
                name: 'Letter',
                isVisible: true
            },
            'app.reviewer.block': {
                name: 'Block',
                isVisible: true
            },
            'app.reviewer.grid': {
                name: 'Grid',
                isVisible: true
            },
            'app.reviewer.ballot': {
                name: 'Ballot',
                isVisible: true
            },
    
    
    
            'app.reviewer.results': {
                name: 'Team',
                isVisible: true
            },
            'app.reviewer.team': {
                name: 'Team',
                isVisible: true
            },
            'app.reviewer.content': {
                name: 'Content',
                isVisible: true
            },
            'app.reviewer.available': {
                name: 'Available',
                isVisible: true
            },
            'app.reviewer.reviewing': {
                name: 'Reviewing',
                isVisible: true
            },
            'app.reviewer.reviewed': {
                name: 'Reviewed',
                isVisible: true
            },
            'app.reviewer.all': {
                name: 'All',
                isVisible: true
            },
            'app.reviewer.settings': {
                name: 'Settings',
                isVisible: true
            },
            'app.reviewer.dev': {
                name: 'Dev',
                isVisible: true
            },
    
    
    
            'app.system.organization': {
                name: 'Organization',
                isVisible: true
            },
            'app.system.event': {
                name: 'Event',
                isVisible: true
            },
            'app.system.email': {
                name: 'Email',
                isVisible: true
            },
            'app.system.precontent': {
                name: 'PreContent',
                isVisible: true
            },
    
    
    
            'app.common.contacts': {
                name: 'Profile',
                isVisible: true
            },
            'app.common.profile': {
                name: 'Profile',
                isVisible: true
            },
    
    
    
            'app.profile': {
                name: 'Profile',
                isVisible: true
            }
        };
    */
    /*
        setVisibility(tabAuthName: string, isVisible: boolean) {
            // console.log('tabAuthName 1');
            // console.log(tabAuthName);
            let tab = this.tabs[tabAuthName];
            if (!tab) {
                this.log.error('unknown tab: ' + tabAuthName);
                return;
            }
            tab.isVisible = isVisible;
    
            let visibleTabsString = JSON.stringify(this.tabs);
            localStorage.setItem('visible-tabs', visibleTabsString);
    
            // update display of tabs
        }
    
    
        getVisibility(tabAuthName: string) {
            if (!this.isLoaded) {
                this.isLoaded = true;
    
                if (!window.localStorage) {
                    console.log('Browser does not support local storage.');
                    return;
                }
    
                let visibleTabsString = localStorage.getItem('visible-tabs');
                if (visibleTabsString) {
                    this.tabs = JSON.parse(visibleTabsString);
                }
            }
    
            let tab = this.tabs[tabAuthName];
            // console.log('tabAuthName 2');
            // console.log(tabAuthName);
            if (!tab) {
                this.log.error('unknown tab: ' + tabAuthName);
                return;
            }
            return tab.isVisible;
        }
    
    
    
    
        getDisplayName(tabAuthName: string) {
            if (!this.isLoaded) {
                this.isLoaded = true;
    
                if (!window.localStorage) {
                    console.log('Browser does not support local storage.');
                    return;
                }
    
                let visibleTabsString = localStorage.getItem('visible-tabs');
                if (visibleTabsString) {
                    this.tabs = JSON.parse(visibleTabsString);
                }
            }
    
            let tab = this.tabs[tabAuthName];
            // console.log('tabAuthName 3');
            // console.log(tabAuthName);
            if (!tab) {
                this.log.error('unknown tab: ' + tabAuthName);
                return;
            }
            return tab.name;
        }
    */
    TabService.prototype.buildTabs = function () {
        var _this = this;
        // find fixed indexes
        this.navTabsFullSet.firstTabs.forEach(function (firstTab, firstTabIndex) {
            if (firstTab.name === 'SITE') {
                _this.siteIndex = firstTabIndex;
            }
            if (firstTab.name === 'REVIEWER') {
                _this.reviewerIndex = firstTabIndex;
                firstTab.secondTab.tabs.forEach(function (secondTab, secondTabIndex) {
                    if (secondTab.name === 'PROFILE') {
                        _this.reviewerProfileIndex = secondTabIndex;
                    }
                });
            }
            if (firstTab.name === 'VOLUNTEER') {
                _this.volunteerIndex = firstTabIndex;
                firstTab.secondTab.tabs.forEach(function (secondTab, secondTabIndex) {
                    if (secondTab.name === 'VOLUNTEER APPLICATION') {
                        _this.volunteerApplicationIndex = secondTabIndex;
                    }
                });
            }
        });
        // console.log('siteIndex = ' + this.siteIndex);
        // console.log('reviewerIndex = ' + this.reviewerIndex);
        // console.log('reviewerProfileIndex = ' + this.reviewerProfileIndex);
        // console.log('volunteerIndex = ' + this.volunteerIndex);
        // console.log('volunteerApplicationIndex = ' + this.volunteerApplicationIndex);
        this.permissionsString = this.getPermissionsString();
        var theTabs = null;
        // start with fresh copy
        // walk the list of visible tabs, remove as
        // hack attack for now!!
        if (window.localStorage) {
            var savedInfoString = localStorage.getItem('saved-info');
            if (savedInfoString) {
                var savedInfo = JSON.parse(savedInfoString);
                // console.log('buildTabs, savedInfo');
                // console.log(savedInfo);
                if (savedInfo && savedInfo.firstName) {
                    this.navTabsFullSet.firstTabs[this.reviewerIndex].secondTab.tabs[this.reviewerProfileIndex].name = savedInfo.firstName.toUpperCase();
                }
            }
        }
        theTabs = JSON.parse(JSON.stringify(this.navTabsFullSet));
        if (theTabs && theTabs.firstTabs && this.authService.organizationId) {
            // console.log('buildTabs with auth');
            // before first, mark site and its tabs as auth'd and visible?
            theTabs.firstTabs[this.siteIndex].isAuth = true;
            theTabs.firstTabs[this.siteIndex].secondTab.tabs.forEach(function (secondTabDefinition) {
                secondTabDefinition.isAuth = true;
            });
            // also, mark volunteer and its volunteerApplication as auth'd and visible?
            theTabs.firstTabs[this.volunteerIndex].isAuth = true;
            theTabs.firstTabs[this.volunteerIndex].secondTab.tabs[this.volunteerApplicationIndex].isAuth = true;
            // also, mark volunteer and its tabs as auth'd and visible?
            // theTabs.firstTabs[this.volunteerIndex].secondTab.tabs.forEach((secondTabDefinition) => {
            // 	secondTabDefinition.isAuth = true;
            // });
            // first, walk the list and mark what is auth'd
            // console.log('this.authService.userAuthorizations');
            // console.log(this.authService.userAuthorizations);
            // console.log('this.authService.organizationId');
            // console.log(this.authService.organizationId);
            Object.keys(this.authService.userAuthorizations).forEach(function (key) {
                if (_this.authService.userAuthorizations[key]) {
                    var parts_1 = key.split('.');
                    if (parts_1.length > 2) {
                        // console.log('authorized for key = ' + key);
                        theTabs.firstTabs.forEach(function (firstTab) {
                            if (parts_1[1].toLowerCase() === 'common') {
                                firstTab.secondTab.tabs.forEach(function (secondTabDefinition) {
                                    if (parts_1[1].toLowerCase() + '/' + parts_1[2].toLowerCase() === secondTabDefinition.link.toLowerCase()) {
                                        secondTabDefinition.isAuth = true;
                                        // console.log('        secondTabDefinition auth, link = ' + secondTabDefinition.link.toLowerCase());
                                    }
                                });
                            }
                            else {
                                if (parts_1[1].toLowerCase() === firstTab.name.toLowerCase()) {
                                    firstTab.isAuth = true;
                                    // console.log('    firstTab auth, name = ' + firstTab.name.toLowerCase());
                                    firstTab.secondTab.tabs.forEach(function (secondTabDefinition) {
                                        if (parts_1[1].toLowerCase() + '/' + parts_1[2].toLowerCase() === secondTabDefinition.link.toLowerCase()) {
                                            secondTabDefinition.isAuth = true;
                                            // console.log('        secondTabDefinition auth, link = ' + secondTabDefinition.link.toLowerCase());
                                        }
                                    });
                                }
                            }
                        });
                    }
                }
            });
            // !!! TODO - Bug, when walking, if db has firstTab but there is no matching secondTab for that firstTab don't mark auth'd
            // festival/tickets versus festival/ticket
            // next, walk the list and mark what is visible
            // finally, rebuild obj only for those that are auth'd and visible
            var newTabs_1 = {};
            newTabs_1.firstIndex = theTabs.firstIndex;
            newTabs_1.firstTabs = [];
            theTabs.firstTabs.forEach(function (firstTab) {
                if (firstTab.isAuth) {
                    var newFirstTab_1 = {};
                    newFirstTab_1.name = firstTab.name;
                    newFirstTab_1.secondTab = {};
                    newFirstTab_1.secondTab.index = firstTab.secondTab.index;
                    newFirstTab_1.secondTab.tabs = [];
                    firstTab.secondTab.tabs.forEach(function (secondTabDefinition) {
                        // console.log('secondTabDefinition.isAuth');
                        // console.log(firstTab.name + ' ' + secondTabDefinition.name);
                        // console.log(secondTabDefinition.isAuth);
                        if (secondTabDefinition.isAuth) {
                            var newSecondTabDefinition = {};
                            newSecondTabDefinition.name = secondTabDefinition.name;
                            newSecondTabDefinition.link = secondTabDefinition.link;
                            newFirstTab_1.secondTab.tabs.push(newSecondTabDefinition);
                        }
                    });
                    newTabs_1.firstTabs.push(newFirstTab_1);
                }
            });
            // console.log('newTabs');
            // console.log(newTabs);
            // console.log(JSON.stringify(newTabs, null, 2) );
            // this.navTabs = theTabs;
            this.navTabs = newTabs_1;
            // console.log('buildTabs with auth');
        }
        else {
            // console.log('buildTabs without auth');
            this.navTabs = this.navTabsSiteOnly;
        }
        // console.log('this.navTabs');
        // console.log(this.navTabs);
        // console.log(JSON.stringify(this.navTabs, null, 2) );
        this.newTabsSource.next(this.navTabs);
    };
    TabService.prototype.setProfileName = function () {
        this.buildTabs();
    };
    TabService.prototype.updateTabsByRoute = function (selectedRoute) {
        if (selectedRoute.length === 0) {
            // console.log('#1 empty selectedRoute');
            return;
        }
        var parts = selectedRoute.split('/');
        if (parts.length < 3) {
            // this.log.error('updateTabIndexesByRoute, invalid selectedRoute split, selectedRoute = ' + selectedRoute);
            return;
        }
        var currentPermissionsString = this.getPermissionsString();
        if (currentPermissionsString !== this.permissionsString) {
            // console.log('updateTabIndexesByRoute, found new permissions string!!!  currentPermissionsString = ' + currentPermissionsString);
            this.buildTabs();
        }
        this.updateTabIndexesByRoute(selectedRoute);
    };
    TabService.prototype.updateTabIndexesByRoute = function (selectedRoute) {
        if (selectedRoute.length === 0) {
            // console.log('#2 empty selectedRoute');
            return;
        }
        if (!this.navTabs || !this.navTabs.firstTabs) {
            this.log.error('updateTabIndexesByRoute, invalid this.navTabs');
            return;
        }
        if (!selectedRoute) {
            this.log.error('updateTabIndexesByRoute, invalid selectedRoute');
            return;
        }
        var parts = selectedRoute.split('/');
        if (parts.length < 3) {
            this.log.error('updateTabIndexesByRoute, invalid selectedRoute split, selectedRoute = ' + selectedRoute);
            return;
        }
        var firstIndex = this.navTabs.firstTabs.findIndex(function (firstTab) {
            if ((firstTab.name.toLowerCase() === 'reviewer') && (parts[1].toLowerCase()) === 'common') {
                // special case for profile and contacts, they live in common, but display on reviewer
                // console.log('found reviewer common');
                return true;
            }
            return (firstTab.name.toLowerCase() === parts[1].toLowerCase());
        });
        if (firstIndex === -1) {
            firstIndex = 0;
        }
        var secondIndex = this.navTabs.firstTabs[firstIndex].secondTab.tabs.findIndex(function (secondTab) {
            return (secondTab.link.toLowerCase() === parts[1].toLowerCase() + '/' + parts[2].toLowerCase());
        });
        if (secondIndex === -1) {
            secondIndex = 0;
        }
        // console.log('firstIndex');
        // console.log(firstIndex);
        // console.log('secondIndex');
        // console.log(secondIndex);
        this.navTabs.firstIndex = firstIndex;
        this.navTabs.firstTabs[firstIndex].secondTab.index = secondIndex;
    };
    TabService.prototype.getPermissionsString = function () {
        var permissions = JSON.stringify(this.authService.userAuthorizations);
        // console.log('permissions = ');
        // console.log(permissions);
        return permissions;
    };
    TabService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__log_service__["a" /* LogService */] }]; };
    return TabService;
}());

//# sourceMappingURL=tab.service.js.map

/***/ }),

/***/ "+wEl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PerfService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__log_service__ = __webpack_require__("B1/m");

var PerfService = (function () {
    function PerfService(log) {
        this.log = log;
    }
    PerfService.prototype.markAppStart = function () {
        if (window && window.performance && window.performance.timing) {
            // let timing = JSON.parse(JSON.stringify(window.performance.timing));
            // console.log(timing);
            // let loadEventEnd = window.performance.timing.loadEventEnd;
            // if (loadEventEnd === 0) {
            // 	// console.log('using Date.now() as loadEventEnd');
            // 	// https://www.w3.org/TR/navigation-timing/
            // 	loadEventEnd = Date.now();
            // }
            var loadEventEnd = Date.now();
            var pageLoadTime = loadEventEnd - window.performance.timing.navigationStart;
            // this.log.perf(`${pageLoadTime}, DOM loaded`);
            this.log.perf('DOM loaded', pageLoadTime);
            this.userActionStartTime = window.performance.timing.navigationStart;
            this.userActionStartLabel = 'page-load-start';
        }
        else {
            this.log.error('window.performance.timing not supported');
        }
    };
    PerfService.prototype.markUserActionStart = function (userActionLabel) {
        this.userActionStartTime = Date.now();
        this.userActionStartLabel = userActionLabel;
        // if (window && window.performance) {
        // 	if (this.userActionStartLabel === 'page-load-start') {
        // 		if (this.lastUserActionEndTime) {
        // 			this.pageLoadEndTime = this.lastUserActionEndTime;
        // 			this.pageLoadEndLabel = 'page-load-end.' + this.lastUserActionEndLabel;
        // 		} else {
        // 			// this.pageLoadEndTime = window.performance.now();
        // 			this.pageLoadEndTime = Date.now();
        // 			this.pageLoadEndLabel = 'page-load-end';
        // 		}
        // 		let elasped = this.pageLoadEndTime - this.userActionStartTime;
        // 		let message = `${elasped}, ${this.userActionStartLabel}, ${this.pageLoadEndLabel}`;
        // 		this.log.perf(message);
        // 	}
        // 	// this.userActionStartTime = window.performance.now();
        // 	this.userActionStartTime = Date.now();
        // 	this.userActionStartLabel = userActionLabel;
        // }
    };
    PerfService.prototype.markTabLoadEnd = function (endLabel) {
        this.lastUserActionEndTime = Date.now();
        this.lastUserActionEndLabel = endLabel;
        var elasped = this.lastUserActionEndTime - this.userActionStartTime;
        // let message = `${elasped}, ${this.userActionStartLabel}, ${this.lastUserActionEndLabel}`;
        // this.log.perf(message);
        var message = this.userActionStartLabel + ", " + this.lastUserActionEndLabel;
        this.log.perf(message, elasped);
        // if (window && window.performance) {
        // 	// this.lastUserActionEndTime = window.performance.now();
        // 	this.lastUserActionEndTime = Date.now();
        // 	this.lastUserActionEndLabel = endLabel;
        // 	let elasped = this.lastUserActionEndTime - this.userActionStartTime;
        // 	let message = `${elasped}, ${this.userActionStartLabel}, ${this.lastUserActionEndLabel}`;
        // 	this.log.perf(message);
        // }
    };
    PerfService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__log_service__["a" /* LogService */] }]; };
    return PerfService;
}());

//# sourceMappingURL=perf.service.js.map

/***/ }),

/***/ "/y7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AllMaterialModule; });
/**
 * NgModule that includes all Material modules that are required to serve the demo-app.
 */
var AllMaterialModule = (function () {
    function AllMaterialModule() {
    }
    return AllMaterialModule;
}());

//# sourceMappingURL=all-material.module.js.map

/***/ }),

/***/ "/zG/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/help-faq/help-faq.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}[_nghost-%COMP%]{width:100%}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9oZWxwLWZhcS9oZWxwLWZhcS5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9wYXQvc291cmNlL2l0ZGV2aWNlcy9naXRsYWIvb2NlYW5ibHVmZnByb2R1Y3Rpb25zL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy11aS9zcmMvYXBwL21vZHVsZXMvc2hhcmVkL2NvbXBvbmVudHMvaGVscC1mYXEvaGVscC1mYXEuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=help-faq.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/core/@angular/core.es5.js
var core_es5 = __webpack_require__("/oeL");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/icon/typings/index.ngfactory.ts
var index_ngfactory = __webpack_require__("Bhux");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/core.es5.js
var esm5_core_es5 = __webpack_require__("j5BN");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/icon.es5.js
var icon_es5 = __webpack_require__("vgc3");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/button/typings/index.ngfactory.ts
var typings_index_ngfactory = __webpack_require__("wjk8");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/button.es5.js
var button_es5 = __webpack_require__("ghl+");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/platform.es5.js
var platform_es5 = __webpack_require__("V8+5");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/a11y.es5.js
var a11y_es5 = __webpack_require__("8Xfy");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/card/typings/index.ngfactory.ts
var card_typings_index_ngfactory = __webpack_require__("z4MQ");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/card.es5.js
var card_es5 = __webpack_require__("Ioj9");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/help-faq/help-faq.component.ts
var help_faq_component = __webpack_require__("FqoL");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/common/@angular/common.es5.js
var common_es5 = __webpack_require__("qbdv");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/router/@angular/router.es5.js
var router_es5 = __webpack_require__("BkNc");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/log.service.ts
var log_service = __webpack_require__("B1/m");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/help-faq/help-faq.component.ngfactory.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenderType_HelpFaqComponent; });
/* harmony export (immutable) */ __webpack_exports__["b"] = View_HelpFaqComponent_0;
/* unused harmony export View_HelpFaqComponent_Host_0 */
/* unused harmony export HelpFaqComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */















var styles_HelpFaqComponent = [styles];
var RenderType_HelpFaqComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_HelpFaqComponent, data: {} });
function View_HelpFaqComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'mat-icon', [['class',
                'mat-icon'], ['role', 'img']], null, null, null, index_ngfactory["b" /* View_MatIcon_0 */], index_ngfactory["a" /* RenderType_MatIcon */])), core_es5["ɵdid"](1, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](2, 638976, null, 0, icon_es5["b" /* MatIcon */], [core_es5["Renderer2"], core_es5["ElementRef"], icon_es5["d" /* MatIconRegistry */], [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['expand_more']))], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_HelpFaqComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'mat-icon', [['class',
                'mat-icon'], ['role', 'img']], null, null, null, index_ngfactory["b" /* View_MatIcon_0 */], index_ngfactory["a" /* RenderType_MatIcon */])), core_es5["ɵdid"](1, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](2, 638976, null, 0, icon_es5["b" /* MatIcon */], [core_es5["Renderer2"], core_es5["ElementRef"], icon_es5["d" /* MatIconRegistry */], [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['expand_less']))], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_HelpFaqComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 24, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['\n\n			'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 21, 'div', [['style', 'width: 100%; padding: 0.5em 0 0.5em 0.5em;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n\n				'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 18, 'button', [['class', 'mat-raised-button'], ['color', 'primary'], ['mat-raised-button',
                ''], ['style', 'margin: 0.5em 0 0 1em; padding: 0.3em 0.5em 0.3em 0.3em;']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.goToFaq() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, typings_index_ngfactory["d" /* View_MatButton_0 */], typings_index_ngfactory["b" /* RenderType_MatButton */])), core_es5["ɵdid"](5, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](6, 180224, null, 0, button_es5["b" /* MatButton */], [core_es5["Renderer2"], core_es5["ElementRef"], platform_es5["a" /* Platform */],
            a11y_es5["i" /* FocusMonitor */]], { color: [0, 'color'] }, null), core_es5["ɵdid"](7, 16384, null, 0, button_es5["h" /* MatRaisedButtonCssMatStyler */], [], null, null),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n					'])), (_l()(), core_es5["ɵeld"](9, 0, null, 0, 12, 'div', [['itd-flex-container-row-start-center', ''], ['style', 'width: 100%;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n						'])), (_l()(), core_es5["ɵeld"](11, 0, null, null, 3, 'mat-icon', [['class', 'mat-icon'], ['itd-flex-item', ''], ['role', 'img']], null, null, null, index_ngfactory["b" /* View_MatIcon_0 */], index_ngfactory["a" /* RenderType_MatIcon */])),
        core_es5["ɵdid"](12, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](13, 638976, null, 0, icon_es5["b" /* MatIcon */], [core_es5["Renderer2"],
            core_es5["ElementRef"], icon_es5["d" /* MatIconRegistry */], [8, null]], null, null),
        (_l()(), core_es5["ɵted"](-1, 0, ['help'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n						'])),
        (_l()(), core_es5["ɵeld"](16, 0, null, null, 4, 'div', [['itd-flex-item', '']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n							'])), (_l()(), core_es5["ɵeld"](18, 0, null, null, 1, 'p', [['style', 'margin: 0 0 0 0.5em; font-size: 1.0rem; font-weight: normal;']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['Questions and Answers'])), (_l()(), core_es5["ɵted"](-1, null, ['\n						'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n					'])),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n				'])), (_l()(), core_es5["ɵted"](-1, null, ['\n			'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n		']))], function (_ck, _v) {
        var currVal_1 = 'primary';
        _ck(_v, 6, 0, currVal_1);
        _ck(_v, 13, 0);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 6).disabled || null);
        _ck(_v, 4, 0, currVal_0);
    });
}
function View_HelpFaqComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 33, 'div', [['itd-flex-item',
                ''], ['style', 'width: 100%;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 30, 'mat-card', [['class', 'mat-card'], ['style', 'margin: 0em 0.5em 0.5em 0.5em; padding: 0;']], null, null, null, card_typings_index_ngfactory["b" /* View_MatCard_0 */], card_typings_index_ngfactory["a" /* RenderType_MatCard */])),
        core_es5["ɵdid"](3, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](4, 49152, null, 0, card_es5["a" /* MatCard */], [], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['\n		'])), (_l()(), core_es5["ɵeld"](6, 0, null, 0, 22, 'button', [['class', 'mat-button'], ['mat-button', ''],
            ['style', 'width: 100%; padding: 0 0 0 0; color: grey; background-color: white; cursor: pointer; line-height: normal;']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = ((_co.help = !_co.help) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, typings_index_ngfactory["d" /* View_MatButton_0 */], typings_index_ngfactory["b" /* RenderType_MatButton */])), core_es5["ɵdid"](7, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](8, 180224, null, 0, button_es5["b" /* MatButton */], [core_es5["Renderer2"], core_es5["ElementRef"], platform_es5["a" /* Platform */],
            a11y_es5["i" /* FocusMonitor */]], { disableRipple: [0, 'disableRipple'] }, null),
        core_es5["ɵdid"](9, 16384, null, 0, button_es5["c" /* MatButtonCssMatStyler */], [], null, null), (_l()(), core_es5["ɵted"](-1, 0, [' \n			'])), (_l()(), core_es5["ɵeld"](11, 0, null, 0, 16, 'div', [['itd-flex-container-row-start-center', ''], ['style', 'width: 100%;']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵeld"](13, 0, null, null, 4, 'div', [['itd-flex-item', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵeld"](15, 0, null, null, 1, 'p', [['class',
                'sidenav-heading'], ['style', 'margin: 0 0 0 0.5em; text-align: left;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['HELP'])), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n\n				'])), (_l()(), core_es5["ɵeld"](19, 0, null, null, 7, 'div', [['itd-flex-item-fixed', ''], ['style', 'color: grey; margin: 0.2em 0.5em 0 0;']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_HelpFaqComponent_1)), core_es5["ɵdid"](22, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_HelpFaqComponent_2)), core_es5["ɵdid"](25, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n			'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n		'])),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n\n		'])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_HelpFaqComponent_3)), core_es5["ɵdid"](31, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n	'])), (_l()(), core_es5["ɵted"](-1, null, ['\n'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = true;
        _ck(_v, 8, 0, currVal_1);
        var currVal_2 = !_co.help;
        _ck(_v, 22, 0, currVal_2);
        var currVal_3 = _co.help;
        _ck(_v, 25, 0, currVal_3);
        var currVal_4 = _co.help;
        _ck(_v, 31, 0, currVal_4);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 8).disabled || null);
        _ck(_v, 6, 0, currVal_0);
    });
}
function View_HelpFaqComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'help-faq', [], null, null, null, View_HelpFaqComponent_0, RenderType_HelpFaqComponent)),
        core_es5["ɵdid"](1, 114688, null, 0, help_faq_component["a" /* HelpFaqComponent */], [router_es5["m" /* Router */], log_service["a" /* LogService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var HelpFaqComponentNgFactory = core_es5["ɵccf"]('help-faq', help_faq_component["a" /* HelpFaqComponent */], View_HelpFaqComponent_Host_0, {}, { navToFaq: 'navToFaq' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=help-faq.component.ngfactory.js.map

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cDNt");


/***/ }),

/***/ "0yio":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__ = __webpack_require__("TO51");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__("fc+i");


var DialogComponent = (function () {
    function DialogComponent(sanitizer) {
        this.sanitizer = sanitizer;
        this.title = '';
        this.content1 = '';
        this.content2 = '';
        this.ok = '';
        this.cancel = '';
        this.data = '';
        this.helpUrlLabel = '';
        this.helpUrlString = '';
        this.dialogCompleteSource = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["b" /* Subject */]();
        this.dialogComplete = this.dialogCompleteSource.asObservable();
    }
    DialogComponent.prototype.ngOnInit = function () {
    };
    DialogComponent.prototype.showDialog = function () {
        var _this = this;
        var modal = document.getElementById('myModal');
        modal.style.display = 'block';
        this.okButton = document.getElementById('okButton');
        setTimeout(function () {
            var cancelButton = document.getElementById('cancelButton');
            if (_this.cancel.length === 0) {
                cancelButton.style.display = 'none';
            }
            else {
                cancelButton.style.display = 'block';
            }
            _this.okButton.focus();
        }, 100);
        return this.dialogComplete;
    };
    DialogComponent.prototype.onCancel = function () {
        var modal = document.getElementById('myModal');
        modal.style.display = 'none';
        var complete = {
            confirm: false,
            data: this.data
        };
        this.dialogCompleteSource.next(complete);
    };
    DialogComponent.prototype.onOk = function () {
        var modal = document.getElementById('myModal');
        modal.style.display = 'none';
        var complete = {
            confirm: true,
            data: this.data
        };
        this.dialogCompleteSource.next(complete);
    };
    DialogComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["c" /* DomSanitizer */] }]; };
    return DialogComponent;
}());

//# sourceMappingURL=dialog.component.js.map

/***/ }),

/***/ "2vLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/list-page/list-page.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}[_nghost-%COMP%]{width:100%}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9saXN0LXBhZ2UvbGlzdC1wYWdlLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9saXN0LXBhZ2UvbGlzdC1wYWdlLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=list-page.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/core/@angular/core.es5.js
var core_es5 = __webpack_require__("/oeL");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/sidenav/sidenav.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var sidenav_component_scss_shim_ngstyle_styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9zaWRlbmF2L3NpZGVuYXYuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvcGF0L3NvdXJjZS9pdGRldmljZXMvZ2l0bGFiL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy9vY2VhbmJsdWZmcHJvZHVjdGlvbnMtdWkvc3JjL2FwcC9tb2R1bGVzL3NoYXJlZC9jb21wb25lbnRzL3NpZGVuYXYvc2lkZW5hdi5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=sidenav.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/log.service.ts
var log_service = __webpack_require__("B1/m");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/sidenav/sidenav.component.ts

var sidenav_component_SidenavComponent = (function () {
    function SidenavComponent(log) {
        this.log = log;
    }
    // @Input() label = '';
    // @Input() link = '';
    // @Output() linkClick = new EventEmitter();
    SidenavComponent.prototype.ngOnInit = function () {
    };
    SidenavComponent.prototype.ngAfterViewInit = function () {
        // console.log('this.label');
        // console.log(this.label);
        // console.log('this.link');
        // console.log(this.link);
    };
    SidenavComponent.prototype.sidenavChanged = function () {
        // TODO
        console.log('sidenavChanged');
        // this.updateFilmList(null);
        // this.initFromAllUsers();
        // this.scrollToTop();
        // this.updateSettings();
    };
    SidenavComponent.prototype.openSidenav = function () {
        // this.editing = true;
        document.getElementById('sidenav').style.marginLeft = '0';
        document.getElementById('sideOverlay').style.display = 'block';
    };
    SidenavComponent.prototype.closeSidenav = function () {
        // this.editing = false;
        document.getElementById('sidenav').style.marginLeft = '-16rem';
        document.getElementById('sideOverlay').style.display = 'none';
    };
    SidenavComponent.prototype.toggleSidenav = function () {
        if (this.isSidenavOpen) {
            this.closeSidenav();
        }
        else {
            this.openSidenav();
        }
    };
    Object.defineProperty(SidenavComponent.prototype, "isSidenavOpen", {
        get: function () {
            return document.getElementById('sideOverlay').style.display === 'block';
        },
        enumerable: true,
        configurable: true
    });
    SidenavComponent.ctorParameters = function () { return [{ type: log_service["a" /* LogService */] }]; };
    return SidenavComponent;
}());

//# sourceMappingURL=sidenav.component.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/button/typings/index.ngfactory.ts
var index_ngfactory = __webpack_require__("wjk8");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/core.es5.js
var esm5_core_es5 = __webpack_require__("j5BN");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/button.es5.js
var button_es5 = __webpack_require__("ghl+");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/platform.es5.js
var platform_es5 = __webpack_require__("V8+5");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/a11y.es5.js
var a11y_es5 = __webpack_require__("8Xfy");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/icon/typings/index.ngfactory.ts
var typings_index_ngfactory = __webpack_require__("Bhux");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/icon.es5.js
var icon_es5 = __webpack_require__("vgc3");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/navigate/navigate.component.ngfactory.ts + 4 modules
var navigate_component_ngfactory = __webpack_require__("DAh2");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/navigate/navigate.component.ts
var navigate_component = __webpack_require__("egrd");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/tab.service.ts
var tab_service = __webpack_require__("+eyU");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/view/view.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var view_component_scss_shim_ngstyle_styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}[_nghost-%COMP%]{width:100%}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy92aWV3L3ZpZXcuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvcGF0L3NvdXJjZS9pdGRldmljZXMvZ2l0bGFiL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy9vY2VhbmJsdWZmcHJvZHVjdGlvbnMtdWkvc3JjL2FwcC9tb2R1bGVzL3NoYXJlZC9jb21wb25lbnRzL3ZpZXcvdmlldy5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=view.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/card/typings/index.ngfactory.ts
var card_typings_index_ngfactory = __webpack_require__("z4MQ");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/card.es5.js
var card_es5 = __webpack_require__("Ioj9");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/view/view.component.ts

var view_component_ViewComponent = (function () {
    function ViewComponent(log) {
        this.log = log;
        this.view = true;
    }
    ViewComponent.prototype.ngOnInit = function () {
    };
    ViewComponent.ctorParameters = function () { return [{ type: log_service["a" /* LogService */] }]; };
    return ViewComponent;
}());

//# sourceMappingURL=view.component.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/common/@angular/common.es5.js
var common_es5 = __webpack_require__("qbdv");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/view/view.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */














var styles_ViewComponent = [view_component_scss_shim_ngstyle_styles];
var RenderType_ViewComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_ViewComponent, data: {} });
function View_ViewComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'mat-icon', [['class',
                'mat-icon'], ['role', 'img']], null, null, null, typings_index_ngfactory["b" /* View_MatIcon_0 */], typings_index_ngfactory["a" /* RenderType_MatIcon */])), core_es5["ɵdid"](1, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](2, 638976, null, 0, icon_es5["b" /* MatIcon */], [core_es5["Renderer2"], core_es5["ElementRef"], icon_es5["d" /* MatIconRegistry */], [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['expand_more']))], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_ViewComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'mat-icon', [['class',
                'mat-icon'], ['role', 'img']], null, null, null, typings_index_ngfactory["b" /* View_MatIcon_0 */], typings_index_ngfactory["a" /* RenderType_MatIcon */])), core_es5["ɵdid"](1, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](2, 638976, null, 0, icon_es5["b" /* MatIcon */], [core_es5["Renderer2"], core_es5["ElementRef"], icon_es5["d" /* MatIconRegistry */], [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['expand_less']))], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_ViewComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['\n			'])), core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵted"](-1, null, ['\n		']))], null, null);
}
function View_ViewComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 33, 'div', [['itd-flex-item',
                ''], ['style', 'width: 100%;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 30, 'mat-card', [['class', 'mat-card'], ['style', 'margin: 0em 0.5em 0.5em 0.5em; padding: 0;']], null, null, null, card_typings_index_ngfactory["b" /* View_MatCard_0 */], card_typings_index_ngfactory["a" /* RenderType_MatCard */])),
        core_es5["ɵdid"](3, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](4, 49152, null, 0, card_es5["a" /* MatCard */], [], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['\n		'])), (_l()(), core_es5["ɵeld"](6, 0, null, 0, 22, 'button', [['class', 'mat-button'], ['mat-button', ''],
            ['style', 'width: 100%; padding: 0 0 0 0; color: grey; background-color: white; cursor: pointer; line-height: normal;']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = ((_co.view = !_co.view) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, index_ngfactory["d" /* View_MatButton_0 */], index_ngfactory["b" /* RenderType_MatButton */])), core_es5["ɵdid"](7, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](8, 180224, null, 0, button_es5["b" /* MatButton */], [core_es5["Renderer2"], core_es5["ElementRef"], platform_es5["a" /* Platform */],
            a11y_es5["i" /* FocusMonitor */]], { disableRipple: [0, 'disableRipple'] }, null),
        core_es5["ɵdid"](9, 16384, null, 0, button_es5["c" /* MatButtonCssMatStyler */], [], null, null), (_l()(), core_es5["ɵted"](-1, 0, [' \n			'])), (_l()(), core_es5["ɵeld"](11, 0, null, 0, 16, 'div', [['itd-flex-container-row-start-center', ''], ['style', 'width: 100%;']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵeld"](13, 0, null, null, 4, 'div', [['itd-flex-item', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵeld"](15, 0, null, null, 1, 'p', [['class',
                'sidenav-heading'], ['style', 'margin: 0 0 0 0.5em; text-align: left;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['VIEW'])), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n\n				'])), (_l()(), core_es5["ɵeld"](19, 0, null, null, 7, 'div', [['itd-flex-item-fixed', ''], ['style', 'color: grey; margin: 0.2em 0.5em 0 0;']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ViewComponent_1)), core_es5["ɵdid"](22, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ViewComponent_2)), core_es5["ɵdid"](25, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵted"](-1, null, ['\n			'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n		'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n\n		'])),
        (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_ViewComponent_3)),
        core_es5["ɵdid"](31, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, 0, ['\n	'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = true;
        _ck(_v, 8, 0, currVal_1);
        var currVal_2 = !_co.view;
        _ck(_v, 22, 0, currVal_2);
        var currVal_3 = _co.view;
        _ck(_v, 25, 0, currVal_3);
        var currVal_4 = _co.view;
        _ck(_v, 31, 0, currVal_4);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 8).disabled || null);
        _ck(_v, 6, 0, currVal_0);
    });
}
function View_ViewComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'view', [], null, null, null, View_ViewComponent_0, RenderType_ViewComponent)),
        core_es5["ɵdid"](1, 114688, null, 0, view_component_ViewComponent, [log_service["a" /* LogService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ViewComponentNgFactory = core_es5["ɵccf"]('view', view_component_ViewComponent, View_ViewComponent_Host_0, {}, {}, ['[viewContent]']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy92aWV3L3ZpZXcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy92aWV3L3ZpZXcuY29tcG9uZW50LnRzIiwibmc6Ly8vVXNlcnMvcGF0L3NvdXJjZS9pdGRldmljZXMvZ2l0bGFiL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy9vY2VhbmJsdWZmcHJvZHVjdGlvbnMtdWkvc3JjL2FwcC9tb2R1bGVzL3NoYXJlZC9jb21wb25lbnRzL3ZpZXcvdmlldy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy92aWV3L3ZpZXcuY29tcG9uZW50LnRzLlZpZXdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGl0ZC1mbGV4LWl0ZW0gIHN0eWxlPVwid2lkdGg6IDEwMCU7XCI+XG5cdDxtYXQtY2FyZCBzdHlsZT1cIm1hcmdpbjogMGVtIDAuNWVtIDAuNWVtIDAuNWVtOyBwYWRkaW5nOiAwO1wiPlxuXHRcdDxidXR0b24gbWF0LWJ1dHRvbiAgc3R5bGU9XCJ3aWR0aDogMTAwJTsgcGFkZGluZzogMCAwIDAgMDsgY29sb3I6IGdyZXk7IGJhY2tncm91bmQtY29sb3I6IHdoaXRlOyBjdXJzb3I6IHBvaW50ZXI7IGxpbmUtaGVpZ2h0OiBub3JtYWw7XCIgKGNsaWNrKT1cInZpZXcgPSAhdmlld1wiIFtkaXNhYmxlUmlwcGxlXT1cInRydWVcIj4gXG5cdFx0XHQ8ZGl2IGl0ZC1mbGV4LWNvbnRhaW5lci1yb3ctc3RhcnQtY2VudGVyIHN0eWxlPVwid2lkdGg6IDEwMCU7XCI+XG5cdFx0XHRcdDxkaXYgaXRkLWZsZXgtaXRlbSA+XG5cdFx0XHRcdFx0PHAgY2xhc3M9XCJzaWRlbmF2LWhlYWRpbmdcIiBzdHlsZT1cIm1hcmdpbjogMCAwIDAgMC41ZW07IHRleHQtYWxpZ246IGxlZnQ7XCI+VklFVzwvcD5cblx0XHRcdFx0PC9kaXY+XG5cblx0XHRcdFx0PGRpdiBpdGQtZmxleC1pdGVtLWZpeGVkIHN0eWxlPVwiY29sb3I6IGdyZXk7IG1hcmdpbjogMC4yZW0gMC41ZW0gMCAwO1wiPlxuXHRcdFx0XHRcdDxtYXQtaWNvbiAqbmdJZj1cIiF2aWV3XCIgPmV4cGFuZF9tb3JlPC9tYXQtaWNvbj5cblx0XHRcdFx0XHQ8bWF0LWljb24gKm5nSWY9XCJ2aWV3XCIgPmV4cGFuZF9sZXNzPC9tYXQtaWNvbj5cblx0XHRcdFx0PC9kaXY+XG5cdFx0XHQ8L2Rpdj5cblx0XHQ8L2J1dHRvbj5cblxuXHRcdDxkaXYgKm5nSWY9XCJ2aWV3XCI+XG5cdFx0XHQ8bmctY29udGVudCBzZWxlY3Q9XCJbdmlld0NvbnRlbnRdXCI+PC9uZy1jb250ZW50PlxuXHRcdDwvZGl2PlxuXHQ8L21hdC1jYXJkPlxuPC9kaXY+XG4iLCI8dmlldz48L3ZpZXc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDU0s7TUFBQTsyQkFBQSxVQUFBO01BQUEsa0RBQUE7aUJBQUE7TUFBQSw2QkFBeUI7SUFBekI7Ozs7b0JBQ0E7TUFBQTsyQkFBQSxVQUFBO01BQUEsa0RBQUE7aUJBQUE7TUFBQSw2QkFBd0I7SUFBeEI7Ozs7b0JBS0g7TUFBQSx3RUFBa0I7YUFBQSxxQ0FDakIsa0JBQWdEO01BQUE7OztvQkFoQm5EO01BQUE7TUFBQSxnQkFBeUMsMkNBQ3hDO01BQUE7TUFBQTthQUFBO1VBQUEsc0JBQUE7VUFBQSw2QkFBNkQsZ0NBQzVEO1VBQUE7Y0FBQTtVQUFBO1lBQUE7WUFBQTtZQUF1STtjQUFBO2NBQUE7WUFBQTtZQUF2STtVQUFBLHVEQUFBO1VBQUEseUVBQUE7VUFBQTs4QkFBQTthQUFBO1VBQUEsZUFBcUwsa0NBQ3BMO1VBQUE7VUFBQTtNQUE4RCw4Q0FDN0Q7VUFBQTtVQUFBLDRDQUFvQjtVQUFBLGNBQ25CO1VBQUE7VUFBQSwwREFBMEU7VUFBQSx5QkFBUSw4Q0FDN0U7aUJBQUEsaUNBRU47VUFBQTtVQUFBO01BQXVFLCtDQUN0RTtVQUFBLDREQUFBO1VBQUE7TUFBK0MsK0NBQy9DO1VBQUEsNERBQUE7VUFBQTtNQUE4Qyw4Q0FDekM7VUFBQSxZQUNELGdDQUNFO01BRVQ7YUFBQTtVQUFBLGlDQUVNLCtCQUNJO2lCQUFBLDJCQUNOOzs7UUFqQjBKO1FBQTlKLFdBQThKLFNBQTlKO1FBT2E7UUFBVixZQUFVLFNBQVY7UUFDVTtRQUFWLFlBQVUsU0FBVjtRQUtFO1FBQUwsWUFBSyxTQUFMOztRQWJBO1FBQUEsV0FBQSxTQUFBOzs7O29CQ0ZGO01BQUE7YUFBQTtVQUFBO0lBQUE7Ozs7In0=
//# sourceMappingURL=view.component.ngfactory.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/help-faq/help-faq.component.ngfactory.ts + 1 modules
var help_faq_component_ngfactory = __webpack_require__("/zG/");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/help-faq/help-faq.component.ts
var help_faq_component = __webpack_require__("FqoL");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/router/@angular/router.es5.js
var router_es5 = __webpack_require__("BkNc");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/feedback/feedback.component.ngfactory.ts + 1 modules
var feedback_component_ngfactory = __webpack_require__("B+Bq");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/feedback/feedback.component.ts
var feedback_component = __webpack_require__("IGQF");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/snack-bar.es5.js
var snack_bar_es5 = __webpack_require__("LT5m");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/feedback.service.ts
var feedback_service = __webpack_require__("MBKK");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/sidenav/sidenav.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */























var styles_SidenavComponent = [sidenav_component_scss_shim_ngstyle_styles];
var RenderType_SidenavComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_SidenavComponent, data: {} });
function View_SidenavComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'button', [['class',
                'app-action-sidenav mat-fab'], ['color', 'primary'], ['mat-fab', '']], [[8, 'disabled',
                0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.openSidenav() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, index_ngfactory["d" /* View_MatButton_0 */], index_ngfactory["b" /* RenderType_MatButton */])), core_es5["ɵdid"](1, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](2, 180224, null, 0, button_es5["b" /* MatButton */], [core_es5["Renderer2"], core_es5["ElementRef"], platform_es5["a" /* Platform */], a11y_es5["i" /* FocusMonitor */]], { color: [0, 'color'] }, null), core_es5["ɵdid"](3, 16384, null, 0, button_es5["e" /* MatFab */], [[2, button_es5["b" /* MatButton */]], [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['\n	'])), (_l()(), core_es5["ɵeld"](5, 0, null, 0, 3, 'mat-icon', [['class', 'mat-icon'],
            ['role', 'img']], null, null, null, typings_index_ngfactory["b" /* View_MatIcon_0 */], typings_index_ngfactory["a" /* RenderType_MatIcon */])), core_es5["ɵdid"](6, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](7, 638976, null, 0, icon_es5["b" /* MatIcon */], [core_es5["Renderer2"], core_es5["ElementRef"], icon_es5["d" /* MatIconRegistry */], [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['menu'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n'])), (_l()(), core_es5["ɵeld"](11, 0, null, null, 1, 'div', [['class', 'sideOverlay'], ['id', 'sideOverlay']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.closeSidenav() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(), core_es5["ɵeld"](14, 0, null, null, 43, 'div', [['class', 'sidenav'], ['id', 'sidenav']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n	'])), (_l()(), core_es5["ɵeld"](17, 0, null, null, 15, 'div', [['itd-flex-container-row-space-between-start',
                '']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), (_l()(), core_es5["ɵeld"](19, 0, null, null, 9, 'button', [['class', 'mat-icon-button'], ['mat-icon-button',
                ''], ['style', 'margin: 5px 0 5px 5px; width: 56px; height: 56px; background-color: white; color: grey;']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.closeSidenav() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, index_ngfactory["d" /* View_MatButton_0 */], index_ngfactory["b" /* RenderType_MatButton */])), core_es5["ɵdid"](20, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](21, 180224, null, 0, button_es5["b" /* MatButton */], [core_es5["Renderer2"], core_es5["ElementRef"], platform_es5["a" /* Platform */],
            a11y_es5["i" /* FocusMonitor */]], null, null), core_es5["ɵdid"](22, 16384, null, 0, button_es5["f" /* MatIconButtonCssMatStyler */], [], null, null),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n			'])), (_l()(), core_es5["ɵeld"](24, 0, null, 0, 3, 'mat-icon', [['class', 'mat-icon'], ['role', 'img']], null, null, null, typings_index_ngfactory["b" /* View_MatIcon_0 */], typings_index_ngfactory["a" /* RenderType_MatIcon */])), core_es5["ɵdid"](25, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](26, 638976, null, 0, icon_es5["b" /* MatIcon */], [core_es5["Renderer2"], core_es5["ElementRef"], icon_es5["d" /* MatIconRegistry */],
            [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['close'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n		'])), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n	'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n	'])), (_l()(), core_es5["ɵeld"](34, 0, null, null, 22, 'div', [['itd-flex-container-column-start-start',
                '']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), (_l()(), core_es5["ɵeld"](36, 0, null, null, 1, 'navigate', [], null, null, null, navigate_component_ngfactory["b" /* View_NavigateComponent_0 */], navigate_component_ngfactory["a" /* RenderType_NavigateComponent */])), core_es5["ɵdid"](37, 114688, null, 0, navigate_component["a" /* NavigateComponent */], [log_service["a" /* LogService */], tab_service["a" /* TabService */]], null, null), (_l()(), core_es5["ɵted"](-1, null, ['\n\n		'])),
        (_l()(), core_es5["ɵeld"](39, 0, null, null, 7, 'view', [], null, null, null, View_ViewComponent_0, RenderType_ViewComponent)),
        core_es5["ɵdid"](40, 114688, null, 0, view_component_ViewComponent, [log_service["a" /* LogService */]], null, null), (_l()(), core_es5["ɵted"](-1, null, ['\n			'])), (_l()(), core_es5["ɵeld"](42, 0, null, 0, 3, 'section', [['viewContent', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), core_es5["ɵncd"](null, 1), (_l()(), core_es5["ɵted"](-1, null, ['\n			'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n		'])), (_l()(), core_es5["ɵeld"](49, 0, null, null, 1, 'help-faq', [], null, [[null,
                'navToFaq']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('navToFaq' === en)) {
                var pd_0 = (_co.closeSidenav() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, help_faq_component_ngfactory["b" /* View_HelpFaqComponent_0 */], help_faq_component_ngfactory["a" /* RenderType_HelpFaqComponent */])), core_es5["ɵdid"](50, 114688, null, 0, help_faq_component["a" /* HelpFaqComponent */], [router_es5["m" /* Router */], log_service["a" /* LogService */]], null, { navToFaq: 'navToFaq' }), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])),
        (_l()(), core_es5["ɵeld"](52, 0, null, null, 1, 'feedback', [], null, [[null, 'feedbackSent']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('feedbackSent' === en)) {
                var pd_0 = (_co.closeSidenav() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, feedback_component_ngfactory["b" /* View_FeedbackComponent_0 */], feedback_component_ngfactory["a" /* RenderType_FeedbackComponent */])), core_es5["ɵdid"](53, 114688, null, 0, feedback_component["a" /* FeedbackComponent */], [snack_bar_es5["b" /* MatSnackBar */], feedback_service["a" /* FeedbackService */],
            log_service["a" /* LogService */]], null, { feedbackSent: 'feedbackSent' }), (_l()(),
            core_es5["ɵted"](-1, null, ['\n\n		'])), core_es5["ɵncd"](null, 2), (_l()(), core_es5["ɵted"](-1, null, ['\n\n	'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n	\n'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var currVal_1 = 'primary';
        _ck(_v, 2, 0, currVal_1);
        _ck(_v, 7, 0);
        _ck(_v, 26, 0);
        _ck(_v, 37, 0);
        _ck(_v, 40, 0);
        _ck(_v, 50, 0);
        _ck(_v, 53, 0);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 2).disabled || null);
        _ck(_v, 0, 0, currVal_0);
        var currVal_2 = (core_es5["ɵnov"](_v, 21).disabled || null);
        _ck(_v, 19, 0, currVal_2);
    });
}
function View_SidenavComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'sidenav', [], null, null, null, View_SidenavComponent_0, RenderType_SidenavComponent)),
        core_es5["ɵdid"](1, 4308992, null, 0, sidenav_component_SidenavComponent, [log_service["a" /* LogService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var SidenavComponentNgFactory = core_es5["ɵccf"]('sidenav', sidenav_component_SidenavComponent, View_SidenavComponent_Host_0, {}, {}, ['[sidenavAdd]', '[sidenavViewContent]',
    '[sidenavBottom]']);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=sidenav.component.ngfactory.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/scroll-to-top/scroll-to-top.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var scroll_to_top_component_scss_shim_ngstyle_styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9zY3JvbGwtdG8tdG9wL3Njcm9sbC10by10b3AuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvcGF0L3NvdXJjZS9pdGRldmljZXMvZ2l0bGFiL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy9vY2VhbmJsdWZmcHJvZHVjdGlvbnMtdWkvc3JjL2FwcC9tb2R1bGVzL3NoYXJlZC9jb21wb25lbnRzL3Njcm9sbC10by10b3Avc2Nyb2xsLXRvLXRvcC5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=scroll-to-top.component.scss.shim.ngstyle.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/scroll-to-top/scroll-to-top.component.ts

var scroll_to_top_component_ScrollToTopComponent = (function () {
    function ScrollToTopComponent(log) {
        this.log = log;
        this.showScrollToTop = false;
    }
    // @Input() label = '';
    // @Input() link = '';
    // @Output() linkClick = new EventEmitter();
    ScrollToTopComponent.prototype.ngOnInit = function () {
    };
    ScrollToTopComponent.prototype.ngAfterViewInit = function () {
        // console.log('this.label');
        // console.log(this.label);
        // console.log('this.link');
        // console.log(this.link);
    };
    ScrollToTopComponent.prototype.checkShowScrollToTop = function (event) {
        // console.log('checkShowScrollToTop');
        // console.log(event);
        this.showScrollToTop = (window.pageYOffset > 65);
    };
    ScrollToTopComponent.prototype.scrollToTop = function () {
        console.log('scrollToTop');
        window.scrollTo(0, 0);
    };
    ScrollToTopComponent.ctorParameters = function () { return [{ type: log_service["a" /* LogService */] }]; };
    return ScrollToTopComponent;
}());

//# sourceMappingURL=scroll-to-top.component.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/scroll-to-top/scroll-to-top.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_ScrollToTopComponent = [scroll_to_top_component_scss_shim_ngstyle_styles];
var RenderType_ScrollToTopComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_ScrollToTopComponent, data: {} });
function View_ScrollToTopComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'button', [['class',
                'app-action-scroll-top mat-fab'], ['color', 'primary'], ['mat-fab', '']], [[8, 'disabled',
                0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.scrollToTop() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, index_ngfactory["d" /* View_MatButton_0 */], index_ngfactory["b" /* RenderType_MatButton */])), core_es5["ɵdid"](1, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](2, 180224, null, 0, button_es5["b" /* MatButton */], [core_es5["Renderer2"], core_es5["ElementRef"], platform_es5["a" /* Platform */], a11y_es5["i" /* FocusMonitor */]], { color: [0, 'color'] }, null), core_es5["ɵdid"](3, 16384, null, 0, button_es5["e" /* MatFab */], [[2, button_es5["b" /* MatButton */]], [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['\n  '])), (_l()(), core_es5["ɵeld"](5, 0, null, 0, 3, 'mat-icon', [['class', 'mat-icon'],
            ['role', 'img']], null, null, null, typings_index_ngfactory["b" /* View_MatIcon_0 */], typings_index_ngfactory["a" /* RenderType_MatIcon */])), core_es5["ɵdid"](6, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](7, 638976, null, 0, icon_es5["b" /* MatIcon */], [core_es5["Renderer2"], core_es5["ElementRef"], icon_es5["d" /* MatIconRegistry */], [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['keyboard_arrow_up'])), (_l()(),
            core_es5["ɵted"](-1, 0, ['\n']))], function (_ck, _v) {
        var currVal_1 = 'primary';
        _ck(_v, 2, 0, currVal_1);
        _ck(_v, 7, 0);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 2).disabled || null);
        _ck(_v, 0, 0, currVal_0);
    });
}
function View_ScrollToTopComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ScrollToTopComponent_1)), core_es5["ɵdid"](1, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.showScrollToTop;
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
function View_ScrollToTopComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'scroll-to-top', [], null, [['window', 'scroll']], function (_v, en, $event) {
            var ad = true;
            if (('window:scroll' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).checkShowScrollToTop($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ScrollToTopComponent_0, RenderType_ScrollToTopComponent)), core_es5["ɵdid"](1, 4308992, null, 0, scroll_to_top_component_ScrollToTopComponent, [log_service["a" /* LogService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ScrollToTopComponentNgFactory = core_es5["ɵccf"]('scroll-to-top', scroll_to_top_component_ScrollToTopComponent, View_ScrollToTopComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9zY3JvbGwtdG8tdG9wL3Njcm9sbC10by10b3AuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9zY3JvbGwtdG8tdG9wL3Njcm9sbC10by10b3AuY29tcG9uZW50LnRzIiwibmc6Ly8vVXNlcnMvcGF0L3NvdXJjZS9pdGRldmljZXMvZ2l0bGFiL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy9vY2VhbmJsdWZmcHJvZHVjdGlvbnMtdWkvc3JjL2FwcC9tb2R1bGVzL3NoYXJlZC9jb21wb25lbnRzL3Njcm9sbC10by10b3Avc2Nyb2xsLXRvLXRvcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9zY3JvbGwtdG8tdG9wL3Njcm9sbC10by10b3AuY29tcG9uZW50LnRzLlNjcm9sbFRvVG9wQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGJ1dHRvbiAqbmdJZj1cInNob3dTY3JvbGxUb1RvcFwiIG1hdC1mYWIgY29sb3I9XCJwcmltYXJ5XCIgY2xhc3M9XCJhcHAtYWN0aW9uLXNjcm9sbC10b3BcIiAoY2xpY2spPVwic2Nyb2xsVG9Ub3AoKVwiPlxuICA8bWF0LWljb24+a2V5Ym9hcmRfYXJyb3dfdXA8L21hdC1pY29uPlxuPC9idXR0b24+XG4iLCI8c2Nyb2xsLXRvLXRvcD48L3Njcm9sbC10by10b3A+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFBc0Y7TUFBQTtNQUFBO0lBQUE7SUFBdEY7RUFBQSx1REFBQTsyQkFBQSxrREFBQTtNQUFBO01BQUEsMENBQUE7TUFBQSxrRUFBOEc7TUFBQSxhQUM1RztNQUFBOzJCQUFBLFVBQUE7TUFBQSxrREFBQTtpQkFBQTtNQUFBLDZCQUFVLDZDQUE0QjthQUFBO0lBREE7SUFBeEMsV0FBd0MsU0FBeEM7SUFDRTs7SUFERjtJQUFBLFdBQUEsU0FBQTs7OztvQkFBQTtNQUFBLHFDQUFBO29CQUFBLG1DQUVTO01BQUE7O0lBRkQ7SUFBUixXQUFRLFNBQVI7Ozs7b0JDQUE7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLHVFQUFBO01BQUE7O1FBQUE7Ozs7In0=
//# sourceMappingURL=scroll-to-top.component.ngfactory.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/list-page/list-page.component.ts
var list_page_component = __webpack_require__("aUiu");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/list-page/list-page.component.ngfactory.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenderType_ListPageComponent; });
/* harmony export (immutable) */ __webpack_exports__["b"] = View_ListPageComponent_0;
/* unused harmony export View_ListPageComponent_Host_0 */
/* unused harmony export ListPageComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */









var styles_ListPageComponent = [styles];
var RenderType_ListPageComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_ListPageComponent, data: {} });
function View_ListPageComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['itd-flex-item-30',
                ''], ['itd-hide-phone', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		']))], null, null);
}
function View_ListPageComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['itd-flex-item-20',
                ''], ['itd-hide-phone', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		']))], null, null);
}
function View_ListPageComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['itd-flex-item-10',
                ''], ['itd-hide-phone', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		']))], null, null);
}
function View_ListPageComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['itd-flex-item-30',
                ''], ['itd-hide-phone', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		']))], null, null);
}
function View_ListPageComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['itd-flex-item-20',
                ''], ['itd-hide-phone', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		']))], null, null);
}
function View_ListPageComponent_6(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'div', [['itd-flex-item-10',
                ''], ['itd-hide-phone', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		']))], null, null);
}
function View_ListPageComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { sidenav: 0 }), core_es5["ɵqud"](402653184, 2, { scrollToTop: 0 }),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 17, 'sidenav', [], null, null, null, View_SidenavComponent_0, RenderType_SidenavComponent)),
        core_es5["ɵdid"](3, 4308992, [[1, 4]], 0, sidenav_component_SidenavComponent, [log_service["a" /* LogService */]], null, null), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵeld"](5, 0, null, 0, 3, 'section', [['sidenavAdd', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n	'])), (_l()(), core_es5["ɵeld"](10, 0, null, 1, 3, 'section', [['sidenavViewContent', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])),
        core_es5["ɵncd"](null, 1), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n\n	'])), (_l()(), core_es5["ɵeld"](15, 0, null, 2, 3, 'section', [['sidenavBottom', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])),
        core_es5["ɵncd"](null, 2), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n'])),
        (_l()(), core_es5["ɵeld"](21, 0, null, null, 1, 'scroll-to-top', [], null, [['window', 'scroll']], function (_v, en, $event) {
            var ad = true;
            if (('window:scroll' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 22).checkShowScrollToTop($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ScrollToTopComponent_0, RenderType_ScrollToTopComponent)), core_es5["ɵdid"](22, 4308992, [[2, 4]], 0, scroll_to_top_component_ScrollToTopComponent, [log_service["a" /* LogService */]], null, null), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n'])), core_es5["ɵncd"](null, 3), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n'])), (_l()(), core_es5["ɵeld"](26, 0, null, null, 27, 'section', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])),
        (_l()(), core_es5["ɵeld"](28, 0, null, null, 24, 'div', [['itd-flex-container-row-start-start',
                '']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ListPageComponent_1)), core_es5["ɵdid"](31, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ListPageComponent_2)), core_es5["ɵdid"](34, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ListPageComponent_3)),
        core_es5["ɵdid"](37, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n\n		'])),
        (_l()(), core_es5["ɵeld"](39, 0, null, null, 3, 'div', [['itd-flex-item', '']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n			'])), core_es5["ɵncd"](null, 4), (_l()(),
            core_es5["ɵted"](-1, null, ['\n		'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n		'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ListPageComponent_4)),
        core_es5["ɵdid"](45, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ListPageComponent_5)),
        core_es5["ɵdid"](48, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ListPageComponent_6)),
        core_es5["ɵdid"](51, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        _ck(_v, 3, 0);
        _ck(_v, 22, 0);
        var currVal_0 = (_co.contentSize === _co.ContentSize.Small);
        _ck(_v, 31, 0, currVal_0);
        var currVal_1 = (_co.contentSize === _co.ContentSize.Medium);
        _ck(_v, 34, 0, currVal_1);
        var currVal_2 = (_co.contentSize === _co.ContentSize.Large);
        _ck(_v, 37, 0, currVal_2);
        var currVal_3 = (_co.contentSize === _co.ContentSize.Small);
        _ck(_v, 45, 0, currVal_3);
        var currVal_4 = (_co.contentSize === _co.ContentSize.Medium);
        _ck(_v, 48, 0, currVal_4);
        var currVal_5 = (_co.contentSize === _co.ContentSize.Large);
        _ck(_v, 51, 0, currVal_5);
    }, null);
}
function View_ListPageComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'list-page', [], null, null, null, View_ListPageComponent_0, RenderType_ListPageComponent)), core_es5["ɵdid"](1, 4308992, null, 0, list_page_component["a" /* ListPageComponent */], [log_service["a" /* LogService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ListPageComponentNgFactory = core_es5["ɵccf"]('list-page', list_page_component["a" /* ListPageComponent */], View_ListPageComponent_Host_0, { contentSize: 'contentSize' }, {}, ['[listPageSidenavAdd]', '[listPageSidenavViewContent]', '[listPageSidenavBottom]',
    '[dialogBox]', '[content]']);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=list-page.component.ngfactory.js.map

/***/ }),

/***/ "6Aok":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AllOrganizationsResolver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("AP4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__organization_service__ = __webpack_require__("msq6");


var AllOrganizationsResolver = (function () {
    function AllOrganizationsResolver(organizationService) {
        this.organizationService = organizationService;
        this.params = {};
    }
    AllOrganizationsResolver.prototype.resolve = function (route, state) {
        // console.log('AllFilmsResolver called    #1');
        // let startResolve = Date.now();
        var _this = this;
        this.params = JSON.parse(JSON.stringify(route.params));
        var thePromise = new Promise(function (resolve, reject) {
            // this.reviewerFilmService.getFilms()
            _this.organizationService.getOrganizations()
                .then(function (organizations) {
                // let endResolve = Date.now();
                // console.log('AllFilmsResolver called    #2, took ' + (endResolve - startResolve) + ' msec' );
                var allOrganizationsInfo = {
                    allOrganizations: organizations.allOrganizations.organizations,
                    params: _this.params
                };
                resolve(allOrganizationsInfo);
            })
                .catch(function (err) {
                return reject(err);
            });
        });
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(thePromise);
    };
    AllOrganizationsResolver.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__organization_service__["a" /* OrganizationService */] }]; };
    return AllOrganizationsResolver;
}());

//# sourceMappingURL=all-organizations.resolver.js.map

/***/ }),

/***/ "8K35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserFilmsResolver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("AP4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reviewer_film_service__ = __webpack_require__("N1s2");


var UserFilmsResolver = (function () {
    function UserFilmsResolver(reviewerFilmService) {
        this.reviewerFilmService = reviewerFilmService;
        this.params = {};
    }
    UserFilmsResolver.prototype.resolve = function (route, state) {
        var _this = this;
        console.log('UserFilmsResolver called    #1');
        this.params = JSON.parse(JSON.stringify(route.params));
        var thePromise = new Promise(function (resolve, reject) {
            _this.reviewerFilmService.getAvailableFilms()
                .then(function (filmIds) {
                console.log('UserFilmsResolver called    #2');
                var userFilmsInfo = {
                    availableFilmIds: filmIds,
                    params: _this.params
                };
                resolve(userFilmsInfo);
            })
                .catch(function (err) {
                return reject(err);
            });
        });
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(thePromise);
    };
    UserFilmsResolver.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__reviewer_film_service__["a" /* ReviewerFilmService */] }]; };
    return UserFilmsResolver;
}());

//# sourceMappingURL=user-films.resolver.js.map

/***/ }),

/***/ "8VUB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReviewerImageService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__log_service__ = __webpack_require__("B1/m");



var ReviewerImageService = (function () {
    function ReviewerImageService(http, config, log) {
        this.http = http;
        this.config = config;
        this.log = log;
    }
    ReviewerImageService.prototype.uploadImage = function (fileList, filmId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Accept', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var file = fileList[0];
            var formData = new FormData();
            formData.append('imagefile', file, file.name);
            _this.http.post(_this.config.basePath + '/v0/films/' + filmId + '/image', formData, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerImageService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__log_service__["a" /* LogService */] }]; };
    return ReviewerImageService;
}());

//# sourceMappingURL=reviewer-image.service.js.map

/***/ }),

/***/ "97bI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserProfileResolver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("AP4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_service__ = __webpack_require__("emCa");


var UserProfileResolver = (function () {
    function UserProfileResolver(userService) {
        this.userService = userService;
        this.params = {};
    }
    UserProfileResolver.prototype.resolve = function (route, state) {
        var _this = this;
        console.log('UserProfileResolver called    #1');
        this.params = JSON.parse(JSON.stringify(route.params));
        var thePromise = new Promise(function (resolve, reject) {
            _this.userService.getUserProfile()
                .then(function (profile) {
                console.log('UserProfileResolver called    #2');
                var profileInfo = {
                    userProfile: profile,
                    params: _this.params
                };
                resolve(profileInfo);
            })
                .catch(function (err) {
                return reject(err);
            });
        });
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(thePromise);
    };
    UserProfileResolver.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__user_service__["a" /* UserService */] }]; };
    return UserProfileResolver;
}());

//# sourceMappingURL=user-profile.resolver.js.map

/***/ }),

/***/ "A9Hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReviewerReviewService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log_service__ = __webpack_require__("B1/m");




var ReviewerReviewService = (function () {
    function ReviewerReviewService(http, authService, config, log) {
        this.http = http;
        this.authService = authService;
        this.config = config;
        this.log = log;
    }
    ReviewerReviewService.prototype.getAllReviews = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/reviews', options)
                .toPromise()
                .then(function (res) {
                var resJson = res.json();
                var reviews = [];
                if (resJson.allReviews && resJson.allReviews.reviews) {
                    reviews = resJson.allReviews.reviews;
                }
                /*
                                    let sortedFilms = foo.allFilms.films.sort((a: any, b: any) => {
                
                                        if (a.title.toLowerCase() === b.title.toLowerCase()) {
                                            return 0;
                                        }
                                        if (a.title.toLowerCase() < b.title.toLowerCase()) {
                                            return -1;
                                        }
                                        return 1;
                
                
                                        // if (a.sortSubmissionId === b.sortSubmissionId) {
                                        // 	return 0;
                                        // }
                                        // if (a.sortSubmissionId < b.sortSubmissionId) {
                                        // 	return -1;
                                        // }
                                        // return 1;
                                    });
                                    foo.allFilms.films = sortedFilms;
                */
                resolve(reviews);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
            });
        });
    };
    ReviewerReviewService.prototype.getUserReviews = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var userId = _this.authService.userId;
            _this.http.get(_this.config.basePath + '/v0/reviews/users/' + userId, options)
                .toPromise()
                .then(function (res) {
                var resJson = res.json();
                var reviews = [];
                if (resJson.userReviews && resJson.userReviews.reviews) {
                    reviews = resJson.userReviews.reviews;
                }
                /*
                                    let sortedFilms = foo.allFilms.films.sort((a: any, b: any) => {
                
                
                                        if (a.title.toLowerCase() === b.title.toLowerCase()) {
                                            return 0;
                                        }
                                        if (a.title.toLowerCase() < b.title.toLowerCase()) {
                                            return -1;
                                        }
                                        return 1;
                
                
                                        // if (a.sortSubmissionId === b.sortSubmissionId) {
                                        // 	return 0;
                                        // }
                                        // if (a.sortSubmissionId < b.sortSubmissionId) {
                                        // 	return -1;
                                        // }
                                        // return 1;
                                    });
                                    foo.allFilms.films = sortedFilms;
                */
                resolve(reviews);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
            });
        });
    };
    /*
        getUserReviewingReview() {
            return new Promise((resolve, reject) => {
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
                let options = new RequestOptions({ headers: headers });
    
                let userId = this.authService.userId;
                this.http.get(this.config.basePath + '/v0/reviews/users/' + userId, options)
                    .toPromise()
                    .then((res: any) => {
                        let resJson = res.json();
    
                        let reviewingReview: any = {};
                        if (resJson.userReviews && resJson.userReviews.reviewingReview) {
                            reviewingReview = resJson.userReviews.reviewingReview;
                        }
                        resolve(reviewingReview);
                    })
                    .catch((err: any) => {			// this is a Response object, with res.status === 401, for example
                        // TODO - handle errors?
                        this.log.error(err);
                    });
            });
        }
    */
    ReviewerReviewService.prototype.updateReview = function (reviewUpdates) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = reviewUpdates;
            var body = JSON.stringify(payload);
            var userId = _this.authService.userId;
            _this.http.put(_this.config.basePath + '/v0/reviews/users/' + userId, body, options)
                .toPromise()
                .then(function (res) {
                // let foo = res.json();
                resolve();
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerReviewService.prototype.createReview = function (reviewPayload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = reviewPayload;
            var body = JSON.stringify(payload);
            var userId = _this.authService.userId;
            _this.http.post(_this.config.basePath + '/v0/reviews/users/' + userId, body, options)
                .toPromise()
                .then(function (res) {
                // let foo = res.json();
                resolve();
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerReviewService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__log_service__["a" /* LogService */] }]; };
    return ReviewerReviewService;
}());

//# sourceMappingURL=reviewer-review.service.js.map

/***/ }),

/***/ "B+Bq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/feedback/feedback.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}[_nghost-%COMP%]{width:100%}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9mZWVkYmFjay9mZWVkYmFjay5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9wYXQvc291cmNlL2l0ZGV2aWNlcy9naXRsYWIvb2NlYW5ibHVmZnByb2R1Y3Rpb25zL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy11aS9zcmMvYXBwL21vZHVsZXMvc2hhcmVkL2NvbXBvbmVudHMvZmVlZGJhY2svZmVlZGJhY2suY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=feedback.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/core/@angular/core.es5.js
var core_es5 = __webpack_require__("/oeL");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/icon/typings/index.ngfactory.ts
var index_ngfactory = __webpack_require__("Bhux");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/core.es5.js
var esm5_core_es5 = __webpack_require__("j5BN");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/icon.es5.js
var icon_es5 = __webpack_require__("vgc3");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/forms/@angular/forms.es5.js
var forms_es5 = __webpack_require__("bm2B");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/button/typings/index.ngfactory.ts
var typings_index_ngfactory = __webpack_require__("wjk8");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/button.es5.js
var button_es5 = __webpack_require__("ghl+");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/platform.es5.js
var platform_es5 = __webpack_require__("V8+5");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/a11y.es5.js
var a11y_es5 = __webpack_require__("8Xfy");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/card/typings/index.ngfactory.ts
var card_typings_index_ngfactory = __webpack_require__("z4MQ");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/card.es5.js
var card_es5 = __webpack_require__("Ioj9");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/feedback/feedback.component.ts
var feedback_component = __webpack_require__("IGQF");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/common/@angular/common.es5.js
var common_es5 = __webpack_require__("qbdv");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/snack-bar.es5.js
var snack_bar_es5 = __webpack_require__("LT5m");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/feedback.service.ts
var feedback_service = __webpack_require__("MBKK");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/log.service.ts
var log_service = __webpack_require__("B1/m");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/feedback/feedback.component.ngfactory.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenderType_FeedbackComponent; });
/* harmony export (immutable) */ __webpack_exports__["b"] = View_FeedbackComponent_0;
/* unused harmony export View_FeedbackComponent_Host_0 */
/* unused harmony export FeedbackComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */

















var styles_FeedbackComponent = [styles];
var RenderType_FeedbackComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_FeedbackComponent, data: {} });
function View_FeedbackComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'mat-icon', [['class',
                'mat-icon'], ['role', 'img']], null, null, null, index_ngfactory["b" /* View_MatIcon_0 */], index_ngfactory["a" /* RenderType_MatIcon */])), core_es5["ɵdid"](1, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](2, 638976, null, 0, icon_es5["b" /* MatIcon */], [core_es5["Renderer2"], core_es5["ElementRef"], icon_es5["d" /* MatIconRegistry */], [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['expand_more']))], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_FeedbackComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'mat-icon', [['class',
                'mat-icon'], ['role', 'img']], null, null, null, index_ngfactory["b" /* View_MatIcon_0 */], index_ngfactory["a" /* RenderType_MatIcon */])), core_es5["ɵdid"](1, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](2, 638976, null, 0, icon_es5["b" /* MatIcon */], [core_es5["Renderer2"], core_es5["ElementRef"], icon_es5["d" /* MatIconRegistry */], [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['expand_less']))], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_FeedbackComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 27, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['\n\n\n\n			'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 24, 'div', [['style', 'width: 100%;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 8, 'div', [['style',
                'padding: 0.5em 0.5em 0 0.5em;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])),
        (_l()(), core_es5["ɵeld"](6, 0, null, null, 5, 'textarea', [['rows', '18'],
            ['style', 'font-size: 1.0em; width: 100%']], [[2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.feedbackComments = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](7, 16384, null, 0, forms_es5["e" /* DefaultValueAccessor */], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["a" /* COMPOSITION_BUFFER_MODE */]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["n" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [forms_es5["e" /* DefaultValueAccessor */]]), core_es5["ɵdid"](9, 671744, null, 0, forms_es5["s" /* NgModel */], [[8,
                null], [8, null], [8, null], [2, forms_es5["n" /* NG_VALUE_ACCESSOR */]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["o" /* NgControl */], null, [forms_es5["s" /* NgModel */]]), core_es5["ɵdid"](11, 16384, null, 0, forms_es5["p" /* NgControlStatus */], [forms_es5["o" /* NgControl */]], null, null), (_l()(),
            core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n				'])),
        (_l()(), core_es5["ɵeld"](14, 0, null, null, 11, 'div', [['itd-flex-container-row-end-start',
                ''], ['style', 'width: 100%;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])),
        (_l()(), core_es5["ɵeld"](16, 0, null, null, 8, 'div', [['style', 'padding: 0.5em;']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n						'])), (_l()(), core_es5["ɵeld"](18, 0, null, null, 4, 'button', [['class', 'mat-raised-button'], ['color', 'primary'],
            ['mat-raised-button', ''], ['style', 'font-size: 1.0em;']], [[8, 'disabled',
                0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.sendFeedback() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, typings_index_ngfactory["d" /* View_MatButton_0 */], typings_index_ngfactory["b" /* RenderType_MatButton */])), core_es5["ɵdid"](19, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](20, 180224, null, 0, button_es5["b" /* MatButton */], [core_es5["Renderer2"], core_es5["ElementRef"], platform_es5["a" /* Platform */],
            a11y_es5["i" /* FocusMonitor */]], { color: [0, 'color'] }, null), core_es5["ɵdid"](21, 16384, null, 0, button_es5["h" /* MatRaisedButtonCssMatStyler */], [], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['SEND'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n					'])), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵted"](-1, null, ['\n			'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n		']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.feedbackComments;
        _ck(_v, 9, 0, currVal_7);
        var currVal_9 = 'primary';
        _ck(_v, 20, 0, currVal_9);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 11).ngClassUntouched;
        var currVal_1 = core_es5["ɵnov"](_v, 11).ngClassTouched;
        var currVal_2 = core_es5["ɵnov"](_v, 11).ngClassPristine;
        var currVal_3 = core_es5["ɵnov"](_v, 11).ngClassDirty;
        var currVal_4 = core_es5["ɵnov"](_v, 11).ngClassValid;
        var currVal_5 = core_es5["ɵnov"](_v, 11).ngClassInvalid;
        var currVal_6 = core_es5["ɵnov"](_v, 11).ngClassPending;
        _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_8 = (core_es5["ɵnov"](_v, 20).disabled || null);
        _ck(_v, 18, 0, currVal_8);
    });
}
function View_FeedbackComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 33, 'div', [['itd-flex-item',
                ''], ['style', 'width: 100%;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 30, 'mat-card', [['class', 'mat-card'], ['style', 'margin: 0em 0.5em 0.5em 0.5em; padding: 0;']], null, null, null, card_typings_index_ngfactory["b" /* View_MatCard_0 */], card_typings_index_ngfactory["a" /* RenderType_MatCard */])),
        core_es5["ɵdid"](3, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](4, 49152, null, 0, card_es5["a" /* MatCard */], [], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['\n		'])), (_l()(), core_es5["ɵeld"](6, 0, null, 0, 22, 'button', [['class', 'mat-button'], ['mat-button', ''],
            ['style', 'width: 100%; padding: 0 0 0 0; color: grey; background-color: white; cursor: pointer; line-height: normal;']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = ((_co.feedback = !_co.feedback) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, typings_index_ngfactory["d" /* View_MatButton_0 */], typings_index_ngfactory["b" /* RenderType_MatButton */])), core_es5["ɵdid"](7, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](8, 180224, null, 0, button_es5["b" /* MatButton */], [core_es5["Renderer2"], core_es5["ElementRef"], platform_es5["a" /* Platform */],
            a11y_es5["i" /* FocusMonitor */]], { disableRipple: [0, 'disableRipple'] }, null),
        core_es5["ɵdid"](9, 16384, null, 0, button_es5["c" /* MatButtonCssMatStyler */], [], null, null), (_l()(), core_es5["ɵted"](-1, 0, [' \n			'])), (_l()(), core_es5["ɵeld"](11, 0, null, 0, 16, 'div', [['itd-flex-container-row-start-center', ''], ['style', 'width: 100%;']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵeld"](13, 0, null, null, 4, 'div', [['itd-flex-item', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵeld"](15, 0, null, null, 1, 'p', [['class',
                'sidenav-heading'], ['style', 'margin: 0 0 0 0.5em; text-align: left;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['FEEDBACK'])), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n				'])), (_l()(), core_es5["ɵeld"](19, 0, null, null, 7, 'div', [['itd-flex-item-fixed', ''], ['style', 'color: grey; margin: 0.2em 0.5em 0 0;']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_FeedbackComponent_1)), core_es5["ɵdid"](22, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_FeedbackComponent_2)), core_es5["ɵdid"](25, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n			'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n		'])),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n\n		'])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_FeedbackComponent_3)), core_es5["ɵdid"](31, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n	'])), (_l()(), core_es5["ɵted"](-1, null, ['\n'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = true;
        _ck(_v, 8, 0, currVal_1);
        var currVal_2 = !_co.feedback;
        _ck(_v, 22, 0, currVal_2);
        var currVal_3 = _co.feedback;
        _ck(_v, 25, 0, currVal_3);
        var currVal_4 = _co.feedback;
        _ck(_v, 31, 0, currVal_4);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 8).disabled || null);
        _ck(_v, 6, 0, currVal_0);
    });
}
function View_FeedbackComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'feedback', [], null, null, null, View_FeedbackComponent_0, RenderType_FeedbackComponent)),
        core_es5["ɵdid"](1, 114688, null, 0, feedback_component["a" /* FeedbackComponent */], [snack_bar_es5["b" /* MatSnackBar */], feedback_service["a" /* FeedbackService */],
            log_service["a" /* LogService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var FeedbackComponentNgFactory = core_es5["ɵccf"]('feedback', feedback_component["a" /* FeedbackComponent */], View_FeedbackComponent_Host_0, {}, { feedbackSent: 'feedbackSent' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=feedback.component.ngfactory.js.map

/***/ }),

/***/ "B1/m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ua_parser_js__ = __webpack_require__("/HhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ua_parser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ua_parser_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__("aMZo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_service__ = __webpack_require__("CNKn");



// note: only import config service, all other modules import log service

var LogService = (function () {
    function LogService(http, config) {
        this.http = http;
        this.config = config;
        this.showInConsole = true;
        this.enableDevMessages = true;
        this.needPageReLoad = false;
        this.originalHref = '';
        this.currentPath = '';
        this.showFaq = false;
        this.showLoadingFilms = false;
        this.visitDeviceId = '';
        this.visitUserId = '';
        this.visitCount = 0;
    }
    // use when continue to re-add console.log debugging messages
    LogService.prototype.dev = function (message) {
        if (this.enableDevMessages) {
            this.logMessage('dev', message);
        }
    };
    // actions user takes
    LogService.prototype.action = function (message) {
        this.logMessage('action', message);
    };
    // actions user takes
    LogService.prototype.perf = function (message, time) {
        this.logMessage('perf', message, time);
    };
    // by design functionality, log info that can be used to improve user experience (example, filling out forms with invalid data)
    LogService.prototype.info = function (message) {
        this.logMessage('info', message);
    };
    // the program is functioning, but these should not happen too often (example, invalid email/password at signin)
    LogService.prototype.warn = function (message) {
        this.logMessage('warn', message);
    };
    // stuff that should not happen
    LogService.prototype.error = function (message) {
        this.logMessage('error', message);
    };
    // uncaught exceptions only
    LogService.prototype.exception = function (message) {
        this.logMessage('exception', message);
    };
    // TODO - write this: https://angular.io/docs/ts/latest/api/core/index/ExceptionHandler-class.html
    // stuff that should not happen, that came from outside the app
    LogService.prototype.windowOnError = function (message) {
        console.log('windowOnError:');
        this.logMessage('error', message);
    };
    LogService.prototype.logMessage = function (logType, message, theTime) {
        if (theTime === void 0) { theTime = 0; }
        if (this.showInConsole) {
            var msg = logType + ': ' + message;
            if ((logType === 'error') || (logType === 'exception')) {
                console.error(msg);
            }
            else if (logType === 'warn') {
                console.warn(msg);
            }
            else if (logType === 'perf') {
                console.log(msg + ', ' + theTime);
            }
            else {
                console.log(msg);
            }
        }
        // TODO - does not work for IE, must throw exception
        var stackLine = '';
        // let stackLine = (new Error).stack.split('\n')[3];
        // let stackLines = (new Error).stack.split('\n');
        var err = new Error();
        // if (err.stack && (err.stack.length > 2) ) {
        if (err.stack) {
            var stackLines = err.stack.split('\n');
            if (stackLines.length > 2) {
                stackLine = stackLines[3];
                // TODO - convert *.js to *.ts line number using source map
                // https://github.com/mozilla/source-map
            }
        }
        // console.log('stackLine');
        // console.log(stackLine);
        var stackTrace = '';
        if (message instanceof Error) {
            if (message.stack) {
                stackTrace = message.stack;
                message = '' + message;
            }
        }
        //    private formatError(arg) {
        //       if (arg instanceof Error) {
        //         if (arg.stack) {
        //           arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
        //               ? 'Error: ' + arg.message + '\n' + arg.stack
        //               : arg.stack;
        //         } else if (arg.sourceURL) {
        //           arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
        //         }
        //       }
        //       return arg;
        //     }
        var browserUserAgent = '';
        try {
            // browserUserAgent = UaService.browserInfo().ua;
            // let userAgentJson  = (new UAParser()).getResult();
            var userAgentJson = (new __WEBPACK_IMPORTED_MODULE_1_ua_parser_js__["UAParser"]()).getResult();
            // console.log('userAgentJson');
            // console.log(userAgentJson);
            browserUserAgent = JSON.stringify(userAgentJson);
            // console.log('browserUserAgent');
            // console.log(browserUserAgent);
        }
        catch (ex) {
            console.log('Error: could not get browserUserAgent'); // only log to console, avoid endless loops
            console.log(ex);
        }
        var browserScreenSize = '';
        try {
            var browserScreenSizeObj = {
                screen: {
                    width: screen.width,
                    height: screen.height
                },
                window: {
                    width: window.innerWidth,
                    height: window.innerHeight
                },
                document: {
                    width: document.documentElement.clientWidth,
                    height: document.documentElement.clientHeight
                }
            };
            browserScreenSize = JSON.stringify(browserScreenSizeObj);
        }
        catch (ex) {
            console.log('Error: could not get browserScreenSize'); // only log to console, avoid endless loops
            console.log(ex);
        }
        var browserPerformance = {};
        try {
            browserPerformance = JSON.stringify(window.performance);
        }
        catch (ex) {
            console.log('Error: could not get browserPerformance'); // only log to console, avoid endless loops
            console.log(ex);
        }
        var browserDownloadSpeed = '';
        try {
            // !!!TODO - add this
            browserDownloadSpeed = '';
        }
        catch (ex) {
            console.log('Error: could not get browserDownloadSpeed'); // only log to console, avoid endless loops
            console.log(ex);
        }
        var payload = {
            logId: __WEBPACK_IMPORTED_MODULE_2_uuid__["v4"]().replace(/-/g, ''),
            logSource: 'ui',
            type: logType,
            message: message || '',
            codeLocation: stackLine || '',
            stackTrace: stackTrace || '',
            // errorSource: errorSource || '',
            time: theTime,
            visitDeviceId: this.visitDeviceId || '',
            visitUserId: this.visitUserId || '',
            visitCount: this.visitCount || 0,
            browserUserAgent: browserUserAgent,
            browserScreenSize: browserScreenSize,
            browserPerformance: browserPerformance,
            browserDownloadSpeed: browserDownloadSpeed
        };
        // console.log('payload');
        // console.log(payload);
        this.createLog(payload);
    };
    LogService.prototype.getBrowser = function () {
        try {
            // let userAgentJson  = (new UAParser()).getResult();
            var userAgentJson = (new __WEBPACK_IMPORTED_MODULE_1_ua_parser_js__["UAParser"]()).getResult();
            // console.log('userAgentJson');
            // console.log(userAgentJson);
            if (userAgentJson.browser && userAgentJson.browser.name) {
                return userAgentJson.browser.name;
            }
            return '';
        }
        catch (ex) {
            console.log('Error: could not get userAgentJson'); // only log to console, avoid endless loops
            console.log(ex);
            return '';
        }
    };
    LogService.prototype.getOs = function () {
        try {
            // let userAgentJson  = (new UAParser()).getResult();
            var userAgentJson = (new __WEBPACK_IMPORTED_MODULE_1_ua_parser_js__["UAParser"]()).getResult();
            // console.log('userAgentJson');
            // console.log(userAgentJson);
            if (userAgentJson.os && userAgentJson.os.name) {
                return userAgentJson.os.name;
            }
            return '';
        }
        catch (ex) {
            console.log('Error: could not get userAgentJson'); // only log to console, avoid endless loops
            console.log(ex);
            return '';
        }
    };
    LogService.prototype.getLogs = function (publicLogEntries, internalLogEntries, logFilterType, logFilterUserId) {
        var _this = this;
        if (publicLogEntries === void 0) { publicLogEntries = false; }
        if (internalLogEntries === void 0) { internalLogEntries = true; }
        if (logFilterType === void 0) { logFilterType = ''; }
        if (logFilterUserId === void 0) { logFilterUserId = ''; }
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/logs?public=' + publicLogEntries + '&internal=' + internalLogEntries + '&type=' + logFilterType + '&userId=' + logFilterUserId, options)
                .toPromise()
                .then(function (res) {
                resolve(res.json());
            })
                .catch(function (err) {
                console.log(err);
                // resolve({});			// TODO - reject with error !!!
            });
        });
    };
    LogService.prototype.createLog = function (payload) {
        var _this = this;
        var accessToken = localStorage.getItem('auth-jwt');
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
        headers.append('Content-Type', 'application/json');
        var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
        var body = JSON.stringify(payload);
        this.http.post(this.config.basePath + '/v0/logs', body, options)
            .toPromise()
            .then(function (res) {
            // let foo = res.json();
            if (payload.type === 'exception') {
                console.log('Exception logged to db, attempting redirect after exception.');
                _this.redirectAfterException();
                // let redirectUrl = location.origin + '/#/site/home';
                // if (location.hash !== '#/site/home') {
                // 	window.location.href = redirectUrl; // condition is required to prevent infinite loop
                // } else {
                // 	console.log('Exception on profile tab, skipping redirect.');
                // }
            }
        })
            .catch(function (err) {
            console.log(err); // only log to console, avoid endless loops
            if (payload.type === 'exception') {
                console.log('Exception NOT logged to db, attempting redirect after exception.');
                _this.redirectAfterException();
                // let redirectUrl = location.origin + '/#/site/home';
                // if (location.hash !== '#/site/home') {
                // 	window.location.href = redirectUrl; // condition is required to prevent infinite loop
                // } else {
                // 	console.log('Exception on profile tab, skipping redirect.');
                // }
            }
        });
    };
    LogService.prototype.redirectAfterException = function () {
        // let redirectUrl = location.origin + '/#/site/home';
        // if (location.hash !== '#/site/home') {
        // 	window.location.href = redirectUrl; // condition is required to prevent infinite loop
        // } else {
        // 	console.log('Exception on profile tab, skipping redirect.');
        // }
        // let redirectPath = 'common/profile';
        var redirectPath = 'site/home';
        var redirectUrl = location.origin + '/#/' + redirectPath;
        // console.log('location.hash');
        // console.log(location.hash);
        console.log('this.currentPath');
        console.log(this.currentPath);
        if (this.currentPath !== '/' + redirectPath) {
            console.log('Redirecting to ' + redirectPath);
            window.location.href = redirectUrl; // condition is required to prevent infinite loop
        }
        else {
            console.log('Skipping redirect to ' + redirectPath + ', already on this tab');
        }
    };
    LogService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_3__config_service__["a" /* ConfigService */] }]; };
    return LogService;
}());

//# sourceMappingURL=log.service.js.map

/***/ }),

/***/ "BWg/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PageComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_log_service__ = __webpack_require__("B1/m");

var ContentSize;
(function (ContentSize) {
    ContentSize[ContentSize["Small"] = 30] = "Small";
    ContentSize[ContentSize["Medium"] = 20] = "Medium";
    ContentSize[ContentSize["Large"] = 10] = "Large";
    // Small = '30',
    // Medium = '20',
    // Large = '10'
})(ContentSize || (ContentSize = {}));
var PageComponent = (function () {
    function PageComponent(log) {
        this.log = log;
        this.ContentSize = ContentSize; // enable enum in template
        this.contentSize = ContentSize.Large;
    }
    // @Output() linkClick = new EventEmitter();
    PageComponent.prototype.ngOnInit = function () {
        console.log('PageComponent, ngOnInit');
    };
    PageComponent.prototype.ngAfterViewInit = function () {
        console.log('PageComponent, ngAfterViewInit');
        // console.log('this.label');
        // console.log(this.label);
        // console.log('this.link');
        // console.log(this.link);
        console.log('this.contentSize');
        console.log(this.contentSize);
    };
    PageComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__services_log_service__["a" /* LogService */] }]; };
    return PageComponent;
}());

//# sourceMappingURL=page.component.js.map

/***/ }),

/***/ "CNKn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigService; });
// note: can not import log service, log service requires config service
var ConfigService = (function () {
    function ConfigService() {
        this.basePath = 'http://localhost:3000';
        // basePath = 'https://localhost';		// used when running with nginx ssl termination
        this.uiBasePath = 'http://localhost:8080';
        this.environment = 'local';
        this.originalHref = '';
        if (window.location.href.indexOf('test.oceanbluffproductions.com.s3-website-us-west-2.amazonaws.com') >= 0) {
            this.basePath = 'http://api.test.oceanbluffproductions.com:3000'; // TODO!!! - update this back to SSL after nginx termination
            this.uiBasePath = 'http://test.oceanbluffproductions.com.s3-website-us-west-2.amazonaws.com';
            this.environment = 'production';
        }
        else if (window.location.href.indexOf('test.oceanbluffproductions.com') >= 0) {
            this.basePath = 'https://api.test.oceanbluffproductions.com';
            this.uiBasePath = 'https://test.oceanbluffproductions.com';
            this.environment = 'production';
        }
        else if (window.location.href.indexOf('oceanbluffproductions.com.s3-website-us-west-2.amazonaws.com') >= 0) {
            this.basePath = 'https://api.ptffportal.org';
            this.uiBasePath = 'http://oceanbluffproductions.com.s3-website-us-west-2.amazonaws.com';
            this.environment = 'production';
        }
        else if (window.location.href.indexOf('oceanbluffproductions.com') >= 0) {
            this.basePath = 'https://api.ptffportal.org';
            this.uiBasePath = 'https://oceanbluffproductions.com';
            this.environment = 'production';
        }
        else if (window.location.href.indexOf('http://localhost:4200') >= 0) {
            this.uiBasePath = 'http://localhost:4200';
            // only used when running again local nginx
            // this.basePath = 'https://localhost';
        }
        else if (window.location.href.indexOf('http://localhost:8080') >= 0) {
            this.uiBasePath = 'http://localhost:8080';
        }
        // let isProd = ((window.location.href.indexOf('patmcfaul.net') >= 0) || (window.location.href.indexOf('oceanbluffproductions.com') >= 0));
        // if (isProd) {
        // 	this.basePath = 'https://api.ptffportal.org';
        // 	this.uiBasePath = 'https://oceanbluffproductions.com';
        // 	this.environment = 'production';
        // }
        this.originalHref = window.location.href;
        console.log("'API basePath = " + this.basePath);
        console.log("'UI basePath = " + this.uiBasePath);
        console.log("'environment = " + this.environment);
        console.log("'originalHref = " + this.originalHref);
    }
    ConfigService.ctorParameters = function () { return []; };
    return ConfigService;
}());

//# sourceMappingURL=config.service.js.map

/***/ }),

/***/ "DAh2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/navigate/navigate.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}[_nghost-%COMP%]{width:100%}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9uYXZpZ2F0ZS9uYXZpZ2F0ZS5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9wYXQvc291cmNlL2l0ZGV2aWNlcy9naXRsYWIvb2NlYW5ibHVmZnByb2R1Y3Rpb25zL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy11aS9zcmMvYXBwL21vZHVsZXMvc2hhcmVkL2NvbXBvbmVudHMvbmF2aWdhdGUvbmF2aWdhdGUuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=navigate.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/core/@angular/core.es5.js
var core_es5 = __webpack_require__("/oeL");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/list/typings/index.ngfactory.ts
var index_ngfactory = __webpack_require__("0EVt");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/list.es5.js
var list_es5 = __webpack_require__("dYU3");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/router/@angular/router.es5.js
var router_es5 = __webpack_require__("BkNc");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/common/@angular/common.es5.js
var common_es5 = __webpack_require__("qbdv");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/core.es5.js
var esm5_core_es5 = __webpack_require__("j5BN");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/expand/expand.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var expand_component_scss_shim_ngstyle_styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}[_nghost-%COMP%]{width:100%}a[_ngcontent-%COMP%]:active, a[_ngcontent-%COMP%]:hover, a[_ngcontent-%COMP%]:link, a[_ngcontent-%COMP%]:visited{color:grey}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9leHBhbmQvZXhwYW5kLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9leHBhbmQvZXhwYW5kLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=expand.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/icon/typings/index.ngfactory.ts
var typings_index_ngfactory = __webpack_require__("Bhux");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/icon.es5.js
var icon_es5 = __webpack_require__("vgc3");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/log.service.ts
var log_service = __webpack_require__("B1/m");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/expand/expand.component.ts


var expand_component_ExpandComponent = (function () {
    function ExpandComponent(log) {
        this.log = log;
        this.expand = false;
        this.label = '';
        this.link = '';
        this.linkClick = new core_es5["EventEmitter"]();
    }
    ExpandComponent.prototype.ngOnInit = function () {
    };
    ExpandComponent.prototype.ngAfterViewInit = function () {
        // console.log('this.label');
        // console.log(this.label);
        // console.log('this.link');
        // console.log(this.link);
    };
    ExpandComponent.ctorParameters = function () { return [{ type: log_service["a" /* LogService */] }]; };
    return ExpandComponent;
}());

//# sourceMappingURL=expand.component.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/button/typings/index.ngfactory.ts
var button_typings_index_ngfactory = __webpack_require__("wjk8");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/button.es5.js
var button_es5 = __webpack_require__("ghl+");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/platform.es5.js
var platform_es5 = __webpack_require__("V8+5");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/a11y.es5.js
var a11y_es5 = __webpack_require__("8Xfy");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/expand/expand.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */













var styles_ExpandComponent = [expand_component_scss_shim_ngstyle_styles];
var RenderType_ExpandComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_ExpandComponent, data: {} });
function View_ExpandComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'p', [['itd-flex-item',
                ''], ['style', 'margin: 0 0 0 0.5rem;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.label;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_ExpandComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'a', [['itd-flex-item',
                ''], ['style', 'margin: 0 0 0 0.5rem; text-decoration: none;']], [[1, 'target', 0],
            [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 1).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](1, 671744, null, 0, router_es5["n" /* RouterLinkWithHref */], [router_es5["m" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["l" /* LocationStrategy */]], { routerLink: [0, 'routerLink'] }, null), (_l()(), core_es5["ɵted"](2, null, ['', '']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = core_es5["ɵinlineInterpolate"](1, '', _co.link, '');
        _ck(_v, 1, 0, currVal_2);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵnov"](_v, 1).target;
        var currVal_1 = core_es5["ɵnov"](_v, 1).href;
        _ck(_v, 0, 0, currVal_0, currVal_1);
        var currVal_3 = _co.label;
        _ck(_v, 2, 0, currVal_3);
    });
}
function View_ExpandComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'mat-icon', [['class',
                'mat-icon'], ['role', 'img']], null, null, null, typings_index_ngfactory["b" /* View_MatIcon_0 */], typings_index_ngfactory["a" /* RenderType_MatIcon */])), core_es5["ɵdid"](1, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](2, 638976, null, 0, icon_es5["b" /* MatIcon */], [core_es5["Renderer2"], core_es5["ElementRef"], icon_es5["d" /* MatIconRegistry */], [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['expand_more']))], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_ExpandComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'mat-icon', [['class',
                'mat-icon'], ['role', 'img']], null, null, null, typings_index_ngfactory["b" /* View_MatIcon_0 */], typings_index_ngfactory["a" /* RenderType_MatIcon */])), core_es5["ɵdid"](1, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](2, 638976, null, 0, icon_es5["b" /* MatIcon */], [core_es5["Renderer2"], core_es5["ElementRef"], icon_es5["d" /* MatIconRegistry */], [8, null]], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['expand_less']))], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, null);
}
function View_ExpandComponent_5(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['\n			'])), core_es5["ɵncd"](null, 0), (_l()(), core_es5["ɵted"](-1, null, ['\n		']))], null, null);
}
function View_ExpandComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 34, 'div', [['itd-flex-item',
                '']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 31, 'div', [['style', 'margin: 0; padding: 0;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), (_l()(), core_es5["ɵeld"](4, 0, null, null, 25, 'button', [['class', 'mat-button'], ['mat-button', ''], ['style', 'width: 100%; padding: 0; color: grey; background-color: white; cursor: pointer; line-height: normal;']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = ((_co.expand = !_co.expand) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, button_typings_index_ngfactory["d" /* View_MatButton_0 */], button_typings_index_ngfactory["b" /* RenderType_MatButton */])), core_es5["ɵdid"](5, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](6, 180224, null, 0, button_es5["b" /* MatButton */], [core_es5["Renderer2"], core_es5["ElementRef"], platform_es5["a" /* Platform */],
            a11y_es5["i" /* FocusMonitor */]], { disableRipple: [0, 'disableRipple'] }, null),
        core_es5["ɵdid"](7, 16384, null, 0, button_es5["c" /* MatButtonCssMatStyler */], [], null, null), (_l()(), core_es5["ɵted"](-1, 0, [' \n			'])), (_l()(), core_es5["ɵeld"](9, 0, null, 0, 19, 'div', [['itd-flex-container-row-space-between-center', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵeld"](11, 0, null, null, 7, 'div', [['itd-flex-item-fixed', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ExpandComponent_1)),
        core_es5["ɵdid"](14, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ExpandComponent_2)),
        core_es5["ɵdid"](17, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n				'])), (_l()(), core_es5["ɵeld"](20, 0, null, null, 7, 'div', [['itd-flex-item-fixed', ''], ['style', 'color: grey; margin: 0.2rem 0.5rem 0 0;']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ExpandComponent_3)), core_es5["ɵdid"](23, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ExpandComponent_4)), core_es5["ɵdid"](26, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n			'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n		'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n		'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ExpandComponent_5)), core_es5["ɵdid"](32, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n\n'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = true;
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = (_co.link.length === 0);
        _ck(_v, 14, 0, currVal_2);
        var currVal_3 = (_co.link.length > 0);
        _ck(_v, 17, 0, currVal_3);
        var currVal_4 = !_co.expand;
        _ck(_v, 23, 0, currVal_4);
        var currVal_5 = _co.expand;
        _ck(_v, 26, 0, currVal_5);
        var currVal_6 = _co.expand;
        _ck(_v, 32, 0, currVal_6);
    }, function (_ck, _v) {
        var currVal_0 = (core_es5["ɵnov"](_v, 6).disabled || null);
        _ck(_v, 4, 0, currVal_0);
    });
}
function View_ExpandComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'expand', [], null, null, null, View_ExpandComponent_0, RenderType_ExpandComponent)),
        core_es5["ɵdid"](1, 4308992, null, 0, expand_component_ExpandComponent, [log_service["a" /* LogService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var ExpandComponentNgFactory = core_es5["ɵccf"]('expand', expand_component_ExpandComponent, View_ExpandComponent_Host_0, { label: 'label', link: 'link' }, { linkClick: 'linkClick' }, ['*']);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=expand.component.ngfactory.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/card/typings/index.ngfactory.ts
var card_typings_index_ngfactory = __webpack_require__("z4MQ");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/card.es5.js
var card_es5 = __webpack_require__("Ioj9");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/navigate/navigate.component.ts
var navigate_component = __webpack_require__("egrd");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/tab.service.ts
var tab_service = __webpack_require__("+eyU");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/navigate/navigate.component.ngfactory.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenderType_NavigateComponent; });
/* harmony export (immutable) */ __webpack_exports__["b"] = View_NavigateComponent_0;
/* unused harmony export View_NavigateComponent_Host_0 */
/* unused harmony export NavigateComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */














var styles_NavigateComponent = [styles];
var RenderType_NavigateComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_NavigateComponent, data: {} });
function View_NavigateComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 8, 'div', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['\n								'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 5, 'a', [['class', 'mat-list-item'], ['mat-list-item', ''], ['role',
                'listitem'], ['style', 'font-size: 0.875rem; font-weight: 500; color: rgba(0, 0, 0, 0.87);']], [[1, 'target', 0], [8, 'href', 4]], [[null, 'focus'], [null, 'blur'],
            [null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('focus' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 3)._handleFocus() !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 3)._handleBlur() !== false);
                ad = (pd_1 && ad);
            }
            if (('click' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 6).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, index_ngfactory["c" /* View_MatListItem_0 */], index_ngfactory["b" /* RenderType_MatListItem */])), core_es5["ɵdid"](3, 1097728, null, 2, list_es5["d" /* MatListItem */], [core_es5["Renderer2"], core_es5["ElementRef"], [2, list_es5["b" /* MatList */]], [2, list_es5["g" /* MatNavListCssMatStyler */]]], null, null), core_es5["ɵqud"](603979776, 1, { _lines: 1 }), core_es5["ɵqud"](335544320, 2, { _hasAvatar: 0 }), core_es5["ɵdid"](6, 671744, null, 0, router_es5["n" /* RouterLinkWithHref */], [router_es5["m" /* Router */],
            router_es5["a" /* ActivatedRoute */], common_es5["l" /* LocationStrategy */]], { routerLink: [0, 'routerLink'] }, null),
        (_l()(), core_es5["ɵted"](7, 2, ['\n									', '\n								'])), (_l()(), core_es5["ɵted"](-1, null, ['\n							']))], function (_ck, _v) {
        var currVal_2 = core_es5["ɵinlineInterpolate"](1, '/', _v.context.$implicit.link, '');
        _ck(_v, 6, 0, currVal_2);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 6).target;
        var currVal_1 = core_es5["ɵnov"](_v, 6).href;
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_3 = _v.context.$implicit.name;
        _ck(_v, 7, 0, currVal_3);
    });
}
function View_NavigateComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 3, 'mat-divider', [['aria-orientation', 'horizontal'], ['class', 'mat-divider'], ['role', 'separator'],
            ['style', 'margin: 0 0.5rem 0 0;']], null, null, null, null, null)), core_es5["ɵdid"](1, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](2, 16384, null, 0, list_es5["c" /* MatListDivider */], [], null, null), core_es5["ɵdid"](3, 16384, null, 0, list_es5["a" /* MatDividerCssMatStyler */], [], null, null)], null, null);
}
function View_NavigateComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 17, 'div', [['style',
                'margin: 0rem 0rem 0rem 0.5rem;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 11, 'expand', [], null, null, null, View_ExpandComponent_0, RenderType_ExpandComponent)),
        core_es5["ɵdid"](3, 4308992, null, 0, expand_component_ExpandComponent, [log_service["a" /* LogService */]], { label: [0,
                'label'], link: [1, 'link'] }, null), (_l()(), core_es5["ɵted"](-1, 0, ['\n						'])),
        (_l()(), core_es5["ɵeld"](5, 0, null, 0, 7, 'mat-nav-list', [['class', 'mat-nav-list'],
            ['dense', ''], ['role', 'list'], ['style', 'background-color: white;']], null, null, null, index_ngfactory["d" /* View_MatList_0 */], index_ngfactory["a" /* RenderType_MatList */])), core_es5["ɵdid"](6, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null),
        core_es5["ɵdid"](7, 49152, null, 0, list_es5["b" /* MatList */], [], null, null),
        core_es5["ɵdid"](8, 16384, null, 0, list_es5["g" /* MatNavListCssMatStyler */], [], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['\n							'])), (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_NavigateComponent_2)), core_es5["ɵdid"](11, 802816, null, 0, common_es5["n" /* NgForOf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](-1, 0, ['\n						'])),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n					'])), (_l()(), core_es5["ɵted"](-1, null, ['\n \n					'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_NavigateComponent_3)),
        core_es5["ɵdid"](16, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n				']))], function (_ck, _v) {
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', _v.context.$implicit.name, '');
        var currVal_1 = core_es5["ɵinlineInterpolate"](1, '/', ((_v.context.$implicit.secondTab.tabs[0] == null) ? null : _v.context.$implicit.secondTab.tabs[0].link), '');
        _ck(_v, 3, 0, currVal_0, currVal_1);
        var currVal_2 = _v.context.$implicit.secondTab.tabs;
        _ck(_v, 11, 0, currVal_2);
        var currVal_3 = !_v.context.last;
        _ck(_v, 16, 0, currVal_3);
    }, null);
}
function View_NavigateComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 16, 'div', [['itd-flex-item',
                ''], ['style', 'margin: 0rem 0.5rem 0.5rem 0.5rem;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 13, 'mat-card', [['class',
                'mat-card'], ['style', 'margin: 0; padding: 0;']], null, null, null, card_typings_index_ngfactory["b" /* View_MatCard_0 */], card_typings_index_ngfactory["a" /* RenderType_MatCard */])), core_es5["ɵdid"](3, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](4, 49152, null, 0, card_es5["a" /* MatCard */], [], null, null),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n		'])), (_l()(), core_es5["ɵeld"](6, 0, null, 0, 8, 'div', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n			'])), (_l()(), core_es5["ɵeld"](8, 0, null, null, 5, 'expand', [['label', 'NAVIGATE'], ['link', '']], null, null, null, View_ExpandComponent_0, RenderType_ExpandComponent)),
        core_es5["ɵdid"](9, 4308992, null, 0, expand_component_ExpandComponent, [log_service["a" /* LogService */]], { label: [0,
                'label'], link: [1, 'link'] }, null), (_l()(), core_es5["ɵted"](-1, 0, ['\n\n				'])),
        (_l()(), core_es5["ɵand"](16777216, null, 0, 1, null, View_NavigateComponent_1)),
        core_es5["ɵdid"](12, 802816, null, 0, common_es5["n" /* NgForOf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"],
            core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](-1, 0, ['\n\n			'])), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n	'])), (_l()(), core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'NAVIGATE';
        var currVal_1 = '';
        _ck(_v, 9, 0, currVal_0, currVal_1);
        var currVal_2 = _co.tabs.firstTabs;
        _ck(_v, 12, 0, currVal_2);
    }, null);
}
function View_NavigateComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'navigate', [], null, null, null, View_NavigateComponent_0, RenderType_NavigateComponent)),
        core_es5["ɵdid"](1, 114688, null, 0, navigate_component["a" /* NavigateComponent */], [log_service["a" /* LogService */], tab_service["a" /* TabService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var NavigateComponentNgFactory = core_es5["ɵccf"]('navigate', navigate_component["a" /* NavigateComponent */], View_NavigateComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=navigate.component.ngfactory.js.map

/***/ }),

/***/ "DDzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log_service__ = __webpack_require__("B1/m");




var EventService = (function () {
    function EventService(http, authService, config, log) {
        this.http = http;
        this.authService = authService;
        this.config = config;
        this.log = log;
    }
    EventService.prototype.getEvents = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/events', options)
                .toPromise()
                .then(function (res) {
                resolve(res.json());
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    // might not be useful, can not edit an event if you are on a different organization
    EventService.prototype.getEventsAllOrganizations = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/eventsallorganizations', options)
                .toPromise()
                .then(function (res) {
                resolve(res.json());
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    /*
        getEvent() {
            return new Promise( (resolve, reject) => {
    
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
                let options = new RequestOptions({ headers: headers });
    
                let userId = this.authService.userId;
                this.http.get(this.config.basePath + '/v0/events/' + organizationsId, options)
                    .toPromise()
                    .then( (res) => {
                        resolve(res.json());
                    })
                    .catch((err) => {			// this is a Response object, with res.status === 401, for example
                        this.log.error(err);
                    });
            });
        }
    */
    EventService.prototype.updateEvent = function (eventId, payload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var body = JSON.stringify(payload);
            _this.http.put(_this.config.basePath + '/v0/events/' + eventId, body, options)
                .toPromise()
                .then(function (res) {
                // console.log('res');
                // console.log(res);
                resolve();
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    EventService.prototype.createEvent = function (payload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/events', body, options)
                .toPromise()
                .then(function (res) {
                // console.log('res');
                // console.log(res);
                resolve();
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    EventService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__log_service__["a" /* LogService */] }]; };
    return EventService;
}());

//# sourceMappingURL=event.service.js.map

/***/ }),

/***/ "DJJ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AllUsersResolver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("AP4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_service__ = __webpack_require__("emCa");


var AllUsersResolver = (function () {
    function AllUsersResolver(userService) {
        this.userService = userService;
        this.params = {};
    }
    AllUsersResolver.prototype.resolve = function (route, state) {
        var _this = this;
        console.log('AllUsersResolver called    #1');
        this.params = JSON.parse(JSON.stringify(route.params));
        var thePromise = new Promise(function (resolve, reject) {
            // this.userService.getUsers()
            _this.userService.getRecentUsersIndexedDb()
                .then(function (users) {
                console.log('AllUsersResolver called    #2');
                // console.log(users);
                var allUsersInfo = {
                    // users: users.allUsers,
                    users: users.allUsers.users,
                    params: _this.params
                };
                resolve(allUsersInfo);
            })
                .catch(function (err) {
                return reject(err);
            });
        });
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(thePromise);
    };
    AllUsersResolver.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__user_service__["a" /* UserService */] }]; };
    return AllUsersResolver;
}());

//# sourceMappingURL=all-users.resolver.js.map

/***/ }),

/***/ "FqoL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelpFaqComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__("BkNc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_log_service__ = __webpack_require__("B1/m");



var HelpFaqComponent = (function () {
    function HelpFaqComponent(router, log) {
        this.router = router;
        this.log = log;
        this.help = false;
        this.navToFaq = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    HelpFaqComponent.prototype.ngOnInit = function () {
    };
    HelpFaqComponent.prototype.goToFaq = function () {
        this.navToFaq.next();
        console.log('goToFaq clicked!!');
        this.help = false;
        // this.router.navigate(['profile'], { queryParams: { faq: 1 } });
        this.log.showFaq = true;
        this.router.navigate(['common/profile']);
    };
    HelpFaqComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_router__["m" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_2__services_log_service__["a" /* LogService */] }]; };
    return HelpFaqComponent;
}());

//# sourceMappingURL=help-faq.component.js.map

/***/ }),

/***/ "Fqty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommunicationsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__log_service__ = __webpack_require__("B1/m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__("aMZo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid__);




var CommunicationsService = (function () {
    function CommunicationsService(log, config, http) {
        this.log = log;
        this.config = config;
        this.http = http;
    }
    CommunicationsService.prototype.queueEmail = function (emailProvider, // gmail, outlook, aws
        fromEmail, fromDisplayName, toEmail, toDisplayName, subject, messageText, messageHtml, messageQuill, syncCollectionRequired, syncCollectionName, syncCollectionField, syncCollectionId) {
        var _this = this;
        if (syncCollectionRequired === void 0) { syncCollectionRequired = false; }
        if (syncCollectionName === void 0) { syncCollectionName = null; }
        if (syncCollectionField === void 0) { syncCollectionField = null; }
        if (syncCollectionId === void 0) { syncCollectionId = null; }
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({
                'Authorization': 'Bearer ' + accessToken,
                'Content-Type': 'application/json'
            });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                communicationId: __WEBPACK_IMPORTED_MODULE_3_uuid__["v4"]().replace(/-/g, ''),
                communicationType: 'email',
                emailProvider: emailProvider,
                fromEmail: fromEmail,
                fromDisplayName: fromDisplayName,
                toEmail: toEmail,
                toDisplayName: toDisplayName,
                subject: subject,
                messageText: messageText,
                messageHtml: messageHtml,
                messageQuill: messageQuill,
                syncCollectionRequired: syncCollectionRequired,
                syncCollectionName: syncCollectionName,
                syncCollectionField: syncCollectionField,
                syncCollectionId: syncCollectionId,
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/communications', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                console.log(result);
                resolve(result);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                console.log(err);
                reject(err);
            });
        });
    };
    CommunicationsService.prototype.queueEmailBatch = function (batchItems) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({
                'Authorization': 'Bearer ' + accessToken,
                'Content-Type': 'application/json'
            });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                batchItems: batchItems
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/communications/batch', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                console.log(result);
                resolve(result);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                console.log(err);
                reject(err);
            });
        });
    };
    // // sends email using gmail OAuth servers
    // sendEmail(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string) {
    // 	return new Promise( (resolve, reject) => {
    // 		let accessToken = localStorage.getItem('auth-jwt');
    // 		let headers = new Headers({
    // 			'Authorization': 'Bearer ' + accessToken,
    // 			'Content-Type': 'application/json'
    // 		});
    // 		let options = new RequestOptions({ headers: headers });
    // 		let payload = {
    // 			emailFrom: emailFrom,
    // 			emailTo: emailTo,
    // 			emailSubject: emailSubject,
    // 			emailBody: emailBody
    // 		};
    // 		let body = JSON.stringify(payload);
    // 		this.http.post(this.config.basePath + '/v0/emails', body, options)
    // 			.toPromise()
    // 			.then( (res) => {
    // 				// console.log(res);
    // 				let foo = res.json();
    // 				console.log(foo);
    // 				// let bar: any = foo;
    // 				resolve();
    // 			})
    // 			.catch((err) => {			// this is a Response object, with res.status === 401, for example
    // 				// TODO - handle errors?
    // 				this.log.error(err);
    // 				console.log(err);
    // 				reject(err);
    // 			});
    // 	});
    // }
    // // sends email using our servers
    // sendEmail2(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string) {
    // 	return new Promise( (resolve, reject) => {
    // 		let accessToken = localStorage.getItem('auth-jwt');
    // 		let headers = new Headers({
    // 			'Authorization': 'Bearer ' + accessToken,
    // 			'Content-Type': 'application/json'
    // 		});
    // 		let options = new RequestOptions({ headers: headers });
    // 		let payload = {
    // 			emailFrom: emailFrom,
    // 			emailTo: emailTo,
    // 			emailSubject: emailSubject,
    // 			emailBody: emailBody
    // 		};
    // 		let body = JSON.stringify(payload);
    // 		this.http.post(this.config.basePath + '/v0/emails2', body, options)
    // 			.toPromise()
    // 			.then( (res) => {
    // 				// console.log(res);
    // 				let foo = res.json();
    // 				console.log(foo);
    // 				// let bar: any = foo;
    // 				resolve();
    // 			})
    // 			.catch((err) => {			// this is a Response object, with res.status === 401, for example
    // 				// TODO - handle errors?
    // 				this.log.error(err);
    // 				reject(err);
    // 			});
    // 	});
    // }
    // // sends email using our servers
    // sendEmailGroupBcc(emailFrom: string, emailTo: string, emailCc: string, emailBcc: string, emailSubject: string, emailBody: string) {
    // 	return new Promise( (resolve, reject) => {
    // 		let accessToken = localStorage.getItem('auth-jwt');
    // 		let headers = new Headers({
    // 			'Authorization': 'Bearer ' + accessToken,
    // 			'Content-Type': 'application/json'
    // 		});
    // 		let options = new RequestOptions({ headers: headers });
    // 		let payload = {
    // 			emailFrom: emailFrom,
    // 			emailTo: emailTo,
    // 			emailCc: emailCc,
    // 			emailBcc: emailBcc,
    // 			emailSubject: emailSubject,
    // 			emailBody: emailBody
    // 		};
    // 		let body = JSON.stringify(payload);
    // 		this.http.post(this.config.basePath + '/v0/emailsGroupBcc', body, options)
    // 			.toPromise()
    // 			.then( (res) => {
    // 				// console.log(res);
    // 				let foo = res.json();
    // 				console.log(foo);
    // 				// let bar: any = foo;
    // 				resolve();
    // 			})
    // 			.catch((err) => {			// this is a Response object, with res.status === 401, for example
    // 				// TODO - handle errors?
    // 				this.log.error(err);
    // 				reject(err);
    // 			});
    // 	});
    // }
    // sendEmailWithAttachments(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string, attachments: any) {
    // 	return new Promise( (resolve, reject) => {
    // 		let accessToken = localStorage.getItem('auth-jwt');
    // 		let headers = new Headers({
    // 			'Authorization': 'Bearer ' + accessToken,
    // 			'Content-Type': 'application/json'
    // 		});
    // 		let options = new RequestOptions({ headers: headers });
    // 		let payload = {
    // 			emailFrom: emailFrom,
    // 			emailTo: emailTo,
    // 			emailSubject: emailSubject,
    // 			emailBody: emailBody,
    // 			attachments: attachments.join(',')
    // 		};
    // 		let body = JSON.stringify(payload);
    // 		this.http.post(this.config.basePath + '/v0/emails/attachments', body, options)
    // 			.toPromise()
    // 			.then( (res) => {
    // 				// console.log(res);
    // 				let foo = res.json();
    // 				console.log(foo);
    // 				// let bar: any = foo;
    // 				resolve();
    // 			})
    // 			.catch((err) => {			// this is a Response object, with res.status === 401, for example
    // 				// TODO - handle errors?
    // 				this.log.error(err);
    // 				reject(err);
    // 			});
    // 	});
    // }
    /*
        sendAcceptLetterEmail(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string, film: any) {
            return new Promise( (resolve, reject) => {
    
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json'
                });
                let options = new RequestOptions({ headers: headers });
                let payload = {
                    emailFrom: emailFrom,
                    emailTo: emailTo,
                    emailSubject: emailSubject,
                    emailBody: emailBody
                };
                let body = JSON.stringify(payload);
    
                console.log(payload);
    
                resolve();
    
    
                // this.http.post(this.config.basePath + '/v0/emails', body, options)
                // 	.toPromise()
                // 	.then( (res) => {
    
                // 		// console.log(res);
    
    
                // 		let foo = res.json();
                // 		console.log(foo);
                // 		// let bar: any = foo;
    
    
                // 		resolve();
                // 	})
                // 	.catch((err) => {			// this is a Response object, with res.status === 401, for example
                // 		// TODO - handle errors?
                // 		this.log.error(err);
                // 		reject();
                // 	});
    
    
            });
        }
    
    
    
    
        sendRejectLetterEmail(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string) {
            return new Promise( (resolve, reject) => {
    
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json'
                });
                let options = new RequestOptions({ headers: headers });
                let payload = {
                    emailFrom: emailFrom,
                    emailTo: emailTo,
                    emailSubject: emailSubject,
                    emailBody: emailBody
                };
                let body = JSON.stringify(payload);
    
                console.log(payload);
    
                resolve();
    
    
                // this.http.post(this.config.basePath + '/v0/emails', body, options)
                // 	.toPromise()
                // 	.then( (res) => {
    
                // 		// console.log(res);
    
    
                // 		let foo = res.json();
                // 		console.log(foo);
                // 		// let bar: any = foo;
    
    
                // 		resolve();
                // 	})
                // 	.catch((err) => {			// this is a Response object, with res.status === 401, for example
                // 		// TODO - handle errors?
                // 		this.log.error(err);
                // 		reject();
                // 	});
    
    
            });
        }
    */
    // ensureTemplate(templateFilenameUrl: string, templateParameters: any, mergedFilenameUrl: string) {
    // 	return new Promise( (resolve, reject) => {
    // 		let accessToken = localStorage.getItem('auth-jwt');
    // 		let headers = new Headers({
    // 			'Authorization': 'Bearer ' + accessToken,
    // 			'Content-Type': 'application/json'
    // 		});
    // 		let options = new RequestOptions({ headers: headers });
    // 		let payload = {
    // 			templateFilenameUrl: templateFilenameUrl,
    // 			templateParameters: JSON.stringify(templateParameters),
    // 			mergedFilenameUrl: mergedFilenameUrl
    // 		};
    // 		let body = JSON.stringify(payload);
    // 		this.http.post(this.config.basePath + '/v0/templates', body, options)
    // 			.toPromise()
    // 			.then( (res) => {
    // 				// console.log(res);
    // 				let foo = res.json();
    // 				// console.log(foo);
    // 				// let bar: any = foo;
    // 				resolve();
    // 			})
    // 			.catch((err) => {			// this is a Response object, with res.status === 401, for example
    // 				// TODO - handle errors?
    // 				this.log.error(err);
    // 				reject(err);
    // 			});
    // 	});
    // }
    // getEmailList() {
    // 	return new Promise( (resolve, reject) => {
    // 		let accessToken = localStorage.getItem('auth-jwt');
    // 		let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
    // 		let options = new RequestOptions({ headers: headers });
    // 		this.http.get(this.config.basePath + '/v0/emails', options)
    // 			.toPromise()
    // 			.then((res) => {
    // 				resolve(res.json());
    // 			})
    // 			.catch((err) => {			// this is a Response object, with res.status === 401, for example
    // 				this.log.error(err);
    // 				reject(err);
    // 			});
    // 	});
    // }
    // getEmail(emailAwsId: string) {
    // 	return new Promise( (resolve, reject) => {
    // 		let accessToken = localStorage.getItem('auth-jwt');
    // 		let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
    // 		let options = new RequestOptions({ headers: headers });
    // 		this.http.get(this.config.basePath + '/v0/emails/' + emailAwsId, options)
    // 			.toPromise()
    // 			.then((res) => {
    // 				resolve(res.json());
    // 			})
    // 			.catch((err) => {			// this is a Response object, with res.status === 401, for example
    // 				this.log.error(err);
    // 				reject(err);
    // 			});
    // 	});
    // }
    // sendTestEmail(displayName: string, email: string, emailProvider: string) {
    // 	return new Promise( (resolve, reject) => {
    // 		let accessToken = localStorage.getItem('auth-jwt');
    // 		let headers = new Headers({
    // 			'Authorization': 'Bearer ' + accessToken,
    // 			'Content-Type': 'application/json'
    // 		});
    // 		let options = new RequestOptions({ headers: headers });
    // 		let payload = {
    // 			displayName: displayName,
    // 			email: email,
    // 			emailProvider: emailProvider
    // 		};
    // 		let body = JSON.stringify(payload);
    // 		this.http.post(this.config.basePath + '/v0/emails/test', body, options)
    // 			.toPromise()
    // 			.then((res) => {
    // 				let result = res.json();
    // 				console.log(result);
    // 				resolve(result);
    // 			})
    // 			.catch((err) => {			// this is a Response object, with res.status === 401, for example
    // 				// TODO - handle errors?
    // 				this.log.error(err);
    // 				reject(err);
    // 			});
    // 	});
    // }
    CommunicationsService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__log_service__["a" /* LogService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }]; };
    return CommunicationsService;
}());

//# sourceMappingURL=communications.service.js.map

/***/ }),

/***/ "IGQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeedbackComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("/oeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__("6lRS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_feedback_service__ = __webpack_require__("MBKK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_log_service__ = __webpack_require__("B1/m");




var FeedbackComponent = (function () {
    function FeedbackComponent(snackBar, feedbackService, log) {
        this.snackBar = snackBar;
        this.feedbackService = feedbackService;
        this.log = log;
        this.feedback = false;
        this.feedbackComments = '';
        this.feedbackSent = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    FeedbackComponent.prototype.ngOnInit = function () {
    };
    FeedbackComponent.prototype.sendFeedback = function () {
        var _this = this;
        this.feedbackSent.next();
        // console.log('sendFeedback clicked!!');
        // console.log('feedbackComments:');
        // console.log(this.feedbackComments);
        this.feedback = false;
        this.feedbackService.sendFeedback(this.feedbackComments)
            .then(function () {
            _this.feedbackComments = '';
            _this.log.info('Feedback saved to db!');
            _this.snackBar.open('Feedback Sent.  Thank You!', 'X', { duration: 2000 });
        })
            .catch(function (err) {
            _this.feedbackComments = '';
            // TODO - add toast
            // console.log('toast: server not available');
            _this.log.error(err);
        });
    };
    FeedbackComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MatSnackBar */] }, { type: __WEBPACK_IMPORTED_MODULE_2__services_feedback_service__["a" /* FeedbackService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__services_log_service__["a" /* LogService */] }]; };
    return FeedbackComponent;
}());

//# sourceMappingURL=feedback.component.js.map

/***/ }),

/***/ "JO6G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__log_service__ = __webpack_require__("B1/m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_service__ = __webpack_require__("CNKn");

// import {Http, Headers, Request, RequestOptions, RequestOptionsArgs, RequestMethod, Response} from '@angular/http';


var EmailService = (function () {
    function EmailService(log, config, http) {
        this.log = log;
        this.config = config;
        this.http = http;
    }
    // sends email using gmail OAuth servers
    EmailService.prototype.sendEmail = function (emailFrom, emailTo, emailSubject, emailBody) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({
                'Authorization': 'Bearer ' + accessToken,
                'Content-Type': 'application/json'
            });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                emailFrom: emailFrom,
                emailTo: emailTo,
                emailSubject: emailSubject,
                emailBody: emailBody
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/emails', body, options)
                .toPromise()
                .then(function (res) {
                // console.log(res);
                var foo = res.json();
                console.log(foo);
                // let bar: any = foo;
                resolve();
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject(err);
            });
        });
    };
    // sends email using our servers
    EmailService.prototype.sendEmail2 = function (emailFrom, emailTo, emailSubject, emailBody) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({
                'Authorization': 'Bearer ' + accessToken,
                'Content-Type': 'application/json'
            });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                emailFrom: emailFrom,
                emailTo: emailTo,
                emailSubject: emailSubject,
                emailBody: emailBody
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/emails2', body, options)
                .toPromise()
                .then(function (res) {
                // console.log(res);
                var foo = res.json();
                console.log(foo);
                // let bar: any = foo;
                resolve();
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject(err);
            });
        });
    };
    // sends email using our servers
    EmailService.prototype.sendEmailGroupBcc = function (emailFrom, emailTo, emailCc, emailBcc, emailSubject, emailBody) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({
                'Authorization': 'Bearer ' + accessToken,
                'Content-Type': 'application/json'
            });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                emailFrom: emailFrom,
                emailTo: emailTo,
                emailCc: emailCc,
                emailBcc: emailBcc,
                emailSubject: emailSubject,
                emailBody: emailBody
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/emailsGroupBcc', body, options)
                .toPromise()
                .then(function (res) {
                // console.log(res);
                var foo = res.json();
                console.log(foo);
                // let bar: any = foo;
                resolve();
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject(err);
            });
        });
    };
    EmailService.prototype.sendEmailWithAttachments = function (emailFrom, emailTo, emailSubject, emailBody, attachments) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({
                'Authorization': 'Bearer ' + accessToken,
                'Content-Type': 'application/json'
            });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                emailFrom: emailFrom,
                emailTo: emailTo,
                emailSubject: emailSubject,
                emailBody: emailBody,
                attachments: attachments.join(',')
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/emails/attachments', body, options)
                .toPromise()
                .then(function (res) {
                // console.log(res);
                var foo = res.json();
                console.log(foo);
                // let bar: any = foo;
                resolve();
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject(err);
            });
        });
    };
    /*
        sendAcceptLetterEmail(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string, film: any) {
            return new Promise( (resolve, reject) => {
    
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json'
                });
                let options = new RequestOptions({ headers: headers });
                let payload = {
                    emailFrom: emailFrom,
                    emailTo: emailTo,
                    emailSubject: emailSubject,
                    emailBody: emailBody
                };
                let body = JSON.stringify(payload);
    
                console.log(payload);
    
                resolve();
    
    
                // this.http.post(this.config.basePath + '/v0/emails', body, options)
                // 	.toPromise()
                // 	.then( (res) => {
    
                // 		// console.log(res);
    
    
                // 		let foo = res.json();
                // 		console.log(foo);
                // 		// let bar: any = foo;
    
    
                // 		resolve();
                // 	})
                // 	.catch((err) => {			// this is a Response object, with res.status === 401, for example
                // 		// TODO - handle errors?
                // 		this.log.error(err);
                // 		reject();
                // 	});
    
    
            });
        }
    
    
    
    
        sendRejectLetterEmail(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string) {
            return new Promise( (resolve, reject) => {
    
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json'
                });
                let options = new RequestOptions({ headers: headers });
                let payload = {
                    emailFrom: emailFrom,
                    emailTo: emailTo,
                    emailSubject: emailSubject,
                    emailBody: emailBody
                };
                let body = JSON.stringify(payload);
    
                console.log(payload);
    
                resolve();
    
    
                // this.http.post(this.config.basePath + '/v0/emails', body, options)
                // 	.toPromise()
                // 	.then( (res) => {
    
                // 		// console.log(res);
    
    
                // 		let foo = res.json();
                // 		console.log(foo);
                // 		// let bar: any = foo;
    
    
                // 		resolve();
                // 	})
                // 	.catch((err) => {			// this is a Response object, with res.status === 401, for example
                // 		// TODO - handle errors?
                // 		this.log.error(err);
                // 		reject();
                // 	});
    
    
            });
        }
    */
    EmailService.prototype.ensureTemplate = function (templateFilenameUrl, templateParameters, mergedFilenameUrl) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({
                'Authorization': 'Bearer ' + accessToken,
                'Content-Type': 'application/json'
            });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                templateFilenameUrl: templateFilenameUrl,
                templateParameters: JSON.stringify(templateParameters),
                mergedFilenameUrl: mergedFilenameUrl
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/templates', body, options)
                .toPromise()
                .then(function (res) {
                // console.log(res);
                var foo = res.json();
                // console.log(foo);
                // let bar: any = foo;
                resolve();
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject(err);
            });
        });
    };
    EmailService.prototype.getEmailList = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/emails', options)
                .toPromise()
                .then(function (res) {
                resolve(res.json());
            })
                .catch(function (err) {
                _this.log.error(err);
                reject(err);
            });
        });
    };
    EmailService.prototype.getEmail = function (emailAwsId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/emails/' + emailAwsId, options)
                .toPromise()
                .then(function (res) {
                resolve(res.json());
            })
                .catch(function (err) {
                _this.log.error(err);
                reject(err);
            });
        });
    };
    EmailService.prototype.sendTestEmail = function (displayName, email, emailProvider) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({
                'Authorization': 'Bearer ' + accessToken,
                'Content-Type': 'application/json'
            });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                displayName: displayName,
                email: email,
                emailProvider: emailProvider
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/emails/test', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                console.log(result);
                resolve(result);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject(err);
            });
        });
    };
    EmailService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__log_service__["a" /* LogService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }]; };
    return EmailService;
}());

//# sourceMappingURL=email.service.js.map

/***/ }),

/***/ "KEXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cache_storage_service__ = __webpack_require__("a36o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__log_service__ = __webpack_require__("B1/m");





var GridService = (function () {
    function GridService(http, authService, cacheStorage, config, log) {
        this.http = http;
        this.authService = authService;
        this.cacheStorage = cacheStorage;
        this.config = config;
        this.log = log;
    }
    GridService.prototype.createGrid = function (payload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var body = JSON.stringify(payload);
            // console.log('payload');
            // console.log(payload);
            // console.log('body');
            // console.log(body);
            _this.http.post(_this.config.basePath + '/v0/grids', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject(err);
            });
        });
    };
    GridService.prototype.updateGrid = function (payload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var body = JSON.stringify(payload);
            _this.http.put(_this.config.basePath + '/v0/grids/' + payload.gridId, body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject(err);
            });
        });
    };
    GridService.prototype.deleteGrid = function (gridId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.delete(_this.config.basePath + '/v0/grids/' + gridId, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                // console.log(result);
                resolve(result);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject(err);
            });
        });
    };
    GridService.prototype.getGrids = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/grids', options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject(err);
            });
        });
    };
    GridService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__cache_storage_service__["a" /* CacheStorageService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_4__log_service__["a" /* LogService */] }]; };
    return GridService;
}());

//# sourceMappingURL=grid.service.js.map

/***/ }),

/***/ "MBKK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeedbackService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log_service__ = __webpack_require__("B1/m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid__ = __webpack_require__("aMZo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid__);





var FeedbackService = (function () {
    function FeedbackService(http, authService, config, log) {
        this.http = http;
        this.authService = authService;
        this.config = config;
        this.log = log;
    }
    /*
        getFilms() {
            return new Promise( (resolve, reject) => {
    
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
                let options = new RequestOptions({ headers: headers });
    
                this.http.get(this.config.basePath + '/v0/films', options)
                    .toPromise()
                    .then( (res) => {
                        let foo = res.json();
    
                        // films.allFilms.films
    
                        // console.log(foo);
                        let sortedFilms = foo.allFilms.films.sort((a: any, b: any) => {
    
    
                            if (a.title.toLowerCase() === b.title.toLowerCase()) {
                                return 0;
                            }
                            if (a.title.toLowerCase() < b.title.toLowerCase()) {
                                return -1;
                            }
                            return 1;
    
                            // if (a.sortSubmissionId === b.sortSubmissionId) {
                            // 	return 0;
                            // }
                            // if (a.sortSubmissionId < b.sortSubmissionId) {
                            // 	return -1;
                            // }
                            // return 1;
                        });
                        foo.allFilms.films = sortedFilms;
                        resolve(foo);
                    })
                    .catch((err) => {			// this is a Response object, with res.status === 401, for example
                        // TODO - handle errors?
                        this.log.error(err);
                    });
            });
        }
    */
    FeedbackService.prototype.sendFeedback = function (feedback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var userId = _this.authService.userId;
            var payload = {
                feedbackId: __WEBPACK_IMPORTED_MODULE_4_uuid__["v4"]().replace(/-/g, ''),
                feedbackUserId: userId,
                feedback: feedback
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/feedbacks', body, options)
                .toPromise()
                .then(function (res) {
                // let foo = res.json();
                // console.log(foo);
                // let bar: any = foo;
                resolve();
            })
                .catch(function (err) {
                _this.log.error(err);
                reject();
            });
        });
    };
    FeedbackService.prototype.getFeedbacks = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/feedbacks', options)
                .toPromise()
                .then(function (res) {
                resolve(res.json());
            })
                .catch(function (err) {
                console.log(err);
                // resolve({});			// TODO - reject with error !!!
            });
        });
        /*
                return $q(function(resolve, reject) {
        
                    $http.get(apiHost + '/v0/feedbacks')
                    .success(function(data, status, headers, config) {
        // console.log('here I am at getFeedbacks #3');
        // console.log('data');
        // console.log(data);
                        return resolve(data);
                    })
                    .error(function(data, status, headers, config) {
        //						console.log('got here #f29');
        //console.log('here I am at getLogs #4');
        
                        // Log.warn('Could not get log list from api.');		// avoid endless loop
                        console.log('Could not get feedback list from api.');
        
                        return resolve(null);
                    });
        
                });
        */
    };
    /*
    
    
    
            return {
                sendFeedback: function(userId, feedback) {
    //				console.log('<------ sendFeedback -------->');
                    return $q(function(resolve, reject) {
                        var payload = {
                            feedbackId: uuid.v4().replace(/-/g, ''),
                            feedbackUserId: userId,
                            feedback: feedback
                        };
    
                        $http.post(apiHost + '/v0/feedbacks', payload)
                        .success(function(data, status, headers, config) {
    //						console.log('got here #f28');
    
                            return resolve(true);
                        })
                        .error(function(data, status, headers, config) {
    //						console.log('got here #f29');
    
                            Log.warn('Could not send feedback to api.');
                            return resolve(null);
                        });
    
                    });
                },
    
    
    
    
    
                getFeedbacks: function () {
                    return $q(function(resolve, reject) {
    
                        $http.get(apiHost + '/v0/feedbacks')
                        .success(function(data, status, headers, config) {
    // console.log('here I am at getFeedbacks #3');
    // console.log('data');
    // console.log(data);
                            return resolve(data);
                        })
                        .error(function(data, status, headers, config) {
    //						console.log('got here #f29');
    //console.log('here I am at getLogs #4');
    
                            // Log.warn('Could not get log list from api.');		// avoid endless loop
                            console.log('Could not get feedback list from api.');
    
                            return resolve(null);
                        });
    
                    });
    
                }
    
    
    
    
    */
    FeedbackService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__log_service__["a" /* LogService */] }]; };
    return FeedbackService;
}());

//# sourceMappingURL=feedback.service.js.map

/***/ }),

/***/ "Msfd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AllGridsResolver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("AP4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid_service__ = __webpack_require__("KEXf");


var AllGridsResolver = (function () {
    function AllGridsResolver(gridService) {
        this.gridService = gridService;
        this.params = {};
    }
    AllGridsResolver.prototype.resolve = function (route, state) {
        // console.log('AllFilmsResolver called    #1');
        // let startResolve = Date.now();
        var _this = this;
        this.params = JSON.parse(JSON.stringify(route.params));
        var thePromise = new Promise(function (resolve, reject) {
            // this.reviewerFilmService.getFilms()
            _this.gridService.getGrids()
                .then(function (grids) {
                // let endResolve = Date.now();
                // console.log('AllFilmsResolver called    #2, took ' + (endResolve - startResolve) + ' msec' );
                var allGridsInfo = {
                    allGrids: grids.allGrids.grids,
                    params: _this.params
                };
                resolve(allGridsInfo);
            })
                .catch(function (err) {
                return reject(err);
            });
        });
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(thePromise);
    };
    AllGridsResolver.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__grid_service__["a" /* GridService */] }]; };
    return AllGridsResolver;
}());

//# sourceMappingURL=all-grids.resolver.js.map

/***/ }),

/***/ "N1s2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReviewerFilmService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cache_storage_service__ = __webpack_require__("a36o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__log_service__ = __webpack_require__("B1/m");





// import {AngularIndexedDB} from 'angular2-indexeddb';
// import {AngularIndexedDB} from '../../shared/classes/angular2-indexeddb';
var ReviewerFilmService = (function () {
    function ReviewerFilmService(http, authService, cacheStorage, config, log) {
        // console.log('-----> creating AngularIndexedDB');
        // this.db = new AngularIndexedDB('oceanbluffproductions', 1);
        // console.log('this.db');
        // console.log(this.db);
        this.http = http;
        this.authService = authService;
        this.cacheStorage = cacheStorage;
        this.config = config;
        this.log = log;
        // db: any = {};
        this.allFilms = {};
        this.allFilmsWithArray = {};
        // setTimeout(() => {
        // 	console.log('-----> creating store');
        // 	this.db.createStore(1, (evt) => {
        // 		console.log('-----> creating store returning');
        // 		let objectStore = evt.currentTarget.result.createObjectStore('films', { keyPath: 'filmId', autoIncrement: false });
        // 		objectStore.createIndex('filmId', 'filmId', { unique: false });
        // 	});
        // }, 100);
    }
    ReviewerFilmService.prototype.getFilms = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/films', options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // films.allFilms.films
                // console.log(foo);
                var sortedFilms = foo.allFilms.films.sort(function (a, b) {
                    if (a.title.toLowerCase() === b.title.toLowerCase()) {
                        return 0;
                    }
                    if (a.title.toLowerCase() < b.title.toLowerCase()) {
                        return -1;
                    }
                    return 1;
                    // if (a.sortSubmissionId === b.sortSubmissionId) {
                    // 	return 0;
                    // }
                    // if (a.sortSubmissionId < b.sortSubmissionId) {
                    // 	return -1;
                    // }
                    // return 1;
                });
                foo.allFilms.films = sortedFilms;
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
            });
        });
    };
    ReviewerFilmService.prototype.getRecentFilms = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            // init first time through, if can
            if (!_this.allFilms.films) {
                // console.log('** first time through getRecentFilms **');
                var tempAllFilms = _this.cacheStorage.read(_this.cacheStorage.keys.allFilms);
                if (tempAllFilms && tempAllFilms.films) {
                    _this.allFilms = tempAllFilms;
                    _this.allFilmsWithArray = {};
                    _this.allFilmsWithArray.allFilms = {};
                    _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                    _this.allFilmsWithArray.allFilms.films = [];
                    Object.keys(_this.allFilms.films).forEach(function (filmId) {
                        var film = _this.allFilms.films[filmId];
                        _this.allFilmsWithArray.allFilms.films.push(film);
                    });
                }
            }
            var modified = 0;
            if (_this.allFilms.modified) {
                modified = _this.allFilms.modified;
            }
            // console.log('getRecentFilms modified');
            // console.log(modified);
            // let init = Date.now();
            // console.log('    ' + (init - start) + 'msec to init, getRecentFilms');
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/films/date/' + modified, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                var api = Date.now();
                // console.log('    ' + (api - init) + 'msec to make api call, getRecentFilms');
                // films.allFilms.films
                // console.log('foo');
                // console.log(foo);
                // console.log('foo.allFilms');
                // console.log(foo.allFilms);
                // let tempFilms = foo.allFilms.films;
                // console.log('tempFilms');
                // console.log(tempFilms);
                // this.cacheStorage.write(this.cacheStorage.keys.allFilms, foo.allFilms);
                // tempAllFilms = data.allFilms;
                // localStorage.setItem('all-films', JSON.stringify(tempAllFilms));
                if (_this.allFilms.films) {
                    // console.log('----  test if should update, count = ' + foo.allFilms.films.length);
                    if (foo.allFilms.films.length > 0) {
                        // console.log('----  updating, count = ' + foo.allFilms.films.length);
                        foo.allFilms.films.forEach(function (film) {
                            _this.trimFilm(film);
                            _this.allFilms.films[film.filmId] = film;
                        });
                        _this.allFilms.modified = foo.allFilms.modified;
                        _this.cacheStorage.write(_this.cacheStorage.keys.allFilms, _this.allFilms);
                        _this.allFilmsWithArray = {};
                        _this.allFilmsWithArray.allFilms = {};
                        _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                        _this.allFilmsWithArray.allFilms.films = [];
                        Object.keys(_this.allFilms.films).forEach(function (filmId) {
                            var film = _this.allFilms.films[filmId];
                            _this.allFilmsWithArray.allFilms.films.push(film);
                        });
                    }
                }
                else {
                    // console.log('----  first time through, count = ' + foo.allFilms.films.length);
                    // convert to object form
                    var objectAllFilms_1 = {};
                    objectAllFilms_1.modified = foo.allFilms.modified;
                    objectAllFilms_1.films = {};
                    foo.allFilms.films.forEach(function (film) {
                        _this.trimFilm(film);
                        objectAllFilms_1.films[film.filmId] = film;
                    });
                    _this.allFilms = objectAllFilms_1;
                    _this.cacheStorage.write(_this.cacheStorage.keys.allFilms, _this.allFilms);
                    _this.allFilmsWithArray = {};
                    _this.allFilmsWithArray.allFilms = {};
                    _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                    _this.allFilmsWithArray.allFilms.films = [];
                    Object.keys(_this.allFilms.films).forEach(function (filmId) {
                        var film = _this.allFilms.films[filmId];
                        _this.allFilmsWithArray.allFilms.films.push(film);
                    });
                }
                // let process = Date.now();
                // console.log('    ' + (process - api) + 'msec to process list, getRecentFilms');
                // console.log('this.allFilms');
                // console.log(this.allFilms);
                // console.log('this.allFilmsWithArray');
                // console.log(this.allFilmsWithArray);
                var sortedFilms = _this.allFilmsWithArray.allFilms.films.sort(function (a, b) {
                    if (a.title.toLowerCase() === b.title.toLowerCase()) {
                        return 0;
                    }
                    if (a.title.toLowerCase() < b.title.toLowerCase()) {
                        return -1;
                    }
                    return 1;
                    // if (a.sortSubmissionId === b.sortSubmissionId) {
                    // 	return 0;
                    // }
                    // if (a.sortSubmissionId < b.sortSubmissionId) {
                    // 	return -1;
                    // }
                    // return 1;
                });
                _this.allFilmsWithArray.allFilms.films = sortedFilms;
                // let sort = Date.now();
                // console.log('    ' + (sort - process) + 'msec to sort list, getRecentFilms');
                // let end = Date.now();
                // console.log('    ' + (end - start) + 'msec total, getRecentFilms');
                resolve(_this.allFilmsWithArray);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
            });
        });
    };
    ReviewerFilmService.prototype.trimFilm = function (film) {
        delete film['aspectRatio'];
        delete film['countriesFilmed'];
        delete film['createdBy'];
        delete film['deleted'];
        delete film['deletedBy'];
        delete film['facebookUrl'];
        delete film['filmColor'];
        delete film['filmFormat'];
        delete film['filmSound'];
        delete film['genres'];
        // delete film['languages'];
        delete film['otherSocialUrl'];
        delete film['submissionDeadline'];
        delete film['submissionDiscountCode'];
        delete film['submissionFee'];
        delete film['submissionProvidedCdnTitle'];
        // delete film['subtitleLanguages'];
        delete film['synopsisEnglish'];
        delete film['synopsisOriginal'];
        delete film['titleEnglish'];
        delete film['titleOriginal'];
        delete film['types'];
        delete film['twitterUrl'];
        delete film['websiteUrl'];
        /*
        acknowledgementSentDate : 1469817024462
        aspectRatio : "1.78:1"
        cdnId : "171336032"
        cdnPassword : "20thankyou16"
        cdnRequiresPassword : true
        cdnSource : "vimeo"
        cdnUrl : "//player.vimeo.com/video/171336032?title=0&amp;byline=0&amp;portrait=0"
        countriesFilmed : "USA"
        country : "USA"
        created : 1469769347150
        createdBy : "c3bed8716ae14d6693b336dfce19d02e"
        deleted : null
        deletedBy : ""
        eventId : "b3b5117aba6249e49084a02d7a1c2c6e"
        facebookUrl : "https://www.facebook.com/pastpresentfutureshortfilm/"
        filmColor : "Color"
        filmDate : 1464739200000
        filmFormat : "DVD, Secure Online Screener"
        filmId : "d960f66d6ba54a55874d8a321458c9b6"
        filmSound : ""
        filmmakers : "Jessica Frierson, Jessica Frierson, Alex Perez"
        genres : "Drama, African American, Black, Disability Culture, Hispanic, Youth/Teen"
        haveDefaultPosterImage : true
        isAnimation : false
        isBlackAndWhile : false
        isDocumentary : false
        isFeature : false
        isNarrative : true
        isShort : true
        isStudent : false
        isSubtitled : false
        languages : "English"
        largePosterUrl : "https://s3-us-west-2.amazonaws.com/cdn.ptffportal.org/sedonafilmfestival/2017/reviewer/image/171134-large.jpg"
        live : true
        modified : 1477805302669
        modifiedBy : "709db6f5a68b404f8f5b879a5c43305f"
        notes : ""
        organizationId : "741cf26002ce4f248238f52d3f5c3351"
        otherSocialUrl : ""
        posterUrl : "https://s3-us-west-2.amazonaws.com/cdn.ptffportal.org/sedonafilmfestival/2017/reviewer/image/171134.jpg"
        programNotes : ""
        programVote : "reviewing"
        runtime : 14
        runtimeSeconds : 784
        screeningAwards : ""
        sortSubmissionId : "171134"
        submissionAcceptance : "UNDECIDED"
        submissionDate : 6312859286400000
        submissionDeadline : ""
        submissionDiscountCode : ""
        submissionFee : "25.00"
        submissionId : "171134"
        submissionPassword : ""
        submissionProvidedCdnPassword : "20thankyou16"
        submissionProvidedCdnTitle : "Past, Present, Future"
        submissionProvidedCdnUrl : "https://vimeo.com/171336032/"
        submissionRequiresPassword : false
        submissionSource : "withoutabox"
        submissionStatus : ""
        submissionTermsSigned : true
        submissionUrl : "https://www.withoutabox.com/01festival/01t_ent/01t_ent_rept.php?festival_id=1318&tracking_id=171134"
        submitterEmail : "jessicaschannel@gmail.com"
        submitterName : "Jessica Frierson"
        submitterPhone : "714-862-9546"
        subtitleLanguages : ""
        synopsis : "A teenager who's headed in the wrong direction has a life-changing encounter with a Vietnam veteran with PTSD. With the veteran believing he's still in Vietnam, he mistakes the teenager for his own rebellious brother whom he lost in the war."
        synopsisEnglish : ""
        synopsisOriginal : ""
        title : "Past, Present, Future"
        titleEnglish : ""
        titleOriginal : ""
        trailerUrl : ""
        twitterUrl : ""
        type : "short"
        types : "Narrative Fiction, Short, Short Films"
        viewMethod : "showCdn"
        vote : "accepted"
        websiteUrl : ""
        year : "2016"
        */
    };
    ReviewerFilmService.prototype.getAvailableFilms = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var userId = _this.authService.userId;
            _this.http.get(_this.config.basePath + '/v0/films/users/' + userId, options)
                .toPromise()
                .then(function (res) {
                var availableFilmIdInfo = res.json();
                // console.log('availableFilmIdInfo');
                // console.log(availableFilmIdInfo);
                var filmIds = availableFilmIdInfo.availableFilmIds.filmIds;
                // console.log('filmIds');
                // console.log(filmIds);
                // let sortedFilms = foo.allFilms.films.sort((a: any, b: any) => {
                // 	if (a.title.toLowerCase() === b.title.toLowerCase()) {
                // 		return 0;
                // 	}
                // 	if (a.title.toLowerCase() < b.title.toLowerCase()) {
                // 		return -1;
                // 	}
                // 	return 1;
                // 	// if (a.sortSubmissionId === b.sortSubmissionId) {
                // 	// 	return 0;
                // 	// }
                // 	// if (a.sortSubmissionId < b.sortSubmissionId) {
                // 	// 	return -1;
                // 	// }
                // 	// return 1;
                // });
                // foo.allFilms.films = sortedFilms;
                resolve(filmIds);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
            });
        });
    };
    ReviewerFilmService.prototype.getRecentFilmsIndexedDb = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            // init first time through, if can
            if (!_this.allFilms.films) {
                console.log('** first time through getRecentFilmsIndexedDb **');
                _this.cacheStorage.readIndexedDb(_this.cacheStorage.keys.allFilms)
                    .then(function (tempAllFilms) {
                    if (tempAllFilms && tempAllFilms.films) {
                        _this.allFilms = tempAllFilms;
                        _this.allFilmsWithArray = {};
                        _this.allFilmsWithArray.allFilms = {};
                        _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                        _this.allFilmsWithArray.allFilms.films = [];
                        Object.keys(_this.allFilms.films).forEach(function (filmId) {
                            var film = _this.allFilms.films[filmId];
                            _this.allFilmsWithArray.allFilms.films.push(film);
                        });
                    }
                    var modified = 0;
                    if (_this.allFilms.modified) {
                        modified = _this.allFilms.modified;
                    }
                    console.log('getRecentFilms modified');
                    console.log(modified);
                    var accessToken = localStorage.getItem('auth-jwt');
                    var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
                    var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
                    _this.http.get(_this.config.basePath + '/v0/films/date/' + modified, options)
                        .toPromise()
                        .then(function (res) {
                        var foo = res.json();
                        // films.allFilms.films
                        // console.log('foo');
                        // console.log(foo);
                        // console.log('foo.allFilms');
                        // console.log(foo.allFilms);
                        if (_this.allFilms.films) {
                            console.log('----  test if should update, count = ' + foo.allFilms.films.length);
                            if (foo.allFilms.films.length > 0) {
                                console.log('----  updating, count = ' + foo.allFilms.films.length);
                                foo.allFilms.films.forEach(function (film) {
                                    _this.trimFilm(film);
                                    _this.allFilms.films[film.filmId] = film;
                                });
                                _this.allFilms.modified = foo.allFilms.modified;
                                _this.cacheStorage.writeIndexedDb(_this.cacheStorage.keys.allFilms, _this.allFilms)
                                    .then(function () {
                                    _this.allFilmsWithArray = {};
                                    _this.allFilmsWithArray.allFilms = {};
                                    _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                                    _this.allFilmsWithArray.allFilms.films = [];
                                    Object.keys(_this.allFilms.films).forEach(function (filmId) {
                                        var film = _this.allFilms.films[filmId];
                                        _this.allFilmsWithArray.allFilms.films.push(film);
                                    });
                                    _this.sortTheFilms();
                                    resolve(_this.allFilmsWithArray);
                                })
                                    .catch(function (err) {
                                    // TODO - handle errors?
                                    _this.log.error(err);
                                    resolve();
                                });
                            }
                            else {
                                _this.sortTheFilms();
                                resolve(_this.allFilmsWithArray);
                            }
                        }
                        else {
                            console.log('----  first time through, count = ' + foo.allFilms.films.length);
                            // convert to object form
                            var objectAllFilms_2 = {};
                            objectAllFilms_2.modified = foo.allFilms.modified;
                            objectAllFilms_2.films = {};
                            foo.allFilms.films.forEach(function (film) {
                                _this.trimFilm(film);
                                objectAllFilms_2.films[film.filmId] = film;
                            });
                            _this.allFilms = objectAllFilms_2;
                            _this.cacheStorage.writeIndexedDb(_this.cacheStorage.keys.allFilms, _this.allFilms)
                                .then(function () {
                                _this.allFilmsWithArray = {};
                                _this.allFilmsWithArray.allFilms = {};
                                _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                                _this.allFilmsWithArray.allFilms.films = [];
                                Object.keys(_this.allFilms.films).forEach(function (filmId) {
                                    var film = _this.allFilms.films[filmId];
                                    _this.allFilmsWithArray.allFilms.films.push(film);
                                });
                                _this.sortTheFilms();
                                resolve(_this.allFilmsWithArray);
                            })
                                .catch(function (err) {
                                // TODO - handle errors?
                                _this.log.error(err);
                                _this.allFilmsWithArray = {};
                                _this.allFilmsWithArray.allFilms = {};
                                _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                                _this.allFilmsWithArray.allFilms.films = [];
                                Object.keys(_this.allFilms.films).forEach(function (filmId) {
                                    var film = _this.allFilms.films[filmId];
                                    _this.allFilmsWithArray.allFilms.films.push(film);
                                });
                                _this.sortTheFilms();
                                resolve(_this.allFilmsWithArray);
                            });
                            // this.allFilmsWithArray = {};
                            // this.allFilmsWithArray.allFilms = {};
                            // this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
                            // this.allFilmsWithArray.allFilms.films = [];
                            // Object.keys(this.allFilms.films).forEach((filmId) => {
                            // 	let film = this.allFilms.films[filmId];
                            // 	this.allFilmsWithArray.allFilms.films.push(film);
                            // });
                        }
                        // console.log('this.allFilms');
                        // console.log(this.allFilms);
                        // console.log('this.allFilmsWithArray');
                        // console.log(this.allFilmsWithArray);
                        // let sortedFilms = this.allFilmsWithArray.allFilms.films.sort((a: any, b: any) => {
                        // 	if (a.title.toLowerCase() === b.title.toLowerCase()) {
                        // 		return 0;
                        // 	}
                        // 	if (a.title.toLowerCase() < b.title.toLowerCase()) {
                        // 		return -1;
                        // 	}
                        // 	return 1;
                        // });
                        // this.allFilmsWithArray.allFilms.films = sortedFilms;
                        // resolve(this.allFilmsWithArray);
                    })
                        .catch(function (err) {
                        // TODO - handle errors?
                        _this.log.error(err);
                        // !!! TODO - check that all promise functions resolve or reject
                        resolve();
                    });
                })
                    .catch(function (errz) {
                    // TODO - handle errors?
                    // !!! TODO - should error, but continue
                    _this.log.error(errz);
                    var modified = 0;
                    if (_this.allFilms.modified) {
                        modified = _this.allFilms.modified;
                    }
                    console.log('getRecentFilms modified');
                    console.log(modified);
                    var accessToken = localStorage.getItem('auth-jwt');
                    var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
                    var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
                    _this.http.get(_this.config.basePath + '/v0/films/date/' + modified, options)
                        .toPromise()
                        .then(function (res) {
                        var foo = res.json();
                        // films.allFilms.films
                        // console.log('foo');
                        // console.log(foo);
                        // console.log('foo.allFilms');
                        // console.log(foo.allFilms);
                        // console.log('foo.allFilms.films.length');
                        // console.log(foo.allFilms.films.length);
                        if (_this.allFilms.films) {
                            console.log('----  test if should update, count = ' + foo.allFilms.films.length);
                            if (foo.allFilms.films.length > 0) {
                                console.log('----  updating, count = ' + foo.allFilms.films.length);
                                foo.allFilms.films.forEach(function (film) {
                                    _this.trimFilm(film);
                                    _this.allFilms.films[film.filmId] = film;
                                });
                                _this.allFilms.modified = foo.allFilms.modified;
                                _this.cacheStorage.writeIndexedDb(_this.cacheStorage.keys.allFilms, _this.allFilms)
                                    .then(function () {
                                    _this.allFilmsWithArray = {};
                                    _this.allFilmsWithArray.allFilms = {};
                                    _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                                    _this.allFilmsWithArray.allFilms.films = [];
                                    Object.keys(_this.allFilms.films).forEach(function (filmId) {
                                        var film = _this.allFilms.films[filmId];
                                        _this.allFilmsWithArray.allFilms.films.push(film);
                                    });
                                    _this.sortTheFilms();
                                    resolve(_this.allFilmsWithArray);
                                })
                                    .catch(function (err) {
                                    // TODO - handle errors?
                                    _this.log.error(err);
                                    resolve();
                                });
                            }
                            else {
                                _this.sortTheFilms();
                                resolve(_this.allFilmsWithArray);
                            }
                        }
                        else {
                            console.log('----  first time through, count = ' + foo.allFilms.films.length);
                            // convert to object form
                            var objectAllFilms_3 = {};
                            objectAllFilms_3.modified = foo.allFilms.modified;
                            objectAllFilms_3.films = {};
                            foo.allFilms.films.forEach(function (film) {
                                _this.trimFilm(film);
                                objectAllFilms_3.films[film.filmId] = film;
                            });
                            _this.allFilms = objectAllFilms_3;
                            _this.cacheStorage.writeIndexedDb(_this.cacheStorage.keys.allFilms, _this.allFilms)
                                .then(function () {
                                _this.allFilmsWithArray = {};
                                _this.allFilmsWithArray.allFilms = {};
                                _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                                _this.allFilmsWithArray.allFilms.films = [];
                                Object.keys(_this.allFilms.films).forEach(function (filmId) {
                                    var film = _this.allFilms.films[filmId];
                                    _this.allFilmsWithArray.allFilms.films.push(film);
                                });
                                _this.sortTheFilms();
                                resolve(_this.allFilmsWithArray);
                            })
                                .catch(function (err) {
                                // TODO - handle errors?
                                _this.log.error(err);
                                _this.allFilmsWithArray = {};
                                _this.allFilmsWithArray.allFilms = {};
                                _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                                _this.allFilmsWithArray.allFilms.films = [];
                                Object.keys(_this.allFilms.films).forEach(function (filmId) {
                                    var film = _this.allFilms.films[filmId];
                                    _this.allFilmsWithArray.allFilms.films.push(film);
                                });
                                _this.sortTheFilms();
                                resolve(_this.allFilmsWithArray);
                            });
                            // this.allFilmsWithArray = {};
                            // this.allFilmsWithArray.allFilms = {};
                            // this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
                            // this.allFilmsWithArray.allFilms.films = [];
                            // Object.keys(this.allFilms.films).forEach((filmId) => {
                            // 	let film = this.allFilms.films[filmId];
                            // 	this.allFilmsWithArray.allFilms.films.push(film);
                            // });
                        }
                        // console.log('this.allFilms');
                        // console.log(this.allFilms);
                        // console.log('this.allFilmsWithArray');
                        // console.log(this.allFilmsWithArray);
                        // let sortedFilms = this.allFilmsWithArray.allFilms.films.sort((a: any, b: any) => {
                        // 	if (a.title.toLowerCase() === b.title.toLowerCase()) {
                        // 		return 0;
                        // 	}
                        // 	if (a.title.toLowerCase() < b.title.toLowerCase()) {
                        // 		return -1;
                        // 	}
                        // 	return 1;
                        // });
                        // this.allFilmsWithArray.allFilms.films = sortedFilms;
                        // resolve(this.allFilmsWithArray);
                    })
                        .catch(function (err) {
                        // TODO - handle errors?
                        _this.log.error(err);
                        // !!! TODO - check that all promise functions resolve or reject
                        resolve();
                    });
                });
            }
            else {
                console.log('** already been through getRecentFilms **');
                var modified = 0;
                if (_this.allFilms.modified) {
                    modified = _this.allFilms.modified;
                }
                console.log('getRecentFilms modified');
                console.log(modified);
                var accessToken = localStorage.getItem('auth-jwt');
                var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
                var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
                _this.http.get(_this.config.basePath + '/v0/films/date/' + modified, options)
                    .toPromise()
                    .then(function (res) {
                    var foo = res.json();
                    // films.allFilms.films
                    // console.log('foo');
                    // console.log(foo);
                    // console.log('foo.allFilms');
                    // console.log(foo.allFilms);
                    // console.log('foo.allFilms.films.length');
                    // console.log(foo.allFilms.films.length);
                    if (_this.allFilms.films) {
                        console.log('----  test if should update, count = ' + foo.allFilms.films.length);
                        if (foo.allFilms.films.length > 0) {
                            console.log('----  updating, count = ' + foo.allFilms.films.length);
                            foo.allFilms.films.forEach(function (film) {
                                _this.trimFilm(film);
                                _this.allFilms.films[film.filmId] = film;
                            });
                            _this.allFilms.modified = foo.allFilms.modified;
                            _this.cacheStorage.writeIndexedDb(_this.cacheStorage.keys.allFilms, _this.allFilms)
                                .then(function () {
                                _this.allFilmsWithArray = {};
                                _this.allFilmsWithArray.allFilms = {};
                                _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                                _this.allFilmsWithArray.allFilms.films = [];
                                Object.keys(_this.allFilms.films).forEach(function (filmId) {
                                    var film = _this.allFilms.films[filmId];
                                    _this.allFilmsWithArray.allFilms.films.push(film);
                                });
                                _this.sortTheFilms();
                                resolve(_this.allFilmsWithArray);
                            })
                                .catch(function (err) {
                                // TODO - handle errors?
                                _this.log.error(err);
                                resolve();
                            });
                        }
                        else {
                            _this.sortTheFilms();
                            resolve(_this.allFilmsWithArray);
                        }
                    }
                    else {
                        console.log('----  first time through, count = ' + foo.allFilms.films.length);
                        // convert to object form
                        var objectAllFilms_4 = {};
                        objectAllFilms_4.modified = foo.allFilms.modified;
                        objectAllFilms_4.films = {};
                        foo.allFilms.films.forEach(function (film) {
                            _this.trimFilm(film);
                            objectAllFilms_4.films[film.filmId] = film;
                        });
                        _this.allFilms = objectAllFilms_4;
                        _this.cacheStorage.writeIndexedDb(_this.cacheStorage.keys.allFilms, _this.allFilms)
                            .then(function () {
                            _this.allFilmsWithArray = {};
                            _this.allFilmsWithArray.allFilms = {};
                            _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                            _this.allFilmsWithArray.allFilms.films = [];
                            Object.keys(_this.allFilms.films).forEach(function (filmId) {
                                var film = _this.allFilms.films[filmId];
                                _this.allFilmsWithArray.allFilms.films.push(film);
                            });
                            _this.sortTheFilms();
                            resolve(_this.allFilmsWithArray);
                        })
                            .catch(function (err) {
                            // TODO - handle errors?
                            _this.log.error(err);
                            _this.allFilmsWithArray = {};
                            _this.allFilmsWithArray.allFilms = {};
                            _this.allFilmsWithArray.allFilms.modfied = _this.allFilms.modified;
                            _this.allFilmsWithArray.allFilms.films = [];
                            Object.keys(_this.allFilms.films).forEach(function (filmId) {
                                var film = _this.allFilms.films[filmId];
                                _this.allFilmsWithArray.allFilms.films.push(film);
                            });
                            _this.sortTheFilms();
                            resolve(_this.allFilmsWithArray);
                        });
                        // this.allFilmsWithArray = {};
                        // this.allFilmsWithArray.allFilms = {};
                        // this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
                        // this.allFilmsWithArray.allFilms.films = [];
                        // Object.keys(this.allFilms.films).forEach((filmId) => {
                        // 	let film = this.allFilms.films[filmId];
                        // 	this.allFilmsWithArray.allFilms.films.push(film);
                        // });
                    }
                    // console.log('this.allFilms');
                    // console.log(this.allFilms);
                    // console.log('this.allFilmsWithArray');
                    // console.log(this.allFilmsWithArray);
                    // let sortedFilms = this.allFilmsWithArray.allFilms.films.sort((a: any, b: any) => {
                    // 	if (a.title.toLowerCase() === b.title.toLowerCase()) {
                    // 		return 0;
                    // 	}
                    // 	if (a.title.toLowerCase() < b.title.toLowerCase()) {
                    // 		return -1;
                    // 	}
                    // 	return 1;
                    // });
                    // this.allFilmsWithArray.allFilms.films = sortedFilms;
                    // resolve(this.allFilmsWithArray);
                })
                    .catch(function (err) {
                    // TODO - handle errors?
                    _this.log.error(err);
                    // !!! TODO - check that all promise functions resolve or reject
                    resolve();
                });
            }
            /*
                        if (!this.allFilms.films) {
                            // console.log('** first time through getRecentFilms **');
                            let tempAllFilms = this.cacheStorage.read(this.cacheStorage.keys.allFilms);
                            if (tempAllFilms && tempAllFilms.films) {
                                this.allFilms = tempAllFilms;
            
                                this.allFilmsWithArray = {};
                                this.allFilmsWithArray.allFilms = {};
                                this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
                                this.allFilmsWithArray.allFilms.films = [];
                                Object.keys(this.allFilms.films).forEach((filmId) => {
                                    let film = this.allFilms.films[filmId];
                                    this.allFilmsWithArray.allFilms.films.push(film);
                                });
                            }
                        }
            */
        });
    };
    ReviewerFilmService.prototype.sortTheFilms = function () {
        var sortedFilms = this.allFilmsWithArray.allFilms.films.sort(function (a, b) {
            if (a.title.toLowerCase() === b.title.toLowerCase()) {
                return 0;
            }
            if (a.title.toLowerCase() < b.title.toLowerCase()) {
                return -1;
            }
            return 1;
        });
        this.allFilmsWithArray.allFilms.films = sortedFilms;
    };
    /*
        getAvailableFilmsIndexedDb() {
            return new Promise( (resolve, reject) => {
    
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
                let options = new RequestOptions({ headers: headers });
    
                let userId = this.authService.userId;
                this.http.get(this.config.basePath + '/v0/films/users/' + userId, options)
                    .toPromise()
                    .then( (res) => {
                        let availableFilmIdInfo = res.json();
                        // console.log('availableFilmIdInfo');
                        // console.log(availableFilmIdInfo);
    
                        let filmIds = availableFilmIdInfo.availableFilmIds.filmIds;
    
                        // console.log('filmIds');
                        // console.log(filmIds);
                        // let sortedFilms = foo.allFilms.films.sort((a: any, b: any) => {
    
    
                        // 	if (a.title.toLowerCase() === b.title.toLowerCase()) {
                        // 		return 0;
                        // 	}
                        // 	if (a.title.toLowerCase() < b.title.toLowerCase()) {
                        // 		return -1;
                        // 	}
                        // 	return 1;
    
    
                        // 	// if (a.sortSubmissionId === b.sortSubmissionId) {
                        // 	// 	return 0;
                        // 	// }
                        // 	// if (a.sortSubmissionId < b.sortSubmissionId) {
                        // 	// 	return -1;
                        // 	// }
                        // 	// return 1;
                        // });
                        // foo.allFilms.films = sortedFilms;
                        resolve(filmIds);
                    })
                    .catch((err) => {			// this is a Response object, with res.status === 401, for example
                        // TODO - handle errors?
                        this.log.error(err);
                    });
            });
        }
    */
    ReviewerFilmService.prototype.setFilmLiveState = function (filmId, state) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filmId: filmId,
                live: state
            };
            var body = JSON.stringify(payload);
            _this.http.put(_this.config.basePath + '/v0/films/' + filmId, body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                console.log(foo);
                // let bar: any = foo;
                resolve();
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.saveAcknowledgementSentDate = function (filmId, acknowledgementCommunicationId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filmId: filmId,
                acknowledgementSentDate: Date.now(),
                acknowledgementCommunicationId: acknowledgementCommunicationId
            };
            var body = JSON.stringify(payload);
            _this.http.put(_this.config.basePath + '/v0/films/' + filmId, body, options)
                .toPromise()
                .then(function (res) {
                // let foo = res.json();
                // console.log(foo);
                // let bar: any = foo;
                resolve();
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.saveAcceptLetterSentDate = function (filmId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filmId: filmId,
                acceptanceSentDate: Date.now()
            };
            var body = JSON.stringify(payload);
            _this.http.put(_this.config.basePath + '/v0/films/' + filmId, body, options)
                .toPromise()
                .then(function (res) {
                // let foo = res.json();
                // console.log(foo);
                // let bar: any = foo;
                resolve();
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.saveRejectLetterSentDate = function (filmId, rejectionCommunicationId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filmId: filmId,
                rejectionSentDate: Date.now(),
                rejectionCommunicationId: rejectionCommunicationId
            };
            var body = JSON.stringify(payload);
            _this.http.put(_this.config.basePath + '/v0/films/' + filmId, body, options)
                .toPromise()
                .then(function (res) {
                // let result = res.json();
                // console.log(foo);
                // let bar: any = foo;
                resolve();
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                console.log(err);
                reject(err);
            });
        });
    };
    ReviewerFilmService.prototype.createFilm = function (newFilmData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = newFilmData;
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/films', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                console.log(foo);
                var bar = foo;
                resolve(bar);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.updateFilm = function (filmUpdates) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = filmUpdates;
            var body = JSON.stringify(payload);
            _this.http.put(_this.config.basePath + '/v0/films/' + filmUpdates.filmId, body, options)
                .toPromise()
                .then(function (res) {
                // let foo = res.json();
                // console.log(foo);
                // let bar: any = foo;
                resolve();
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.exportProgramFilms = function (filename, data) {
        // console.log('<------ exportProgramFilms -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/films/program', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log('returned from exportProgramFilms');
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.exportReviewerStats = function (filename, data) {
        // console.log('<------ exportReviewerStats -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/films/reviewerstats', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log('returned from exportReviewerStats');
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.exportCampaignUsers = function (filename, data) {
        // console.log('<------ exportCampaignUsers -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/users/campaign', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log('returned from exportProgramFilms');
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.agileExport = function (filename, data) {
        // console.log('<------ exportProgramFilms -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/films/agile', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log('returned from exportProgramFilms');
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.gridLabelExport = function (filename, data) {
        // console.log('<------ gridLabelExport -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/grids/labels', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log('returned from gridLabelExport');
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.gridPresenterNotesExport = function (filename, data) {
        // console.log('<------ gridPresenterNotesExport -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/grids/presenternotes', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log('returned from gridLabelExport');
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.gridBallotExport = function (filename, data) {
        // console.log('<------ gridBallotExport -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/grids/ballots', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log('returned from gridLabelExport');
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject(err);
            });
        });
    };
    ReviewerFilmService.prototype.gridBallotSheetsExport = function (filename, data) {
        // console.log('<------ gridBallotExport -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/grids/sheets', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log('returned from gridLabelExport');
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject(err);
            });
        });
    };
    ReviewerFilmService.prototype.exportFilmContacts = function (filename, data) {
        // console.log('<------ exportFilmContacts -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/films/contacts', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log('returned from exportProgramFilms');
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.exportFilmsWithLinks = function (filename, data) {
        // console.log('<------ exportFilmsWithLinks -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/films/filmswithlinks', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                resolve(result);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                console.log(err);
                reject(err);
            });
        });
    };
    ReviewerFilmService.prototype.exportFilmNames = function (filename, data) {
        // console.log('<------ exportFilmNames -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/films/filmnames', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                resolve(result);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                console.log(err);
                reject(err);
            });
        });
    };
    ReviewerFilmService.prototype.exportReelTimely = function (filename, data) {
        // console.log('<------ exportReelTimely -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/grids/reeltimely', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                resolve(result);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                console.log(err);
                reject(err);
            });
        });
    };
    ReviewerFilmService.prototype.exportEventive = function (filename, data) {
        // console.log('<------ exportEventive -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/grids/eventive', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                resolve(result);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                console.log(err);
                reject(err);
            });
        });
    };
    ReviewerFilmService.prototype.exportCustomProgram = function (filename, data) {
        // console.log('<------ exportCustomProgram -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/grids/customprogram', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                resolve(result);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                console.log(err);
                reject(err);
            });
        });
    };
    ReviewerFilmService.prototype.exportBallotResults = function (filename, data) {
        // console.log('<------ exportBallotResults -------->');
        // console.log('filename');
        // console.log(filename);
        // console.log('data');
        // console.log(data);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/grids/ballotresults', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log('returned from exportProgramFilms');
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.exportFile = function (filename, data) {
        var _this = this;
        console.log('<------ exportProgramFilms -------->');
        console.log('filename');
        console.log(filename);
        // console.log('data');
        // console.log(data);
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                filename: filename,
                data: data
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/files', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log('returned from exportProgramFilms');
                console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    ReviewerFilmService.prototype.createFilmUrls = function (submissionId) {
        // console.log('<------ createFilmUrls -------->');
        // console.log('submissionId');
        // console.log(submissionId);
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {};
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/films/urls/' + submissionId, body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log('returned from createFilmUrls');
                // console.log(foo);
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    /*
        importFilmFreeway(newFilmData: any) {
            return new Promise( (resolve, reject) => {
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
                headers.append('Content-Type', 'application/json');
                let options = new RequestOptions({ headers: headers });
    
                let payload = newFilmData;
                let body = JSON.stringify(payload);
    
    
    
    
    
                this.http.post(this.config.basePath + '/v0/films', body, options)
                    .toPromise()
                    .then((res) => {
                        let foo = res.json();
                        console.log(foo);
                        let bar: any = foo;
                        resolve(bar);
                    })
                    .catch((err) => {			// this is a Response object, with res.status === 401, for example
                        // TODO - handle errors?
                        this.log.error(err);
                        reject();
                    });
            });
    
    
    
                var target = document.getElementById('filmFreewayFilnameId');
                var uploadUrl = apiHost + '/v0/films/filmfreeway';
                var formData = new FormData();
                formData.append('filmsfile', target.files[0]);
    
                $http.post(uploadUrl, formData, {
                    transformRequest: angular.identity,
                    headers: {'Content-Type': undefined}
                })
                .success(function(data, status, headers, config) {
    //				console.log('got here #u1');
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    ToastService.showMessage('FilmFreeway films uploaded successfully!');
                })
                .error(function(data, status, headers, config) {
    //				console.log('got here #u2');
    
                    Log.warn('Could not upload to FilmFreeway.');
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    ToastService.showMessage('The server is not available, please try again later.');
                });
    
    
    
    
        }
    */
    ReviewerFilmService.prototype.importWithoutabox = function () {
    };
    ReviewerFilmService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__cache_storage_service__["a" /* CacheStorageService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_4__log_service__["a" /* LogService */] }]; };
    return ReviewerFilmService;
}());

//# sourceMappingURL=reviewer-film.service.js.map

/***/ }),

/***/ "POd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MyIndexedDbService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log_service__ = __webpack_require__("B1/m");




var Utils = (function () {
    function Utils() {
        this.indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
        // this.dbMode = {
        // 	readOnly: 'readonly',
        // 	readWrite: 'readwrite'
        // };
    }
    return Utils;
}());
// interface DbMode {
// 	readOnly: string;
// 	readWrite: string;
// }
var DbWrapper = (function () {
    function DbWrapper(dbName, version) {
        this.dbName = dbName;
        this.dbVersion = version || 1;
        this.db = null;
    }
    DbWrapper.prototype.validateStoreName = function (storeName) {
        return this.db.objectStoreNames.contains(storeName);
    };
    DbWrapper.prototype.validateBeforeTransaction = function (storeName, reject) {
        if (!this.db) {
            reject('You need to use the createStore function to create a database before you query it!');
        }
        if (!this.validateStoreName(storeName)) {
            reject(('objectStore does not exists: ' + storeName));
        }
    };
    DbWrapper.prototype.createTransaction = function (options) {
        var trans = this.db.transaction(options.storeName, options.dbMode);
        trans.onerror = options.error;
        trans.oncomplete = options.complete;
        trans.onabort = options.abort;
        return trans;
    };
    DbWrapper.prototype.close = function () {
        if (this.db) {
            this.db.close();
        }
    };
    DbWrapper.prototype.getDb = function () {
        return this.db;
    };
    return DbWrapper;
}());
var AngularIndexedDB = (function () {
    function AngularIndexedDB(dbName, version) {
        this.utils = new Utils();
        this.dbWrapper = new DbWrapper(dbName, version);
    }
    AngularIndexedDB.prototype.createStore = function (version, upgradeCallback) {
        var _this = this;
        var self = this, promise = new Promise(function (resolve, reject) {
            _this.dbWrapper.dbVersion = version;
            console.log('about to open db with version = ' + version);
            var request = _this.utils.indexedDB.open(_this.dbWrapper.dbName, version);
            request.onsuccess = function (e) {
                console.log('onsuccess, during open db');
                self.dbWrapper.db = request.result;
                resolve();
            };
            request.onerror = function (e) {
                console.log('onerror, during open db');
                console.log(e);
                // reject('IndexedDB error: ' + (<any>e.target).errorCode);
                reject('IndexedDB error: ' + e.target.error.message);
                // reject('IndexedDB error: ' + e.target.error.message);
            };
            request.onupgradeneeded = function (e) {
                console.log('onupgradeneeded, during open db');
                upgradeCallback(e, self.dbWrapper.db);
            };
        });
        return promise;
    };
    AngularIndexedDB.prototype.getByKey = function (storeName, key) {
        var self = this;
        var promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var transaction = self.dbWrapper.createTransaction({ storeName: storeName,
                dbMode: 'readonly',
                // dbMode: self.utils.dbMode.readOnly .readOnly,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                }
            }), objectStore = transaction.objectStore(storeName), request;
            request = objectStore.get(key);
            request.onsuccess = function (event) {
                resolve(event.target.result);
            };
        });
        return promise;
    };
    AngularIndexedDB.prototype.getAll = function (storeName, keyRange) {
        var self = this;
        var promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var transaction = self.dbWrapper.createTransaction({ storeName: storeName,
                dbMode: 'readonly',
                // dbMode: self.utils.dbMode.readOnly,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                }
            }), objectStore = transaction.objectStore(storeName), result = [], request = objectStore.openCursor(keyRange);
            request.onerror = function (e) {
                reject(e);
            };
            request.onsuccess = function (evt) {
                var cursor = evt.target.result;
                if (cursor) {
                    result.push(cursor.value);
                    cursor['continue']();
                }
                else {
                    resolve(result);
                }
            };
        });
        return promise;
    };
    AngularIndexedDB.prototype.add = function (storeName, value, key) {
        var self = this;
        var promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var transaction = self.dbWrapper.createTransaction({ storeName: storeName,
                dbMode: 'readwrite',
                // dbMode: self.utils.dbMode.readWrite,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                    resolve({ key: key, value: value });
                }
            }), objectStore = transaction.objectStore(storeName);
            objectStore.add(value, key);
        });
        return promise;
    };
    AngularIndexedDB.prototype.update = function (storeName, value, key) {
        var self = this;
        var promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var transaction = self.dbWrapper.createTransaction({ storeName: storeName,
                dbMode: 'readwrite',
                // dbMode: self.utils.dbMode.readWrite,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                    resolve(value);
                },
                abort: function (e) {
                    reject(e);
                }
            }), objectStore = transaction.objectStore(storeName);
            objectStore.put(value, key);
        });
        return promise;
    };
    AngularIndexedDB.prototype.delete = function (storeName, key) {
        var self = this;
        var promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var transaction = self.dbWrapper.createTransaction({ storeName: storeName,
                dbMode: 'readwrite',
                // dbMode: self.utils.dbMode.readWrite,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                    resolve();
                },
                abort: function (e) {
                    reject(e);
                }
            }), objectStore = transaction.objectStore(storeName);
            objectStore['delete'](key);
        });
        return promise;
    };
    AngularIndexedDB.prototype.openCursor = function (storeName, cursorCallback, keyRange) {
        var self = this;
        var promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var transaction = self.dbWrapper.createTransaction({ storeName: storeName,
                dbMode: 'readonly',
                // dbMode: self.utils.dbMode.readOnly,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                    resolve();
                },
                abort: function (e) {
                    reject(e);
                }
            }), objectStore = transaction.objectStore(storeName), request = objectStore.openCursor(keyRange);
            request.onsuccess = function (evt) {
                cursorCallback(evt);
                resolve();
            };
        });
        return promise;
    };
    AngularIndexedDB.prototype.clear = function (storeName) {
        var self = this;
        var promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var transaction = self.dbWrapper.createTransaction({ storeName: storeName,
                dbMode: 'readwrite',
                // dbMode: self.utils.dbMode.readWrite,
                error: function (e) {
                    reject(e);
                },
                complete: function (e) {
                    resolve();
                },
                abort: function (e) {
                    reject(e);
                }
            }), objectStore = transaction.objectStore(storeName);
            objectStore.clear();
            resolve();
        });
        return promise;
    };
    AngularIndexedDB.prototype.getByIndex = function (storeName, indexName, key) {
        var self = this;
        var promise = new Promise(function (resolve, reject) {
            self.dbWrapper.validateBeforeTransaction(storeName, reject);
            var transaction = self.dbWrapper.createTransaction({ storeName: storeName,
                dbMode: 'readonly',
                // dbMode: self.utils.dbMode.readOnly,
                error: function (e) {
                    reject(e);
                },
                abort: function (e) {
                    reject(e);
                },
                complete: function (e) {
                }
            }), objectStore = transaction.objectStore(storeName), index = objectStore.index(indexName), request = index.get(key);
            request.onsuccess = function (event) {
                resolve(event.target.result);
            };
        });
        return promise;
    };
    AngularIndexedDB.prototype.close = function () {
        if (this.dbWrapper) {
            this.dbWrapper.close();
        }
    };
    AngularIndexedDB.prototype.getDb = function () {
        if (this.dbWrapper) {
            this.dbWrapper.getDb();
        }
        else {
            return null;
        }
    };
    return AngularIndexedDB;
}());
var MyIndexedDbService = (function () {
    function MyIndexedDbService(http, authService, config, log) {
        this.http = http;
        this.authService = authService;
        this.config = config;
        this.log = log;
    }
    MyIndexedDbService.prototype.createDb = function (dbName, version) {
        // console.log('MyIndexedDbService, createDb');
        // console.log('dbName');
        // console.log(dbName);
        // console.log('version');
        // console.log(version);
        this.theDb = new AngularIndexedDB(dbName, version);
        // console.log('this.theDb');
        // console.log(this.theDb);
        return this.theDb;
    };
    MyIndexedDbService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__log_service__["a" /* LogService */] }]; };
    return MyIndexedDbService;
}());

//# sourceMappingURL=myindexeddb.service.js.map

/***/ }),

/***/ "RsOe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AllEventsResolver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("AP4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_service__ = __webpack_require__("DDzU");


var AllEventsResolver = (function () {
    function AllEventsResolver(eventService) {
        this.eventService = eventService;
        this.params = {};
    }
    AllEventsResolver.prototype.resolve = function (route, state) {
        // console.log('AllFilmsResolver called    #1');
        // let startResolve = Date.now();
        var _this = this;
        this.params = JSON.parse(JSON.stringify(route.params));
        var thePromise = new Promise(function (resolve, reject) {
            // this.reviewerFilmService.getFilms()
            _this.eventService.getEvents()
                .then(function (events) {
                // let endResolve = Date.now();
                // console.log('AllFilmsResolver called    #2, took ' + (endResolve - startResolve) + ' msec' );
                var allEventsInfo = {
                    allEvents: events.allEvents.events,
                    params: _this.params
                };
                return resolve(allEventsInfo);
            })
                .catch(function (err) {
                return reject(err);
            });
        });
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(thePromise);
    };
    AllEventsResolver.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__event_service__["a" /* EventService */] }]; };
    return AllEventsResolver;
}());

//# sourceMappingURL=all-events.resolver.js.map

/***/ }),

/***/ "SlU0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoLoginService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log_service__ = __webpack_require__("B1/m");

// import {Http, Response} from '@angular/http';



var AutoLoginService = (function () {
    function AutoLoginService(http, authService, config, log) {
        this.http = http;
        this.authService = authService;
        this.config = config;
        this.log = log;
        // private lastVersionChecked = '';
        // private timeLastVersionChecked = 0;
        this.autoLogin = {
            enableAutoLogin: false,
            filmFreeway: Date.now(),
            withoutabox: Date.now(),
            vimeo: {}
        };
    }
    AutoLoginService.prototype.touch = function (loginType, filmId) {
        if (filmId === void 0) { filmId = ''; }
        console.log("'AutoLoginService touch: " + loginType + " " + filmId);
        if (!window.localStorage) {
            console.log('Browser does not support local storage.');
            return;
        }
        var autoLogin = {};
        var autoLoginString = localStorage.getItem('auto-login');
        if (autoLoginString) {
            autoLogin = JSON.parse(autoLoginString);
        }
        if (loginType === 'vimeo') {
            if (!filmId) {
                return;
            }
            autoLogin.vimeo = autoLogin.vimeo || {};
            autoLogin.vimeo[filmId] = Date.now();
        }
        else {
            autoLogin[loginType] = Date.now();
        }
        autoLoginString = JSON.stringify(autoLogin);
        localStorage.setItem('auto-login', autoLoginString);
    };
    // TODO!!! - walk the full list of prior logins, purge any that have expired
    AutoLoginService.prototype.isLoggedIn = function (loginType, filmId) {
        if (filmId === void 0) { filmId = ''; }
        if (!window.localStorage) {
            console.log('Browser does not support local storage.');
            return false;
        }
        var autoLoginString = localStorage.getItem('auto-login');
        if (!autoLoginString) {
            return false;
        }
        var autoLogin = JSON.parse(autoLoginString);
        if (loginType === 'vimeo') {
            // console.log('isLoggedIn, #1');
            if (!filmId) {
                return false;
            }
            // console.log('isLoggedIn, #2');
            // vimeos are logged in for 45 minutes
            var lastTouch = autoLogin.vimeo[filmId];
            if (!lastTouch) {
                return false;
            }
            // console.log('isLoggedIn, #3');
            // console.log('lastTouch:');
            // console.log(lastTouch);
            var toCompare = lastTouch + 45 * 60 * 1000;
            var now = Date.now();
            var diff = toCompare - now;
            if (diff > 0) {
                console.log('isLoggedIn, minutes remaining = ' + (diff / 60 / 1000));
            }
            else {
                console.log('isLoggedIn, no longer logged in');
            }
            if (lastTouch + 45 * 60 * 1000 > Date.now()) {
                console.log('isLoggedIn, is logged in');
                return true;
            }
            else {
                console.log('isLoggedIn, is NOT logged in');
                return false;
            }
        }
        else if (loginType === 'filmFreeway') {
            // filmFreeways are logged in for 3 days - 5 minutes
            var lastTouch = autoLogin.filmFreeway;
            if (!lastTouch) {
                return false;
            }
            if (lastTouch + 3 * 24 * 60 * 60 * 1000 - 5 * 60 * 1000 > Date.now()) {
                return true;
            }
            else {
                return false;
            }
        }
        else if (loginType === 'withoutabox') {
            // withoutaboxs are logged in for 1 day - 5 minutes
            var lastTouch = autoLogin.filmFreeway;
            if (!lastTouch) {
                return false;
            }
            if (lastTouch + 1 * 24 * 60 * 60 * 1000 - 5 * 60 * 1000 > Date.now()) {
                return true;
            }
            else {
                return false;
            }
        }
        return false;
    };
    AutoLoginService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__log_service__["a" /* LogService */] }]; };
    return AutoLoginService;
}());

//# sourceMappingURL=auto-login.service.js.map

/***/ }),

/***/ "Tlsw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VersionService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__log_service__ = __webpack_require__("B1/m");



var VersionService = (function () {
    function VersionService(http, config, log) {
        this.http = http;
        this.config = config;
        this.log = log;
        this.lastVersionChecked = '';
        this.timeLastVersionChecked = 0;
        this.uiVersion = {
            version: '0.0.93',
            gitSha: '37c5667e63073a9d020a21ab7e1b11dee3f34589',
            environment: this.config.environment,
            libVersion: '0.0.9'
        };
    }
    VersionService.prototype.getVersion = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.http.get(_this.config.basePath + '/v0/version')
                .subscribe(function (res) {
                var result = {
                    apiVersion: res.json(),
                    uiVersion: _this.uiVersion
                };
                resolve(result);
            });
        });
    };
    VersionService.prototype.isNewVersion = function (ver) {
        if (ver === this.uiVersion.version) {
            // console.log('isNewVersion, same versions');
            // console.log(`lastVersionChecked = ${this.lastVersionChecked}`);
            // console.log(`timeLastVersionChecked = ${this.timeLastVersionChecked}`);
            return false;
        }
        if (!window.localStorage) {
            console.log('Browser does not support local storage.');
            return false;
        }
        var checkVersionString = localStorage.getItem('check-version');
        if (checkVersionString) {
            var checkVersion = JSON.parse(checkVersionString);
            this.lastVersionChecked = checkVersion.version;
            this.timeLastVersionChecked = checkVersion.modified;
        }
        if (ver !== this.lastVersionChecked) {
            // console.log('isNewVersion, found new version, that has not been checked');
            // console.log(`lastVersionChecked = ${this.lastVersionChecked}`);
            // console.log(`timeLastVersionChecked = ${this.timeLastVersionChecked}`);
            this.lastVersionChecked = ver;
            this.timeLastVersionChecked = Date.now();
            var checkVersion = {
                version: this.lastVersionChecked,
                modified: this.timeLastVersionChecked
            };
            var checkVersionStringz = JSON.stringify(checkVersion);
            localStorage.setItem('check-version', checkVersionStringz);
            return true;
        }
        var isTimeForNextCheck = (Date.now() > (this.timeLastVersionChecked + 60 * 60 * 1000));
        // let isTimeForNextCheck = (Date.now() > (this.timeLastVersionChecked + 8 * 1000) );
        if (isTimeForNextCheck) {
            this.log.warn('isNewVersion, found new version, that has been checked, time to check again. current ' + this.uiVersion.version + ', new ' + ver);
            // console.log(`lastVersionChecked = ${this.lastVersionChecked}`);
            // console.log(`timeLastVersionChecked = ${this.timeLastVersionChecked}`);
            this.timeLastVersionChecked = Date.now();
            var checkVersion = {
                version: this.lastVersionChecked,
                modified: this.timeLastVersionChecked
            };
            var checkVersionStringx = JSON.stringify(checkVersion);
            localStorage.setItem('check-version', checkVersionStringx);
            return true;
        }
        // console.log('isNewVersion, found new version, that has been checked, wait to check again');
        // console.log(`lastVersionChecked = ${this.lastVersionChecked}`);
        // console.log(`timeLastVersionChecked = ${this.timeLastVersionChecked}`);
        return false;
    };
    VersionService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__log_service__["a" /* LogService */] }]; };
    return VersionService;
}());

//# sourceMappingURL=version.service.js.map

/***/ }),

/***/ "W6ZD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/dialog/dialog.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}.modal[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{display:none;width:100%}.modal[_ngcontent-%COMP%]{position:fixed;z-index:100;left:0;top:0;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,.4)}.modal-content[_ngcontent-%COMP%]{position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:95%;max-width:35em;max-height:100vh}.close[_ngcontent-%COMP%]{color:#fff;float:right;font-size:28px;font-weight:700}.close[_ngcontent-%COMP%]:focus, .close[_ngcontent-%COMP%]:hover{color:#000;text-decoration:none;cursor:pointer}.modal-header[_ngcontent-%COMP%]{background-color:#5cb85c;color:#fff}.modal-body[_ngcontent-%COMP%], .modal-footer[_ngcontent-%COMP%], .modal-header[_ngcontent-%COMP%]{padding:2px 16px}.modal-footer[_ngcontent-%COMP%]{background-color:#5cb85c;color:#fff}p[_ngcontent-%COMP%]{margin:0}button[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-size:1.14em;line-height:1.88em;font-family:Roboto,Helvetica Neue,"sans-serif";-webkit-font-smoothing:antialiased}.ok-button[_ngcontent-%COMP%]{color:#2196f3}mat-card-title[_ngcontent-%COMP%]{line-height:normal}@media (hover:none){[mat-button][_ngcontent-%COMP%]:hover:after{content:none}}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9kaWFsb2cvZGlhbG9nLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9kaWFsb2cvZGlhbG9nLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=dialog.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/core/@angular/core.es5.js
var core_es5 = __webpack_require__("/oeL");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/card/typings/index.ngfactory.ts
var index_ngfactory = __webpack_require__("z4MQ");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/core.es5.js
var esm5_core_es5 = __webpack_require__("j5BN");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/card.es5.js
var card_es5 = __webpack_require__("Ioj9");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/common/@angular/common.es5.js
var common_es5 = __webpack_require__("qbdv");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/dialog/dialog.component.ts
var dialog_component = __webpack_require__("0yio");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/button/typings/index.ngfactory.ts
var typings_index_ngfactory = __webpack_require__("wjk8");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/button.es5.js
var button_es5 = __webpack_require__("ghl+");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/platform.es5.js
var platform_es5 = __webpack_require__("V8+5");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/a11y.es5.js
var a11y_es5 = __webpack_require__("8Xfy");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/platform-browser/@angular/platform-browser.es5.js
var platform_browser_es5 = __webpack_require__("fc+i");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/dialog/dialog.component.ngfactory.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenderType_DialogComponent; });
/* harmony export (immutable) */ __webpack_exports__["b"] = View_DialogComponent_0;
/* unused harmony export View_DialogComponent_Host_0 */
/* unused harmony export DialogComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_DialogComponent = [styles];
var RenderType_DialogComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_DialogComponent, data: {} });
function View_DialogComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'a', [['style',
                'color: #2196F3; cursor: pointer; font-size: 1.14em; font-weight: normal;'],
            ['target', '_blank']], [[8, 'href', 4]], null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['\n						', '\n					']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', _co.helpUrlString, '');
        _ck(_v, 0, 0, currVal_0);
        var currVal_1 = _co.helpUrlLabel;
        _ck(_v, 1, 0, currVal_1);
    });
}
function View_DialogComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 51, 'section', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 48, 'div', [['class', 'modal'], ['id', 'myModal']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), (_l()(),
            core_es5["ɵeld"](4, 0, null, null, 45, 'div', [['class', 'modal-content']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n			'])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 42, 'mat-card', [['class', 'mat-card']], null, null, null, index_ngfactory["b" /* View_MatCard_0 */], index_ngfactory["a" /* RenderType_MatCard */])), core_es5["ɵdid"](7, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null),
        core_es5["ɵdid"](8, 49152, null, 0, card_es5["a" /* MatCard */], [], null, null),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n				'])), (_l()(), core_es5["ɵeld"](10, 0, null, 0, 3, 'mat-card-title', [['class', 'mat-card-title']], null, null, null, null, null)), core_es5["ɵdid"](11, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](12, 16384, null, 0, card_es5["f" /* MatCardTitle */], [], null, null), (_l()(), core_es5["ɵted"](13, null, ['', ''])), (_l()(), core_es5["ɵted"](-1, 0, ['   \n				'])), (_l()(), core_es5["ɵeld"](15, 0, null, 0, 12, 'mat-card-content', [['class', 'mat-card-content']], null, null, null, null, null)), core_es5["ɵdid"](16, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](17, 16384, null, 0, card_es5["c" /* MatCardContent */], [], null, null),
        (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵeld"](19, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](20, null, ['', ''])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵeld"](22, 0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](23, null, ['', ''])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_DialogComponent_1)), core_es5["ɵdid"](26, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n				'])), (_l()(), core_es5["ɵeld"](29, 0, null, 0, 18, 'mat-card-actions', [['class', 'mat-card-actions']], [[2, 'mat-card-actions-align-end', null]], null, null, null, null)), core_es5["ɵdid"](30, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null),
        core_es5["ɵdid"](31, 16384, null, 0, card_es5["b" /* MatCardActions */], [], null, null), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵeld"](33, 0, null, null, 13, 'div', [['itd-flex-container-row-end-start',
                '']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n						'])), (_l()(), core_es5["ɵeld"](35, 0, null, null, 4, 'button', [['class', 'mat-button'], ['id', 'cancelButton'], ['mat-button',
                '']], [[8, 'disabled', 0]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onCancel() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, typings_index_ngfactory["d" /* View_MatButton_0 */], typings_index_ngfactory["b" /* RenderType_MatButton */])), core_es5["ɵdid"](36, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](37, 180224, null, 0, button_es5["b" /* MatButton */], [core_es5["Renderer2"], core_es5["ElementRef"], platform_es5["a" /* Platform */],
            a11y_es5["i" /* FocusMonitor */]], null, null), core_es5["ɵdid"](38, 16384, null, 0, button_es5["c" /* MatButtonCssMatStyler */], [], null, null), (_l()(),
            core_es5["ɵted"](39, 0, ['', ''])), (_l()(), core_es5["ɵted"](-1, null, ['\n						'])), (_l()(),
            core_es5["ɵeld"](41, 0, null, null, 4, 'button', [['class', 'ok-button mat-button'],
                ['id', 'okButton'], ['mat-button', '']], [[8, 'disabled', 0]], [[null,
                    'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (_co.onOk() !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, typings_index_ngfactory["d" /* View_MatButton_0 */], typings_index_ngfactory["b" /* RenderType_MatButton */])), core_es5["ɵdid"](42, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](43, 180224, null, 0, button_es5["b" /* MatButton */], [core_es5["Renderer2"], core_es5["ElementRef"], platform_es5["a" /* Platform */],
            a11y_es5["i" /* FocusMonitor */]], null, null), core_es5["ɵdid"](44, 16384, null, 0, button_es5["c" /* MatButtonCssMatStyler */], [], null, null), (_l()(),
            core_es5["ɵted"](45, 0, ['', ''])), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n			'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n\n		'])), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_3 = (_co.helpUrlString.length > 0);
        _ck(_v, 26, 0, currVal_3);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.title;
        _ck(_v, 13, 0, currVal_0);
        var currVal_1 = _co.content1;
        _ck(_v, 20, 0, currVal_1);
        var currVal_2 = _co.content2;
        _ck(_v, 23, 0, currVal_2);
        var currVal_4 = (core_es5["ɵnov"](_v, 31).align === 'end');
        _ck(_v, 29, 0, currVal_4);
        var currVal_5 = (core_es5["ɵnov"](_v, 37).disabled || null);
        _ck(_v, 35, 0, currVal_5);
        var currVal_6 = _co.cancel;
        _ck(_v, 39, 0, currVal_6);
        var currVal_7 = (core_es5["ɵnov"](_v, 43).disabled || null);
        _ck(_v, 41, 0, currVal_7);
        var currVal_8 = _co.ok;
        _ck(_v, 45, 0, currVal_8);
    });
}
function View_DialogComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'itd-dialog', [], null, null, null, View_DialogComponent_0, RenderType_DialogComponent)), core_es5["ɵdid"](1, 114688, null, 0, dialog_component["a" /* DialogComponent */], [platform_browser_es5["c" /* DomSanitizer */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var DialogComponentNgFactory = core_es5["ɵccf"]('itd-dialog', dialog_component["a" /* DialogComponent */], View_DialogComponent_Host_0, { title: 'title', content1: 'content1',
    content2: 'content2', ok: 'ok', cancel: 'cancel', data: 'data', helpUrlLabel: 'helpUrlLabel',
    helpUrlString: 'helpUrlString' }, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9kaWFsb2cvZGlhbG9nLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9wYXQvc291cmNlL2l0ZGV2aWNlcy9naXRsYWIvb2NlYW5ibHVmZnByb2R1Y3Rpb25zL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy11aS9zcmMvYXBwL21vZHVsZXMvc2hhcmVkL2NvbXBvbmVudHMvZGlhbG9nL2RpYWxvZy5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9wYXQvc291cmNlL2l0ZGV2aWNlcy9naXRsYWIvb2NlYW5ibHVmZnByb2R1Y3Rpb25zL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy11aS9zcmMvYXBwL21vZHVsZXMvc2hhcmVkL2NvbXBvbmVudHMvZGlhbG9nL2RpYWxvZy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvbW9kdWxlcy9zaGFyZWQvY29tcG9uZW50cy9kaWFsb2cvZGlhbG9nLmNvbXBvbmVudC50cy5EaWFsb2dDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c2VjdGlvbj5cblx0PGRpdiBpZD1cIm15TW9kYWxcIiBjbGFzcz1cIm1vZGFsXCIgPlxuXHRcdDxkaXYgY2xhc3M9XCJtb2RhbC1jb250ZW50XCIgPlxuXG5cdFx0XHQ8bWF0LWNhcmQgPlxuXHRcdFx0XHQ8bWF0LWNhcmQtdGl0bGU+e3t0aXRsZX19PC9tYXQtY2FyZC10aXRsZT4gICBcblx0XHRcdFx0PG1hdC1jYXJkLWNvbnRlbnQ+XG5cdFx0XHRcdFx0PHA+e3tjb250ZW50MX19PC9wPlxuXHRcdFx0XHRcdDxwPnt7Y29udGVudDJ9fTwvcD5cblx0XHRcdFx0XHQ8YSAqbmdJZj1cImhlbHBVcmxTdHJpbmcubGVuZ3RoID4gMFwiIGhyZWY9XCJ7e2hlbHBVcmxTdHJpbmd9fVwiIHRhcmdldD1cIl9ibGFua1wiIHN0eWxlPVwiY29sb3I6ICMyMTk2RjM7IGN1cnNvcjogcG9pbnRlcjsgZm9udC1zaXplOiAxLjE0ZW07IGZvbnQtd2VpZ2h0OiBub3JtYWw7XCI+XG5cdFx0XHRcdFx0XHR7e2hlbHBVcmxMYWJlbH19XG5cdFx0XHRcdFx0PC9hPlxuXHRcdFx0XHQ8L21hdC1jYXJkLWNvbnRlbnQ+XG5cdFx0XHRcdDxtYXQtY2FyZC1hY3Rpb25zPlxuXHRcdFx0XHRcdDxkaXYgaXRkLWZsZXgtY29udGFpbmVyLXJvdy1lbmQtc3RhcnQ+XG5cdFx0XHRcdFx0XHQ8YnV0dG9uIG1hdC1idXR0b24gaWQ9Y2FuY2VsQnV0dG9uIChjbGljayk9XCJvbkNhbmNlbCgpXCI+e3tjYW5jZWx9fTwvYnV0dG9uPlxuXHRcdFx0XHRcdFx0PGJ1dHRvbiBtYXQtYnV0dG9uIGlkPW9rQnV0dG9uIGNsYXNzPVwib2stYnV0dG9uXCIgKGNsaWNrKT1cIm9uT2soKVwiPnt7b2t9fTwvYnV0dG9uPlxuXHRcdFx0XHRcdDwvZGl2PlxuXHRcdFx0XHQ8L21hdC1jYXJkLWFjdGlvbnM+XG5cdFx0XHQ8L21hdC1jYXJkPlxuXG5cdFx0PC9kaXY+XG5cdDwvZGl2PlxuPC9zZWN0aW9uPlxuIiwiPGl0ZC1kaWFsb2c+PC9pdGQtZGlhbG9nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNTSztNQUFBO01BQUE7TUFBQSxnQkFBOEo7OztRQUExSDtRQUFwQyxXQUFvQyxTQUFwQztRQUE4SjtRQUFBOzs7O29CQVRuSztNQUFBLHdFQUFTO2FBQUEsNEJBQ1I7TUFBQTtNQUFBLDhCQUFpQyw0Q0FDaEM7YUFBQTtVQUFBO01BQTRCLCtDQUUzQjtVQUFBO1VBQUEsK0RBQUE7VUFBQTthQUFBO01BQVcsa0NBQ1Y7VUFBQTtVQUFBLHVCQUFBO1VBQUEsb0NBQUE7VUFBQSwyQ0FBZ0I7VUFBQSxVQUEwQixxQ0FDMUM7VUFBQTtVQUFBLG1EQUFBO1VBQUEseUVBQUE7VUFBQTtNQUFrQiwrQ0FDakI7VUFBQTtVQUFBLDhCQUFHO01BQWdCLCtDQUNuQjtVQUFBO1VBQUEsOEJBQUc7TUFBZ0IsK0NBQ25CO1VBQUEsOERBQUE7VUFBQTtVQUFBLGVBRUksOENBQ2M7VUFBQSxlQUNuQjtVQUFBO1VBQUEsaUVBQUE7VUFBQTthQUFBO1VBQUEsZUFBa0IsK0NBQ2pCO1VBQUE7Y0FBQTtNQUFzQyxnREFDckM7VUFBQTtjQUFBO1lBQUE7WUFBQTtZQUFtQztjQUFBO2NBQUE7WUFBQTtZQUFuQztVQUFBLHVEQUFBO1VBQUEseUVBQUE7VUFBQTs4QkFBQSxzQ0FBQTtVQUFBLHNFQUF3RDtpQkFBQSxnQkFBbUIsZ0RBQzNFO2lCQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7WUFBaUQ7Y0FBQTtjQUFBO1lBQUE7WUFBakQ7VUFBQSx1REFBQTtVQUFBLHlFQUFBO1VBQUE7OEJBQUEsc0NBQUE7VUFBQSxzRUFBa0U7aUJBQUEsZ0JBQWUsK0NBQzVFO2lCQUFBLCtCQUNZLGlDQUNUO2lCQUFBLCtCQUVOO01BQ0QsMENBQ0c7OztRQWRGO1FBQUgsWUFBRyxTQUFIOzs7UUFKZTtRQUFBO1FBRVo7UUFBQTtRQUNBO1FBQUE7UUFLSjtRQUFBLFlBQUEsU0FBQTtRQUVFO1FBQUEsWUFBQSxTQUFBO1FBQXdEO1FBQUE7UUFDeEQ7UUFBQSxZQUFBLFNBQUE7UUFBa0U7UUFBQTs7OztvQkNoQnhFO01BQUE7Z0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7OzsifQ==
//# sourceMappingURL=dialog.component.ngfactory.js.map

/***/ }),

/***/ "XPX5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthExistsGuard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__("BkNc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__log_service__ = __webpack_require__("B1/m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular2_jwt__ = __webpack_require__("W4CS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular2_jwt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angular2_jwt__);



var AuthExistsGuard = (function () {
    function AuthExistsGuard(router, log) {
        this.router = router;
        this.log = log;
        this.jwtHelper = new __WEBPACK_IMPORTED_MODULE_2_angular2_jwt__["JwtHelper"]();
    }
    AuthExistsGuard.prototype.canActivate = function () {
        if (!window.localStorage) {
            this.log.warn('AuthExistsGuard, Browser does not support local storage.');
            // TODO!!! - fix this
            // alert('Authentication Missing.  No Local Storage');
            this.router.navigate(['site/home']);
            return false;
        }
        var authJwt = localStorage.getItem('auth-jwt');
        if (!authJwt) {
            this.log.warn('AuthExistsGuard, auth-jwt missing from local storage.');
            // TODO!!! - fix this
            // alert('Authentication Missing.');
            this.router.navigate(['site/home']);
            return false;
        }
        var expireDate = this.jwtHelper.getTokenExpirationDate(authJwt);
        // console.log('local jwt expires = ' + expireDate);
        if (new Date() > expireDate) {
            this.log.warn('AuthExistsGuard, auth-jwt from local storage has expired.  expireDate = ' + expireDate);
            // TODO!!! - fix this
            // alert('Authentication Expired.');
            return false;
        }
        return true;
    };
    AuthExistsGuard.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_router__["m" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_1__log_service__["a" /* LogService */] }]; };
    return AuthExistsGuard;
}());

/*

@Injectable()

export class AuthGuard implements CanActivate {

auth: any = {};

constructor(private authService: AuthService, private router: Router) {

}

canActivate() {
    if (user is logged in) {
        this.router.navigate(['/dashboard']);
        return true;
    }
    else {
        this.router.navigate(['/Login']);
    }
    return false;
}
}


*/
//# sourceMappingURL=auth-exists-guard.service.js.map

/***/ }),

/***/ "Yhac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FestivalService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log_service__ = __webpack_require__("B1/m");




var FestivalService = (function () {
    function FestivalService(http, authService, config, log) {
        this.http = http;
        this.authService = authService;
        this.config = config;
        this.log = log;
        this.indexDay = 0;
        this.timeSlots = [
            9,
            12,
            15,
            18,
            21
        ];
        this.festival = null;
        this.timeSlotShowingsWrapper = {
            timeSlotShowings: []
        };
    }
    FestivalService.prototype.getFestival = function () {
        var _this = this;
        console.log('<------ getFestival -------->');
        this.makeIndexDay();
        return new Promise(function (resolve, reject) {
            // if just opened app, get copy from local storage if it exists and is for this user
            if (!_this.festival && localStorage) {
                console.log('got here #f1');
                var festivalString = localStorage.getItem('festival');
                if (festivalString) {
                    console.log('got here #f2');
                    var storedFestival = null;
                    try {
                        storedFestival = JSON.parse(festivalString);
                    }
                    catch (err) {
                        _this.log.error('Could not parse festivalString.');
                        console.log('Could not parse festivalString.');
                        _this.log.error(err);
                        storedFestival = null;
                    }
                    console.log('got here #f3');
                    _this.festival = storedFestival;
                }
            }
            // make async calls here
            if (_this.festival) {
                console.log('got here #f6');
                _this.http.get(_this.config.basePath + '/v0/festival/timestamp')
                    .toPromise()
                    .then(function (res) {
                    var result = res.json();
                    var newTimestamp = result.timestamp;
                    console.log('newTimestamp');
                    console.log(newTimestamp);
                    console.log('-----checking time-----');
                    console.log('newTimestamp            = ' + newTimestamp);
                    console.log('this.festival.timestamp = ' + _this.festival.timestamp);
                    if (!newTimestamp || !_this.festival.timestamp || (newTimestamp > _this.festival.timestamp)) {
                        console.log('got here #f10');
                        _this.http.get(_this.config.basePath + '/v0/festival')
                            .toPromise()
                            .then(function (res2) {
                            var result2 = res2.json();
                            _this.festival = result2.festival;
                            console.log('getFestival, festival');
                            console.log(_this.festival);
                            try {
                                localStorage.setItem('festival', JSON.stringify(_this.festival));
                                resolve(_this.festival);
                            }
                            catch (err) {
                                _this.log.error(err);
                                console.log(err);
                                reject(err);
                            }
                        })
                            .catch(function (err) {
                            _this.log.error(err);
                            console.log(err);
                            reject(err);
                        });
                    }
                    else {
                        console.log('got here #f13');
                        resolve(_this.festival);
                    }
                })
                    .catch(function (err) {
                    _this.log.error(err);
                    console.log(err);
                    reject(err);
                });
            }
            else {
                console.log('got here #f5');
                // no local storage version, so just grab the data and be done
                _this.http.get(_this.config.basePath + '/v0/festival')
                    .toPromise()
                    .then(function (res3) {
                    var result3 = res3.json();
                    _this.festival = result3.festival;
                    console.log('getFestival, festival');
                    console.log(_this.festival);
                    try {
                        if (localStorage) {
                            localStorage.setItem('festival', JSON.stringify(_this.festival));
                        }
                    }
                    catch (err) {
                        // this.log.error(err);
                        console.log(err);
                        // reject(err);
                    }
                    resolve(_this.festival);
                })
                    .catch(function (err) {
                    _this.log.error(err);
                    console.log(err);
                    reject(err);
                });
            }
        });
    };
    FestivalService.prototype.getTimeSlotShowings = function () {
        var _this = this;
        console.log('<------ getTimeSlotShowings -------->');
        this.makeIndexDay();
        var now = new Date();
        var hour = now.getHours();
        // hour = fakeHour;
        var weekdayName = '';
        switch (this.indexDay) {
            case 0:
                weekdayName = 'friday';
                break;
            case 1:
                weekdayName = 'saturday';
                break;
            case 2:
                weekdayName = 'sunday';
                break;
        }
        var timeSlot = weekdayName + '+' + this.getCurrentTimeSlot(hour);
        console.log('timeSlot');
        console.log(timeSlot);
        return new Promise(function (resolve, reject) {
            // let accessToken = localStorage.getItem('auth-jwt');
            // let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
            // let options = new RequestOptions({ headers: headers });
            // this.http.get(this.config.basePath + '/v0/festival/timestamp', options)
            _this.http.get(_this.config.basePath + '/v0/showings/' + timeSlot)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                _this.timeSlotShowingsWrapper = result;
                console.log('this.timeSlotShowingsWrapper');
                console.log(_this.timeSlotShowingsWrapper);
                resolve(result.timeSlotShowings);
            })
                .catch(function (err) {
                _this.log.error(err);
                console.log(err);
                reject(err);
            });
        });
    };
    FestivalService.prototype.getCurrentShowings = function () {
        console.log('getCurrentShowings');
        this.makeIndexDay();
        var now = new Date();
        var hour = now.getHours();
        // hour = fakeHour;
        var returnShowings = [];
        var timeSlotName = 'No More Films Today';
        var timeSlotHour = this.getCurrentTimeSlot(hour);
        if (timeSlotHour) {
            returnShowings = this.getCurrentShowingz(timeSlotHour);
            timeSlotName = this.formatTimeSlot(timeSlotHour);
        }
        var allTicketsz = {
            modified: null,
            userId: '',
            timeSlotName: timeSlotName,
            // showingsTime: '3pm Time Slot',
            // showingsTime: '3pm Presentations',
            theatres: returnShowings
        };
        console.log('when the current hour is');
        console.log(hour);
        console.log('allTicketsz');
        console.log(allTicketsz);
        return allTicketsz;
    };
    FestivalService.prototype.makeIndexDay = function () {
        var now = new Date();
        var dayOfWeek = now.getDay();
        // console.log('now');
        // console.log(now);
        // console.log('dayOfWeek');
        // console.log(dayOfWeek);
        this.indexDay = (dayOfWeek + 7 - 5) % 7;
        if (this.indexDay > 2) {
            this.indexDay = 0;
        }
        // console.log('this.indexDay');
        // console.log(this.indexDay);
    };
    FestivalService.prototype.getCurrentShowingz = function (timeSlotHour) {
        console.log('<------ getCurrentShowingz -------->');
        this.makeIndexDay();
        var now = new Date();
        var hour = now.getHours();
        // hour = fakeHour;
        console.log('getCurrentShowingz, this.festival');
        console.log(this.festival);
        console.log('this.indexDay');
        console.log(this.indexDay);
        console.log('this.festival.festivalDays');
        console.log(this.festival.festivalDays);
        var returnShowings = [];
        var festivalDay = this.festival.festivalDays[this.indexDay];
        var showings = (festivalDay) ? festivalDay.showings : [];
        for (var i = 0; i < showings.length; i++) {
            var showing = showings[i];
            var parts = showing.showTime.split(':');
            var showingHour = parseInt(parts[0], 10);
            if (showingHour === timeSlotHour) {
                var film = this.festival.films[showing.filmId];
                var theatre = this.festival.theatres[showing.theatreId];
                var timeSlot = festivalDay.dayOfWeek.toLowerCase() + '+' + this.getCurrentTimeSlot(hour);
                var timeSlotShowing = {
                    currentTicket: 1,
                    lastTicket: theatre.totalSeats,
                    soldOut: false,
                    updated: '',
                    modified: 0 // <--- TODO!!! double check
                };
                if (this.timeSlotShowingsWrapper.timeSlotShowings) {
                    for (var j = 0; j < this.timeSlotShowingsWrapper.timeSlotShowings.length; j++) {
                        var tempTimeSlotShowing = this.timeSlotShowingsWrapper.timeSlotShowings[j];
                        var partz = tempTimeSlotShowing.showingKey.split('+');
                        if ((partz) && (partz.length > 0) && (tempTimeSlotShowing.timeSlot === timeSlot) && (partz[1] === showing.theatreId)) {
                            timeSlotShowing = tempTimeSlotShowing;
                            timeSlotShowing.updated = this.convertToUpdatedTime(timeSlotShowing.modified);
                            break;
                        }
                    }
                }
                var returnShowing = {
                    theatre: theatre.name,
                    name: theatre.name,
                    film: film.title,
                    showTime: this.convertTo12Hour(showing.showTime),
                    // showTime: convertTo12Hour('12:00'),
                    totalSeats: theatre.totalSeats,
                    currentTicket: timeSlotShowing.currentTicket,
                    lastTicket: timeSlotShowing.lastTicket,
                    soldOut: timeSlotShowing.soldOut,
                    // updated: '2:18pm',
                    updated: timeSlotShowing.updated,
                    noMoreFilmsToday: false,
                    timeSlot: festivalDay.dayOfWeek.toLowerCase() + '+' + this.getCurrentTimeSlot(hour)
                };
                // 					returnShowing.soldOut = true;
                // //					if (showing.theatreId === 'rose-theatre') {
                // 						returnShowing.currentTicket = 40;
                // 						returnShowing.updated = '5:57pm'
                // //					}
                // 					if (showing.theatreId === 'northwest-maritime-center') {
                // 						returnShowing.soldOut = false;
                // 					}
                returnShowings.push(returnShowing);
            }
        }
        return returnShowings;
    };
    FestivalService.prototype.getCurrentShowingByTheatreId = function (theatreId) {
        console.log('----------- getCurrentShowingByTheatreId--------------------');
        this.makeIndexDay();
        console.log(theatreId);
        var now = new Date();
        var hour = now.getHours();
        // hour = fakeHour;
        var theatre = this.festival.theatres[theatreId];
        // console.log('theatre');
        // console.log(theatre);
        var festivalDay = this.festival.festivalDays[this.indexDay];
        var showings = festivalDay.showings;
        var currentShowing = null;
        for (var i = 0; i < showings.length; i++) {
            var showing = showings[i];
            if (showing.theatreId === theatreId) {
                console.log(showing);
                var parts = showing.showTime.split(':');
                var showingHour = parseInt(parts[0], 10);
                if (showingHour + 1 > hour) {
                    currentShowing = showing;
                    break;
                }
                // var showTime = new Date(2015, 8, 25+indexDay, parseInt(parts[0]), parseInt(parts[1]), 0);
                // console.log(showTime);
                // var showRolloverTime = new Date(2015, 8, 25+indexDay, parseInt(parts[0])+1, parseInt(parts[1]), 0);;
                // console.log(showRolloverTime);
            }
        }
        // console.log('when the current hour is');
        // console.log(hour);
        // console.log('currentShowing');
        // console.log(currentShowing);
        var timeSlot = festivalDay.dayOfWeek.toLowerCase() + '+' + this.getCurrentTimeSlot(hour);
        // console.log('timeSlotzzzzz');
        // console.log(timeSlot);
        // console.log('this.timeSlotShowings');
        // console.log(this.timeSlotShowings);
        // console.log('this.timeSlotShowings.length');
        // console.log(this.timeSlotShowings.length);
        var timeSlotShowing = {
            currentTicket: 1,
            lastTicket: theatre.totalSeats,
            soldOut: false,
            updated: '',
            modified: 0
            // updated: convertToUpdatedTime(now.valueOf()),
        };
        if (this.timeSlotShowingsWrapper.timeSlotShowings) {
            for (var j = 0; j < this.timeSlotShowingsWrapper.timeSlotShowings.length; j++) {
                var tempTimeSlotShowing = this.timeSlotShowingsWrapper.timeSlotShowings[j];
                // if (tempTimeSlotShowing.timeSlot === timeSlot) {
                // 	timeSlotShowing = tempTimeSlotShowing;
                // 	break;
                // }
                var partz = tempTimeSlotShowing.showingKey.split('+');
                if ((partz) && (partz.length > 0) && (tempTimeSlotShowing.timeSlot === timeSlot) && (partz[1] === theatreId)) {
                    timeSlotShowing = tempTimeSlotShowing;
                    timeSlotShowing.updated = this.convertToUpdatedTime(timeSlotShowing.modified);
                    break;
                }
            }
        }
        console.log('timeSlotShowing');
        console.log(timeSlotShowing);
        var returnShowing = {};
        if (currentShowing) {
            var film = this.festival.films[currentShowing.filmId];
            returnShowing = {
                dayOfWeek: festivalDay.dayOfWeek.toLowerCase(),
                showTime: currentShowing.showTime,
                theatre: theatre.name,
                theatreKey: theatreId,
                film: film.title,
                filmKey: currentShowing.filmId,
                showTime12Hour: this.convertTo12Hour(currentShowing.showTime),
                totalSeats: theatre.totalSeats,
                currentTicket: timeSlotShowing.currentTicket,
                lastTicket: timeSlotShowing.lastTicket,
                soldOut: timeSlotShowing.soldOut,
                updated: this.convertToUpdatedTime(timeSlotShowing.modified),
                noMoreFilmsToday: false,
                timeSlot: festivalDay.dayOfWeek.toLowerCase() + '+' + this.getCurrentTimeSlot(hour)
            };
        }
        else {
            returnShowing = {
                theatre: '',
                theatreKey: '',
                film: 'No more films today.',
                filmKey: '',
                showTime: '',
                totalSeats: 0,
                currentTicket: 0,
                lastTicket: 0,
                soldOut: false,
                updated: '',
                noMoreFilmsToday: true,
                timeSlot: ''
            };
        }
        console.log('returnShowing');
        console.log(returnShowing);
        return returnShowing;
    };
    FestivalService.prototype.createTicketCount = function (payload) {
        var _this = this;
        console.log('<------ createTicketCount -------->');
        console.log('payload');
        console.log(payload);
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var userId = _this.authService.userId;
            // let payload = {
            // 	feedbackId: uuid.v4().replace(/-/g, ''),
            // 	feedbackUserId: userId,
            // 	feedback: feedback
            // };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/ticketcounts', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                console.log(result);
                resolve(result);
            })
                .catch(function (err) {
                _this.log.error(err);
                console.log(err);
                reject(err);
            });
        });
    };
    FestivalService.prototype.getShowingsInfo = function () {
        var _this = this;
        console.log('getShowingsInfo');
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/showings', options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                console.log('result');
                console.log(result);
                resolve(result.showings);
            })
                .catch(function (err) {
                _this.log.error(err);
                console.log(err);
                reject(err);
            });
        });
    };
    FestivalService.prototype.getCurrentTimeSlot = function (hour) {
        for (var i = 0; i < this.timeSlots.length; i++) {
            var timeSlot = this.timeSlots[i];
            if (timeSlot + 1 > hour) {
                return timeSlot;
            }
        }
        return null;
    };
    FestivalService.prototype.formatTimeSlot = function (timeSlotHour) {
        var suffix = 'am';
        if (timeSlotHour === 12) {
            suffix = 'noon';
        }
        else if (timeSlotHour >= 12) {
            suffix = 'pm';
        }
        // console.log('suffix');
        // console.log(suffix);
        if (timeSlotHour > 12) {
            timeSlotHour -= 12;
            return timeSlotHour + suffix + ' Films';
        }
        else {
            return timeSlotHour + suffix + ' Films';
        }
    };
    FestivalService.prototype.convertTo12Hour = function (time) {
        var parts = time.split(':');
        var hour = parseInt(parts[0], 10);
        var minute = parseInt(parts[1], 10);
        // console.log('hour');
        // console.log(hour);
        // console.log('minute');
        // console.log(minute);
        var suffix = 'am';
        if ((hour === 12) && (minute === 0)) {
            suffix = 'noon';
        }
        else if (hour >= 12) {
            suffix = 'pm';
        }
        // console.log('suffix');
        // console.log(suffix);
        if (hour > 12) {
            hour -= 12;
            return hour + ':' + parts[1] + suffix;
        }
        else {
            return time + suffix;
        }
    };
    FestivalService.prototype.convertToUpdatedTime = function (timeUtc) {
        if (!timeUtc) {
            timeUtc = Date.now();
        }
        var date = new Date(timeUtc);
        var hour = date.getHours();
        var minute = date.getMinutes();
        // console.log('hour');
        // console.log(hour);
        // console.log('minute');
        // console.log(minute);
        var suffix = 'am';
        if ((hour === 12) && (minute === 0)) {
            suffix = 'noon';
        }
        else if (hour >= 12) {
            suffix = 'pm';
        }
        // console.log('suffix');
        // console.log(suffix);
        var minuteText = '' + minute;
        if (minute < 10) {
            minuteText = '0' + minute;
        }
        if (hour > 12) {
            hour -= 12;
        }
        var updatedTime = hour + ':' + minuteText + suffix;
        // console.log('updatedTime');
        // console.log(updatedTime);
        return updatedTime;
    };
    /*
        getEvents() {
            return new Promise( (resolve, reject) => {
    
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
                let options = new RequestOptions({ headers: headers });
    
                this.http.get(this.config.basePath + '/v0/events', options)
                    .toPromise()
                    .then( (res) => {
                        resolve(res.json());
                    })
                    .catch((err) => {			// this is a Response object, with res.status === 401, for example
                        this.log.error(err);
                    });
            });
        }
    
    
    
        // might not be useful, can not edit an event if you are on a different organization
        getEventsAllOrganizations() {
            return new Promise( (resolve, reject) => {
    
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
                let options = new RequestOptions({ headers: headers });
    
                this.http.get(this.config.basePath + '/v0/eventsallorganizations', options)
                    .toPromise()
                    .then( (res) => {
                        resolve(res.json());
                    })
                    .catch((err) => {			// this is a Response object, with res.status === 401, for example
                        this.log.error(err);
                    });
            });
        }
    
    
    
        updateEvent(eventId: any, payload: any) {
            return new Promise( (resolve, reject) => {
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
                headers.append('Content-Type', 'application/json');
                let options = new RequestOptions({ headers: headers });
    
                let body = JSON.stringify(payload);
    
                this.http.put(this.config.basePath + '/v0/events/' + eventId, body, options)
                    .toPromise()
                    .then((res) => {
    // console.log('res');
    // console.log(res);
                        resolve();
                    })
                    .catch((err) => {			// this is a Response object, with res.status === 401, for example
                        this.log.error(err);
                    });
            });
        }
    
    
        createEvent(payload: any) {
            return new Promise( (resolve, reject) => {
                let accessToken = localStorage.getItem('auth-jwt');
                let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
                headers.append('Content-Type', 'application/json');
                let options = new RequestOptions({ headers: headers });
    
                let body = JSON.stringify(payload);
    
                this.http.post(this.config.basePath + '/v0/events', body, options)
                    .toPromise()
                    .then((res) => {
    // console.log('res');
    // console.log(res);
                        resolve();
                    })
                    .catch((err) => {			// this is a Response object, with res.status === 401, for example
                        this.log.error(err);
                    });
            });
    
        }
    */
    /*
    
    
    
    
    'use strict';
    
    
    angular.module('app').factory('ApiTicketService', ['$http', '$q', 'Log', 'ConfigService', 'AuthService', 'ApiQueueService',
        function($http, $q, Log, ConfigService, AuthService, ApiQueueService) {
    
            var apiHost = ConfigService.getApiHost();
    
    //		console.log('------ ApiTicketService --------');
    
    
    //TODO!!! - remove all these
    //		var fakeHour = 17;
    
    
            var now = new Date();
            var dayOfWeek = now.getDay();
    //		console.log(now);
    //		console.log(dayOfWeek);
            var indexDay = (dayOfWeek + 7 - 5) % 7;
    //		console.log(indexDay);
            if (indexDay > 2) {
                indexDay = 0;
            }
    
    //		console.log(indexDay);
    
    
            var allTickets = {
                modified: null,
                userId: '',
                timeSlotName: '3pm Films',
    //			showingsTime: '3pm Time Slot',
    //			showingsTime: '3pm Presentations',
                theatres: [{
                    name: 'The Starlight Room',
                    film: 'WA 2 WA Shorts Program',
                    showTime: '3:00pm',
                    totalSeats: 45,
                    currentTicket: 1,
                    lastTicket: 45,
                    soldOut: false,
                    updated: '2:18pm'
                }, {
                    name: 'Key City Public Theatre',
                    film: 'The Little Death',
                    showTime: '3:00pm',
                    totalSeats: 66,
                    currentTicket: 1,
                    lastTicket: 66,
                    soldOut: false,
                    updated: '2:18pm'
                }, {
                    name: 'Peter Simpson Free Cinema',
                    film: 'Austin to Boston',
                    showTime: '3:00pm',
                    totalSeats: 100,
                    currentTicket: 1,
                    lastTicket: 100,
                    soldOut: true,
                    updated: '2:18pm'
                }, {
                    name: 'Rose Theatre',
                    film: 'Sweet Land',
                    showTime: '3:15pm',
                    totalSeats: 158,
                    currentTicket: 1,
                    lastTicket: 158,
                    soldOut: false,
                    updated: '2:18pm'
                }, {
                    name: 'Northwest Maritime Center',
                    film: 'Austin to Boston',
                    showTime: '3:15pm',
                    totalSeats: 200,
                    currentTicket: 1,
                    lastTicket: 200,
                    soldOut: false,
                    updated: '2:18pm'
                }, {
                    name: 'Rosebud Cinema',
                    film: 'The Breach',
                    showTime: '3:30pm',
                    totalSeats: 79,
                    currentTicket: 1,
                    lastTicket: 79,
                    soldOut: false,
                    updated: '2:18pm'
                }, {
                    name: 'American Legion Theatre',
                    film: 'Frame By Frame',
                    showTime: '3:30pm',
                    totalSeats: 250,
                    currentTicket: 1,
                    lastTicket: 250,
                    soldOut: false,
                    updated: '2:18pm'
                }]
            };
    
    
            // reset
            // allTickets.theatres[0].currentTicket = 1;
            // allTickets.theatres[0].lastTicket = 45;
            // allTickets.theatres[0].soldOut = false;
            // allTickets.theatres[0].updated = '';
    
            // allTickets.theatres[1].currentTicket = 1;
            // allTickets.theatres[1].lastTicket = 66;
            // allTickets.theatres[1].soldOut = false;
            // allTickets.theatres[1].updated = '';
    
            // allTickets.theatres[2].currentTicket = 1;
            // allTickets.theatres[2].lastTicket = 100;
            // allTickets.theatres[2].soldOut = false;
            // allTickets.theatres[2].updated = '';
    
            // allTickets.theatres[3].currentTicket = 1;
            // allTickets.theatres[3].lastTicket = 158;
            // allTickets.theatres[3].soldOut = false;
            // allTickets.theatres[3].updated = '';
    
            // allTickets.theatres[4].currentTicket = 1;
            // allTickets.theatres[4].lastTicket = 200;
            // allTickets.theatres[4].soldOut = false;
            // allTickets.theatres[4].updated = '';
    
            // allTickets.theatres[5].currentTicket = 1;
            // allTickets.theatres[5].lastTicket = 79;
            // allTickets.theatres[5].soldOut = false;
            // allTickets.theatres[5].updated = '';
    
            // allTickets.theatres[6].currentTicket = 1;
            // allTickets.theatres[6].lastTicket = 250;
            // allTickets.theatres[6].soldOut = false;
            // allTickets.theatres[6].updated = '';
    
    
            // // example
            allTickets.theatres[0].currentTicket = 40;
            allTickets.theatres[0].lastTicket = 45;
            allTickets.theatres[0].soldOut = false;
            allTickets.theatres[0].updated = '2:18pm';
    
            allTickets.theatres[1].currentTicket = 46;
            allTickets.theatres[1].lastTicket = 66;
            allTickets.theatres[1].soldOut = false;
            allTickets.theatres[1].updated = '2:19pm';
    
            allTickets.theatres[2].currentTicket = 67;
            allTickets.theatres[2].lastTicket = 100;
            allTickets.theatres[2].soldOut = false;
            allTickets.theatres[2].updated = '2:05pm';
    
            allTickets.theatres[3].currentTicket = 26;
            allTickets.theatres[3].lastTicket = 158;
            allTickets.theatres[3].soldOut = false;
            allTickets.theatres[3].updated = '2:10pm';
    
            allTickets.theatres[4].currentTicket = 76;
            allTickets.theatres[4].lastTicket = 200;
            allTickets.theatres[4].soldOut = false;
            allTickets.theatres[4].updated = '2:15pm';
    
            allTickets.theatres[5].currentTicket = 4;
            allTickets.theatres[5].lastTicket = 79;
            allTickets.theatres[5].soldOut = false;
    //		allTickets.theatres[5].updated = '1:58pm';
            allTickets.theatres[5].updated = '';
    
            allTickets.theatres[6].currentTicket = 18;
            allTickets.theatres[6].lastTicket = 250;
            allTickets.theatres[6].soldOut = false;
            allTickets.theatres[6].updated = '2:17pm';
    
    
    // console.log(allTickets);
    // console.log(allTickets.theatres);
    // console.log(allTickets.theatres[0]);
    
            var tempFestival = null;
    
            var festival = {
                timestamp: null,
    //			userId: '',
                films: [],
                theatres: [],
                festivalDays: []
                // filmsById: {},
                // filmsBySubmissionId: {}
            };
    
            var timeSlotShowingsWrapper = {
                timeSlotShowings: []
            };
    
            // {
            // 	showingKey: {
            // 		type: String,
            // 		default: '',
            // 		trim: true,
            // 		required: 'showingKey cannot be blank'
            // 	},
            // 	filmKey: {
            // 		type: String,
            // 		default: '',
            // 		trim: true,
            // 		required: 'filmKey cannot be blank'
            // 	},
            // 	currentTicket: {
            // 		type: Number,
            // 		default: '',
            // 		required: 'currentTicket cannot be blank'
            // 	},
            // 	lastTicket: {
            // 		type: Number,
            // 		default: '',
            // 		required: 'lastTicket cannot be blank'
            // 	},
            // 	soldOut: {
            // 		type: Boolean,
            // 		default: false,
            // 		required: 'soldOut cannot be blank'
            // 	},
            // 	timeSlot: {
            // 		type: String,
            // 		default: '',
            // 		trim: true,
            // 		required: 'timeSlot cannot be blank'
            // 	},
    
    
            // }
    
    
    
    
    
    
            // var tempAvailableFilmIds = null;
    
            // var availableFilmIds = {
            // 	modified: null,
            // 	userId: '',
            // 	filmIds: []
            // };
    
    
    
            // function convertHourStringTo12HourFormat(hour) {
            // 	var parts = time.split(':');
            // 	var showingHour = parseInt(parts[0]);
    
            // 	if (showingHour+1 > hour) {
            // 		currentShowing = showing;
            // 		break;
            // 	}
    
            // }
    
    
    
    
            return {
                festival: festival,
    //			timeSlotShowings: timeSlotShowingsWrapper.timeSlotShowings,
                timeSlotShowingsWrapper: timeSlotShowingsWrapper,
    
                allTickets: allTickets,
    
                getAllTickets: function() {
                    return allTickets;
                },
    
    
    
                privateUpdateProperties: function() {
                    var that = this;
                    if (tempFestival) {
                        angular.forEach(tempFestival, function(value, key) {
                            that.festival[key] = tempFestival[key];
                        });
                    }
    
                    // var jsonFilmsById = {};
                    // var jsonFilmsBySubmissionId = {};
                    // that.allFilms.films.forEach(function(film) {
                    // 	jsonFilmsById[film.filmId] = film;
                    // 	jsonFilmsBySubmissionId[film.submissionId] = film;
                    // });
                    // that.allFilms.filmsById = jsonFilmsById;
                    // that.allFilms.filmsBySubmissionId = jsonFilmsBySubmissionId;
    
    
    
                },
    
    
    
    
    
    
    
                // theatres: [{
                // 	name: 'The Starlight Room',
                // 	film: 'WA 2 WA Shorts Program',
                // 	showTime: '3:00pm',
                // 	totalSeats: 45,
                // 	currentTicket: 1,
                // 	lastTicket: 45,
                // 	soldOut: false,
                // 	updated: '2:18pm'
                // }, {
    
    
    
                // showingsTime: '3pm Films',
                // theatres: [{
                // 	name: 'The Starlight Room',
                // 	film: 'WA 2 WA Shorts Program',
                // 	showTime: '3:00pm',
                // 	totalSeats: 45,
                // 	currentTicket: 1,
                // 	lastTicket: 45,
                // 	soldOut: false,
                // 	updated: '2:18pm'
                // }, {
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    // 			updateFilm: function(payload) {
    // //				console.log('<------ updateFilm -------->');
    // 				// console.log('payload.filmId');
    // 				// console.log(payload.filmId);
    // 				// console.log('payload');
    // 				// console.log(payload);
    
    // 				var fullUrl = apiHost + '/v0/films/' + payload.filmId;
    // 				ApiQueueService.addQueue('put', fullUrl, payload);
    // 				ApiQueueService.flushQueue();
    
    // 			},
    
    
    
    // 			createFilm: function(payload) {
    // //				console.log('<------ createFilm -------->');
    // 				// console.log('payload');
    // 				// console.log(payload);
    
    // 				var fullUrl = apiHost + '/v0/films';
    // 				ApiQueueService.addQueue('post', fullUrl, payload);
    // 				ApiQueueService.flushQueue();
    // 			},
    
    
    
    
    
    
    
    
    
    
    
    
    
    // 			availableFilmIds: availableFilmIds,
    
    
    
    // 			privateUpdateAvailableFilmIdProperties: function() {
    // 				var that = this;
    // 				if (tempAvailableFilmIds) {
    // 					angular.forEach(tempAvailableFilmIds, function(value, key) {
    // 						that.availableFilmIds[key] = tempAvailableFilmIds[key];
    // 					});
    // 				}
    // 			},
    
    
    
    // 			getAvailableFilmIds: function() {
    // //				console.log('<------ getAvailableFilmIds -------->');
    // 				var that = this;
    // 				return $q(function(resolve, reject) {
    
    // 					// get userId from auth service
    // 					var auth = AuthService.getAuth();
    // 					if (!auth) {
    // 						return resolve(null);
    // 					}
    // 					if (!auth.userId) {
    // 						return resolve(null);
    // 					}
    // 					var userId = auth.userId;
    
    
    // 					// if just opened app, get copy from local storage if it exists and is for this user
    // 					if (!tempAvailableFilmIds) {
    // //						console.log('got here #a1');
    // 						var availableFilmIdsString = localStorage.getItem('user-films');
    // 						if (availableFilmIdsString) {
    // //							console.log('got here #a2');
    // 							var storedAvailableFilmIds = null;
    // 							try {
    // 								storedAvailableFilmIds = JSON.parse(availableFilmIdsString);
    // 							} catch (ex) {
    // 								Log.error('Could not parse availableFilmIdsString.');
    // 								Log.error(ex);
    // 								storedAvailableFilmIds = null;
    // 							}
    
    // 							// check to make sure correct userId
    // 							if (storedAvailableFilmIds && (storedAvailableFilmIds.userId === userId) ) {
    // //								console.log('got here #a3');
    // 								tempAvailableFilmIds = storedAvailableFilmIds;
    // 								that.privateUpdateAvailableFilmIdProperties();
    // 							} else {
    // //								console.log('got here #a4');
    // 								// remove the local storage as it was for another user
    // 								localStorage.removeItem('user-films');
    // 							}
    // 						}
    // 					}
    
    // 					// make async calls here
    // 					if (tempAvailableFilmIds) {
    // //						console.log('got here #a6');
    
    // 						$http.get(apiHost + '/v0/films/users/' + userId + '/date')
    // 						.success(function(data, status, headers, config) {
    // //							console.log('got here #a11');
    
    // 							var availableFilmIdsDate = data.modified;
    // 							// console.log('-----checking time-----');
    // 							// console.log('availableFilmIdsDate          = ' + availableFilmIdsDate);
    // 							// console.log('tempAvailableFilmIds.modified = ' + tempAvailableFilmIds.modified);
    // 							if ( (!availableFilmIdsDate) || (availableFilmIdsDate > tempAvailableFilmIds.modified) || (tempAvailableFilmIds.userId !== userId)  ) {
    // //								console.log('got here #a10');
    
    // 								$http.get(apiHost + '/v0/films/users/' + userId)
    // 								.success(function(data, status, headers, config) {
    // //									console.log('got here #a28');
    
    // 									tempAvailableFilmIds = data.availableFilmIds;
    // 									localStorage.setItem('user-films', JSON.stringify(tempAvailableFilmIds));
    
    // 									that.privateUpdateAvailableFilmIdProperties();
    // 									return resolve(that.availableFilmIds);
    // 								})
    // 								.error(function(data, status, headers, config) {
    // //									console.log('got here #a29');
    
    // 									Log.warn('Could not get available filmIds from api.');
    // 									return resolve(null);
    // 								});
    
    // 							} else {
    // 								// we have current data, so we're all done
    // //								console.log('got here #a13');
    // 								// console.log('we are all good!!');
    // 								that.privateUpdateAvailableFilmIdProperties();
    // 								return resolve(that.availableFilmIds);
    // 							}
    
    // 						})
    // 						.error(function(data, status, headers, config) {
    // //							console.log('got here #a12');
    
    // 							Log.warn('Could not get available filmIds date from api.');
    // 							return resolve(null);
    // 						});
    
    // 					} else {
    // //						console.log('got here #a5');
    // 						// no local storage version, so just grab the data and be done
    // 						$http.get(apiHost + '/v0/films/users/' + userId)
    // 						.success(function(data, status, headers, config) {
    // //							console.log('got here #a8');
    
    // 							tempAvailableFilmIds = data.availableFilmIds;
    // 							localStorage.setItem('user-films', JSON.stringify(tempAvailableFilmIds));
    
    // 							that.privateUpdateAvailableFilmIdProperties();
    // 							return resolve(that.availableFilmIds);
    // 						})
    // 						.error(function(data, status, headers, config) {
    // //							console.log('got here #a9');
    
    // 							Log.warn('Could not get available filmIds from api.');
    // 							return resolve(null);
    // 						});
    // 					}
    // 				});
    // 			},
    
    
    
    
    
    
    // 			exportProgramFilms: function(filename, data, callback) {
    // 				// console.log('<------ exportProgramFilms -------->');
    // 				// console.log('filename');
    // 				// console.log(filename);
    // 				// console.log('data');
    // 				// console.log(data);
    
    // 				var fullUrl = apiHost + '/v0/films/program';
    
    // 				var payload = {
    // 					filename: filename,
    // 					data: data
    // 				};
    
    // 				$http.post(fullUrl, payload)
    // 				.success(function(data, status, headers, config) {
    // //					console.log('got here #exportProgramFilms1');
    
    // 					return callback(null, data);
    
    // 				})
    // 				.error(function(data, status, headers, config) {
    // 					// console.log('got here #exportProgramFilms2');
    
    // 					var message = 'exportProgramFilms could not post to api.';
    // 					Log.warn(message);
    
    // 					return callback(new Error(message));
    // 				});
    // 			},
    
    
    
    
    
    
            };
        }
    ]);
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    */
    FestivalService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__log_service__["a" /* LogService */] }]; };
    return FestivalService;
}());

//# sourceMappingURL=festival.service.js.map

/***/ }),

/***/ "a36o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CacheStorageService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__myindexeddb_service__ = __webpack_require__("POd8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__log_service__ = __webpack_require__("B1/m");
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// import {AngularIndexedDB} from 'angular2-indexeddb';
// import {AngularIndexedDB} from '../classes/angular2-indexeddb';



// import * as pako from 'pako';
var CacheStorageService = (function () {
    function CacheStorageService(authService, log, myIndexedDbService) {
        this.authService = authService;
        this.log = log;
        this.myIndexedDbService = myIndexedDbService;
        this.db = null;
        this.keys = {
            authJwt: 'authJwt',
            allFilms: 'allFilms',
            allUsers: 'allUsers',
            allFilter: 'allFilter',
            availableFilter: 'availableFilter',
            lineupFilter: 'lineupFilter',
            reviewedFilter: 'reviewedFilter',
            ballotFilter: 'ballotFilter',
            blockFilter: 'blockFilter',
            gridFilter: 'gridFilter',
            letterFilter: 'letterFilter',
            autoLogin: 'autoLogin',
            checkVersion: 'checkVersion',
            savedInfo: 'savedInfo',
            visibleTabs: 'visibleTabs',
            enableBallotReport: 'enableBallotReport'
        };
        this.keyNames = {
            authJwt: 'auth-jwt',
            allFilms: 'all-films',
            allUsers: 'all-users',
            allFilter: 'all-filter',
            availableFilter: 'available-filter',
            lineupFilter: 'lineup-filter',
            reviewedFilter: 'reviewed-filter',
            letterFilter: 'letter-filter',
            ballotFilter: 'ballot-filter',
            blockFilter: 'block-filter',
            gridFilter: 'grid-filter',
            autoLogin: 'auto-login',
            checkVersion: 'check-version',
            savedInfo: 'saved-info',
            visibleTabs: 'visible-tabs',
            enableBallotReport: 'enable-ballot-report'
        };
        // localStorage.removeItem('user-profile');
        // localStorage.removeItem('user-profile-queue');
        // localStorage.removeItem('all-users');
        // localStorage.removeItem('all-films');
        // localStorage.removeItem('all-reviews');
        // localStorage.removeItem('user-reviews');
        // localStorage.removeItem('user-reviews-queue');
        // localStorage.removeItem('user-films');
        this.campaignUserIds = [];
    }
    CacheStorageService.prototype.getStatsString = function () {
        // return '' + (this.getStorageUsed() / (1024 * 1024)).toFixed(3) + ' MB used, ' +  (this.getStorageRemaining() / (1024 * 1024)).toFixed(3) + ' MB remaining';
        return '' + (this.getStorageUsed() / (1024 * 1024)).toFixed(3) + ' MB used';
    };
    CacheStorageService.prototype.getStorageUsed = function () {
        try {
            return JSON.stringify(localStorage).length * 2;
        }
        catch (ex) {
            this.log.error('Exception while getting size of localStorage.');
            this.log.error(ex);
            return 0;
        }
    };
    CacheStorageService.prototype.getStorageRemaining = function () {
        var remaining = this.getStorageMax() - this.getStorageUsed();
        if (remaining > 0) {
            return remaining;
        }
        else {
            return 0;
        }
    };
    // I think actually there is a max on individual string size, separate from the max total size
    // says 5 MB is max, https://www.html5rocks.com/en/tutorials/offline/quota-research/
    // to test https://arty.name/localstorage.html
    CacheStorageService.prototype.getStorageMax = function () {
        return 1024 * 1024 * 5;
    };
    CacheStorageService.prototype.read = function (key) {
        var start = Date.now();
        if (!key) {
            this.log.error('Invalid key.');
            return null;
        }
        console.log('read, key = ' + key);
        try {
            if (localStorage) {
                if (this.keyNames[key]) {
                    // no compression
                    var valueString = localStorage.getItem(this.keyNames[key]);
                    if (!valueString) {
                        return {};
                    }
                    var value = JSON.parse(valueString);
                    if (!value) {
                        return {};
                    }
                    var end = Date.now();
                    console.log('    ...   ' + (end - start) + 'msec to read key, CacheStorageService');
                    /*
                                        // with compression
                                        let valueBase64Compressed = localStorage.getItem(this.keyNames[key]);
                                        if (!valueBase64Compressed) {
                                            return {};
                                        }
                                        let valueCompressed = atob(valueBase64Compressed);
                                        if (!valueCompressed) {
                                            return {};
                                        }
                                        let valueString: any = pako.inflate(valueCompressed, {to: 'string'});
                                        if (!valueString) {
                                            return {};
                                        }
                                        let value = JSON.parse(valueString);
                                        if (!value) {
                                            return {};
                                        }
                    
                    
                    
                                        let end = Date.now();
                                        console.log('    ...   ' + (end - start) + 'msec to read key, CacheStorageService');
                    */
                    return value;
                }
                else {
                    this.log.error('Could not find key to read.  key = ' + key);
                }
            }
            else {
                this.log.error('No local storage support');
            }
            return {};
        }
        catch (ex) {
            this.log.error('Exception while reading key.  key = ' + key);
            this.log.error(ex);
            return {};
        }
    };
    CacheStorageService.prototype.write = function (key, value) {
        var start = Date.now();
        if (!key) {
            this.log.error('Invalid key.');
            return;
        }
        if (!value) {
            this.log.error('Invalid value.');
            return;
        }
        console.log('write, key = ' + key);
        try {
            if (localStorage) {
                if (this.keyNames[key]) {
                    // no compression
                    var valueString = JSON.stringify(value);
                    // let stringify = Date.now();
                    // console.log('    ...    ' + (stringify - start) + 'msec to stringify key, CacheStorageService');
                    localStorage.setItem(this.keyNames[key], valueString);
                    var end = Date.now();
                    console.log('    ...   ' + (end - start) + 'msec to write key, CacheStorageService');
                    // let save = Date.now();
                    // console.log('    ...    ' + (save - stringify) + 'msec to save key, CacheStorageService');
                    /*
                                        // with compression
                                        let valueString = JSON.stringify(value);
                    
                    
                                        let stringify = Date.now();
                                        console.log('    ...    ' + (stringify - start) + 'msec to stringify key, CacheStorageService');
                    
                    
                                        let valueCompressed = pako.deflate(valueString, {to: 'string'});
                    
                    
                                        let compress = Date.now();
                                        console.log('    ...    ' + (compress - stringify) + 'msec to compress key, CacheStorageService');
                    
                    
                                        let valueBase64Compressed = btoa(valueCompressed);
                    
                    
                                        let base64 = Date.now();
                                        console.log('    ...    ' + (base64 - compress) + 'msec to base64 key, CacheStorageService');
                    
                    
                                        localStorage.setItem(this.keyNames[key], valueBase64Compressed);
                    
                    
                                        let save = Date.now();
                                        console.log('    ...    ' + (save - base64) + 'msec to save key, CacheStorageService');
                    */
                }
                else {
                    this.log.error('Could not find key to write.  key = ' + key);
                }
            }
            else {
                this.log.error('No local storage support.');
            }
        }
        catch (ex) {
            this.log.error('Exception while writing key.  key = ' + key + ', value = ' + value);
            this.log.error(ex);
        }
    };
    CacheStorageService.prototype.clearAll = function () {
        var _this = this;
        if (localStorage) {
            Object.keys(this.keyNames).forEach(function (key) {
                var keyName = _this.keyNames[key];
                localStorage.removeItem(keyName);
            });
        }
        else {
            this.log.error('No local storage support.');
        }
        if (window.indexedDB) {
            console.log('clearing indexed db');
            var DBDeleteRequest = window.indexedDB.deleteDatabase('oceanbluffproductions');
            DBDeleteRequest.onerror = function (event) {
                console.log('Error deleting database.');
                console.log(event);
            };
            DBDeleteRequest.onsuccess = function (event) {
                console.log('Database deleted successfully');
                console.log(event.result); // should be undefined
                console.log(event);
            };
        }
        else {
            this.log.error('No indexed db support.');
        }
    };
    CacheStorageService.prototype.clearAllExceptAuth = function () {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var needsResolve_1, DBDeleteRequest, that_1;
            return __generator(this, function (_a) {
                if (localStorage) {
                    Object.keys(this.keyNames).forEach(function (key) {
                        var keyName = _this.keyNames[key];
                        if (keyName !== 'auth-jwt') {
                            localStorage.removeItem(keyName);
                        }
                    });
                }
                else {
                    this.log.error('No local storage support.');
                }
                if (window.indexedDB) {
                    console.log('clearing indexed db');
                    needsResolve_1 = true;
                    if (this.db) {
                        this.db.close();
                    }
                    DBDeleteRequest = window.indexedDB.deleteDatabase('oceanbluffproductions');
                    that_1 = this;
                    DBDeleteRequest.onblocked = function () {
                        that_1.log.error('onblocked, Your database version can\'t be upgraded because the app is open somewhere else.');
                        needsResolve_1 = false;
                        return resolve();
                    };
                    DBDeleteRequest.onupgradeneeded = function (event) {
                        that_1.log.error('onupgradeneeded, Should not be called.');
                        that_1.log.info(event);
                        needsResolve_1 = false;
                        return resolve();
                    };
                    // IDBRequest
                    DBDeleteRequest.onerror = function (event) {
                        that_1.log.error('onerror, Error deleting database.');
                        // that.log.error(event);
                        needsResolve_1 = false;
                        return resolve();
                    };
                    DBDeleteRequest.onsuccess = function (event) {
                        console.log('onsuccess, Database deleted successfully');
                        // console.log(event.result); // should be undefined
                        // console.log(event);
                        needsResolve_1 = false;
                        return resolve();
                    };
                    console.log('waiting for deleted database');
                    setTimeout(function () {
                        if (needsResolve_1) {
                            that_1.log.error('clearAllExceptAuth, indexedDB.deleteDatabase, needsResolve was true');
                            return resolve();
                        }
                    }, 500);
                }
                else {
                    this.log.error('No indexed db support.');
                    return [2 /*return*/, resolve()];
                }
                return [2 /*return*/];
            });
        }); });
    };
    CacheStorageService.prototype.ensureIndexedDb = function () {
        var _this = this;
        // in Chrome devtools console
        // indexedDB.deleteDatabase("oceanbluffproductions")
        // then do page refresh
        var schemaVersion = 2;
        return new Promise(function (resolve, reject) {
            if (_this.db) {
                console.log('-----> db already setup');
                return resolve();
            }
            if (!window.indexedDB) {
                console.log('No indexed db support.');
                return resolve();
            }
            var start = Date.now();
            console.log('-----> creating AngularIndexedDB');
            // this.db = new AngularIndexedDB('oceanbluffproductions', schemaVersion);
            _this.db = _this.myIndexedDbService.createDb('oceanbluffproductions', schemaVersion);
            // console.log('this.db');
            // console.log(this.db);
            console.log('-----> creating store');
            _this.db.createStore(schemaVersion, function (evt) {
                console.log('-----> creating store returning, onupgradeneeded');
                // let objectStore = evt.currentTarget.result.createObjectStore('films', { keyPath: 'filmId'});
                // objectStore.createIndex('filmId', 'filmId', { unique: false });
                var theDb = evt.target.result;
                if (theDb) {
                    console.log('theDb.objectStoreNames 1');
                    console.log(theDb.objectStoreNames);
                    var existingNames_1 = [];
                    if (theDb.objectStoreNames) {
                        if (Array.isArray(theDb.objectStoreNames)) {
                            console.log('--- found an array!!');
                            existingNames_1 = theDb.objectStoreNames;
                        }
                        else {
                            console.log('--- found an object!!');
                            Object.keys(theDb.objectStoreNames).forEach(function (objectStoreName) {
                                existingNames_1.push(theDb.objectStoreNames[objectStoreName]);
                            });
                        }
                    }
                    console.log('existingNames');
                    console.log(existingNames_1);
                    if (existingNames_1.indexOf(_this.keyNames.allFilms) === -1) {
                        var objectStore1 = evt.currentTarget.result.createObjectStore(_this.keyNames.allFilms);
                    }
                    if (existingNames_1.indexOf(_this.keyNames.allUsers) === -1) {
                        var objectStore2 = evt.currentTarget.result.createObjectStore(_this.keyNames.allUsers);
                    }
                }
                // let objectStore1 = evt.currentTarget.result.createObjectStore(this.keyNames.allFilms);
                // let objectStore2 = evt.currentTarget.result.createObjectStore(this.keyNames.allUsers);
                // if (theDb) {
                // 	console.log('theDb.objectStoreNames 2');
                // 	console.log(theDb.objectStoreNames);
                // 	console.log(typeof theDb.objectStoreNames);
                // }
                console.log('ensureIndexedDb, onupgradeneeded, elasped = ' + (Date.now() - start));
            })
                .then(function () {
                // let theOther = this;
                // setTimeout(() => {
                // 	if (theOther && theOther.db && theOther.db.getDb()) {
                // 		console.log('theOther.db.getDb().objectStoreNames');
                // 		console.log(theOther.db.getDb().objectStoreNames);
                // 	} else {
                // 		console.log('things are null');
                // 	}
                // }, 3000);
                console.log('ensureIndexedDb, then, elasped = ' + (Date.now() - start));
                resolve();
            })
                .catch(function (err) {
                _this.log.error('IndexedDb error creating store:');
                _this.log.error(err);
            });
        });
    };
    CacheStorageService.prototype.readIndexedDb = function (key) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            if (!key) {
                _this.log.error('Invalid key.');
                return resolve();
            }
            if (!_this.keyNames[key]) {
                _this.log.error('Invalid key name.');
                return resolve();
            }
            console.log('read, key = ' + key);
            console.log('read, keyName = ' + _this.keyNames[key]);
            try {
                _this.ensureIndexedDb()
                    .then(function () {
                    if (!_this.db) {
                        return resolve();
                    }
                    _this.db.getByKey(_this.keyNames[key], _this.keyNames[key]).then(function (allFilms) {
                        // console.log('-----> readIndexedDb, getByKey success');
                        // console.log(allFilms);
                        console.log('readIndexedDb, add, elasped = ' + (Date.now() - start));
                        return resolve(allFilms);
                    }, function (error) {
                        console.log('-----> readIndexedDb, getByKey error');
                        console.log(error);
                        return resolve();
                    });
                })
                    .catch(function (err) {
                    _this.log.error(err);
                    return resolve();
                });
                /*
                                if (localStorage) {
                                    if (this.keyNames[key]) {
                                        // no compression
                                        let valueString = localStorage.getItem(this.keyNames[key]);
                                        if (!valueString) {
                                            return {};
                                        }
                                        let value = JSON.parse(valueString);
                                        if (!value) {
                                            return {};
                                        }
                
                                        let end = Date.now();
                                        console.log('    ...   ' + (end - start) + 'msec to read key, CacheStorageService');
                
                                        return value;
                                    } else {
                                        this.log.error('Could not find key to read.  key = ' + key);
                                    }
                                } else {
                                    this.log.error('No local storage support');
                                }
                                return {};
                */
            }
            catch (ex) {
                _this.log.error('Exception while reading key.  key = ' + key);
                _this.log.error(ex);
                return {};
            }
        });
    };
    CacheStorageService.prototype.writeIndexedDb = function (key, value) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            if (!key) {
                _this.log.error('Invalid key.');
                return resolve();
            }
            if (!_this.keyNames[key]) {
                _this.log.error('Invalid key name.');
                return resolve();
            }
            if (!value) {
                _this.log.error('Invalid value.');
                return resolve();
            }
            console.log('write, key = ' + key);
            console.log('write, keyName = ' + _this.keyNames[key]);
            try {
                _this.ensureIndexedDb()
                    .then(function () {
                    if (!_this.db) {
                        return resolve();
                    }
                    console.log('value');
                    console.log(value);
                    // first, remove the item
                    // note ok if error because item was not there while removing
                    _this.db.delete(_this.keyNames[key], _this.keyNames[key]).then(function () {
                        console.log('-----> writeIndexedDb, remove success');
                        // now add
                        _this.db.add(_this.keyNames[key], value, _this.keyNames[key]).then(function () {
                            console.log('-----> writeIndexedDb, add success');
                            console.log('writeIndexedDb, add, elasped = ' + (Date.now() - start));
                            return resolve();
                        }, function (err) {
                            console.log('-----> writeIndexedDb, add error');
                            console.log(err);
                            return resolve();
                        });
                    }, function (err2) {
                        console.log(err2);
                        console.log('-----> writeIndexedDb, remove error');
                        // now add
                        _this.db.add(_this.keyNames[key], value, _this.keyNames[key]).then(function () {
                            console.log('-----> writeIndexedDb, add success');
                            console.log('writeIndexedDb, add, elasped = ' + (Date.now() - start));
                            return resolve();
                        }, function (err) {
                            console.log('-----> writeIndexedDb, add error');
                            console.log(err);
                            return resolve();
                        });
                    });
                })
                    .catch(function (err) {
                    _this.log.error(err);
                    return resolve();
                });
                /*
                                if (localStorage) {
                                    if (this.keyNames[key]) {
                                        let valueString = JSON.stringify(value);
                
                                        localStorage.setItem(this.keyNames[key], valueString);
                
                                        let end = Date.now();
                                        console.log('    ...   ' + (end - start) + 'msec to write key, CacheStorageService');
                
                                    } else {
                                        this.log.error('Could not find key to write.  key = ' + key);
                                        return resolve();
                                    }
                                } else {
                                    this.log.error('No local storage support.');
                                    return resolve();
                                }
                */
            }
            catch (ex) {
                _this.log.error('Exception while writing key.  key = ' + key + ', value = ' + value);
                _this.log.error(ex);
                return resolve();
            }
        });
    };
    CacheStorageService.prototype.readCampaign = function () {
        try {
            if (localStorage) {
                var valueString = localStorage.getItem('campaignIds');
                if (!valueString) {
                    return;
                }
                var value = JSON.parse(valueString);
                if (!value) {
                    return;
                }
                this.campaignUserIds = value;
            }
        }
        catch (ex) {
            this.log.error('Exception while reading key.  key = campaignIds');
            this.log.error(ex);
            return;
        }
    };
    CacheStorageService.prototype.writeCampaign = function () {
        try {
            if (localStorage) {
                var valueString = JSON.stringify(this.campaignUserIds);
                localStorage.setItem('campaignIds', valueString);
            }
        }
        catch (ex) {
            this.log.error('Exception while reading key.  key = campaignIds');
            this.log.error(ex);
            return;
        }
    };
    CacheStorageService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__log_service__["a" /* LogService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__myindexeddb_service__["a" /* MyIndexedDbService */] }]; };
    return CacheStorageService;
}());

//# sourceMappingURL=cache-storage.service.js.map

/***/ }),

/***/ "aUiu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListPageComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page_page_component__ = __webpack_require__("BWg/");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ListPageComponent = (function (_super) {
    __extends(ListPageComponent, _super);
    function ListPageComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // @Input() contentSize: ContentSize = ContentSize.Small;
    // @Output() linkClick = new EventEmitter();
    ListPageComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        console.log('ListPageComponent, ngOnInit');
    };
    ListPageComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
        console.log('ListPageComponent, ngAfterViewInit');
        console.log('ListPageComponent, this.sidenav');
        console.log(this.sidenav);
    };
    return ListPageComponent;
}(__WEBPACK_IMPORTED_MODULE_0__page_page_component__["b" /* PageComponent */]));

//# sourceMappingURL=list-page.component.js.map

/***/ }),

/***/ "aZFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__("BkNc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("qbdv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular2_jwt__ = __webpack_require__("W4CS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular2_jwt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angular2_jwt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid__ = __webpack_require__("aMZo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__log_service__ = __webpack_require__("B1/m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__version_service__ = __webpack_require__("Tlsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_url__ = __webpack_require__("ETzN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_url__);



// import {Http, Headers, Request, RequestOptions, RequestOptionsArgs, RequestMethod, Response} from '@angular/http';

// import {AuthHttp, tokenNotExpired, JwtHelper} from 'angular2-jwt';
// import {Observable} from 'rxjs/Observable';





// TODO - add "edit" to each
var fullAuth = {
    passes: {
        passContent: true,
        passesSettings: true
    },
    realtimeSeats: {
        theaterManager: 'rose-theater',
        realtimeSeatsSettings: true
    },
    reviewer: {
        reviewer: 'documentary',
        teamCapitan: 'documentary',
        festivalProgrammer: 'all',
        filmContent: true,
        reviewerSettings: true
    }
};
var AuthService = (function () {
    function AuthService(http, location, router, config, log, versionService) {
        this.http = http;
        this.location = location;
        this.router = router;
        this.config = config;
        this.log = log;
        this.versionService = versionService;
        this.jwtHelper = new __WEBPACK_IMPORTED_MODULE_3_angular2_jwt__["JwtHelper"]();
        this.lastModified = {
            allUsers: 0,
            allFilms: 0,
            allReviews: 0,
            userUsers: 0,
            userFilms: 0,
            userReviews: 0,
        };
        this.userId = '';
        this.organizationId = '';
        this.eventId = '';
        this.userAuthorizations = {};
        this.showRoleReviewerTeam = '';
        this.showRoleTeamCaptainTeam = '';
        // try and read userId etc.
        try {
            if (localStorage) {
                var authJwt = localStorage.getItem('auth-jwt');
                if (!authJwt) {
                    return;
                }
                var authPayload = this.jwtHelper.decodeToken(authJwt);
                if (!authPayload) {
                    return;
                }
                this.userId = authPayload.auth.userId;
                this.organizationId = authPayload.auth.organizationId;
                this.eventId = authPayload.auth.eventId;
                this.userAuthorizations = authPayload.auth.userAuthorizations;
            }
            else {
                log.error('localStorage');
            }
        }
        catch (ex) {
            log.exception(ex);
        }
    }
    // first check if path is in no-auth list, if yes simply return
    // if no local jwt, or jwt expired, redirect to "/"
    // try API, get new jwt + last modified dates
    // save jwt + last modified dates
    // if no internet, use last saved
    // if no jwt, redirct to "/"
    // if jwt expired, redirect to "/"
    // verify jwt allows path
    // if not, redirect to "/"
    AuthService.prototype.ensureAuth = function (path) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.log.needPageReLoad) {
                _this.log.needPageReLoad = false;
                window.location.reload(true);
                return resolve();
            }
            // console.log('ensureAuth, path');
            // console.log(path);
            // check no-auth list
            if (['', '/'].indexOf(path) >= 0) {
                return resolve();
            }
            if (path.indexOf('/nonce/') === 0) {
                return resolve();
            }
            if (path.indexOf('/site/') === 0) {
                return resolve();
            }
            if (path.indexOf('/oauth') === 0) {
                return resolve();
            }
            // TODO - fix this !!!
            if (path.indexOf('/volunteer/') === 0) {
                return resolve();
            }
            // TODO - fix this !!!
            // if (path.indexOf('/festival/') === 0) {
            // 	return resolve();
            // }
            if (path.indexOf('/festival/5dde71766d5342f39e8a0abfaaeab3f4/nextup') === 0) {
                return resolve();
            }
            if (path === '/festival/nextup') {
                _this.router.navigate(['/festival/5dde71766d5342f39e8a0abfaaeab3f4/nextup']);
                return resolve();
            }
            if (path === '/festival/tickets') {
                _this.router.navigate(['/festival/5dde71766d5342f39e8a0abfaaeab3f4/tickets']);
                return resolve();
            }
            var authPayload = _this.readAuthFromLocalStorage();
            if (!authPayload) {
                _this.router.navigate(['']);
                return resolve();
            }
            /*
                        if (!window.localStorage) {
                            this.log.warn('ensureAuth, Browser does not support local storage.');
                            this.router.navigate(['']);
                            return resolve();
                        }
            
                        let authJwt = localStorage.getItem('auth-jwt');
                        if (!authJwt) {
                            this.log.warn('ensureAuth, auth-jwt missing from local storage.');
                            this.router.navigate(['']);
                            return resolve();
                        }
            
                        let expireDate = this.jwtHelper.getTokenExpirationDate(authJwt);
                        // console.log('local jwt expires = ' + expireDate);
                        if (!expireDate) {
                            this.log.warn('ensureAuth, auth-jwt from local storage missing expireDate.');
                            this.router.navigate(['']);
                            return resolve();
                        }
            
                        if (new Date() > expireDate) {
                            this.log.warn('ensureAuth, auth-jwt from local storage has expired.  expireDate = ' + expireDate);
                            this.router.navigate(['']);
                            return resolve();
                        }
            
                        let authPayload = this.jwtHelper.decodeToken(authJwt);
                        if (!authPayload) {
                            this.log.warn('ensureAuth, No authPayload while decoding auth-jwt.');
                            this.router.navigate(['']);
                            return resolve();
                        }
                        this.userId = authPayload.auth.userId;
                        this.organizationId = authPayload.auth.organizationId;
                        this.eventId = authPayload.auth.eventId;
                        this.userAuthorizations = authPayload.auth.userAuthorizations;
                        this.showRoleReviewerTeam = authPayload.auth.showRoleReviewerTeam;
                        this.showRoleTeamCaptainTeam = authPayload.auth.showRoleTeamCaptainTeam;
                        // console.log(authPayload);
            */
            _this.getNewJwtAndModifiedDates(authPayload)
                .then(function (res) {
                var result = res.result;
                if (_this.versionService.isNewVersion(result.uiVersion)) {
                    var currentVersion = _this.versionService.uiVersion.version;
                    _this.log.info('Found new UI version.  current v' + currentVersion + ', new v' + result.uiVersion);
                    window.location.reload(true);
                    return resolve();
                }
                // let newExpireDate = this.jwtHelper.getTokenExpirationDate(result.token);
                // console.log('new jwt expires = ' + newExpireDate);
                var newAuthPayload = _this.jwtHelper.decodeToken(result.token);
                if (!newAuthPayload) {
                    _this.log.warn('ensureAuth, No newAuthPayload while decoding newAuth.');
                    _this.router.navigate(['']);
                    return resolve();
                }
                localStorage.setItem('auth-jwt', result.token);
                _this.userId = newAuthPayload.auth.userId;
                _this.organizationId = newAuthPayload.auth.organizationId;
                _this.eventId = newAuthPayload.auth.eventId;
                _this.userAuthorizations = newAuthPayload.auth.userAuthorizations;
                _this.showRoleReviewerTeam = authPayload.auth.showRoleReviewerTeam;
                _this.showRoleTeamCaptainTeam = authPayload.auth.showRoleTeamCaptainTeam;
                // console.log('newAuthPayload');
                // console.log(newAuthPayload);
                var parts = path.split('/');
                if (parts.length > 0) {
                    parts = parts.slice(1);
                    var pathname = 'app.' + parts.join('.');
                    // console.log('pathname before');
                    // console.log(pathname);
                    // TODO!!! - fix this !!!
                    if (pathname.indexOf('app.festival.5dde71766d5342f39e8a0abfaaeab3f4.tickets') === 0) {
                        pathname = 'app.festival.ticket';
                    }
                    if (pathname.indexOf('app.organization.settings') === 0) {
                        pathname = 'app.organization.settings';
                    }
                    if (pathname.indexOf('app.program.lineup') === 0) {
                        pathname = 'app.program.lineup';
                    }
                    if (pathname.indexOf('app.program.letter') === 0) {
                        pathname = 'app.program.letter';
                    }
                    if (pathname.indexOf('app.program.block') === 0) {
                        pathname = 'app.program.block';
                    }
                    if (pathname.indexOf('app.program.grid') === 0) {
                        pathname = 'app.program.grid';
                    }
                    if (pathname.indexOf('app.program.ballot') === 0) {
                        pathname = 'app.program.ballot';
                    }
                    if (pathname.indexOf('app.reviewer.program') === 0) {
                        pathname = 'app.reviewer.program';
                    }
                    if (pathname.indexOf('app.reviewer.results') === 0) {
                        pathname = 'app.reviewer.results';
                    }
                    if (pathname.indexOf('app.reviewer.team') === 0) {
                        pathname = 'app.reviewer.team';
                    }
                    if (pathname.indexOf('app.reviewer.content') === 0) {
                        pathname = 'app.reviewer.content';
                    }
                    if (pathname.indexOf('app.reviewer.available') === 0) {
                        pathname = 'app.reviewer.available';
                    }
                    if (pathname.indexOf('app.reviewer.reviewing') === 0) {
                        pathname = 'app.reviewer.reviewing';
                    }
                    if (pathname.indexOf('app.reviewer.reviewed') === 0) {
                        pathname = 'app.reviewer.reviewed';
                    }
                    if (pathname.indexOf('app.reviewer.all') === 0) {
                        pathname = 'app.reviewer.all';
                    }
                    if (pathname.indexOf('app.common.contacts') === 0) {
                        pathname = 'app.common.contacts';
                    }
                    if (pathname.indexOf('app.common.profile') === 0) {
                        pathname = 'app.common.profile';
                    }
                    if (pathname.indexOf('app.dashboard.contact') === 0) {
                        pathname = 'app.dashboard.contact';
                    }
                    if (pathname.indexOf('app.dashboard.film') === 0) {
                        pathname = 'app.dashboard.film';
                    }
                    if (pathname.indexOf('app.system.email') === 0) {
                        pathname = 'app.system.email';
                    }
                    // if (pathname.indexOf('app.profile') === 0) {
                    // 	pathname = 'app.profile';
                    // }
                    // console.log('pathname after');
                    // console.log(pathname);
                    if (newAuthPayload.auth.userAuthorizations[pathname]) {
                        // console.log('url ' + path + ' is authorized by ' +  pathname);
                        return resolve(newAuthPayload.auth);
                    }
                    else {
                        _this.log.warn('url ' + path + ' is not authorized by ' + pathname);
                        _this.router.navigate(['']);
                        return resolve();
                    }
                }
                return resolve();
            })
                .catch(function (err) {
                // don't redirect or will be in endless loop
                _this.log.error(err);
                return resolve();
            });
        });
    };
    AuthService.prototype.readAuthFromLocalStorage = function () {
        var authJwt = localStorage.getItem('auth-jwt');
        if (!authJwt) {
            this.log.warn('ensureAuth, auth-jwt missing from local storage.');
            return null;
        }
        var expireDate = this.jwtHelper.getTokenExpirationDate(authJwt);
        // console.log('local jwt expires = ' + expireDate);
        if (!expireDate) {
            this.log.warn('ensureAuth, auth-jwt from local storage missing expireDate.');
            return null;
        }
        if (new Date() > expireDate) {
            this.log.warn('ensureAuth, auth-jwt from local storage has expired.  expireDate = ' + expireDate);
            return null;
        }
        var authPayload = this.jwtHelper.decodeToken(authJwt);
        if (!authPayload) {
            this.log.warn('ensureAuth, No authPayload while decoding auth-jwt.');
            return null;
        }
        this.userId = authPayload.auth.userId;
        this.organizationId = authPayload.auth.organizationId;
        this.eventId = authPayload.auth.eventId;
        this.userAuthorizations = authPayload.auth.userAuthorizations;
        this.showRoleReviewerTeam = authPayload.auth.showRoleReviewerTeam;
        this.showRoleTeamCaptainTeam = authPayload.auth.showRoleTeamCaptainTeam;
        return authPayload;
    };
    AuthService.prototype.getNewJwtAndModifiedDates = function (authPayload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/tokens/newjwtmodifydatesuiversion', options)
                .toPromise()
                .then(function (res) {
                return resolve(res.json());
            })
                .catch(function (err) {
                _this.log.error(err);
                return reject(err);
            });
        });
    };
    AuthService.prototype.switchOrganizationAndEvent = function (organizationId, eventId, observer) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["Headers"]({
                'Authorization': 'Bearer ' + accessToken,
                'Content-Type': 'application/json'
            });
            var options = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                organizationId: organizationId,
                eventId: eventId,
                observer: observer
            };
            var body = JSON.stringify(payload);
            _this.http.put(_this.config.basePath + '/v0/tokens/switch', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log(foo);
                return resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                return reject(err);
            });
        });
    };
    AuthService.prototype.redirectIfAuthorized = function () {
        if (!window.localStorage) {
            this.log.warn('redirectIfAuthorized, Browser does not support local storage.');
            return false;
        }
        var authJwt = localStorage.getItem('auth-jwt');
        if (!authJwt) {
            this.log.warn('redirectIfAuthorized, auth-jwt missing from local storage.');
            return false;
        }
        var expireDate = this.jwtHelper.getTokenExpirationDate(authJwt);
        // console.log('local jwt expires = ' + expireDate);
        if (new Date() > expireDate) {
            this.log.warn('redirectIfAuthorized, auth-jwt from local storage has expired.  expireDate = ' + expireDate);
            return false;
        }
        var authPayload = this.jwtHelper.decodeToken(authJwt);
        if (!authPayload) {
            this.log.warn('redirectIfAuthorized, No authPayload while decoding auth-jwt.');
            return false;
        }
        console.log('authPayload');
        console.log(authPayload);
        // TODO!!! - add more sophisticated redirect logic here !!!
        var originalHref = this.log.originalHref;
        console.log('redirectIfAuthorized, originalHref');
        console.log(originalHref);
        var theUrl;
        try {
            theUrl = __WEBPACK_IMPORTED_MODULE_8_url__["parse"](originalHref);
            console.log('theUrl');
            console.log(theUrl);
            var parts = theUrl.pathname.split('/');
            console.log('redirectIfAuthorized, pathname parts');
            console.log(parts);
            if (parts.length > 1) {
                var pathBase = parts[1].toLowerCase();
                if (pathBase === 'oauth') {
                    console.log('found pathBase oauth');
                    return false;
                }
            }
        }
        catch (err) {
            this.log.error('Error parsing href, originalHref = ' + originalHref);
            this.log.error(err);
        }
        // TODO!!! - remove, temp hack
        if (
        // (authPayload.auth.userId === 'c3bed8716ae14d6693b336dfce19d02e') ||		// Pat McFaul
        (authPayload.auth.userId === '647418a39d724bef86b1b244b6c40a8a') ||
            (authPayload.auth.userId === 'd1530b1b2b6b4ed6b65f3671e632b683') ||
            (authPayload.auth.userId === '71e297b3621840b8ba30f57b42557d9b') // BFF, Paul Sturtz
        ) {
            this.router.navigate(['/reviewer/all']);
            return true;
        }
        // first check if authorized for festival.ticket
        if (authPayload.auth.userAuthorizations['app.festival.ticket']) {
            this.router.navigate(['/festival/5dde71766d5342f39e8a0abfaaeab3f4/nextup']);
            return true;
        }
        // first check if authorized for reviewer.available
        if (authPayload.auth.userAuthorizations['app.reviewer.available']) {
            this.router.navigate(['/reviewer/available']);
            return true;
        }
        // second check if authorized for common.profile
        if (authPayload.auth.userAuthorizations['app.common.profile']) {
            this.router.navigate(['/common/profile']);
            return true;
        }
        // else nope
        return false;
    };
    AuthService.prototype.getAuth = function () {
        return new Promise(function (resolve, reject) {
            return resolve(fullAuth);
            // this.http.get('http://localhost:3000/v0/version')
            // 	.subscribe( (res) => {
            // 		console.log(res.json());
            // 		resolve(  JSON.stringify(res.json(), null, 4)    );
            // 	});
        });
    };
    AuthService.prototype.getSavedAuth = function () {
        var authJwt = localStorage.getItem('auth-jwt');
        if (!authJwt) {
            return [];
        }
        var expireDate = this.jwtHelper.getTokenExpirationDate(authJwt);
        if (!expireDate) {
            return [];
        }
        if (new Date() > expireDate) {
            return [];
        }
        var authPayload = this.jwtHelper.decodeToken(authJwt);
        if (!authPayload) {
            return [];
        }
        // console.log('authPayload.auth.userAuthorizations');
        // console.log(authPayload.auth.userAuthorizations);
        return authPayload.auth.userAuthorizations;
    };
    AuthService.prototype.clearCache = function () {
        if (window.localStorage) {
            localStorage.removeItem('all-films');
            localStorage.removeItem('all-reviews');
            localStorage.removeItem('all-users');
            localStorage.removeItem('user-films');
            localStorage.removeItem('user-profile');
            localStorage.removeItem('user-reviews');
            localStorage.removeItem('all-filter');
            localStorage.removeItem('reviewed-filter');
            localStorage.removeItem('available-filter');
            localStorage.removeItem('visible-tabs');
            localStorage.removeItem('enable-ballot-report');
        }
    };
    AuthService.prototype.authUsingNonce = function (userId, nonce) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // let accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["Headers"]({ 'Content-Type': 'application/json' });
            var options = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["RequestOptions"]({ headers: headers });
            var randomPassword = __WEBPACK_IMPORTED_MODULE_4_uuid__["v4"]().replace(/-/g, '');
            // let passwordResetExpires = Date.now() + 30 days; ??
            var passwordResetExpires = Date.now(); // currently not checked
            var payload = {
                password: randomPassword,
                passwordResetToken: nonce,
                passwordResetExpires: passwordResetExpires,
                noPassword: true
            };
            var body = JSON.stringify(payload);
            _this.http.put(_this.config.basePath + '/v0/users/' + userId + '/nopassword', body, options)
                .toPromise()
                .then(function (res) {
                var foo = res.json();
                // console.log(foo);
                var bar = foo;
                console.log('authUsingNonce, saving auth-jwt');
                localStorage.setItem('auth-jwt', bar.token);
                var authPayload = _this.jwtHelper.decodeToken(bar.token);
                if (authPayload && authPayload.auth) {
                    console.log('authUsingNonce, successfully decoded auth-jwt');
                    _this.userId = authPayload.auth.userId;
                    _this.organizationId = authPayload.auth.organizationId;
                    _this.eventId = authPayload.auth.eventId;
                    console.log('authUsingNonce, setting userId, organizationId, and eventId.  userId=' + _this.userId + ', organizationId=' + _this.organizationId + ', eventId=' + _this.eventId);
                }
                resolve();
            })
                .catch(function (err) {
                _this.log.error(err);
                reject();
            });
        });
    };
    AuthService.prototype.authUsingActivationCode = function (activationCode) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var headers = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["Headers"]({ 'Content-Type': 'application/json' });
            var options = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                activationCode: activationCode
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/users/activation', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                // // console.log(foo);
                // let bar: any = foo;
                if (result.messageId === 'token-created') {
                    console.log('authUsingActivationCode, saving auth-jwt');
                    localStorage.setItem('auth-jwt', result.token);
                    var authPayload = _this.jwtHelper.decodeToken(result.token);
                    if (authPayload && authPayload.auth) {
                        console.log('authUsingActivationCode, successfully decoded auth-jwt');
                        _this.userId = authPayload.auth.userId;
                        _this.organizationId = authPayload.auth.organizationId;
                        _this.eventId = authPayload.auth.eventId;
                        console.log('authUsingActivationCode, setting userId, organizationId, and eventId.  userId=' + _this.userId + ', organizationId=' + _this.organizationId + ', eventId=' + _this.eventId);
                    }
                }
                resolve(result);
            })
                .catch(function (err) {
                _this.log.error(err);
                reject(err);
            });
        });
    };
    AuthService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_common__["k" /* Location */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_router__["m" /* Router */] }, { type: __WEBPACK_IMPORTED_MODULE_5__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_6__log_service__["a" /* LogService */] }, { type: __WEBPACK_IMPORTED_MODULE_7__version_service__["a" /* VersionService */] }]; };
    return AuthService;
}());

// TODO - detetct "private mode browsing on iOS !!!
// "_id" : ObjectId("57a6434a98cbc7906c93070b"),
// "deletedBy" : "",
// "deleted" : null,
// "modifiedBy" : "",
// "modified" : 1470513994714,
// "createdBy" : "",
// "created" : 1470513994714,
// "browserDownloadSpeed" : "",
// "browserPerformance" : "{}",
// "browserScreenSize" : "{\"screen\":{\"width\":768,\"height\":1024},\"window\":{\"width\":1024,\"height\":649},\"document\":{\"width\":1024,\"height\":649}}",
// "browserUserAgent" : "{\"ua\":\"Mozilla/5.0 (iPad; CPU OS 9_3_3 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Version/9.0 Mobile/13G34 Safari/601.1\",\"browser\":{\"name\":\"Mobile Safari\",\"version\":\"9.0\",\"major\":\"9\"},\"engine\":{\"version\":\"601.1.46\",\"name\":\"WebKit\"},\"os\":{\"name\":\"iOS\",\"version\":\"9.3.3\"},\"device\":{\"model\":\"iPad\",\"vendor\":\"Apple\",\"type\":\"tablet\"},\"cpu\":{}}",
// "browserIpAddress" : "47.215.230.64",
// "browserHeaders" : "{\"x-forwarded-for\":\"47.215.230.64\",\"host\":\"api.ptffportal.org\",\"x-real-ip\":\"47.215.230.64\",\"x-forwarded-proto\":\"https\",\"connection\":\"close\",\"content-length\":\"1679\",\"accept\":\"*/*\",\"accept-language\":\"en-us\",\"accept-encoding\":\"gzip, deflate\",\"content-type\":\"application/json\",\"origin\":\"https://oceanbluffproductions.com\",\"referer\":\"https://oceanbluffproductions.com/\",\"dnt\":\"1\"}",
// "stackTrace" : "setItem@[native code]\n\ninvoke@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:7220\nonInvoke\ninvoke@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:7174\nrun@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:4608\nhttps://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:3339\ninvokeTask@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:7851\nonInvokeTask\ninvokeTask@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:7794\nrunTask@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:5214\na@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:2435\ninvoke@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:8990",
// "codeLocation" : "invoke@https://oceanbluffproductions.com/lib-00003/zone.js/dist/zone.min.js:1:7220",
// "message" : "Error: QuotaExceededError: DOM Exception 22",
// "errorSource" : "",
// "type" : "error",
// "logSource" : "ui",
// "logId" : "3749ef30bd244bd1810d4c13cc0d16de",
// "__v" : 0
//# sourceMappingURL=auth.service.js.map

/***/ }),

/***/ "cDNt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/core/@angular/core.es5.js
var core_es5 = __webpack_require__("/oeL");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/environments/environment.ts
var environment = {
    production: true
};
//# sourceMappingURL=environment.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/rxjs/_esm5/Rx.js + 336 modules
var Rx = __webpack_require__("U6yM");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rgUS");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/app.module.ts

 // only needs to be included here, not in lazy loaded modules
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());

//# sourceMappingURL=app.module.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/router/@angular/router.es5.js
var router_es5 = __webpack_require__("BkNc");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/common/@angular/common.es5.js
var common_es5 = __webpack_require__("qbdv");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/uuid/index.js
var uuid = __webpack_require__("aMZo");
var uuid_default = /*#__PURE__*/__webpack_require__.n(uuid);

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/auth.service.ts
var auth_service = __webpack_require__("aZFh");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/feedback.service.ts
var feedback_service = __webpack_require__("MBKK");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/log.service.ts
var log_service = __webpack_require__("B1/m");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/perf.service.ts
var perf_service = __webpack_require__("+wEl");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/tab.service.ts
var tab_service = __webpack_require__("+eyU");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/user.service.ts
var user_service = __webpack_require__("emCa");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/app.component.ts









/* tslint:disable:no-unused-variable */
var events = {
    '5dde71766d5342f39e8a0abfaaeab3f4': {
        domain: 'ptfilmfest',
        imageBasePath: 'https://s3-us-west-2.amazonaws.com/cdn.ptffportal.org/porttownsend/2016/reviewer/image/',
        wabFestivalId: '1364',
        filmTypeList: [
            'feature,narrative,feature narrative',
            'feature,documentary,feature documentary',
            'short,narrative,short narrative',
            'short,documentary,short documentary'
        ],
        teamTypeList: [
            'narrative',
            'documentary'
        ],
        programDirectorTypeList: [
            'feature,short,narrative,documentary,animation,student'
        ],
        defaultSumissionCredentials: {
            filmFreewayUsername: 'ReviewerService@ptfilmfest.com',
            filmFreewayPassword: 'Opinions@boutFilm5',
            withoutaboxUsername: 'ReviewerService@ptfilmfest.com',
            withoutaboxPassword: 'Opinions@boutFilm5'
        }
    },
    'b3b5117aba6249e49084a02d7a1c2c6e': {
        domain: 'sedonafilmfestival',
        imageBasePath: 'https://s3-us-west-2.amazonaws.com/cdn.ptffportal.org/sedonafilmfestival/2017/reviewer/image/',
        wabFestivalId: '1318',
        filmTypeList: [
            'short,short',
            'documentary,feature documentary',
            'narrative,feature narrative',
            'feature,feature narrative'
        ],
        teamTypeList: [
            'short',
            'feature,documentary',
            'feature,narrative'
        ],
        programDirectorTypeList: [
            'short',
            'feature,documentary',
            'feature,narrative'
        ],
        defaultSumissionCredentials: {
            filmFreewayUsername: 'screeners@sedonafilmfestival.com',
            filmFreewayPassword: 'Vi3wF1lms',
            withoutaboxUsername: 'screeners@sedonafilmfestival.com',
            withoutaboxPassword: 'Vi3wF1lms'
        }
    }
};
/* tslint:enable:no-unused-variable */
var app_component_AppComponent = (function () {
    function AppComponent(activatedRoute, location, router, authService, feedbackService, log, perf, tabService, userService) {
        this.activatedRoute = activatedRoute;
        this.location = location;
        this.router = router;
        this.authService = authService;
        this.feedbackService = feedbackService;
        this.log = log;
        this.perf = perf;
        this.tabService = tabService;
        this.userService = userService;
        // @ViewChild(ContactsComponent) contactsComponent: ContactsComponent;
        // @ViewChild(ReviewerContentComponent) reviewerContentComponent: ReviewerContentComponent;
        // eventId = '';
        this.view = true;
        this.help = false;
        this.feedback = false;
        this.feedbackComments = '';
        this.userProfile = {
            showFeatureNarrative: true,
            showFeatureDocumentary: true,
            showShortNarrative: true,
            showShortDocumentary: true,
            showShort: true,
            showUnsent: true,
            showSent: true,
            showAccepted: true,
            showReviewing: true,
            showRejected: true,
            showSubmissionIdAndDate: true,
            sortField: 'title',
            sortDirection: 'ascending',
            tempFilteredFilmCount: 0,
            tempTotalFilmCount: 0,
            isContentTab: false,
            isLetterTab: false,
            isLineupTab: false,
            hideAll: false,
            showToolbar: true,
            module: 'reviewer',
            tab: '',
            showFilmCount: true,
            showFilterType: 'all',
            showReviewerFilms: true,
            showExternalLineupFilms: true,
            showSortField: true,
            showSortDirection: true,
            showLineupVoteFilter: true,
            showLetterFilter: true,
            displayFeatureNarrative: true,
            displayFeatureDocumentary: true,
            displayShortNarrative: false,
            displayShortDocumentary: false,
            displayShort: true
        };
        this.onlyReviewerOrOnlyObserver = false;
        this.onlyReviewerOrOnlyObserverDocumentary = false;
        this.onlyReviewerOrOnlyObserverNarrative = false;
        this.showGotoTop = false;
        this.pinMenuBar = true;
        this.showTwoRowMenuBar = false;
        this.tabs = {};
        this.needProfileInitialized = true;
        /*
            onGotoTopOfPage() {
                window.scrollTo(0, 0);
            }
        
        
            onScroll(ev: any) {
                let bodyScrollTop = window.document.body.scrollTop || window.document.documentElement.scrollTop;
                let screenHeight = window.innerHeight;
                // console.log('bodyScrollTop = ' + bodyScrollTop);
                // console.log('screenHeight = ' + screenHeight);
        
                if (bodyScrollTop > 90) {
                // if (bodyScrollTop > 500) {
                // if (bodyScrollTop > screenHeight) {
                    this.showGotoTop = true;
                } else {
                    this.showGotoTop = false;
                }
            }
        */
        this.profileTabs = [{
                name: 'Contacts',
                route: '/contacts',
                isSelected: false,
                isEnabled: false,
                auth: 'app.contacts'
            }, {
                name: 'Companies',
                route: '/companies',
                isSelected: false,
                isEnabled: false,
                auth: 'app.companies'
            }, {
                name: 'Films',
                route: '/films',
                isSelected: false,
                isEnabled: false,
                auth: 'app.films'
            }, {
                name: 'Lineup',
                route: '/reviewer/program',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.program'
            }, {
                name: 'Letter',
                route: '/reviewer/letter',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.letter'
            }, {
                name: 'Block',
                route: '/reviewer/block',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.block'
            }, {
                name: 'Grid',
                route: '/reviewer/grid',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.grid'
            }, {
                name: 'Ballot',
                route: '/reviewer/ballot',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.ballot'
            }, {
                name: 'Team',
                route: '/reviewer/team',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.team'
            }, {
                name: 'Content',
                route: '/reviewer/content',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.content'
            }, {
                name: 'Available',
                route: '/reviewer/available',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.available'
            }, {
                name: 'Reviewing',
                route: '/reviewer/reviewing',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.reviewing'
            }, {
                name: 'Reviewed',
                route: '/reviewer/reviewed',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.reviewed'
            }, {
                name: 'All',
                route: '/reviewer/all',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.all'
            }, {
                name: 'Settings',
                route: '/reviewer/settings',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.settings'
            }, {
                name: 'Organization',
                route: '/system/organization',
                isSelected: false,
                isEnabled: false,
                auth: 'app.system.organization'
            }, {
                name: 'Event',
                route: '/system/event',
                isSelected: false,
                isEnabled: false,
                auth: 'app.system.event'
            }, {
                name: 'Email',
                route: '/system/email',
                isSelected: false,
                isEnabled: false,
                auth: 'app.system.email'
            }, {
                name: 'Profile',
                route: '/profile',
                isSelected: false,
                isEnabled: false,
                auth: 'app.profile'
            }, {
                name: 'Dev',
                route: '/reviewer/dev',
                isSelected: false,
                isEnabled: false,
                auth: 'app.reviewer.dev'
            }];
        // console.log('AppComponent constructor');
    }
    // tabLinkz = [
    // 	{label: 'SITE', link: 'reviewer/result'},
    // 	{label: 'FESTIVAL', link: 'reviewer/contact'},
    // 	{label: 'PROGRAM', link: 'reviewer/team'},
    // 	{label: 'REVIEWER', link: 'reviewer/content'},
    // 	{label: 'PASSES', link: 'reviewer/availalbe'},
    // 	{label: 'VOLUNTEER', link: 'reviewer/reviewing'},
    // 	{label: 'SPONSOR', link: 'reviewer/reviewed'},
    // 	{label: 'DONATION', link: 'reviewer/all'},
    // 	{label: 'SETTINGS', link: 'profile'},
    // 	{label: 'SYSTEM', link: 'reviewer/dev'}
    // ];
    // tabs2 = {
    // 	firstIndex: 3,
    // 	firstTabs: [
    // 		{name: 'SITE'},
    // 		{name: 'FESTIVAL'},
    // 		{name: 'PROGRAM'},
    // 		{name: 'REVIEWER'},
    // 		// {name: 'PASSES', link: 'reviewer/availalbe'},
    // 		// {name: 'VOLUNTEER', link: 'reviewer/reviewing'},
    // 		// {name: 'SPONSOR', link: 'reviewer/reviewed'},
    // 		// {name: 'DONATION', link: 'reviewer/all'},
    // 		// {name: 'SETTINGS', link: 'profile'},
    // 		{name: 'SYSTEM'}
    // 	],
    // 	secondTabs: [
    // 		{
    // 			index: 0,
    // 			tabs: [
    // 				{name: 'HOME', link: 'site/home'},
    // 				{name: 'STORY', link: 'site/story'},
    // 				{name: 'FEATURES', link: 'site/features'},
    // 				{name: 'PRICING', link: 'site/pricing'},
    // 				{name: 'GET STARTED', link: 'site/getstarted'},
    // 				{name: 'CONTACT', link: 'site/contact'}
    // 			]
    // 		},
    // 		{
    // 			index: 0,
    // 			tabs: [
    // 				// {name: 'ROSE THEATER', link: 'festival/venues'},
    // 				{name: 'CONCIERGE', link: 'festival/concierge'},
    // 				{name: 'BALLOTS', link: 'festival/ballots'},
    // 				{name: 'NEXT UP', link: 'festival/nextup'},
    // 				{name: 'PROGRAM', link: 'festival/program'},
    // 				{name: 'FILMS', link: 'festival/films'},
    // 				{name: 'FAVORITES', link: 'festival/favorites'},
    // 				{name: 'TICKETS', link: 'festival/tickets'}
    // 			]
    // 		},
    // 		{
    // 			index: 0,
    // 			tabs: [
    // 				{name: 'LINEUP', link: 'program/lineup'},
    // 				{name: 'LETTER', link: 'program/letter'},
    // 				{name: 'BLOCK', link: 'program/block'},
    // 				{name: 'GRID', link: 'program/grid'},
    // 				{name: 'BALLOT', link: 'program/ballot'}
    // 			]
    // 		},
    // 		{
    // 			index: 0,
    // 			tabs: [
    // 				{name: 'RESULTS', link: 'reviewer/results'},
    // 				{name: 'TEAM', link: 'reviewer/team'},
    // 				{name: 'CONTENT', link: 'reviewer/content'},
    // 				{name: 'AVAILABLE', link: 'reviewer/available'},
    // 				{name: 'REVIEWING', link: 'reviewer/reviewing'},
    // 				{name: 'REVIEWED', link: 'reviewer/reviewed'},
    // 				{name: 'ALL', link: 'reviewer/all'},
    // 				{name: 'CONTACTS', link: 'common/contacts'},
    // 				// {name: 'SETTINGS', link: 'common/settings'},
    // 				{name: 'PROFILE', link: 'common/profile'},
    // 				{name: 'DEV', link: 'reviewer/dev'}
    // 			]
    // 		},
    // 		{
    // 			index: 0,
    // 			tabs: [
    // 				{name: 'ORGANIZATION', link: 'system/organization'},
    // 				{name: 'EVENT', link: 'system/event'},
    // 				{name: 'EMAIL', link: 'system/email'},
    // 				{name: 'PRECONTENT', link: 'system/precontent'}
    // 			]
    // 		}
    // 	]
    // };
    // async ngOnInit() {
    AppComponent.prototype.ngOnInit = function () {
        // console.log('AppComponent ngOnInit #1');
        var _this = this;
        // save to be used on unhandled exception
        window['log'] = this.log;
        // console.log('AppComponent ngOnInit #1.1');
        this.log.originalHref = window.location.href;
        // console.log('AppComponent, this.log.originalHref');
        // console.log(this.log.originalHref);
        // console.log('AppComponent ngOnInit #1.2');
        if (!localStorage) {
            this.log.error('No local storage support.');
        }
        if (!window.indexedDB) {
            this.log.error('No indexed db support.');
        }
        // console.log('AppComponent ngOnInit #1.3');
        try {
            if (localStorage) {
                // console.log('AppComponent ngOnInit #1.4');
                // check if there is a deviceId
                var visitDeviceId = localStorage.getItem('d');
                // console.log('AppComponent ngOnInit #1.5');
                if (visitDeviceId) {
                    // console.log('AppComponent ngOnInit #1.6');
                    // returning device, inc count
                    this.log.visitDeviceId = visitDeviceId;
                    var tempVisitCount = 1;
                    var visitCountString = localStorage.getItem('c');
                    try {
                        tempVisitCount = parseInt(visitCountString, 10);
                        tempVisitCount += 1;
                    }
                    catch (ex) {
                        tempVisitCount = 1;
                    }
                    this.log.visitCount = tempVisitCount;
                    localStorage.setItem('c', '' + this.log.visitCount);
                    this.log.visitUserId = localStorage.getItem('u');
                    if (!this.log.visitUserId && this.authService.userId) {
                        this.log.visitUserId = this.authService.userId;
                        localStorage.setItem('u', '' + this.log.visitUserId);
                    }
                }
                else {
                    // console.log('AppComponent ngOnInit #1.7');
                    // new device
                    this.log.visitDeviceId = uuid["v4"]().replace(/-/g, '');
                    localStorage.setItem('d', this.log.visitDeviceId);
                    this.log.visitCount = 1;
                    localStorage.setItem('c', '' + this.log.visitCount);
                    this.log.info('New device. visitDeviceId = ' + this.log.visitDeviceId);
                }
            }
        }
        catch (err) {
            console.log('AppComponent ngOnInit, Error writing to local storage');
            console.log(err);
        }
        // console.log('AppComponent ngOnInit #2');
        // !!! TODO - turn this into subscription
        this.pinMenuBar = this.tabService.pinMenuBar;
        this.showTwoRowMenuBar = this.tabService.showTwoRowMenuBar;
        this.tabs = this.tabService.navTabs;
        this.tabService.pinMenuBarSource.asObservable()
            .subscribe(function (pinMenuBarChecked) {
            console.log('pinMenuBarChecked');
            console.log(pinMenuBarChecked);
            _this.pinMenuBar = pinMenuBarChecked;
        });
        this.tabService.showTwoRowMenuBarSource.asObservable()
            .subscribe(function (showTwoRowMenuBarChecked) {
            // console.log('showTwoRowMenuBarChecked');
            // console.log(showTwoRowMenuBarChecked);
            _this.showTwoRowMenuBar = showTwoRowMenuBarChecked;
        });
        this.tabService.newTabsSource.asObservable()
            .subscribe(function (newTabs) {
            // console.log('newTabs');
            // console.log(newTabs);
            _this.tabs = newTabs;
        });
        /*
                // ensure auth already read, so can make api call to get user info
                if (this.authService.readAuthFromLocalStorage()) {
                    // new, now always read profile to get settings at startup, but only after auth
                    // init twoRowMemuBar before updating tabs
        
                    // tab service always reads the profile name from local storage
                    // check to see if profile name does not exist in local storage
                    // if not there, make call to get, store, then refresh tabs
                    if (this.authService.organizationId && !this.userService.settings) {
                        console.log('AppComponent before userService.getUserProfile()');
                        let profile: any = await this.userService.getUserProfile();
                        console.log('AppComponent after userService.getUserProfile()');
                        if (profile) {
                            if (profile && profile.profile) {
                                let savedInfo: any = {
                                    firstName: profile.profile.firstName,
                                    lastWithoutaboxLogin: 0,
                                    lastFilmFreewayLogin: 0
                                };
        
                                if (localStorage) {
                                    let savedInfoString2 = JSON.stringify(savedInfo);
                                    localStorage.setItem('saved-info', savedInfoString2);
                                }
        
                                if (this.userService.settings && this.userService.settings.profile) {
                                    if (this.userService.settings.profile.twoRowMemuBar) {
                                        this.tabService.showTwoRowMenuBar = this.showTwoRowMenuBar = true;
                                    } else {
                                        this.tabService.showTwoRowMenuBar = this.showTwoRowMenuBar = false;
                                    }
                                }
                            }
                        }
                        // this.tabService.updateTabsByRoute(currentPath);
                    }
                }
        */
        // console.log('AppComponent ngOnInit #3');
        this.router.events.subscribe(function (ev) {
            // console.log('>>>>> AppComponent router.events.subscribe');
            if (ev instanceof router_es5["e" /* NavigationStart */]) {
                var currentPath1 = _this.location.path();
                // console.log('>>>>> NavigationStart: ' + currentPath1);
                _this.log.currentPath = ev.url;
                _this.log.action(ev.url);
                return;
            }
            if (ev instanceof router_es5["r" /* RoutesRecognized */]) {
                // console.log('>>>>> RoutesRecognized');
                return;
            }
            var end = (ev instanceof router_es5["d" /* NavigationEnd */]);
            if (!end) {
                // console.log('>>>>> Unknown navigation event:');
                // console.log(ev);
                return;
            }
            var currentPath = _this.location.path();
            // console.log('>>>>> NavigationEnd: ' + currentPath);
            console.log('NavigationEnd: ' + currentPath);
            // console.log(ev);
            try {
                // tab service always reads the profile name from local storage
                // check to see if profile name does not exist in local storage
                // if not there, make call to get, store, then refresh tabs
                if (_this.authService.organizationId && window.localStorage) {
                    if (!localStorage.getItem('saved-info')) {
                        _this.userService.getUserProfile()
                            .then(function (profile) {
                            console.log('AppComponent, getUserProfile called');
                            console.log('profile = ');
                            console.log(profile);
                            if (profile && profile.profile) {
                                var savedInfo = {
                                    firstName: profile.profile.firstName,
                                    lastWithoutaboxLogin: 0,
                                    lastFilmFreewayLogin: 0
                                };
                                console.log('savedInfo = ' + savedInfo);
                                console.log(savedInfo);
                                var savedInfoString2 = JSON.stringify(savedInfo);
                                localStorage.setItem('saved-info', savedInfoString2);
                                _this.tabService.setProfileName();
                                _this.tabService.updateTabsByRoute(currentPath);
                                if (profile &&
                                    profile.profile &&
                                    profile.profile.settings &&
                                    profile.profile.settings.common &&
                                    profile.profile.settings.common.profile &&
                                    profile.profile.settings.common.profile.twoRowMemuBar) {
                                    console.log('profile.profile.settings.common.profile.twoRowMemuBar');
                                    console.log(profile.profile.settings.common.profile.twoRowMemuBar);
                                    _this.tabService.showTwoRowMenuBarSource.next(true);
                                }
                                _this.needProfileInitialized = false;
                            }
                        });
                    }
                    else if (_this.needProfileInitialized) {
                        _this.userService.getUserProfile()
                            .then(function (profile) {
                            // console.log('AppComponent, getUserProfile called for needProfileInitialized');
                            // console.log('profile = ');
                            // console.log(profile);
                            if (profile &&
                                profile.profile &&
                                profile.profile.settings &&
                                profile.profile.settings.common &&
                                profile.profile.settings.common.profile &&
                                profile.profile.settings.common.profile.twoRowMemuBar) {
                                // console.log('profile.profile.settings.common.profile.twoRowMemuBar');
                                // console.log(profile.profile.settings.common.profile.twoRowMemuBar);
                                _this.tabService.showTwoRowMenuBarSource.next(true);
                            }
                            _this.needProfileInitialized = false;
                        });
                    }
                }
            }
            catch (err) {
                console.log('AppComponent router.events.subscribe, Error writing to local storage');
                console.log(err);
            }
            return _this.authService.ensureAuth(currentPath)
                .then(function (newAuthPayload) {
                // console.log('AppComponent, this.authService.ensureAuth, resolve, currentPath = ' + currentPath);
                // if (newAuthPayload) {
                // 	this.eventId = newAuthPayload.eventId;
                // 	this.updateVisibleTabsByAuth(newAuthPayload);
                // }
                // console.log('AppComponent ensureAuth, before tabService.updateTabsByRoute');
                _this.tabService.updateTabsByRoute(currentPath);
                // console.log('AppComponent ensureAuth, after tabService.updateTabsByRoute');
                // update ink bar manually until Material Design fixes this
                // setTimeout(() => {
                // 	console.log('AppComponent setTimeout, updateInkBar');
                // 	this.toolBars.forEach((itdToolbarComponent: ItdToolbarComponent) => {
                // 		itdToolbarComponent.updateInkBar();
                // 	});
                // }, 10);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                _this.tabService.updateTabsByRoute(currentPath);
                // update ink bar manually until Material Design fixes this
                // setTimeout(() => {
                // 	// console.log('AppComponent setTimeout, updateInkBar');
                // 	this.toolBars.forEach((itdToolbarComponent: ItdToolbarComponent) => {
                // 		itdToolbarComponent.updateInkBar();
                // 	});
                // }, 10);
            });
        });
        /*
                this.filmFilterService.filmCount
                    .debounceTime(10)
                    .subscribe((count) => {
        
                    if (window.localStorage) {
                        let savedInfo: any = {
                            firstName: '',
                            lastWithoutaboxLogin: 0,
                            lastFilmFreewayLogin: 0
                        };
                        let savedInfoString = localStorage.getItem('saved-info');
                        if (savedInfoString) {
                            savedInfo = JSON.parse(savedInfoString);
                        }
        
                        if (savedInfo.firstName) {
                            this.profileTabs.forEach((tab) => {
                                if (tab.auth === 'app.profile') {
                                    tab.name = savedInfo.firstName;
                                }
                            });
                        }
                    }
        
                    this.userProfile.tempFilteredFilmCount = count.selected;
                    this.userProfile.tempTotalFilmCount = count.total;
                    this.userProfile.isContentTab = (count.tab === 'content');
                    this.userProfile.isLetterTab = (count.tab === 'letter');
                    this.userProfile.isLineupTab = (count.tab === 'lineup');
                    this.userProfile.hideAll = count.hideAll;
                    if (typeof count.showToolbar === 'undefined') {
                        this.userProfile.showToolbar = true;
                    } else {
                        this.userProfile.showToolbar = count.showToolbar;
                    }
                    this.userProfile.tab = count.tab;
                    this.userProfile.showFilmCount = count.showFilmCount;
                    this.userProfile.showSortField = count.showSortField;
                    this.userProfile.showSortDirection = count.showSortDirection;
                    this.userProfile.showLineupVoteFilter = count.showLineupVoteFilter;
                    this.userProfile.showLetterFilter = count.showLetterFilter;
        
                    if (count.module) {
                        this.userProfile.module = count.module;
                    } else {
                        this.userProfile.module = 'reviewer';
                    }
        
                    if (count.savedFilter) {
                        this.userProfile.showFeatureNarrative = count.savedFilter.showFeatureNarrative;
                        this.userProfile.showFeatureDocumentary = count.savedFilter.showFeatureDocumentary;
                        this.userProfile.showShortNarrative = count.savedFilter.showShortNarrative;
                        this.userProfile.showShortDocumentary = count.savedFilter.showShortDocumentary;
                        this.userProfile.showShort = count.savedFilter.showShort;
        
                        this.userProfile.showUnsent = count.savedFilter.showUnsent;
                        this.userProfile.showSent = count.savedFilter.showSent;
        
                        this.userProfile.showAccepted = count.savedFilter.showAccepted;
                        this.userProfile.showReviewing = count.savedFilter.showReviewing;
                        this.userProfile.showRejected = count.savedFilter.showRejected;
        
                        this.userProfile.showSubmissionIdAndDate = count.savedFilter.showSubmissionIdAndDate;
                        this.userProfile.sortField = count.savedFilter.sortField;
                        this.userProfile.sortDirection = count.savedFilter.sortDirection;
                    }
                    switch (count.showFilterType) {
                    case 'all':
                        if (this.eventId === '5dde71766d5342f39e8a0abfaaeab3f4') {
                            this.userProfile.displayFeatureNarrative = true;
                            this.userProfile.displayFeatureDocumentary = true;
                            this.userProfile.displayShortNarrative = true;
                            this.userProfile.displayShortDocumentary = true;
                        }
                        if (this.eventId === 'b3b5117aba6249e49084a02d7a1c2c6e') {
                            this.userProfile.displayFeatureNarrative = true;
                            this.userProfile.displayFeatureDocumentary = true;
                            this.userProfile.displayShort = true;
                        }
                        break;
        
                    case 'team':
                        this.userProfile.displayFeatureNarrative = false;
                        this.userProfile.displayFeatureDocumentary = false;
                        this.userProfile.displayShortNarrative = false;
                        this.userProfile.displayShortDocumentary = false;
                        this.userProfile.displayShort = false;
        
                        let teamString = this.authService.showRoleReviewerTeam;
                        if (teamString) {
                            // console.log('found teamString = ' + teamString);
        
                            let teams = teamString.split(';');
                            teams.forEach((team: any) => {
                                if (team === 'all') {
                                    if (this.eventId === '5dde71766d5342f39e8a0abfaaeab3f4') {
                                        this.userProfile.displayFeatureNarrative = true;
                                        this.userProfile.displayFeatureDocumentary = true;
                                        this.userProfile.displayShortNarrative = true;
                                        this.userProfile.displayShortDocumentary = true;
                                    }
                                    if (this.eventId === 'b3b5117aba6249e49084a02d7a1c2c6e') {
                                        this.userProfile.displayFeatureNarrative = true;
                                        this.userProfile.displayFeatureDocumentary = true;
                                        this.userProfile.displayShort = true;
                                    }
                                }
                                if (team === 'both') {
                                    if (this.eventId === '5dde71766d5342f39e8a0abfaaeab3f4') {
                                        this.userProfile.displayFeatureNarrative = true;
                                        this.userProfile.displayFeatureDocumentary = true;
                                        this.userProfile.displayShortNarrative = true;
                                        this.userProfile.displayShortDocumentary = true;
                                    }
                                    if (this.eventId === 'b3b5117aba6249e49084a02d7a1c2c6e') {
                                        this.userProfile.displayFeatureNarrative = true;
                                        this.userProfile.displayFeatureDocumentary = true;
                                        this.userProfile.displayShort = true;
                                    }
                                }
                                if (team === 'documentary') {
                                    this.userProfile.displayFeatureDocumentary = true;
                                    this.userProfile.displayShortDocumentary = true;
                                }
                                if (team === 'narrative') {
                                    this.userProfile.displayFeatureNarrative = true;
                                    this.userProfile.displayShortNarrative = true;
                                }
                                if (team === 'feature,documentary') {
                                    this.userProfile.displayFeatureDocumentary = true;
                                }
                                if (team === 'feature,narrative') {
                                    this.userProfile.displayFeatureNarrative = true;
                                }
                                if (team === 'short') {
                                    this.userProfile.displayShort = true;
                                }
                            });
                        } else {
                            // console.log('teamString NOT found');
        
                            if (this.eventId === '5dde71766d5342f39e8a0abfaaeab3f4') {
                                this.userProfile.displayFeatureNarrative = true;
                                this.userProfile.displayFeatureDocumentary = true;
                                this.userProfile.displayShortNarrative = true;
                                this.userProfile.displayShortDocumentary = true;
                            }
                            if (this.eventId === 'b3b5117aba6249e49084a02d7a1c2c6e') {
                                this.userProfile.displayFeatureNarrative = true;
                                this.userProfile.displayFeatureDocumentary = true;
                                this.userProfile.displayShort = true;
                            }
                        }
                        break;
        
                    case 'none':
                        this.userProfile.displayFeatureNarrative = false;
                        this.userProfile.displayFeatureDocumentary = false;
                        this.userProfile.displayShortNarrative = false;
                        this.userProfile.displayShortDocumentary = false;
                        this.userProfile.displayShort = false;
                        break;
                    }
        
                    // console.log('userProfile');
                    // console.log(this.userProfile);
                });
        
        */
    };
    AppComponent.prototype.ngAfterViewInit = function () {
        console.log('AppComponent ngAfterViewInit');
        this.perf.markAppStart();
    };
    AppComponent.prototype.ngOnDestroy = function () {
    };
    AppComponent.prototype.updateSelected = function (index) {
        if (index >= this.profileTabs.length) {
            return;
        }
        var authString = this.profileTabs[index].auth;
        authString = authString.slice(4);
        this.perf.markUserActionStart(authString + '.clicked');
        this.profileTabs.forEach(function (profileTab) {
            profileTab.isSelected = false;
        });
        this.profileTabs[index].isSelected = true;
        var route = this.profileTabs[index].route;
        this.router.navigate([route]);
    };
    // public updateSelectedTabByRoute(selectedRoute: string) {
    // 	// console.log('updateSelectedTabByRoute');
    // 	// console.log('selectedRoute');
    // 	// console.log(selectedRoute);
    // 	this.tabService.updateTabIndexesByRoute(this.tabs, selectedRoute);
    // }
    /*
        public updateVisibleTabsByAuth(auth: any) {
            // console.log('auth.userAuthorizations');
            // console.log(auth.userAuthorizations);
    
            this.profileTabs.forEach( (profileTab) => {
                if (auth.userAuthorizations[profileTab.auth] && this.tabService.getVisibility(profileTab.auth)) {
                    profileTab.isEnabled = true;
                } else {
                    profileTab.isEnabled = false;
                }
            });
        }
    */
    // updateFilmList(ev: any) {
    // 	let filter = JSON.parse(JSON.stringify(this.userProfile));
    // 	this.filmFilterService.updateFilmFilter(filter);
    // }
    AppComponent.prototype.goToFaq = function () {
        // console.log('goToFaq clicked!!');
        this.view = true;
        this.help = false;
        this.feedback = false;
        // this.router.navigate(['profile'], { queryParams: { faq: 1 } });
        this.log.showFaq = true;
        this.router.navigate(['profile']);
    };
    AppComponent.prototype.goToFestival = function (tabName) {
        this.perf.markUserActionStart('festival.' + tabName + '.sidenav-clicked');
        console.log('goToFestival clicked!!');
        this.view = true;
        this.help = false;
        this.feedback = false;
        this.router.navigate(['festival/5dde71766d5342f39e8a0abfaaeab3f4/' + tabName]);
    };
    AppComponent.prototype.sendFeedback = function () {
        var _this = this;
        // console.log('sendFeedback clicked!!');
        // console.log('feedbackComments:');
        // console.log(this.feedbackComments);
        this.view = true;
        this.help = false;
        this.feedback = false;
        this.feedbackService.sendFeedback(this.feedbackComments)
            .then(function () {
            _this.feedbackComments = '';
            _this.log.info('Feedback saved to db!');
        })
            .catch(function (err) {
            _this.feedbackComments = '';
            // TODO - add toast
            // console.log('toast: server not available');
            _this.log.error(err);
        });
    };
    // !!! TODO - PUT THESE BACK !!!
    // exportLineup() {
    // 	this.sidenav.close();
    // 	this.filmFilterService.updateExportFilms();
    // }
    // exportAgile() {
    // 	this.sidenav.close();
    // 	this.filmFilterService.updateAgileExport();
    // }
    // addExternalFilm() {
    // 	this.sidenav.close();
    // 	this.perf.markUserActionStart('reviewer.program.add-external-film-clicked');
    // 	this.router.navigateByUrl('/reviewer/program/0');
    // 	// this.router.navigateByUrl('/reviewer/program/c857502877b44d5ca6691dbea25684b9');
    // }
    AppComponent.prototype.search = function () {
        console.log('search');
    };
    AppComponent.ctorParameters = function () { return [{ type: router_es5["a" /* ActivatedRoute */] }, { type: common_es5["k" /* Location */] }, { type: router_es5["m" /* Router */] }, { type: auth_service["a" /* AuthService */] }, { type: feedback_service["a" /* FeedbackService */] }, { type: log_service["a" /* LogService */] }, { type: perf_service["a" /* PerfService */] }, { type: tab_service["a" /* TabService */] }, { type: user_service["a" /* UserService */] }]; };
    return AppComponent;
}());

//# sourceMappingURL=app.component.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/dialog/typings/index.ngfactory.ts
var index_ngfactory = __webpack_require__("kJcM");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/datepicker/typings/index.ngfactory.ts
var typings_index_ngfactory = __webpack_require__("/Srw");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/tooltip/typings/index.ngfactory.ts
var tooltip_typings_index_ngfactory = __webpack_require__("O00e");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/snack-bar/typings/index.ngfactory.ts
var snack_bar_typings_index_ngfactory = __webpack_require__("8HKE");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/oauth-callback/oauth-callback.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9vYXV0aC1jYWxsYmFjay9vYXV0aC1jYWxsYmFjay5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9wYXQvc291cmNlL2l0ZGV2aWNlcy9naXRsYWIvb2NlYW5ibHVmZnByb2R1Y3Rpb25zL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy11aS9zcmMvYXBwL2NvbXBvbmVudHMvb2F1dGgtY2FsbGJhY2svb2F1dGgtY2FsbGJhY2suY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=oauth-callback.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/list-page/list-page.component.ngfactory.ts + 10 modules
var list_page_component_ngfactory = __webpack_require__("2vLz");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/list-page/list-page.component.ts
var list_page_component = __webpack_require__("aUiu");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/button/typings/index.ngfactory.ts
var button_typings_index_ngfactory = __webpack_require__("wjk8");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/core.es5.js
var esm5_core_es5 = __webpack_require__("j5BN");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/button.es5.js
var button_es5 = __webpack_require__("ghl+");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/platform.es5.js
var platform_es5 = __webpack_require__("V8+5");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/a11y.es5.js
var a11y_es5 = __webpack_require__("8Xfy");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/platform-browser/@angular/platform-browser.es5.js
var platform_browser_es5 = __webpack_require__("fc+i");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/material.es5.js
var material_es5 = __webpack_require__("6lRS");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/page/page.component.ts
var page_component = __webpack_require__("BWg/");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/http/@angular/http.es5.js
var http_es5 = __webpack_require__("CPp0");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/config.service.ts
var config_service = __webpack_require__("CNKn");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/oauth.service.ts




var oauth_service_OauthService = (function () {
    function OauthService(http, authService, config, log) {
        this.http = http;
        this.authService = authService;
        this.config = config;
        this.log = log;
    }
    OauthService.prototype.createEmailAuthorizationUrl = function (payload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new http_es5["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new http_es5["RequestOptions"]({ headers: headers });
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/oauth/emailauthorizationurl', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                console.log('result');
                console.log(result);
                resolve(result);
            })
                .catch(function (err) {
                _this.log.error(err);
                reject(err);
            });
        });
    };
    OauthService.prototype.createEmailAccessToken = function (payload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new http_es5["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new http_es5["RequestOptions"]({ headers: headers });
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/oauth/emailaccesstoken', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                console.log('result');
                console.log(result);
                resolve(result);
            })
                .catch(function (err) {
                _this.log.error(err);
                reject(err);
            });
        });
    };
    OauthService.ctorParameters = function () { return [{ type: http_es5["Http"] }, { type: auth_service["a" /* AuthService */] }, { type: config_service["a" /* ConfigService */] }, { type: log_service["a" /* LogService */] }]; };
    return OauthService;
}());

//# sourceMappingURL=oauth.service.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/components/oauth-callback/oauth-callback.component.ts









var oauth_callback_component_OauthCallbackComponent = (function () {
    function OauthCallbackComponent(location, router, activatedRoute, sanitizer, snackBar, authService, log, oauthService, perf) {
        this.location = location;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.sanitizer = sanitizer;
        this.snackBar = snackBar;
        this.authService = authService;
        this.log = log;
        this.oauthService = oauthService;
        this.perf = perf;
        this.ContentSize = page_component["a" /* ContentSize */]; // enable enum in template
        // viewHeight = '';
        // dialogTitle = '';
        // dialogContent1 = '';
        // dialogContent2 = '';
        // dialogOk = '';
        // dialogCancel = '';
        // dialogData = '';
        // helpUrlLabel = '';
        // helpUrlString = '';
        // @ViewChild('confirmDialog') confirmDialog: DialogComponent;
        this.oauthAuthorizeCode = '';
        this.oauthError = '';
        this.oauthState = '';
        this.emailProvider = '';
        this.errorDescription = '';
    }
    OauthCallbackComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.log('OauthCallbackComponent ngOnInit');
        window.scrollTo(0, 0);
        // this.activatedRoute.queryParams
        this.activatedRoute.params
            .subscribe(function (params) {
            console.log('params');
            console.log(params);
            if (params.code) {
                _this.oauthAuthorizeCode = params.code;
            }
            if (params.error) {
                _this.oauthError = params.error;
            }
            if (params.error_description) {
                _this.errorDescription = params.error_description;
            }
            if (params.state) {
                _this.oauthState = params.state;
            }
            console.log('this.oauthAuthorizeCode');
            console.log(_this.oauthAuthorizeCode);
            console.log('this.oauthError');
            console.log(_this.oauthError);
            console.log('this.errorDescription');
            console.log(_this.errorDescription);
            console.log('this.oauthState');
            console.log(_this.oauthState);
            if (_this.oauthState) {
                if (_this.oauthState.indexOf('gmail') === 0) {
                    _this.emailProvider = 'gmail';
                }
                else if (_this.oauthState.indexOf('outlook') === 0) {
                    _this.emailProvider = 'outlook';
                }
            }
            console.log('this.emailProvider');
            console.log(_this.emailProvider);
            if (_this.oauthError) {
                return;
            }
            var payload = {
                oauthAuthorizeCode: _this.oauthAuthorizeCode,
                organizationId: _this.authService.organizationId,
                emailProvider: _this.emailProvider
            };
            console.log('payload');
            console.log(payload);
            _this.oauthService.createEmailAccessToken(payload)
                .then(function (result) {
                console.log('OauthCallbackComponent, result');
                console.log(result);
                _this.log.info('createEmailAccessToken successful');
                _this.router.navigate(['/organization/settings/authorizedemail']);
                return;
            })
                .catch(function (err) {
                console.log(err);
                _this.log.error(err);
                _this.oauthAuthorizeCode = '';
                _this.oauthError = '';
                _this.oauthState = '';
                _this.emailProvider = '';
                _this.snackBar.open('Could not create email access token.', 'X', { duration: 2000 });
            });
        });
    };
    OauthCallbackComponent.prototype.ngAfterViewInit = function () {
        this.perf.markTabLoadEnd('landing');
    };
    OauthCallbackComponent.ctorParameters = function () { return [{ type: common_es5["k" /* Location */] }, { type: router_es5["m" /* Router */] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: platform_browser_es5["c" /* DomSanitizer */] }, { type: material_es5["b" /* MatSnackBar */] }, { type: auth_service["a" /* AuthService */] }, { type: log_service["a" /* LogService */] }, { type: oauth_service_OauthService }, { type: perf_service["a" /* PerfService */] }]; };
    return OauthCallbackComponent;
}());

//# sourceMappingURL=oauth-callback.component.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/snack-bar.es5.js
var snack_bar_es5 = __webpack_require__("LT5m");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/oauth-callback/oauth-callback.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


















var styles_OauthCallbackComponent = [styles];
var RenderType_OauthCallbackComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_OauthCallbackComponent, data: {} });
function View_OauthCallbackComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'p', [['itd-flex-item',
                ''], ['style', 'margin: 0; text-align: center;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['Authorization Successful, code = ', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.oauthAuthorizeCode;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OauthCallbackComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'p', [['itd-flex-item',
                ''], ['style', 'margin: 0; text-align: center;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](1, null, ['Authorization Error, ', '']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.oauthError;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_OauthCallbackComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'p', [['itd-flex-item',
                ''], ['style', 'margin: 0; text-align: center;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Authorization Status Unknown']))], null, null);
}
function View_OauthCallbackComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 35, 'list-page', [], null, null, null, list_page_component_ngfactory["b" /* View_ListPageComponent_0 */], list_page_component_ngfactory["a" /* RenderType_ListPageComponent */])), core_es5["ɵdid"](1, 4308992, null, 0, list_page_component["a" /* ListPageComponent */], [log_service["a" /* LogService */]], { contentSize: [0, 'contentSize'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n	'])), (_l()(), core_es5["ɵeld"](7, 0, null, 4, 27, 'section', [['content', ''], ['style', 'margin: 1rem 0 1rem 0;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), (_l()(), core_es5["ɵeld"](9, 0, null, null, 24, 'div', [['itd-flex-container-row-center-center', ''], ['style', 'width: 100%; height: 80vh; color: grey;']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n			'])), (_l()(), core_es5["ɵeld"](11, 0, null, null, 21, 'div', [['itd-flex-container-col-center-center', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OauthCallbackComponent_1)), core_es5["ɵdid"](14, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OauthCallbackComponent_2)), core_es5["ɵdid"](17, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])),
        (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_OauthCallbackComponent_3)),
        core_es5["ɵdid"](20, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n\n				'])),
        (_l()(), core_es5["ɵeld"](22, 0, null, null, 9, 'div', [['itd-flex-container-row-center-center',
                ''], ['style', 'margin: 1.5rem 0 1.5rem 0;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵeld"](24, 0, null, null, 6, 'a', [['class',
                'mat-raised-button'], ['mat-raised-button', '']], [[1, 'tabindex', 0], [1, 'disabled',
                0], [1, 'aria-disabled', 0], [1, 'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 26)._haltDisabledEvents($event) !== false);
                ad = (pd_0 && ad);
            }
            if (('click' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 28).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, button_typings_index_ngfactory["c" /* View_MatAnchor_0 */], button_typings_index_ngfactory["a" /* RenderType_MatAnchor */])), core_es5["ɵdid"](25, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](26, 180224, null, 0, button_es5["a" /* MatAnchor */], [platform_es5["a" /* Platform */], a11y_es5["i" /* FocusMonitor */], core_es5["ElementRef"],
            core_es5["Renderer2"]], null, null), core_es5["ɵdid"](27, 16384, null, 0, button_es5["h" /* MatRaisedButtonCssMatStyler */], [], null, null),
        core_es5["ɵdid"](28, 671744, null, 0, router_es5["n" /* RouterLinkWithHref */], [router_es5["m" /* Router */], router_es5["a" /* ActivatedRoute */],
            common_es5["l" /* LocationStrategy */]], { routerLink: [0, 'routerLink'] }, null), core_es5["ɵpad"](29, 1), (_l()(), core_es5["ɵted"](-1, 0, ['\n						Authorized Emails\n					'])), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵted"](-1, null, ['\n			'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n		'])), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', _co.ContentSize.Large, '');
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _co.oauthAuthorizeCode;
        _ck(_v, 14, 0, currVal_1);
        var currVal_2 = _co.oauthError;
        _ck(_v, 17, 0, currVal_2);
        var currVal_3 = (!_co.oauthAuthorizeCode && !_co.oauthError);
        _ck(_v, 20, 0, currVal_3);
        var currVal_9 = _ck(_v, 29, 0, '/organization/settings/authorizedemail');
        _ck(_v, 28, 0, currVal_9);
    }, function (_ck, _v) {
        var currVal_4 = (core_es5["ɵnov"](_v, 26).disabled ? (0 - 1) : 0);
        var currVal_5 = (core_es5["ɵnov"](_v, 26).disabled || null);
        var currVal_6 = core_es5["ɵnov"](_v, 26).disabled.toString();
        var currVal_7 = core_es5["ɵnov"](_v, 28).target;
        var currVal_8 = core_es5["ɵnov"](_v, 28).href;
        _ck(_v, 24, 0, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    });
}
function View_OauthCallbackComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'oauth-callback', [], null, null, null, View_OauthCallbackComponent_0, RenderType_OauthCallbackComponent)), core_es5["ɵdid"](1, 4308992, null, 0, oauth_callback_component_OauthCallbackComponent, [common_es5["k" /* Location */], router_es5["m" /* Router */], router_es5["a" /* ActivatedRoute */], platform_browser_es5["c" /* DomSanitizer */], snack_bar_es5["b" /* MatSnackBar */],
            auth_service["a" /* AuthService */], log_service["a" /* LogService */], oauth_service_OauthService, perf_service["a" /* PerfService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OauthCallbackComponentNgFactory = core_es5["ɵccf"]('oauth-callback', oauth_callback_component_OauthCallbackComponent, View_OauthCallbackComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=oauth-callback.component.ngfactory.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/oauth/oauth.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var oauth_component_scss_shim_ngstyle_styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9vYXV0aC9vYXV0aC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9wYXQvc291cmNlL2l0ZGV2aWNlcy9naXRsYWIvb2NlYW5ibHVmZnByb2R1Y3Rpb25zL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy11aS9zcmMvYXBwL2NvbXBvbmVudHMvb2F1dGgvb2F1dGguY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=oauth.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/card/typings/index.ngfactory.ts
var card_typings_index_ngfactory = __webpack_require__("z4MQ");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/card.es5.js
var card_es5 = __webpack_require__("Ioj9");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/form-field/typings/index.ngfactory.ts
var form_field_typings_index_ngfactory = __webpack_require__("6OSA");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/form-field.es5.js
var form_field_es5 = __webpack_require__("Lpd/");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/components/oauth/oauth.component.ts









var oauth_component_OauthComponent = (function () {
    function OauthComponent(location, router, sanitizer, snackBar, authService, log, oauthService, perf) {
        this.location = location;
        this.router = router;
        this.sanitizer = sanitizer;
        this.snackBar = snackBar;
        this.authService = authService;
        this.log = log;
        this.oauthService = oauthService;
        this.perf = perf;
        this.ContentSize = page_component["a" /* ContentSize */]; // enable enum in template
        this.email = '';
        this.emailProvider = '';
    }
    // viewHeight = '';
    // dialogTitle = '';
    // dialogContent1 = '';
    // dialogContent2 = '';
    // dialogOk = '';
    // dialogCancel = '';
    // dialogData = '';
    // helpUrlLabel = '';
    // helpUrlString = '';
    // @ViewChild('confirmDialog') confirmDialog: DialogComponent;
    OauthComponent.prototype.ngOnInit = function () {
    };
    OauthComponent.prototype.ngAfterViewInit = function () {
        this.perf.markTabLoadEnd('landing');
    };
    OauthComponent.prototype.authorizedEmail = function () {
        var _this = this;
        console.log('authorizedEmail');
        console.log('email');
        console.log(this.email);
        console.log('emailProvider');
        console.log(this.emailProvider);
        if (!this.email) {
            this.snackBar.open('Enter email address to authorize.', 'X', { duration: 2000 });
            return;
        }
        if (!this.emailProvider) {
            this.snackBar.open('Select Gmail or Outlook email provider.', 'X', { duration: 2000 });
            return;
        }
        var payload = {
            email: this.email,
            emailProvider: this.emailProvider
        };
        this.oauthService.createEmailAuthorizationUrl(payload)
            .then(function (result) {
            console.log('OauthComponent, result');
            console.log(result);
            _this.log.info('createEmailAuthorizationUrl successful, redirecting to emailProvider. url = ' + result.authorizeUrl);
            // TODO!!! - optionally save 'state' in local storage, then check on callback
            if (result.authorizeUrl) {
                window.location.href = result.authorizeUrl;
            }
            else {
                _this.snackBar.open('Could not create redirect URL, token already exists.', 'X', { duration: 2000 });
            }
        })
            .catch(function (err) {
            console.log(err);
            _this.log.error(err);
            _this.snackBar.open('Could not create redirect URL.', 'X', { duration: 2000 });
        });
    };
    OauthComponent.ctorParameters = function () { return [{ type: common_es5["k" /* Location */] }, { type: router_es5["m" /* Router */] }, { type: platform_browser_es5["c" /* DomSanitizer */] }, { type: material_es5["b" /* MatSnackBar */] }, { type: auth_service["a" /* AuthService */] }, { type: log_service["a" /* LogService */] }, { type: oauth_service_OauthService }, { type: perf_service["a" /* PerfService */] }]; };
    return OauthComponent;
}());

//# sourceMappingURL=oauth.component.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/forms/@angular/forms.es5.js
var forms_es5 = __webpack_require__("bm2B");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/input.es5.js
var input_es5 = __webpack_require__("SlD5");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/radio.es5.js
var radio_es5 = __webpack_require__("9Rbf");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/radio/typings/index.ngfactory.ts
var radio_typings_index_ngfactory = __webpack_require__("l9NV");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/collections.es5.js
var collections_es5 = __webpack_require__("ka8K");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/oauth/oauth.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



























var styles_OauthComponent = [oauth_component_scss_shim_ngstyle_styles];
var RenderType_OauthComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_OauthComponent, data: {} });
function View_OauthComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 78, 'list-page', [], null, null, null, list_page_component_ngfactory["b" /* View_ListPageComponent_0 */], list_page_component_ngfactory["a" /* RenderType_ListPageComponent */])), core_es5["ɵdid"](1, 4308992, null, 0, list_page_component["a" /* ListPageComponent */], [log_service["a" /* LogService */]], { contentSize: [0, 'contentSize'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n	'])), (_l()(), core_es5["ɵeld"](7, 0, null, 4, 70, 'section', [['content', ''], ['style', 'margin: 1rem 0 1rem 0;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), (_l()(), core_es5["ɵeld"](9, 0, null, null, 67, 'mat-card', [['class', 'mat-card']], null, null, null, card_typings_index_ngfactory["b" /* View_MatCard_0 */], card_typings_index_ngfactory["a" /* RenderType_MatCard */])), core_es5["ɵdid"](10, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](11, 49152, null, 0, card_es5["a" /* MatCard */], [], null, null),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n			'])), (_l()(), core_es5["ɵeld"](13, 0, null, 0, 3, 'mat-card-title', [['class', 'mat-card-title']], null, null, null, null, null)), core_es5["ɵdid"](14, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](15, 16384, null, 0, card_es5["f" /* MatCardTitle */], [], null, null), (_l()(), core_es5["ɵted"](-1, null, ['Authorize Email'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n\n			'])), (_l()(), core_es5["ɵeld"](18, 0, null, 0, 1, 'p', [], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Enter the email address to authorize, choose the Gmail or Outlook email provider, then click the AUTHORIZE EMAIL button.'])),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n\n			'])), (_l()(), core_es5["ɵeld"](21, 0, null, 0, 1, 'p', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['This process requires your browser email.  If you are already logged in with your browser Gmail or Outlook webmail account as the email account you are authorizing, then you are all set.  To authorize another email, log out of your current webmail account before proceeding.'])),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n\n			'])), (_l()(), core_es5["ɵeld"](24, 0, null, 0, 22, 'div', [], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵeld"](26, 0, null, null, 19, 'mat-form-field', [['class', 'mat-input-container mat-form-field'],
            ['style', 'width: 100%;']], [[2, 'mat-input-invalid', null], [2,
                'mat-form-field-invalid', null], [2, 'mat-form-field-can-float',
                null], [2, 'mat-form-field-should-float', null], [2, 'mat-focused',
                null], [2, 'mat-primary', null], [2, 'mat-accent', null],
            [2, 'mat-warn', null], [2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], null, null, form_field_typings_index_ngfactory["b" /* View_MatFormField_0 */], form_field_typings_index_ngfactory["a" /* RenderType_MatFormField */])), core_es5["ɵdid"](27, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](28, 7389184, null, 6, form_field_es5["b" /* MatFormField */], [core_es5["ElementRef"], core_es5["Renderer2"], core_es5["ChangeDetectorRef"], [2, esm5_core_es5["k" /* MAT_PLACEHOLDER_GLOBAL_OPTIONS */]]], null, null), core_es5["ɵqud"](335544320, 1, { _control: 0 }), core_es5["ɵqud"](335544320, 2, { _placeholderChild: 0 }), core_es5["ɵqud"](603979776, 3, { _errorChildren: 1 }), core_es5["ɵqud"](603979776, 4, { _hintChildren: 1 }), core_es5["ɵqud"](603979776, 5, { _prefixChildren: 1 }), core_es5["ɵqud"](603979776, 6, { _suffixChildren: 1 }), (_l()(), core_es5["ɵted"](-1, 1, ['\n					'])), (_l()(), core_es5["ɵeld"](36, 0, null, 1, 8, 'input', [['class', 'full-width mat-input-element mat-form-field-autofill-control'],
            ['matInput', ''], ['placeholder', 'Email To Authorize']], [[1, 'id', 0], [8,
                'placeholder', 0], [8, 'disabled', 0], [8, 'required', 0], [8, 'readOnly', 0],
            [1, 'aria-describedby', 0], [1, 'aria-invalid', 0], [2, 'ng-untouched', null],
            [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
            [2, 'ng-pending', null]], [[null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'], [null,
                'compositionend'], [null, 'focus']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 38)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (core_es5["ɵnov"](_v, 38).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (core_es5["ɵnov"](_v, 38)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (core_es5["ɵnov"](_v, 38)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
                var pd_4 = (core_es5["ɵnov"](_v, 42)._focusChanged(false) !== false);
                ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
                var pd_5 = (core_es5["ɵnov"](_v, 42)._focusChanged(true) !== false);
                ad = (pd_5 && ad);
            }
            if (('input' === en)) {
                var pd_6 = (core_es5["ɵnov"](_v, 42)._onInput() !== false);
                ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_7 = ((_co.email = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](37, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](38, 16384, null, 0, forms_es5["e" /* DefaultValueAccessor */], [core_es5["Renderer2"], core_es5["ElementRef"], [2, forms_es5["a" /* COMPOSITION_BUFFER_MODE */]]], null, null), core_es5["ɵprd"](1024, null, forms_es5["n" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [forms_es5["e" /* DefaultValueAccessor */]]), core_es5["ɵdid"](40, 671744, null, 0, forms_es5["s" /* NgModel */], [[8, null], [8, null], [8, null], [2, forms_es5["n" /* NG_VALUE_ACCESSOR */]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["o" /* NgControl */], null, [forms_es5["s" /* NgModel */]]), core_es5["ɵdid"](42, 933888, null, 0, input_es5["a" /* MatInput */], [core_es5["ElementRef"], core_es5["Renderer2"], platform_es5["a" /* Platform */], [2, forms_es5["o" /* NgControl */]],
            [2, forms_es5["r" /* NgForm */]], [2, forms_es5["j" /* FormGroupDirective */]], esm5_core_es5["e" /* ErrorStateMatcher */]], { placeholder: [0,
                'placeholder'] }, null), core_es5["ɵdid"](43, 16384, null, 0, forms_es5["p" /* NgControlStatus */], [forms_es5["o" /* NgControl */]], null, null), core_es5["ɵprd"](2048, [[1, 4]], form_field_es5["c" /* MatFormFieldControl */], null, [input_es5["a" /* MatInput */]]), (_l()(), core_es5["ɵted"](-1, 1, ['\n				'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n			'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n			\n			'])),
        (_l()(), core_es5["ɵeld"](48, 0, null, 0, 21, 'div', [['itd-flex-item', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵeld"](50, 0, null, null, 18, 'mat-radio-group', [['class', 'mat-radio-group'], ['itd-flex-container-column-start-start',
                ''], ['role', 'radiogroup']], [[2, 'ng-untouched', null], [2, 'ng-touched',
                null], [2, 'ng-pristine', null], [2, 'ng-dirty', null],
            [2, 'ng-valid', null], [2, 'ng-invalid', null], [2, 'ng-pending',
                null]], [[null, 'ngModelChange']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('ngModelChange' === en)) {
                var pd_0 = ((_co.emailProvider = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core_es5["ɵdid"](51, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](52, 1064960, null, 1, radio_es5["b" /* MatRadioGroup */], [core_es5["ChangeDetectorRef"]], null, null),
        core_es5["ɵqud"](603979776, 7, { _radios: 1 }), core_es5["ɵprd"](1024, null, forms_es5["n" /* NG_VALUE_ACCESSOR */], function (p0_0) {
            return [p0_0];
        }, [radio_es5["b" /* MatRadioGroup */]]), core_es5["ɵdid"](55, 671744, null, 0, forms_es5["s" /* NgModel */], [[8,
                null], [8, null], [8, null], [2, forms_es5["n" /* NG_VALUE_ACCESSOR */]]], { model: [0, 'model'] }, { update: 'ngModelChange' }), core_es5["ɵprd"](2048, null, forms_es5["o" /* NgControl */], null, [forms_es5["s" /* NgModel */]]), core_es5["ɵdid"](57, 16384, null, 0, forms_es5["p" /* NgControlStatus */], [forms_es5["o" /* NgControl */]], null, null), (_l()(),
            core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵeld"](59, 0, null, null, 3, 'mat-radio-button', [['class', 'sidenav-text mat-radio-button'],
            ['itd-flex-item', ''], ['value', 'gmail']], [[2, 'mat-radio-checked', null],
            [2, 'mat-radio-disabled', null], [1, 'id', 0]], [[null, 'focus']], function (_v, en, $event) {
            var ad = true;
            if (('focus' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 61)._inputElement.nativeElement.focus() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, radio_typings_index_ngfactory["b" /* View_MatRadioButton_0 */], radio_typings_index_ngfactory["a" /* RenderType_MatRadioButton */])), core_es5["ɵdid"](60, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null),
        core_es5["ɵdid"](61, 4440064, [[7, 4]], 0, radio_es5["a" /* MatRadioButton */], [[2, radio_es5["b" /* MatRadioGroup */]], core_es5["ElementRef"],
            core_es5["Renderer2"], core_es5["ChangeDetectorRef"], a11y_es5["i" /* FocusMonitor */], collections_es5["c" /* UniqueSelectionDispatcher */]], { value: [0, 'value'] }, null), (_l()(), core_es5["ɵted"](-1, 0, ['Gmail'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n					'])), (_l()(), core_es5["ɵeld"](64, 0, null, null, 3, 'mat-radio-button', [['class', 'sidenav-text mat-radio-button'],
            ['itd-flex-item', ''], ['value', 'outlook']], [[2, 'mat-radio-checked', null],
            [2, 'mat-radio-disabled', null], [1, 'id', 0]], [[null, 'focus']], function (_v, en, $event) {
            var ad = true;
            if (('focus' === en)) {
                var pd_0 = (core_es5["ɵnov"](_v, 66)._inputElement.nativeElement.focus() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, radio_typings_index_ngfactory["b" /* View_MatRadioButton_0 */], radio_typings_index_ngfactory["a" /* RenderType_MatRadioButton */])), core_es5["ɵdid"](65, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null),
        core_es5["ɵdid"](66, 4440064, [[7, 4]], 0, radio_es5["a" /* MatRadioButton */], [[2, radio_es5["b" /* MatRadioGroup */]], core_es5["ElementRef"],
            core_es5["Renderer2"], core_es5["ChangeDetectorRef"], a11y_es5["i" /* FocusMonitor */], collections_es5["c" /* UniqueSelectionDispatcher */]], { value: [0, 'value'] }, null), (_l()(), core_es5["ɵted"](-1, 0, ['Outlook'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵted"](-1, null, ['\n			'])),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n			\n			'])), (_l()(), core_es5["ɵeld"](71, 0, null, 0, 4, 'button', [['class', 'mat-raised-button'], ['color', 'primary'], ['mat-raised-button',
                ''], ['style', 'margin: 1rem 0 0 0;']], [[8, 'disabled', 0]], [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.authorizedEmail() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, button_typings_index_ngfactory["d" /* View_MatButton_0 */], button_typings_index_ngfactory["b" /* RenderType_MatButton */])), core_es5["ɵdid"](72, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](73, 180224, null, 0, button_es5["b" /* MatButton */], [core_es5["Renderer2"], core_es5["ElementRef"], platform_es5["a" /* Platform */],
            a11y_es5["i" /* FocusMonitor */]], { color: [0, 'color'] }, null), core_es5["ɵdid"](74, 16384, null, 0, button_es5["h" /* MatRaisedButtonCssMatStyler */], [], null, null), (_l()(), core_es5["ɵted"](-1, 0, ['\n				AUTHORIZE EMAIL\n			'])), (_l()(),
            core_es5["ɵted"](-1, 0, ['\n		'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n	'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = core_es5["ɵinlineInterpolate"](1, '', _co.ContentSize.Large, '');
        _ck(_v, 1, 0, currVal_0);
        var currVal_30 = _co.email;
        _ck(_v, 40, 0, currVal_30);
        var currVal_31 = 'Email To Authorize';
        _ck(_v, 42, 0, currVal_31);
        var currVal_39 = _co.emailProvider;
        _ck(_v, 55, 0, currVal_39);
        var currVal_43 = 'gmail';
        _ck(_v, 61, 0, currVal_43);
        var currVal_47 = 'outlook';
        _ck(_v, 66, 0, currVal_47);
        var currVal_49 = 'primary';
        _ck(_v, 73, 0, currVal_49);
    }, function (_ck, _v) {
        var currVal_1 = core_es5["ɵnov"](_v, 28)._control.errorState;
        var currVal_2 = core_es5["ɵnov"](_v, 28)._control.errorState;
        var currVal_3 = core_es5["ɵnov"](_v, 28)._canPlaceholderFloat;
        var currVal_4 = (core_es5["ɵnov"](_v, 28)._control.shouldPlaceholderFloat || core_es5["ɵnov"](_v, 28)._shouldAlwaysFloat);
        var currVal_5 = core_es5["ɵnov"](_v, 28)._control.focused;
        var currVal_6 = (core_es5["ɵnov"](_v, 28).color == 'primary');
        var currVal_7 = (core_es5["ɵnov"](_v, 28).color == 'accent');
        var currVal_8 = (core_es5["ɵnov"](_v, 28).color == 'warn');
        var currVal_9 = core_es5["ɵnov"](_v, 28)._shouldForward('untouched');
        var currVal_10 = core_es5["ɵnov"](_v, 28)._shouldForward('touched');
        var currVal_11 = core_es5["ɵnov"](_v, 28)._shouldForward('pristine');
        var currVal_12 = core_es5["ɵnov"](_v, 28)._shouldForward('dirty');
        var currVal_13 = core_es5["ɵnov"](_v, 28)._shouldForward('valid');
        var currVal_14 = core_es5["ɵnov"](_v, 28)._shouldForward('invalid');
        var currVal_15 = core_es5["ɵnov"](_v, 28)._shouldForward('pending');
        _ck(_v, 26, 1, [currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7,
            currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14,
            currVal_15]);
        var currVal_16 = core_es5["ɵnov"](_v, 42).id;
        var currVal_17 = core_es5["ɵnov"](_v, 42).placeholder;
        var currVal_18 = core_es5["ɵnov"](_v, 42).disabled;
        var currVal_19 = core_es5["ɵnov"](_v, 42).required;
        var currVal_20 = core_es5["ɵnov"](_v, 42).readonly;
        var currVal_21 = (core_es5["ɵnov"](_v, 42)._ariaDescribedby || null);
        var currVal_22 = core_es5["ɵnov"](_v, 42).errorState;
        var currVal_23 = core_es5["ɵnov"](_v, 43).ngClassUntouched;
        var currVal_24 = core_es5["ɵnov"](_v, 43).ngClassTouched;
        var currVal_25 = core_es5["ɵnov"](_v, 43).ngClassPristine;
        var currVal_26 = core_es5["ɵnov"](_v, 43).ngClassDirty;
        var currVal_27 = core_es5["ɵnov"](_v, 43).ngClassValid;
        var currVal_28 = core_es5["ɵnov"](_v, 43).ngClassInvalid;
        var currVal_29 = core_es5["ɵnov"](_v, 43).ngClassPending;
        _ck(_v, 36, 1, [currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21,
            currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28,
            currVal_29]);
        var currVal_32 = core_es5["ɵnov"](_v, 57).ngClassUntouched;
        var currVal_33 = core_es5["ɵnov"](_v, 57).ngClassTouched;
        var currVal_34 = core_es5["ɵnov"](_v, 57).ngClassPristine;
        var currVal_35 = core_es5["ɵnov"](_v, 57).ngClassDirty;
        var currVal_36 = core_es5["ɵnov"](_v, 57).ngClassValid;
        var currVal_37 = core_es5["ɵnov"](_v, 57).ngClassInvalid;
        var currVal_38 = core_es5["ɵnov"](_v, 57).ngClassPending;
        _ck(_v, 50, 0, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38);
        var currVal_40 = core_es5["ɵnov"](_v, 61).checked;
        var currVal_41 = core_es5["ɵnov"](_v, 61).disabled;
        var currVal_42 = core_es5["ɵnov"](_v, 61).id;
        _ck(_v, 59, 0, currVal_40, currVal_41, currVal_42);
        var currVal_44 = core_es5["ɵnov"](_v, 66).checked;
        var currVal_45 = core_es5["ɵnov"](_v, 66).disabled;
        var currVal_46 = core_es5["ɵnov"](_v, 66).id;
        _ck(_v, 64, 0, currVal_44, currVal_45, currVal_46);
        var currVal_48 = (core_es5["ɵnov"](_v, 73).disabled || null);
        _ck(_v, 71, 0, currVal_48);
    });
}
function View_OauthComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'oauth', [], null, null, null, View_OauthComponent_0, RenderType_OauthComponent)),
        core_es5["ɵdid"](1, 4308992, null, 0, oauth_component_OauthComponent, [common_es5["k" /* Location */], router_es5["m" /* Router */],
            platform_browser_es5["c" /* DomSanitizer */], snack_bar_es5["b" /* MatSnackBar */], auth_service["a" /* AuthService */], log_service["a" /* LogService */], oauth_service_OauthService,
            perf_service["a" /* PerfService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var OauthComponentNgFactory = core_es5["ɵccf"]('oauth', oauth_component_OauthComponent, View_OauthComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9vYXV0aC9vYXV0aC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvcGF0L3NvdXJjZS9pdGRldmljZXMvZ2l0bGFiL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy9vY2VhbmJsdWZmcHJvZHVjdGlvbnMtdWkvc3JjL2FwcC9jb21wb25lbnRzL29hdXRoL29hdXRoLmNvbXBvbmVudC50cyIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9vYXV0aC9vYXV0aC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9vYXV0aC9vYXV0aC5jb21wb25lbnQudHMuT2F1dGhDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bGlzdC1wYWdlIGNvbnRlbnRTaXplPVwie3tDb250ZW50U2l6ZS5MYXJnZX19XCI+XG5cbjwhLS0gXG5cdDxzZWN0aW9uIGxpc3RQYWdlU2lkZW5hdkFkZD5cblx0XHQ8cD5MZXR0ZXIgQWRkIEJ1dHRvbjwvcD5cblx0PC9zZWN0aW9uPlxuIC0tPlxuXG48IS0tIFxuXHQ8c2VjdGlvbiBsaXN0UGFnZVNpZGVuYXZWaWV3Q29udGVudD5cblx0XHQ8ZGl2IGl0ZC1mbGV4LWNvbnRhaW5lci1jb2x1bW4tc3RhcnQtc3RhcnQgc3R5bGU9XCJwYWRkaW5nOiAwZW0gMWVtIDFlbSAxZW07XCI+XG5cblx0XHRcdDxwIGNsYXNzPVwic2lkZW5hdi10ZXh0XCIgc3R5bGU9XCJtYXJnaW46IDA7XCI+e3tzaWRlbmF2LmZpbHRlcmVkSXRlbUNvdW50fX0ve3tzaWRlbmF2LnRvdGFsSXRlbUNvdW50fX0gZmlsbXM8L3A+XG5cblxuXHRcdFx0PG1hdC1jaGVja2JveFxuXHRcdFx0XHRjbGFzcz1cInNpZGVuYXYtdGV4dFwiXG5cdFx0XHRcdFsobmdNb2RlbCldPVwic2V0dGluZ3MucHJvZ3JhbS5sZXR0ZXIuc2hvd0FjY2VwdGVkXCJcblx0XHRcdFx0c3R5bGU9XCJtYXJnaW4tdG9wOiAwOyBtYXJnaW4tYm90dG9tOiAwO1wiIFxuXHRcdFx0XHQoY2hhbmdlKT1cInNpZGVuYXZDaGFuZ2VkKCk7XCIgXG5cdFx0XHRcdD5BY2NlcHRlZDwvbWF0LWNoZWNrYm94PlxuXG5cblx0XHRcdDxtYXQtY2hlY2tib3hcblx0XHRcdFx0Y2xhc3M9XCJzaWRlbmF2LXRleHRcIiBcblx0XHRcdFx0WyhuZ01vZGVsKV09XCJzZXR0aW5ncy5wcm9ncmFtLmxldHRlci5zaG93UmVqZWN0ZWRcIlxuXHRcdFx0XHRzdHlsZT1cIm1hcmdpbi1ib3R0b206IDA7XCIgXG5cdFx0XHRcdChjaGFuZ2UpPVwic2lkZW5hdkNoYW5nZWQoKTtcIiBcblx0XHRcdFx0PlJlamVjdGVkPC9tYXQtY2hlY2tib3g+XG5cblxuXHRcdFx0PGRpdiBzdHlsZT1cIm1hcmdpbjogMWVtIDBlbSAxZW0gMGVtOyBoZWlnaHQ6IDFweDsgd2lkdGg6IDEwMCU7IGJvcmRlci10b3Atc3R5bGU6IHNvbGlkOyBib3JkZXItdG9wLXdpZHRoOiAxcHg7IGJvcmRlci10b3AtY29sb3I6IHJnYmEoMCwgMCwgMCwgMC4xMTc2NDcpO1wiPjwvZGl2PlxuXHRcdFx0PG1hdC1jaGVja2JveFxuXHRcdFx0XHRjbGFzcz1cInNpZGVuYXYtdGV4dFwiXG5cdFx0XHRcdFsobmdNb2RlbCldPVwic2V0dGluZ3MucHJvZ3JhbS5sZXR0ZXIuc2hvd0xldHRlcnNTZW50XCJcblx0XHRcdFx0c3R5bGU9XCJtYXJnaW4tdG9wOiAwOyBtYXJnaW4tYm90dG9tOiAwO1wiIFxuXHRcdFx0XHQoY2hhbmdlKT1cInNpZGVuYXZDaGFuZ2VkKCk7XCIgXG5cdFx0XHRcdD5MZXR0ZXJzIFNlbnQ8L21hdC1jaGVja2JveD5cblxuXHRcdFx0PG1hdC1jaGVja2JveFxuXHRcdFx0XHRjbGFzcz1cInNpZGVuYXYtdGV4dFwiIFxuXHRcdFx0XHRbKG5nTW9kZWwpXT1cInNldHRpbmdzLnByb2dyYW0ubGV0dGVyLnNob3dMZXR0ZXJzVG9TZW50XCJcblx0XHRcdFx0c3R5bGU9XCJtYXJnaW4tYm90dG9tOiAwO1wiIFxuXHRcdFx0XHQoY2hhbmdlKT1cInNpZGVuYXZDaGFuZ2VkKCk7XCIgXG5cdFx0XHRcdD5MZXR0ZXJzIFRvIFNlbmQ8L21hdC1jaGVja2JveD5cblxuXHRcdFx0PG1hdC1jaGVja2JveFxuXHRcdFx0XHRjbGFzcz1cInNpZGVuYXYtdGV4dFwiIFxuXHRcdFx0XHRbKG5nTW9kZWwpXT1cInNldHRpbmdzLnByb2dyYW0ubGV0dGVyLnNob3dQZW5kaW5nTGV0dGVyc1wiXG5cdFx0XHRcdHN0eWxlPVwibWFyZ2luLWJvdHRvbTogMDtcIiBcblx0XHRcdFx0KGNoYW5nZSk9XCJzaWRlbmF2Q2hhbmdlZCgpO1wiIFxuXHRcdFx0XHQ+UGVuZGluZyBMZXR0ZXJzPC9tYXQtY2hlY2tib3g+XG5cblxuXHRcdFx0PGRpdiBzdHlsZT1cIm1hcmdpbjogMWVtIDBlbSAxZW0gMGVtOyBoZWlnaHQ6IDFweDsgd2lkdGg6IDEwMCU7IGJvcmRlci10b3Atc3R5bGU6IHNvbGlkOyBib3JkZXItdG9wLXdpZHRoOiAxcHg7IGJvcmRlci10b3AtY29sb3I6IHJnYmEoMCwgMCwgMCwgMC4xMTc2NDcpO1wiPjwvZGl2PlxuXHRcdFx0PG1hdC1jaGVja2JveCAqbmdJZj1cInR3b1JvdW5kc1wiXG5cdFx0XHRcdGNsYXNzPVwic2lkZW5hdi10ZXh0XCIgXG5cdFx0XHRcdFsobmdNb2RlbCldPVwic2V0dGluZ3MucHJvZ3JhbS5sZXR0ZXIuc2hvd1NlY29uZFJvdW5kXCJcblx0XHRcdFx0c3R5bGU9XCJtYXJnaW4tYm90dG9tOiAwO1wiIFxuXHRcdFx0XHQoY2hhbmdlKT1cInNpZGVuYXZDaGFuZ2VkKCk7XCIgXG5cdFx0XHRcdD5JbmNsdWRlIFNlY29uZCBSb3VuZDwvbWF0LWNoZWNrYm94PlxuXHRcdFx0PG1hdC1jaGVja2JveCAqbmdJZj1cInR3b1JvdW5kc1wiXG5cdFx0XHRcdGNsYXNzPVwic2lkZW5hdi10ZXh0XCIgXG5cdFx0XHRcdFsobmdNb2RlbCldPVwic2V0dGluZ3MucHJvZ3JhbS5sZXR0ZXIuc2hvd1Jldmlld2luZ1wiXG5cdFx0XHRcdHN0eWxlPVwibWFyZ2luLWJvdHRvbTogMDtcIiBcblx0XHRcdFx0KGNoYW5nZSk9XCJzaWRlbmF2Q2hhbmdlZCgpO1wiIFxuXHRcdFx0XHQ+SW5jbHVkZSBGaXJzdCBSb3VuZDwvbWF0LWNoZWNrYm94PlxuXG5cdFx0XHQ8bWF0LWNoZWNrYm94ICpuZ0lmPVwiIXR3b1JvdW5kc1wiXG5cdFx0XHRcdGNsYXNzPVwic2lkZW5hdi10ZXh0XCIgXG5cdFx0XHRcdFsobmdNb2RlbCldPVwic2V0dGluZ3MucHJvZ3JhbS5sZXR0ZXIuc2hvd1Jldmlld2luZ1wiXG5cdFx0XHRcdHN0eWxlPVwibWFyZ2luLWJvdHRvbTogMDtcIiBcblx0XHRcdFx0KGNoYW5nZSk9XCJzaWRlbmF2Q2hhbmdlZCgpO1wiIFxuXHRcdFx0XHQ+SW5jbHVkZSBSZXZpZXdpbmc8L21hdC1jaGVja2JveD5cblxuXHRcdFx0PGRpdiBzdHlsZT1cIm1hcmdpbjogMWVtIDBlbSAxZW0gMGVtOyBoZWlnaHQ6IDFweDsgd2lkdGg6IDEwMCU7IGJvcmRlci10b3Atc3R5bGU6IHNvbGlkOyBib3JkZXItdG9wLXdpZHRoOiAxcHg7IGJvcmRlci10b3AtY29sb3I6IHJnYmEoMCwgMCwgMCwgMC4xMTc2NDcpO1wiPjwvZGl2PlxuXHRcdFx0PGRpdiBpdGQtZmxleC1pdGVtPlxuXHRcdFx0XHQ8bWF0LXJhZGlvLWdyb3VwIFsobmdNb2RlbCldPVwic2V0dGluZ3MucHJvZ3JhbS5sZXR0ZXIuc29ydEZpZWxkXCIgKGNoYW5nZSk9XCJzaWRlbmF2Q2hhbmdlZCgpO1wiIGl0ZC1mbGV4LWNvbnRhaW5lci1jb2x1bW4tc3RhcnQtc3RhcnQ+XG5cdFx0XHRcdFx0PG1hdC1yYWRpby1idXR0b24gIHZhbHVlPVwidm90ZVwiIGFyaWEtbGFiZWw9XCJMYWJlbCAxXCI+Vm90ZTwvbWF0LXJhZGlvLWJ1dHRvbj5cblx0XHRcdFx0XHQ8bWF0LXJhZGlvLWJ1dHRvbiAgdmFsdWU9XCJ0aXRsZVwiIGFyaWEtbGFiZWw9XCJMYWJlbCAxXCI+VGl0bGU8L21hdC1yYWRpby1idXR0b24+XG5cdFx0XHRcdFx0PG1hdC1yYWRpby1idXR0b24gIHZhbHVlPVwiZGF0ZVwiIGFyaWEtbGFiZWw9XCJMYWJlbCAxXCI+RGF0ZSBTZW50PC9tYXQtcmFkaW8tYnV0dG9uPlxuXHRcdFx0XHQ8L21hdC1yYWRpby1ncm91cD5cblx0XHRcdDwvZGl2PlxuXG5cblx0XHRcdDxkaXYgc3R5bGU9XCJtYXJnaW46IDFlbSAwZW0gMWVtIDBlbTsgaGVpZ2h0OiAxcHg7IHdpZHRoOiAxMDAlOyBib3JkZXItdG9wLXN0eWxlOiBzb2xpZDsgYm9yZGVyLXRvcC13aWR0aDogMXB4OyBib3JkZXItdG9wLWNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuMTE3NjQ3KTtcIj48L2Rpdj5cblx0XHRcdDxkaXYgaXRkLWZsZXgtaXRlbT5cblx0XHRcdFx0PG1hdC1yYWRpby1ncm91cCBbKG5nTW9kZWwpXT1cInNldHRpbmdzLnByb2dyYW0ubGV0dGVyLnNvcnREaXJlY3Rpb25cIiAoY2hhbmdlKT1cInNpZGVuYXZDaGFuZ2VkKCk7XCIgaXRkLWZsZXgtY29udGFpbmVyLWNvbHVtbi1zdGFydC1zdGFydD5cblx0XHRcdFx0XHQ8bWF0LXJhZGlvLWJ1dHRvbiB2YWx1ZT1cImFzY2VuZGluZ1wiIGl0ZC1mbGV4LWl0ZW0gY2xhc3M9XCJzaWRlbmF2LXRleHRcIj5Bc2NlbmRpbmc8L21hdC1yYWRpby1idXR0b24+XG5cdFx0XHRcdFx0PG1hdC1yYWRpby1idXR0b24gdmFsdWU9XCJkZXNjZW5kaW5nXCIgaXRkLWZsZXgtaXRlbSBjbGFzcz1cInNpZGVuYXYtdGV4dFwiPkRlc2NlbmRpbmc8L21hdC1yYWRpby1idXR0b24+XG5cdFx0XHRcdDwvbWF0LXJhZGlvLWdyb3VwPlxuXHRcdFx0PC9kaXY+XG5cdFx0PC9kaXY+XG5cdDwvc2VjdGlvbj5cbiAtLT5cblxuPCEtLSAgXG5cdDxzZWN0aW9uIGxpc3RQYWdlU2lkZW5hdkJvdHRvbT5cblx0XHQ8ZGl2IGl0ZC1mbGV4LWl0ZW0gc3R5bGU9XCJ3aWR0aDogMTAwJTtcIj5cblx0XHRcdDxidXR0b24gbWF0LXJhaXNlZC1idXR0b24gY29sb3I9XCJwcmltYXJ5XCIgc3R5bGU9XCJtYXJnaW46IDAgMCAwIDAuNWVtO1wiIFtkaXNhYmxlZF09XCJhY2NlcHRhbmNlTGV0dGVyQ291bnQgPT09IDAgJiYgcmVqZWN0aW9uTGV0dGVyQ291bnQgPT09IDBcIiAoY2xpY2spPVwib25TZW5kTGV0dGVycygpXCI+U0VORCBMRVRURVJTPC9idXR0b24+XG5cdFx0PC9kaXY+XG5cdDwvc2VjdGlvbj5cbiAtLT5cbjwhLS0gXG5cdDxzZWN0aW9uIGRpYWxvZ0JveD5cblx0XHQ8aXRkLWRpYWxvZ1xuXHRcdFx0I2NvbmZpcm1EaWFsb2dcblx0XHRcdFt0aXRsZV09XCJkaWFsb2dUaXRsZVwiXG5cdFx0XHRbY29udGVudDFdPVwiZGlhbG9nQ29udGVudDFcIlxuXHRcdFx0W2NvbnRlbnQyXT1cImRpYWxvZ0NvbnRlbnQyXCJcblx0XHRcdFtva109XCJkaWFsb2dPa1wiXG5cdFx0XHRbY2FuY2VsXT1cImRpYWxvZ0NhbmNlbFwiXG5cdFx0XHRbZGF0YV09XCJkaWFsb2dEYXRhXCJcblxuXHRcdFx0W2hlbHBVcmxMYWJlbF09XCJoZWxwVXJsTGFiZWxcIlxuXHRcdFx0W2hlbHBVcmxTdHJpbmddPVwiaGVscFVybFN0cmluZ1wiXG5cdFx0PjwvaXRkLWRpYWxvZz5cblx0PC9zZWN0aW9uPlxuIC0tPlxuXG5cdDxzZWN0aW9uIGNvbnRlbnQgc3R5bGU9XCJtYXJnaW46IDFyZW0gMCAxcmVtIDA7XCI+XG5cdFx0PG1hdC1jYXJkPlxuXHRcdFx0PG1hdC1jYXJkLXRpdGxlPkF1dGhvcml6ZSBFbWFpbDwvbWF0LWNhcmQtdGl0bGU+XG5cblx0XHRcdDxwPkVudGVyIHRoZSBlbWFpbCBhZGRyZXNzIHRvIGF1dGhvcml6ZSwgY2hvb3NlIHRoZSBHbWFpbCBvciBPdXRsb29rIGVtYWlsIHByb3ZpZGVyLCB0aGVuIGNsaWNrIHRoZSBBVVRIT1JJWkUgRU1BSUwgYnV0dG9uLjwvcD5cblxuXHRcdFx0PHA+VGhpcyBwcm9jZXNzIHJlcXVpcmVzIHlvdXIgYnJvd3NlciBlbWFpbC4gIElmIHlvdSBhcmUgYWxyZWFkeSBsb2dnZWQgaW4gd2l0aCB5b3VyIGJyb3dzZXIgR21haWwgb3IgT3V0bG9vayB3ZWJtYWlsIGFjY291bnQgYXMgdGhlIGVtYWlsIGFjY291bnQgeW91IGFyZSBhdXRob3JpemluZywgdGhlbiB5b3UgYXJlIGFsbCBzZXQuICBUbyBhdXRob3JpemUgYW5vdGhlciBlbWFpbCwgbG9nIG91dCBvZiB5b3VyIGN1cnJlbnQgd2VibWFpbCBhY2NvdW50IGJlZm9yZSBwcm9jZWVkaW5nLjwvcD5cblxuXHRcdFx0PGRpdj5cblx0XHRcdFx0PG1hdC1mb3JtLWZpZWxkICBzdHlsZT1cIndpZHRoOiAxMDAlO1wiPlxuXHRcdFx0XHRcdDxpbnB1dCBtYXRJbnB1dCBjbGFzcz1cImZ1bGwtd2lkdGhcIiBwbGFjZWhvbGRlcj1cIkVtYWlsIFRvIEF1dGhvcml6ZVwiIFsobmdNb2RlbCldPVwiZW1haWxcIj5cblx0XHRcdFx0PC9tYXQtZm9ybS1maWVsZD5cblx0XHRcdDwvZGl2PlxuXHRcdFx0XG5cdFx0XHQ8ZGl2IGl0ZC1mbGV4LWl0ZW0+XG5cdFx0XHRcdDxtYXQtcmFkaW8tZ3JvdXAgWyhuZ01vZGVsKV09XCJlbWFpbFByb3ZpZGVyXCIgIGl0ZC1mbGV4LWNvbnRhaW5lci1jb2x1bW4tc3RhcnQtc3RhcnQ+XG5cdFx0XHRcdFx0PG1hdC1yYWRpby1idXR0b24gdmFsdWU9XCJnbWFpbFwiIGl0ZC1mbGV4LWl0ZW0gY2xhc3M9XCJzaWRlbmF2LXRleHRcIj5HbWFpbDwvbWF0LXJhZGlvLWJ1dHRvbj5cblx0XHRcdFx0XHQ8bWF0LXJhZGlvLWJ1dHRvbiB2YWx1ZT1cIm91dGxvb2tcIiBpdGQtZmxleC1pdGVtIGNsYXNzPVwic2lkZW5hdi10ZXh0XCI+T3V0bG9vazwvbWF0LXJhZGlvLWJ1dHRvbj5cblx0XHRcdFx0PC9tYXQtcmFkaW8tZ3JvdXA+XG5cdFx0XHQ8L2Rpdj5cblx0XHRcdFxuXHRcdFx0PGJ1dHRvbiBtYXQtcmFpc2VkLWJ1dHRvbiBjb2xvcj1cInByaW1hcnlcIiBzdHlsZT1cIm1hcmdpbjogMXJlbSAwIDAgMDtcIiAoY2xpY2spPVwiYXV0aG9yaXplZEVtYWlsKClcIj5cblx0XHRcdFx0QVVUSE9SSVpFIEVNQUlMXG5cdFx0XHQ8L2J1dHRvbj5cblx0XHQ8L21hdC1jYXJkPlxuXG5cdDwvc2VjdGlvbj5cbjwvbGlzdC1wYWdlPlxuIiwiPG9hdXRoPjwvb2F1dGg+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7cUNBQUEsVUFBQTtNQUFBLCtEQUErQztNQUFBLHlCQU0zQyw0Q0F3RkE7YUFBQSw2QkFRQTtNQWdCQSw2Q0FFSDtVQUFBO1VBQUEsMERBQWdEO1VBQUEseUJBQy9DO1VBQUE7aURBQUEsVUFBQTtVQUFBLHlFQUFBO1VBQUE7TUFBVSxpQ0FDVDtVQUFBO1VBQUEsdUJBQUE7VUFBQSxvQ0FBQTtVQUFBLDJDQUFnQjtVQUFBLHNCQUFnQyxtQ0FFaEQ7VUFBQTtVQUFBLDhCQUFHO01BQTRILG1DQUUvSDtVQUFBO01BQUc7TUFBc1IsbUNBRXpSO1VBQUE7TUFBSyw4Q0FDSjtVQUFBO2NBQUE7Y0FBQTtjQUFBO2NBQUE7Y0FBQTtrQkFBQTtjQUFBO2tCQUFBO29DQUFBLFVBQUE7VUFBQSxrREFBQTtVQUFBO1VBQUE7VUFBQTtVQUFBO1VBQUEsdUJBQXNDLG1DQUNyQztVQUFBO2NBQUE7Y0FBQTtjQUFBO2NBQUE7a0JBQUE7Y0FBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBb0U7Y0FBQTtjQUFBO1lBQUE7WUFBcEU7VUFBQSx1Q0FBQTtVQUFBLGtEQUFBO1VBQUE7VUFBQSxvQ0FBQTtVQUFBO1lBQUE7VUFBQSxxQ0FBQTtVQUFBO1VBQUEscURBQUE7d0JBQUEsb0NBQUE7VUFBQTtjQUFBO2NBQUEsc0NBQUE7VUFBQSxvREFBQTtVQUFBLDhCQUF3RixrQ0FDeEU7aUJBQUEsOEJBQ1o7TUFFTjtVQUFBLDBEQUFtQjtVQUFBLDJCQUNsQjtVQUFBO2NBQUE7Y0FBQTtjQUFBO2tCQUFBO1lBQUE7WUFBQTtZQUFpQjtjQUFBO2NBQUE7WUFBQTtZQUFqQjtVQUFBLHVDQUFBO1VBQUEsa0RBQUE7VUFBQTthQUFBLGlDQUFBO1VBQUE7WUFBQTtVQUFBLDhCQUFBO1VBQUE7VUFBQSxxREFBQTt3QkFBQSxvQ0FBQTtVQUFBLG1FQUFvRjtpQkFBQSxnQ0FDbkY7VUFBQTtjQUFBO2NBQUE7VUFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtVQUFBLG1FQUFBO1VBQUE7YUFBQTswRkFBQTtVQUFBLG1DQUFtRSxpQ0FBd0I7aUJBQUEsZ0NBQzNGO1VBQUE7Y0FBQTtjQUFBO1VBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7VUFBQSxtRUFBQTtVQUFBO2FBQUE7MEZBQUE7VUFBQSxtQ0FBcUUsbUNBQTBCO2lCQUFBLCtCQUM5RTtNQUNiLHNDQUVOO1VBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtZQUFzRTtjQUFBO2NBQUE7WUFBQTtZQUF0RTtVQUFBLHlEQUFBO1VBQUEseUVBQUE7VUFBQTs4QkFBQSw0Q0FBQTtVQUFBO1VBQUEsZUFBa0csc0RBRXpGO2lCQUFBLGlCQUNDLDZDQUVGO2lCQUFBLDJCQUNDOzs7UUFuSkQ7UUFBWCxXQUFXLFNBQVg7UUFrSXlFO1FBQXBFLFlBQW9FLFVBQXBFO1FBQW1DO1FBQW5DLFlBQW1DLFVBQW5DO1FBS2dCO1FBQWpCLFlBQWlCLFVBQWpCO1FBQ21CO1FBQWxCLFlBQWtCLFVBQWxCO1FBQ2tCO1FBQWxCLFlBQWtCLFVBQWxCO1FBSXdCO1FBQTFCLFlBQTBCLFVBQTFCOztRQVpDO1FBQUE7UUFBQTtRQUFBO1lBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUEsYUFBQTtZQUFBO1lBQUEsVUFBQTtRQUNDO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQSxhQUFBO1lBQUEsV0FBQTtZQUFBLFVBQUE7UUFLRDtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBLFlBQUE7WUFBQSxVQUFBO1FBQ0M7UUFBQTtRQUFBO1FBQUEsWUFBQSxnQ0FBQTtRQUNBO1FBQUE7UUFBQTtRQUFBLFlBQUEsZ0NBQUE7UUFJRjtRQUFBLFlBQUEsVUFBQTs7OztvQkM3SUg7TUFBQTthQUFBOzt5QkFBQTtJQUFBOzs7OyJ9
//# sourceMappingURL=oauth.component.ngfactory.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/nonce/nonce.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var nonce_component_scss_shim_ngstyle_styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9ub25jZS9ub25jZS5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9wYXQvc291cmNlL2l0ZGV2aWNlcy9naXRsYWIvb2NlYW5ibHVmZnByb2R1Y3Rpb25zL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy11aS9zcmMvYXBwL2NvbXBvbmVudHMvbm9uY2Uvbm9uY2UuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=nonce.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/email.service.ts
var email_service = __webpack_require__("JO6G");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/organization.service.ts
var organization_service = __webpack_require__("msq6");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/components/nonce/nonce.component.ts







var nonce_component_NonceComponent = (function () {
    function NonceComponent(router, activatedRoute, authService, emailService, log, organizationService, perf, userService) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.authService = authService;
        this.emailService = emailService;
        this.log = log;
        this.organizationService = organizationService;
        this.perf = perf;
        this.userService = userService;
        this.userId = '';
        this.token = '';
        this.organization = {
            internalAbbreviatedName: '',
            domain: ''
        };
        this.contact = {
            firstName: '',
            lastName: '',
            email: ''
        };
    }
    NonceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute.params.subscribe(function (params) {
            _this.userId = params.userId;
            _this.token = params.token;
        });
        try {
            if (localStorage) {
                this.log.visitUserId = this.userId;
                localStorage.setItem('u', this.log.visitUserId);
            }
        }
        catch (err) {
            console.log('NonceComponent ngOnInit, Error writing to local storage');
            console.log(err);
        }
        this.log.info("Nonce start. userId=" + this.userId + " token=" + this.token);
        // TODO - add in clearCache
        // this.authService.clearCache();
        this.authService.authUsingNonce(this.userId, this.token).then(function () {
            _this.log.info("Nonce successful. userId=" + _this.userId);
            console.log('sending nonce successful email using AWS now.');
            // get the organization
            console.log('this.authService.organizationId = ' + _this.authService.organizationId);
            _this.organizationService.getOrganization(_this.authService.organizationId)
                .then(function (organization) {
                _this.organization = organization.organization;
                console.log('this.organization');
                console.log(_this.organization);
                // get the user
                _this.userService.getUserProfile()
                    .then(function (profile) {
                    _this.contact = profile.profile;
                    console.log('this.contact');
                    console.log(_this.contact);
                    // let emailFrom = '"' + this.organization.internalAbbreviatedName + ' Team Manager" <teammanager.ptfilmfest@oceanbluffproductions.com>';
                    var emailFrom = '"' + _this.organization.internalAbbreviatedName + ' Team Manager" <teammanager.' + _this.organization.domain + '@oceanbluffproductions.com>';
                    var emailTo = '"' + _this.contact.firstName + ' ' + _this.contact.lastName + '" <' + _this.contact.email + '>';
                    // let emailFrom = '"Pat McFaul" <patmcfaul@gmail.com>';
                    // let emailTo = '"Pat McFaul" <patmcfaul@itdevices.com>';
                    // console.log('emailFrom = ' + emailFrom);
                    // console.log('emailTo = ' + emailTo);
                    var emailSubject = 'Reviewer Team Setup Complete';
                    var emailBody = 'Congratulations ' + _this.contact.firstName + '!\n\nYou have successfully setup your access to the reviewer software.  To access the site at any time, simply use this link:\n\n' + 'https://oceanbluffproductions.com' + '\n\nRemember, if you want to screen films on another device or browser, contact us for a second email invitation.\n\nGood luck on your films!\n\nThanks!\n\n';
                    console.log('emailFrom = ' + emailFrom);
                    console.log('emailTo = ' + emailTo);
                    console.log('emailSubject = ' + emailSubject);
                    console.log('emailBody = ' + emailBody);
                    _this.emailService.sendEmail2(emailFrom, emailTo, emailSubject, emailBody)
                        .then(function () {
                        console.log('nonce successful email sent.');
                        // this.snackBar.open('Invite email sent!', 'X', {duration: 2000});
                        // redirect
                        _this.router.navigate(['']);
                    })
                        .catch(function (err) {
                        // TODO - handle errors?
                        _this.log.error(err);
                        // this.snackBar.open('Service not available now.', 'X', {duration: 2000});
                        // redirect
                        _this.router.navigate(['']);
                    });
                })
                    .catch(function (err) {
                    // !!! TODO - make sure should everywhere has catch, then fix everywhere!!!
                    _this.log.error(err);
                    _this.router.navigate(['']);
                });
            })
                .catch(function (err) {
                // !!! TODO - make sure should everywhere has catch, then fix everywhere!!!
                _this.log.error(err);
                _this.router.navigate(['']);
            });
            // // redirect
            // this.router.navigate(['']);
        }).catch(function (err) {
            _this.log.error("Nonce failed. userId=" + _this.userId + " token=" + _this.token);
            _this.log.error(err);
            // redirect for now
            _this.router.navigate(['']);
        });
    };
    NonceComponent.prototype.ngAfterViewInit = function () {
        this.perf.markTabLoadEnd('nonce');
    };
    NonceComponent.ctorParameters = function () { return [{ type: router_es5["m" /* Router */] }, { type: router_es5["a" /* ActivatedRoute */] }, { type: auth_service["a" /* AuthService */] }, { type: email_service["a" /* EmailService */] }, { type: log_service["a" /* LogService */] }, { type: organization_service["a" /* OrganizationService */] }, { type: perf_service["a" /* PerfService */] }, { type: user_service["a" /* UserService */] }]; };
    return NonceComponent;
}());

//# sourceMappingURL=nonce.component.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/nonce/nonce.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */










var styles_NonceComponent = [nonce_component_scss_shim_ngstyle_styles];
var RenderType_NonceComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_NonceComponent, data: {} });
function View_NonceComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'section', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'p', [['style', 'margin: 1em;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Registering Device'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], null, null);
}
function View_NonceComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'nonce', [], null, null, null, View_NonceComponent_0, RenderType_NonceComponent)),
        core_es5["ɵdid"](1, 4308992, null, 0, nonce_component_NonceComponent, [router_es5["m" /* Router */], router_es5["a" /* ActivatedRoute */],
            auth_service["a" /* AuthService */], email_service["a" /* EmailService */], log_service["a" /* LogService */], organization_service["a" /* OrganizationService */], perf_service["a" /* PerfService */],
            user_service["a" /* UserService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var NonceComponentNgFactory = core_es5["ɵccf"]('nonce', nonce_component_NonceComponent, View_NonceComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9ub25jZS9ub25jZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvcGF0L3NvdXJjZS9pdGRldmljZXMvZ2l0bGFiL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy9vY2VhbmJsdWZmcHJvZHVjdGlvbnMtdWkvc3JjL2FwcC9jb21wb25lbnRzL25vbmNlL25vbmNlLmNvbXBvbmVudC50cyIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9ub25jZS9ub25jZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9ub25jZS9ub25jZS5jb21wb25lbnQudHMuTm9uY2VDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c2VjdGlvbj5cblx0PHAgc3R5bGU9XCJtYXJnaW46IDFlbTtcIj5SZWdpc3RlcmluZyBEZXZpY2U8L3A+XG48L3NlY3Rpb24+XG4iLCI8bm9uY2U+PC9ub25jZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUEsd0VBQVM7YUFBQSw0QkFDUjtNQUFBO01BQUEsZ0JBQXdCLDBEQUFzQjthQUFBLDJCQUNyQzs7OztvQkNGVjtNQUFBO2FBQUE7O3dCQUFBO0lBQUE7Ozs7In0=
//# sourceMappingURL=nonce.component.ngfactory.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/landing/landing.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var landing_component_scss_shim_ngstyle_styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9sYW5kaW5nL2xhbmRpbmcuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvcGF0L3NvdXJjZS9pdGRldmljZXMvZ2l0bGFiL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy9vY2VhbmJsdWZmcHJvZHVjdGlvbnMtdWkvc3JjL2FwcC9jb21wb25lbnRzL2xhbmRpbmcvbGFuZGluZy5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=
//# sourceMappingURL=landing.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/modules/shared/components/dialog/dialog.component.ngfactory.ts + 1 modules
var dialog_component_ngfactory = __webpack_require__("W6ZD");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/dialog/dialog.component.ts
var dialog_component = __webpack_require__("0yio");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/node-libs-browser/node_modules/url/url.js
var url = __webpack_require__("ETzN");
var url_default = /*#__PURE__*/__webpack_require__.n(url);

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/querystring-es3/index.js
var querystring_es3 = __webpack_require__("Xgfo");
var querystring_es3_default = /*#__PURE__*/__webpack_require__.n(querystring_es3);

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/components/landing/landing.component.ts








var landing_component_LandingComponent = (function () {
    function LandingComponent(location, router, sanitizer, authService, log, perf) {
        this.location = location;
        this.router = router;
        this.sanitizer = sanitizer;
        this.authService = authService;
        this.log = log;
        this.perf = perf;
        this.viewHeight = '';
        this.dialogTitle = '';
        this.dialogContent1 = '';
        this.dialogContent2 = '';
        this.dialogOk = '';
        this.dialogCancel = '';
        this.dialogData = '';
        this.helpUrlLabel = '';
        this.helpUrlString = '';
    }
    LandingComponent.prototype.ngOnInit = function () {
        var _this = this;
        window.scrollTo(0, 0);
        // console.log('LandingComponent, this.log.originalHref');
        // console.log(this.log.originalHref);
        this.viewHeight = (window.innerHeight - 64) + 'px';
        // console.log('About to test LandingComponent....!!');
        try {
            // let testKey = 'testLocalStorageKey';
            // let testValue = 'testLocalStorageValue-' + uuid.v4().replace(/-/g, '');
            // localStorage.setItem(testKey, testValue);
            // let testValueRead = localStorage.getItem(testKey);
            // if (testValueRead !== testValue) {
            // 	this.log.error('Browser does not support Local Storage, read incorrect value. testValue=' + testValue + ', testValueRead=' + testValueRead);
            // 	// this.showPrivateBrowsingDialog();
            // 	this.router.navigate(['site/home']);
            // } else {
            try {
                // localStorage.removeItem(testKey);
                var wasRedirected = this.authService.redirectIfAuthorized();
                console.log('wasRedirected = ' + wasRedirected);
                if (!wasRedirected) {
                    var originalHref = this.log.originalHref;
                    console.log('originalHref');
                    console.log(originalHref);
                    var theUrl = void 0;
                    try {
                        theUrl = url["parse"](originalHref);
                        // theUrl = new URL(originalHref);
                        console.log('theUrl');
                        console.log(theUrl);
                        var parts = theUrl.pathname.split('/');
                        console.log('pathname parts');
                        console.log(parts);
                        // General URL mappings
                        // 1 - find any keyword mappings  (example: oauth)
                        // 2 - find any alias mappings  (example: ptff)
                        // 3 - find any alias mappings  (example: ptff)
                        if (parts.length > 1) {
                            var pathBase = parts[1].toLowerCase();
                            switch (pathBase) {
                                case 'oauth':
                                    console.log('Found oauth !!');
                                    if (parts.length > 2) {
                                        var oauthEndpoint = parts[2].toLowerCase();
                                        switch (oauthEndpoint) {
                                            case 'callback':
                                                console.log('Found oauth callback !!');
                                                var theQueryObject_1 = querystring_es3["parse"](theUrl.query);
                                                console.log('theQueryObject');
                                                console.log(theQueryObject_1);
                                                var navigationExtras = {
                                                    queryParams: { theQueryObject: theQueryObject_1 }
                                                };
                                                setTimeout(function () {
                                                    console.log('Nav to /oauth/callback');
                                                    _this.router.navigate(['/oauth/callback', theQueryObject_1]);
                                                    // this.router.navigate(['/oauth/callback', {queryParams: theQueryString}]);
                                                    // this.router.navigate(['/oauth/callback', navigationExtras]);
                                                    // this.router.navigateByUrl(theUrl.host + '/#/oauth/callback' + theUrl.search);
                                                }, 0);
                                                break;
                                        }
                                    }
                                    else {
                                        setTimeout(function () {
                                            console.log('Nav to /oauth');
                                            _this.router.navigate(['/oauth']);
                                        }, 0);
                                    }
                                    break;
                                case 'ptff':
                                    console.log('Found ptff !!');
                                    setTimeout(function () {
                                        _this.router.navigate(['festival/5dde71766d5342f39e8a0abfaaeab3f4/nextup']);
                                    }, 0);
                                    // this.router.navigate(['/site/home']);
                                    break;
                                case 'ptfilmfest':
                                    console.log('Found ptfilmfest !!');
                                    setTimeout(function () {
                                        _this.router.navigate(['festival/5dde71766d5342f39e8a0abfaaeab3f4/nextup']);
                                    }, 0);
                                    // this.router.navigate(['/site/home']);
                                    break;
                                case 'sedonafilmfestival':
                                    console.log('Found sedonafilmfestival !!');
                                    // setTimeout(() => {
                                    // 	this.router.navigate(['festival/b3b5117aba6249e49084a02d7a1c2c6e/ballots']);
                                    // }, 1000);
                                    this.router.navigate(['/site/home']);
                                    // this.router.navigate(['festival/b3b5117aba6249e49084a02d7a1c2c6e/nextup']);
                                    break;
                                default:
                                    // TODO!!! - try and lookup festival/organization domain, if found nav to that
                                    this.router.navigate(['/site/home']);
                            }
                        }
                    }
                    catch (err) {
                        this.log.error('Error parsing href, originalHref = ' + originalHref);
                        this.log.error(err);
                        this.router.navigate(['/site/home']);
                        return;
                    }
                }
            }
            catch (ex) {
                this.log.error(ex);
                throw ex;
            }
            // }
        }
        catch (ex) {
            this.log.error('Browser does not support Local Storage.');
            this.log.error(ex);
            // this.showPrivateBrowsingDialog();
            this.router.navigate(['site/home']);
        }
    };
    LandingComponent.prototype.ngAfterViewInit = function () {
        this.perf.markTabLoadEnd('landing');
    };
    LandingComponent.prototype.showPrivateBrowsingDialog2 = function () {
        var _this = this;
        this.dialogTitle = 'Local Storage Not Available';
        this.dialogContent1 = 'It appears that your browser does not support Local Storage.  Often this is the result of using "Private Browsing".  Please turn off private browsing and try again.';
        var browser = this.log.getBrowser();
        var tempUrl = '';
        this.helpUrlLabel = browser + ' instructions';
        switch (browser.toLowerCase()) {
            case 'mobile safari':
                tempUrl = 'https://support.google.com/chrome/answer/95464?hl=en';
                break;
            case 'safari':
                tempUrl = 'https://support.apple.com/kb/ph21413?locale=en_US';
                break;
            case 'chrome':
                tempUrl = 'https://support.google.com/chrome/answer/95464?hl=en';
                break;
            case 'firefox':
                tempUrl = 'https://support.mozilla.org/en-US/kb/private-browsing-use-firefox-without-history';
                break;
            case 'edge':
                tempUrl = 'https://support.microsoft.com/en-us/instantanswers/34b9a3a6-68bc-510b-2a9e-833107495ee5/browse-inprivate-in-microsoft-edge';
                break;
        }
        if (tempUrl) {
            this.helpUrlString = tempUrl;
        }
        // iOS
        // https://support.google.com/chrome/answer/95464?hl=en
        // Safari
        // https://support.apple.com/kb/ph21413?locale=en_US
        // Chrome
        // https://support.google.com/chrome/answer/95464?hl=en
        // FireFox
        // https://support.mozilla.org/en-US/kb/private-browsing-use-firefox-without-history
        // Edge
        // https://support.microsoft.com/en-us/instantanswers/34b9a3a6-68bc-510b-2a9e-833107495ee5/browse-inprivate-in-microsoft-edge
        this.dialogContent2 = '';
        this.dialogData = '';
        this.dialogOk = 'OK';
        this.dialogCancel = '';
        var subscription = this.confirmDialog.showDialog()
            .subscribe(function (voteCompleteData) {
            subscription.unsubscribe();
            _this.log.action('Private browsing dialog closed.');
        });
    };
    LandingComponent.ctorParameters = function () { return [{ type: common_es5["k" /* Location */] }, { type: router_es5["m" /* Router */] }, { type: platform_browser_es5["c" /* DomSanitizer */] }, { type: auth_service["a" /* AuthService */] }, { type: log_service["a" /* LogService */] }, { type: perf_service["a" /* PerfService */] }]; };
    return LandingComponent;
}());

//# sourceMappingURL=landing.component.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/landing/landing.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */











var styles_LandingComponent = [landing_component_scss_shim_ngstyle_styles];
var RenderType_LandingComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_LandingComponent, data: {} });
function View_LandingComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { confirmDialog: 0 }), (_l()(), core_es5["ɵeld"](1, 0, null, null, 7, 'section', [], [[4, 'height', null]], null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵeld"](3, 0, null, null, 1, 'itd-dialog', [], null, null, null, dialog_component_ngfactory["b" /* View_DialogComponent_0 */], dialog_component_ngfactory["a" /* RenderType_DialogComponent */])),
        core_es5["ɵdid"](4, 114688, [[1, 4], ['confirmDialog', 4]], 0, dialog_component["a" /* DialogComponent */], [platform_browser_es5["c" /* DomSanitizer */]], { title: [0, 'title'], content1: [1, 'content1'], content2: [2, 'content2'], ok: [3,
                'ok'], cancel: [4, 'cancel'], data: [5, 'data'], helpUrlLabel: [6, 'helpUrlLabel'],
            helpUrlString: [7, 'helpUrlString'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n\n	\n	'])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 1, 'p', [['style', 'margin: 1em;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Welcome to Ocean Bluff Productions!'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.dialogTitle;
        var currVal_2 = _co.dialogContent1;
        var currVal_3 = _co.dialogContent2;
        var currVal_4 = _co.dialogOk;
        var currVal_5 = _co.dialogCancel;
        var currVal_6 = _co.dialogData;
        var currVal_7 = _co.helpUrlLabel;
        var currVal_8 = _co.helpUrlString;
        _ck(_v, 4, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.viewHeight;
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_LandingComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'landing', [], null, null, null, View_LandingComponent_0, RenderType_LandingComponent)),
        core_es5["ɵdid"](1, 4308992, null, 0, landing_component_LandingComponent, [common_es5["k" /* Location */], router_es5["m" /* Router */],
            platform_browser_es5["c" /* DomSanitizer */], auth_service["a" /* AuthService */], log_service["a" /* LogService */], perf_service["a" /* PerfService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var LandingComponentNgFactory = core_es5["ɵccf"]('landing', landing_component_LandingComponent, View_LandingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9sYW5kaW5nL2xhbmRpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9sYW5kaW5nL2xhbmRpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vVXNlcnMvcGF0L3NvdXJjZS9pdGRldmljZXMvZ2l0bGFiL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy9vY2VhbmJsdWZmcHJvZHVjdGlvbnMtdWkvc3JjL2FwcC9jb21wb25lbnRzL2xhbmRpbmcvbGFuZGluZy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9sYW5kaW5nL2xhbmRpbmcuY29tcG9uZW50LnRzLkxhbmRpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c2VjdGlvbiBbc3R5bGUuaGVpZ2h0XT1cInZpZXdIZWlnaHRcIj5cblx0PGl0ZC1kaWFsb2dcblx0XHQjY29uZmlybURpYWxvZ1xuXHRcdFt0aXRsZV09XCJkaWFsb2dUaXRsZVwiXG5cdFx0W2NvbnRlbnQxXT1cImRpYWxvZ0NvbnRlbnQxXCJcblx0XHRbY29udGVudDJdPVwiZGlhbG9nQ29udGVudDJcIlxuXHRcdFtva109XCJkaWFsb2dPa1wiXG5cdFx0W2NhbmNlbF09XCJkaWFsb2dDYW5jZWxcIlxuXHRcdFtkYXRhXT1cImRpYWxvZ0RhdGFcIlxuXG5cdFx0W2hlbHBVcmxMYWJlbF09XCJoZWxwVXJsTGFiZWxcIlxuXHRcdFtoZWxwVXJsU3RyaW5nXT1cImhlbHBVcmxTdHJpbmdcIlxuXHQ+PC9pdGQtZGlhbG9nPlxuXG5cdFxuXHQ8cCBzdHlsZT1cIm1hcmdpbjogMWVtO1wiPldlbGNvbWUgdG8gT2NlYW4gQmx1ZmYgUHJvZHVjdGlvbnMhPC9wPlxuPC9zZWN0aW9uPlxuIiwiPGxhbmRpbmc+PC9sYW5kaW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzJEQ0FBO01BQUE7TUFBQSw0Q0FBcUM7TUFBQSxVQUNwQztNQUFBO2FBQUE7VUFBQTtjQUFBO2NBQUEsa0RBV2M7VUFBQSw2QkFHZDtVQUFBO1VBQUEsOEJBQXdCO01BQXVDLDBDQUN0RDs7O1FBYlI7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBRUE7UUFDQTtRQVZELFdBRUMsVUFDQSxVQUNBLFVBQ0EsVUFDQSxVQUNBLFVBRUE7WUFDQSxTQVZEOzs7UUFEUTtRQUFULFdBQVMsU0FBVDs7OztvQkNBQTtNQUFBO2FBQUE7c0VBQUE7VUFBQTtJQUFBOzs7OyJ9
//# sourceMappingURL=landing.component.ngfactory.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/redirect/redirect.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var redirect_component_scss_shim_ngstyle_styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9yZWRpcmVjdC9yZWRpcmVjdC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9wYXQvc291cmNlL2l0ZGV2aWNlcy9naXRsYWIvb2NlYW5ibHVmZnByb2R1Y3Rpb25zL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy11aS9zcmMvYXBwL2NvbXBvbmVudHMvcmVkaXJlY3QvcmVkaXJlY3QuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=redirect.component.scss.shim.ngstyle.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/components/redirect/redirect.component.ts




var redirect_component_RedirectComponent = (function () {
    function RedirectComponent(location, router, log, perf) {
        this.location = location;
        this.router = router;
        this.log = log;
        this.perf = perf;
    }
    RedirectComponent.prototype.ngOnInit = function () {
        var currentPath = this.location.path();
        this.log.warn('Redirecting from invalid path.  path=' + currentPath);
        this.router.navigate(['']);
    };
    RedirectComponent.prototype.ngAfterViewInit = function () {
        this.perf.markTabLoadEnd('redirect');
    };
    RedirectComponent.ctorParameters = function () { return [{ type: common_es5["k" /* Location */] }, { type: router_es5["m" /* Router */] }, { type: log_service["a" /* LogService */] }, { type: perf_service["a" /* PerfService */] }]; };
    return RedirectComponent;
}());

//# sourceMappingURL=redirect.component.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/redirect/redirect.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */







var styles_RedirectComponent = [redirect_component_scss_shim_ngstyle_styles];
var RenderType_RedirectComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_RedirectComponent, data: {} });
function View_RedirectComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 4, 'section', [], null, null, null, null, null)), (_l()(),
            core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 1, 'p', [['style', 'margin: 1em;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Welcome to Ocean Bluff Productions!'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], null, null);
}
function View_RedirectComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'redirect', [], null, null, null, View_RedirectComponent_0, RenderType_RedirectComponent)),
        core_es5["ɵdid"](1, 4308992, null, 0, redirect_component_RedirectComponent, [common_es5["k" /* Location */], router_es5["m" /* Router */],
            log_service["a" /* LogService */], perf_service["a" /* PerfService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var RedirectComponentNgFactory = core_es5["ɵccf"]('redirect', redirect_component_RedirectComponent, View_RedirectComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9yZWRpcmVjdC9yZWRpcmVjdC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvcGF0L3NvdXJjZS9pdGRldmljZXMvZ2l0bGFiL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy9vY2VhbmJsdWZmcHJvZHVjdGlvbnMtdWkvc3JjL2FwcC9jb21wb25lbnRzL3JlZGlyZWN0L3JlZGlyZWN0LmNvbXBvbmVudC50cyIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9yZWRpcmVjdC9yZWRpcmVjdC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9yZWRpcmVjdC9yZWRpcmVjdC5jb21wb25lbnQudHMuUmVkaXJlY3RDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c2VjdGlvbj5cblx0PHAgc3R5bGU9XCJtYXJnaW46IDFlbTtcIj5XZWxjb21lIHRvIE9jZWFuIEJsdWZmIFByb2R1Y3Rpb25zITwvcD5cbjwvc2VjdGlvbj5cbiIsIjxyZWRpcmVjdD48L3JlZGlyZWN0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQSx3RUFBUzthQUFBLDRCQUNSO01BQUE7TUFBQSxnQkFBd0I7TUFBdUMsMENBQ3REOzs7O29CQ0ZWO01BQUE7YUFBQTtzQ0FBQTtJQUFBOzs7OyJ9
//# sourceMappingURL=redirect.component.ngfactory.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/app.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var app_component_scss_shim_ngstyle_styles = ['[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}mat-toolbar[_ngcontent-%COMP%]{background-color:#2196f3}.toolbar-container[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;height:auto}[mat-raised-button][_ngcontent-%COMP%]{color:#fff;background-color:#2196f3}.toolbar-icon[_ngcontent-%COMP%]{color:#fff;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.toolbar-buttons-container[_ngcontent-%COMP%], .toolbar-icon[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}.toolbar-buttons-container[_ngcontent-%COMP%]{-ms-flex-pack:distribute;justify-content:space-around;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;width:100%;height:auto}.toolbar-button-content[_ngcontent-%COMP%]{font-size:14px;font-weight:400;text-transform:uppercase}button.toolbar-button[_ngcontent-%COMP%]:hover{background-color:rgba(0,0,0,.15)}.toolbar-button-unselected[_ngcontent-%COMP%]{color:hsla(0,0%,100%,.7)}.toolbar-end-button[_ngcontent-%COMP%]{color:#fff;background-color:#2196f3;border:0;padding:0;cursor:pointer}.sidenav-heading[_ngcontent-%COMP%]{font-size:1.14em;font-weight:400}.export-button[_ngcontent-%COMP%]{font-size:1rem;font-weight:400}.sidenav-checkbox[_ngcontent-%COMP%]{color:purple;background-color:#ff0}@media (hover:none){[mat-button][_ngcontent-%COMP%]:hover:after{content:none}}.loading-films[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,"sans-serif";font-size:1rem}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==
//# sourceMappingURL=app.component.scss.shim.ngstyle.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/itd-toolbar/itd-toolbar.component.scss.shim.ngstyle.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */ var itd_toolbar_component_scss_shim_ngstyle_styles = ['[itd-flex-container-row-start-end][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-end][_ngcontent-%COMP%], [itd-flex-container-row-start-end][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-end-end][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-end][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}[itd-flex-container-row-center-end][_ngcontent-%COMP%], [itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-space-around-start][_ngcontent-%COMP%]{-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-column-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-item-5][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 5%;flex:0 0 5%}[itd-flex-item-8][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 8.3333333%;flex:0 0 8.3333333%}[itd-flex-item-13][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 13%;flex:0 0 13%}[itd-flex-item-15][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 15%;flex:0 0 15%}[itd-flex-item-16][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 16.6666666%;flex:0 0 16.6666666%}[itd-flex-item-18][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 18%;flex:0 0 18%}[itd-flex-item-20][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 20%;flex:0 0 20%}[itd-flex-item-25][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 25%;flex:0 0 25%}[itd-flex-item-37][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 37.5%;flex:0 0 37.5%}[itd-flex-item-41][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 41.66666660%;flex:0 0 41.66666660%}[itd-flex-item-66][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 66.6666666%;flex:0 0 66.6666666%}@media (max-width:600px){[itd-hide-phone][_ngcontent-%COMP%]{display:none}}@media (min-width:600px){[itd-show-phone][_ngcontent-%COMP%]{display:none}}.app-action-sidenav[_ngcontent-%COMP%]{left:5px}.app-action-search[_ngcontent-%COMP%], .app-action-sidenav[_ngcontent-%COMP%]{display:inline-block;position:fixed;top:5px;z-index:20}.app-action-search[_ngcontent-%COMP%]{right:5px}.app-action-scroll-top[_ngcontent-%COMP%]{display:inline-block;position:fixed;bottom:5px;right:5px;z-index:20}.my-red[_ngcontent-%COMP%]{background-color:red}.app-toolbar-pinned[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:260px;z-index:10}.sidenav[_ngcontent-%COMP%]{width:16rem;margin-left:-16rem;z-index:100;background-color:#fafafa;overflow-x:hidden;transition:.4s}.sidenav[_ngcontent-%COMP%], .sideOverlay[_ngcontent-%COMP%]{height:100%;position:fixed;top:0;left:0}.sideOverlay[_ngcontent-%COMP%]{display:none;width:100%;z-index:99;background-color:rgba(0,0,0,.6);overflow:hidden}.example-icon[_ngcontent-%COMP%]{padding:0 14px}.example-spacer[_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.demo-nav-bar[_ngcontent-%COMP%]{background-color:#2196f3;color:#fff;padding:.5rem 59px .5rem 59px}.mat-tab-link[_ngcontent-%COMP%]{font-size:1rem}.mat-ink-bar[_ngcontent-%COMP%], mat-ink-bar[_ngcontent-%COMP%], mat-ink-bar.mat-ink-bar[_ngcontent-%COMP%], mat-ink-bar[_ngcontent-%COMP%] > .mat-ink-bar[_ngcontent-%COMP%]{background-color:#fff}.mat-tab-nav-bar[_ngcontent-%COMP%]{border-bottom:1px solid #2196f3}.app-toolbar-active[_ngcontent-%COMP%]{opacity:1}[itd-flex-container][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}[itd-flex-container-row-start-start][_ngcontent-%COMP%], [itd-flex-container-row][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}[itd-flex-container-row-start-start][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-end-start][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-start][_ngcontent-%COMP%], [itd-flex-container-row-end-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-center-start][_ngcontent-%COMP%]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[itd-flex-container-row-start-center][_ngcontent-%COMP%]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}[itd-flex-container-row-end-center][_ngcontent-%COMP%], [itd-flex-container-row-start-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-end-center][_ngcontent-%COMP%]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}[itd-flex-container-row-center-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-between-start-with-wrap][_ngcontent-%COMP%]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-container-row-space-between-center-with-wrap][_ngcontent-%COMP%], [itd-flex-container-row-space-between-start-with-wrap][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}[itd-flex-container-row-space-between-center-with-wrap][_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[itd-flex-container-column][_ngcontent-%COMP%], [itd-flex-container-row-space-around-center][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal}[itd-flex-container-column-start-start][_ngcontent-%COMP%], [itd-flex-container-column][_ngcontent-%COMP%]{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}[itd-flex-container-column-start-start][_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}[itd-flex-item][_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}[itd-flex-item-fixed][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}[itd-flex-item-10][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 10%;flex:0 0 10%}[itd-flex-item-30][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%}[itd-flex-item-33][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 33.3333333%;flex:0 0 33.3333333%}[itd-flex-item-50][_ngcontent-%COMP%]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvY29tcG9uZW50cy9pdGQtdG9vbGJhci9pdGQtdG9vbGJhci5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9wYXQvc291cmNlL2l0ZGV2aWNlcy9naXRsYWIvb2NlYW5ibHVmZnByb2R1Y3Rpb25zL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy11aS9zcmMvYXBwL2NvbXBvbmVudHMvaXRkLXRvb2xiYXIvaXRkLXRvb2xiYXIuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9
//# sourceMappingURL=itd-toolbar.component.scss.shim.ngstyle.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/tabs.es5.js
var tabs_es5 = __webpack_require__("ZFRd");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/tabs/typings/index.ngfactory.ts
var tabs_typings_index_ngfactory = __webpack_require__("Pfd5");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/bidi.es5.js
var bidi_es5 = __webpack_require__("l6RC");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/scrolling.es5.js
var scrolling_es5 = __webpack_require__("4jwp");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/components/itd-toolbar/itd-toolbar.component.ts


// import {MdInkBar, MdTabNavBar} from '@angular/material';

var itd_toolbar_component_ItdToolbarComponent = (function () {
    function ItdToolbarComponent(elementRef, renderer, router, 
        // private log: LogService
        perf) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.router = router;
        this.perf = perf;
        // @ViewChildren(MdInkBar) inkBars: QueryList<MdInkBar>;
        // @ViewChildren(MdTabNavBar) tabBars: QueryList<MdTabNavBar>;
        this.tabLinks = [];
        this.activeLinkIndex = 0;
        this.tabs = [];
        this.showFirst = false;
        this.showSecond = false;
        // @Input()
        // firstIndex = 0;
        // @Input()
        // secondIndex = 0;
        this.color = '';
        this.isWatch = true;
        this.editTheFilm = new core_es5["EventEmitter"]();
        this.reviewTheFilm = new core_es5["EventEmitter"]();
    }
    ItdToolbarComponent.prototype.ngAfterViewInit = function () {
        var inkBars = this.elementRef.nativeElement.getElementsByTagName('mat-ink-bar');
        // const inkBars = window.document.getElementsByTagName('md-ink-bar');
        // console.log(inkBars);
        if (inkBars && inkBars[0]) {
            inkBars[0].style.backgroundColor = 'white';
        }
        // list.getElementsByTagName("LI")[0].innerHTML = "Milk";
        // console.log(this.inkBars);
        // console.log(this.tabBars);
        // this.tabBars.forEach((mdTabNavBar: MdTabNavBar) => {
        // 	console.log(mdTabNavBar);
        // 	// if (mdTabNavBar && mdTabNavBar._inkBar && mdTabNavBar._inkBar._elementRef && mdTabNavBar._inkBar._elementRef.nativeElement) {
        // 	// 	const element = mdTabNavBar._inkBar._elementRef.nativeElement;
        // 	// 	console.log(mdTabNavBar._inkBar);
        // 	// }
        // });
        // setTimeout(() => {
        // 	console.log('this.inkBars');
        // 	console.log(this.inkBars);
        // 	console.log('this.tabBars');
        // 	console.log(this.tabBars);
        // 	this.tabBars.forEach((mdTabNavBar: MdTabNavBar) => {
        // 		console.log(mdTabNavBar);
        // 	});
        // 	if (this.tabBars && this.tabBars[0]) {
        // 		console.log('this.tabBars[0]');
        // 		const tabBar = this.tabBars[0];
        // 		console.log('tabBar');
        // 		if (tabBar && tabBar._inkBar) {
        // 			console.log('tabBar._inkBar');
        // 			console.log(tabBar._inkBar);
        // 		}
        // 	}
        // }, 3000);
    };
    // !!! TODO - NOPE!!!
    /*
        onResize(event: any) {
            // console.log('ItdToolbarComponent onResize');
            this.updateInkBar();
    
            // console.log('onResize. showFirst=' + this.showFirst + ', showSecond=' + this.showSecond);
    
            // console.log(this.tabBars);
            // this.tabBars.forEach((mdTabNavBar: MdTabNavBar) => {
            // 	console.log(mdTabNavBar);
    
            // 	mdTabNavBar.updateInkBar();
    
            // 	// let inkBar = mdTabNavBar._inkBar;
            // 	// // inkBar.hide();
            // 	// // inkBar.show();
            // });
    
        }
    */
    /*
        updateInkBar() {
            // !!! no longer needed as of 2.0.0-beta.5 !!!
    
    
            // console.log('ItdToolbarComponent updateInkBar');
            // this.tabBars.forEach((mdTabNavBar: MdTabNavBar) => {
            this.tabBars.forEach((mdTabNavBar: any) => {
                // mdTabNavBar.updateInkBar();
    
                // // //mdTabNavBar._alignInkBar();
    
            });
        }
    */
    ItdToolbarComponent.prototype.firstMenuBarClick = function (firstTab) {
        if (!this.tabs) {
            console.log('firstMenuBarClick error, no tabs');
            return;
        }
        console.log('firstMenuBarClick');
        console.log(firstTab);
        // let authString = this.profileTabs[index].auth;
        // authString = authString.slice(4);
        this.perf.markUserActionStart(firstTab.name.toLowerCase() + '.clicked');
        var firstIndex = this.tabs.firstIndex;
        // console.log('firstIndex');
        // console.log(firstIndex);
        var secondIndex = this.tabs.firstTabs[this.tabs.firstIndex].secondTab.index;
        // console.log('secondIndex');
        // console.log(secondIndex);
        var theRealTabs = JSON.stringify(this.tabs, null, 2);
        // console.log('theRealTabs');
        // console.log(theRealTabs);
        // console.log('this.tabs');
        // console.log(this.tabs);
        // console.log('this.tabs.firstTabs[this.tabs.firstIndex].secondTab');
        // console.log(this.tabs.firstTabs[this.tabs.firstIndex].secondTab);
        var link = this.tabs.firstTabs[this.tabs.firstIndex].secondTab.tabs[secondIndex].link;
        // console.log('link');
        // console.log(link);
        this.router.navigate([link]);
    };
    ItdToolbarComponent.prototype.secondMenuBarClick = function (secondTab) {
        if (!this.tabs) {
            console.log('secondMenuBarClick error, no tabs');
            return;
        }
        // console.log('secondMenuBarClick');
        // console.log(secondTab);
        // let authString = this.profileTabs[index].auth;
        // authString = authString.slice(4);
        this.perf.markUserActionStart(secondTab.link.replace(/\//g, '.') + '.clicked');
    };
    ItdToolbarComponent.prototype.getSecondBarTabs = function (theTabs) {
        // tabs?.firstTabs[tabs?.firstIndex]?.secondTab?.tabs
        var secondBarTabs = [];
        if (!this.tabs || !this.tabs.firstTabs) {
            return secondBarTabs;
        }
        var firstIndex = this.tabs.firstIndex || 0;
        var firstBarTabObject = this.tabs.firstTabs[firstIndex];
        if (!firstBarTabObject || !firstBarTabObject.secondTab || !firstBarTabObject.secondTab.tabs) {
            return secondBarTabs;
        }
        secondBarTabs = firstBarTabObject.secondTab.tabs;
        return secondBarTabs;
    };
    ItdToolbarComponent.prototype.getSecondBarTabIndex = function (theTabs) {
        // tabs?.firstTabs[tabs?.firstIndex]?.secondTab?.index
        var secondBarTabIndex = 0;
        if (!this.tabs || !this.tabs.firstTabs) {
            return secondBarTabIndex;
        }
        var firstIndex = this.tabs.firstIndex || 0;
        var firstBarTabObject = this.tabs.firstTabs[firstIndex];
        if (!firstBarTabObject || !firstBarTabObject.secondTab) {
            return secondBarTabIndex;
        }
        secondBarTabIndex = firstBarTabObject.secondTab.index;
        return secondBarTabIndex;
    };
    ItdToolbarComponent.prototype.setSecondBarTabIndex = function (theTabs, index) {
        // tabs.firstTabs[tabs.firstIndex].secondTab.index = j
        if (!this.tabs || !this.tabs.firstTabs) {
            return;
        }
        var firstIndex = this.tabs.firstIndex || 0;
        var firstBarTabObject = this.tabs.firstTabs[firstIndex];
        if (!firstBarTabObject || !firstBarTabObject.secondTab) {
            return;
        }
        firstBarTabObject.secondTab.index = index;
        return;
    };
    ItdToolbarComponent.ctorParameters = function () { return [{ type: core_es5["ElementRef"] }, { type: core_es5["Renderer"] }, { type: router_es5["m" /* Router */] }, { type: perf_service["a" /* PerfService */] }]; };
    return ItdToolbarComponent;
}());

//# sourceMappingURL=itd-toolbar.component.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/components/itd-toolbar/itd-toolbar.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */












var styles_ItdToolbarComponent = [itd_toolbar_component_scss_shim_ngstyle_styles];
var RenderType_ItdToolbarComponent = core_es5["ɵcrt"]({ encapsulation: 0,
    styles: styles_ItdToolbarComponent, data: {} });
function View_ItdToolbarComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 9, 'div', [['itd-flex-item',
                '']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 6, 'div', [['itd-flex-container-row-center-start', ''], ['style',
                'width: 100%;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n\n					'])), (_l()(),
            core_es5["ɵeld"](4, 0, null, null, 3, 'a', [['class', 'mat-tab-link'],
                ['itd-flex-item-fixed', ''], ['matTabLink', ''], ['style', 'font-size: 0.875rem; line-height: 2.0rem; height: 2.0rem; min-width: 88px;']], [[2, 'app-toolbar-active', null], [1, 'aria-disabled', 0], [1, 'tabindex',
                    0], [2, 'mat-tab-disabled', null], [2, 'mat-tab-label-active',
                    null]], [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    _co.tabs.firstIndex = _v.context.index;
                    var pd_0 = (_co.firstMenuBarClick(_v.context.$implicit) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](5, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](6, 147456, [[1, 4]], 0, tabs_es5["g" /* MatTabLink */], [tabs_es5["h" /* MatTabNav */], core_es5["ElementRef"], core_es5["NgZone"], platform_es5["a" /* Platform */], [2, esm5_core_es5["l" /* MAT_RIPPLE_GLOBAL_OPTIONS */]]], { active: [0, 'active'] }, null), (_l()(), core_es5["ɵted"](7, null, ['\n						',
            '\n					'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n				'])), (_l()(), core_es5["ɵted"](-1, null, ['\n			']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_5 = (_co.tabs.firstIndex === _v.context.index);
        _ck(_v, 6, 0, currVal_5);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.tabs.firstIndex === _v.context.index);
        var currVal_1 = core_es5["ɵnov"](_v, 6).disabled.toString();
        var currVal_2 = core_es5["ɵnov"](_v, 6).tabIndex;
        var currVal_3 = core_es5["ɵnov"](_v, 6).disabled;
        var currVal_4 = core_es5["ɵnov"](_v, 6).active;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4);
        var currVal_6 = _v.context.$implicit.name;
        _ck(_v, 7, 0, currVal_6);
    });
}
function View_ItdToolbarComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 13, 'div', [['class',
                'demo-nav-bar']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n	'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 10, 'nav', [['class', 'mat-tab-nav-bar'], ['mat-tab-nav-bar', '']], null, null, null, tabs_typings_index_ngfactory["e" /* View_MatTabNav_0 */], tabs_typings_index_ngfactory["c" /* RenderType_MatTabNav */])),
        core_es5["ɵdid"](3, 3325952, null, 1, tabs_es5["h" /* MatTabNav */], [core_es5["Renderer2"], core_es5["ElementRef"], [2,
                bidi_es5["c" /* Directionality */]], core_es5["NgZone"], core_es5["ChangeDetectorRef"], scrolling_es5["f" /* ViewportRuler */]], null, null), core_es5["ɵqud"](603979776, 1, { _tabLinks: 1 }), (_l()(), core_es5["ɵted"](-1, 0, ['\n'])),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n		'])), (_l()(), core_es5["ɵeld"](7, 0, null, 0, 4, 'div', [['itd-flex-container-row-space-between-center-with-wrap', ''], ['style', 'width: 100%; height: auto; min-height: 48px']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n			'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ItdToolbarComponent_2)), core_es5["ɵdid"](10, 802816, null, 0, common_es5["n" /* NgForOf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n	'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.tabs.firstTabs;
        _ck(_v, 10, 0, currVal_0);
    }, null);
}
function View_ItdToolbarComponent_4(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 11, 'div', [['itd-flex-item',
                '']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n				'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 8, 'div', [['itd-flex-container-row-center-start', ''], ['style',
                'width: 100%;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n\n					'])), (_l()(),
            core_es5["ɵeld"](4, 0, null, null, 5, 'a', [['class', 'mat-tab-link'],
                ['itd-flex-item-fixed', ''], ['matTabLink', ''], ['style', 'font-size: 0.875rem; line-height: 2.0rem; height: 2.0rem; min-width: 88px;']], [[2, 'app-toolbar-active', null], [1, 'aria-disabled', 0], [1, 'tabindex',
                    0], [2, 'mat-tab-disabled', null], [2, 'mat-tab-label-active',
                    null], [1, 'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('click' === en)) {
                    var pd_0 = (core_es5["ɵnov"](_v, 7).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                    ad = (pd_0 && ad);
                }
                if (('click' === en)) {
                    _co.setSecondBarTabIndex(_co.tabs, _v.context.index);
                    var pd_1 = (_co.secondMenuBarClick(_v.context.$implicit) !== false);
                    ad = (pd_1 && ad);
                }
                return ad;
            }, null, null)), core_es5["ɵdid"](5, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](6, 147456, [[2, 4]], 0, tabs_es5["g" /* MatTabLink */], [tabs_es5["h" /* MatTabNav */], core_es5["ElementRef"], core_es5["NgZone"], platform_es5["a" /* Platform */], [2, esm5_core_es5["l" /* MAT_RIPPLE_GLOBAL_OPTIONS */]]], { active: [0, 'active'] }, null), core_es5["ɵdid"](7, 671744, null, 0, router_es5["n" /* RouterLinkWithHref */], [router_es5["m" /* Router */], router_es5["a" /* ActivatedRoute */], common_es5["l" /* LocationStrategy */]], { routerLink: [0, 'routerLink'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n'])), (_l()(), core_es5["ɵted"](9, null, ['\n\n\n						', '\n					'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n				'])), (_l()(), core_es5["ɵted"](-1, null, ['\n			']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = (_co.getSecondBarTabIndex(_co.tabs) === _v.context.index);
        _ck(_v, 6, 0, currVal_7);
        var currVal_8 = _v.context.$implicit.link;
        _ck(_v, 7, 0, currVal_8);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.getSecondBarTabIndex(_co.tabs) === _v.context.index);
        var currVal_1 = core_es5["ɵnov"](_v, 6).disabled.toString();
        var currVal_2 = core_es5["ɵnov"](_v, 6).tabIndex;
        var currVal_3 = core_es5["ɵnov"](_v, 6).disabled;
        var currVal_4 = core_es5["ɵnov"](_v, 6).active;
        var currVal_5 = core_es5["ɵnov"](_v, 7).target;
        var currVal_6 = core_es5["ɵnov"](_v, 7).href;
        _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_9 = _v.context.$implicit.name;
        _ck(_v, 9, 0, currVal_9);
    });
}
function View_ItdToolbarComponent_3(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 13, 'div', [['class',
                'demo-nav-bar']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n	'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 10, 'nav', [['class', 'mat-tab-nav-bar'], ['mat-tab-nav-bar', '']], null, null, null, tabs_typings_index_ngfactory["e" /* View_MatTabNav_0 */], tabs_typings_index_ngfactory["c" /* RenderType_MatTabNav */])),
        core_es5["ɵdid"](3, 3325952, null, 1, tabs_es5["h" /* MatTabNav */], [core_es5["Renderer2"], core_es5["ElementRef"], [2,
                bidi_es5["c" /* Directionality */]], core_es5["NgZone"], core_es5["ChangeDetectorRef"], scrolling_es5["f" /* ViewportRuler */]], null, null), core_es5["ɵqud"](603979776, 2, { _tabLinks: 1 }), (_l()(), core_es5["ɵted"](-1, 0, ['\n'])),
        (_l()(), core_es5["ɵted"](-1, 0, ['\n		'])), (_l()(), core_es5["ɵeld"](7, 0, null, 0, 4, 'div', [['itd-flex-container-row-space-between-center-with-wrap', ''], ['style', 'width: 100%; height: auto; min-height: 48px']], null, null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n			'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ItdToolbarComponent_4)), core_es5["ɵdid"](10, 802816, null, 0, common_es5["n" /* NgForOf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"], core_es5["IterableDiffers"]], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n		'])), (_l()(), core_es5["ɵted"](-1, 0, ['\n	'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getSecondBarTabs(_co.tabs);
        _ck(_v, 10, 0, currVal_0);
    }, null);
}
function View_ItdToolbarComponent_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ItdToolbarComponent_1)), core_es5["ɵdid"](3, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"],
            core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_ItdToolbarComponent_3)), core_es5["ɵdid"](7, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0,
                'ngIf'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.showFirst;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.showSecond;
        _ck(_v, 7, 0, currVal_1);
    }, null);
}
function View_ItdToolbarComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'itd-toolbar', [], null, null, null, View_ItdToolbarComponent_0, RenderType_ItdToolbarComponent)), core_es5["ɵdid"](1, 4243456, null, 0, itd_toolbar_component_ItdToolbarComponent, [core_es5["ElementRef"], core_es5["Renderer"], router_es5["m" /* Router */], perf_service["a" /* PerfService */]], null, null)], null, null);
}
var ItdToolbarComponentNgFactory = core_es5["ɵccf"]('itd-toolbar', itd_toolbar_component_ItdToolbarComponent, View_ItdToolbarComponent_Host_0, { tabLinks: 'tabLinks', tabs: 'tabs',
    showFirst: 'showFirst', showSecond: 'showSecond', color: 'color', showMore: 'showMore',
    isWatch: 'isWatch' }, { editTheFilm: 'editTheFilm', reviewTheFilm: 'reviewTheFilm' }, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=itd-toolbar.component.ngfactory.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/node_modules/@angular/material/progress-spinner/typings/index.ngfactory.ts
var progress_spinner_typings_index_ngfactory = __webpack_require__("OBOK");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/progress-spinner.es5.js
var progress_spinner_es5 = __webpack_require__("0bRs");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/app.component.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */

















var styles_AppComponent = [app_component_scss_shim_ngstyle_styles];
var RenderType_AppComponent = core_es5["ɵcrt"]({ encapsulation: 0, styles: styles_AppComponent,
    data: {} });
function View_AppComponent_1(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 2, 'itd-toolbar', [], null, null, null, View_ItdToolbarComponent_0, RenderType_ItdToolbarComponent)), core_es5["ɵdid"](1, 4243456, [[2, 4]], 0, itd_toolbar_component_ItdToolbarComponent, [core_es5["ElementRef"], core_es5["Renderer"], router_es5["m" /* Router */], perf_service["a" /* PerfService */]], { tabs: [0, 'tabs'], showFirst: [1,
                'showFirst'], showSecond: [2, 'showSecond'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n	']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.tabs;
        var currVal_1 = _co.showTwoRowMenuBar;
        var currVal_2 = !_co.showTwoRowMenuBar;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2);
    }, null);
}
function View_AppComponent_2(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 8, 'div', [['class',
                'loading-films'], ['itd-flex-container-row-center-center', '']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵeld"](2, 0, null, null, 2, 'mat-spinner', [['class', 'mat-spinner mat-progress-spinner'], ['mode', 'indeterminate'], ['role',
                'progressbar'], ['style', 'width: 48px; height: 48px;']], [[4, 'width', 'px'],
            [4, 'height', 'px']], null, null, progress_spinner_typings_index_ngfactory["b" /* View_MatSpinner_0 */], progress_spinner_typings_index_ngfactory["a" /* RenderType_MatSpinner */])),
        core_es5["ɵdid"](3, 16384, null, 0, esm5_core_es5["v" /* MatPrefixRejector */], [], null, null), core_es5["ɵdid"](4, 573440, null, 0, progress_spinner_es5["c" /* MatSpinner */], [core_es5["Renderer2"],
            core_es5["ElementRef"], platform_es5["a" /* Platform */], [2, common_es5["e" /* DOCUMENT */]]], { mode: [0, 'mode'] }, null),
        (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵeld"](6, 0, null, null, 1, 'span', [['style', 'margin: 0 0 0 2.0rem;']], null, null, null, null, null)), (_l()(), core_es5["ɵted"](-1, null, ['Loading new films, may take some time.'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var currVal_2 = 'indeterminate';
        _ck(_v, 4, 0, currVal_2);
    }, function (_ck, _v) {
        var currVal_0 = core_es5["ɵnov"](_v, 4)._elementSize;
        var currVal_1 = core_es5["ɵnov"](_v, 4)._elementSize;
        _ck(_v, 2, 0, currVal_0, currVal_1);
    });
}
function View_AppComponent_0(_l) {
    return core_es5["ɵvid"](0, [core_es5["ɵqud"](402653184, 1, { sidenav: 0 }), core_es5["ɵqud"](671088640, 2, { toolBars: 1 }),
        (_l()(), core_es5["ɵeld"](2, 0, null, null, 8, 'div', [], [[2, 'app-toolbar-pinned',
                null]], null, null, null, null)),
        (_l()(), core_es5["ɵted"](-1, null, ['\n	'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AppComponent_1)), core_es5["ɵdid"](5, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n	'])), (_l()(), core_es5["ɵeld"](7, 0, null, null, 2, 'itd-toolbar', [], null, null, null, View_ItdToolbarComponent_0, RenderType_ItdToolbarComponent)),
        core_es5["ɵdid"](8, 4243456, [[2, 4]], 0, itd_toolbar_component_ItdToolbarComponent, [core_es5["ElementRef"], core_es5["Renderer"],
            router_es5["m" /* Router */], perf_service["a" /* PerfService */]], { tabs: [0, 'tabs'], showFirst: [1, 'showFirst'], showSecond: [2,
                'showSecond'] }, null), (_l()(), core_es5["ɵted"](-1, null, ['\n	'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(), core_es5["ɵand"](16777216, null, null, 1, null, View_AppComponent_2)), core_es5["ɵdid"](14, 16384, null, 0, common_es5["o" /* NgIf */], [core_es5["ViewContainerRef"], core_es5["TemplateRef"]], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n'])), (_l()(), core_es5["ɵeld"](16, 16777216, null, null, 1, 'router-outlet', [], null, null, null, null, null)), core_es5["ɵdid"](17, 212992, null, 0, router_es5["p" /* RouterOutlet */], [router_es5["b" /* ChildrenOutletContexts */], core_es5["ViewContainerRef"], core_es5["ComponentFactoryResolver"],
            [8, null], core_es5["ChangeDetectorRef"]], null, null),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n'])),
        (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n\n\n\n'])), (_l()(),
            core_es5["ɵted"](-1, null, ['\n\n\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n\n\n\n\n\n'])), (_l()(), core_es5["ɵted"](-1, null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_1 = _co.showTwoRowMenuBar;
        _ck(_v, 5, 0, currVal_1);
        var currVal_2 = _co.tabs;
        var currVal_3 = false;
        var currVal_4 = true;
        _ck(_v, 8, 0, currVal_2, currVal_3, currVal_4);
        var currVal_5 = _co.log.showLoadingFilms;
        _ck(_v, 14, 0, currVal_5);
        _ck(_v, 17, 0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.pinMenuBar;
        _ck(_v, 2, 0, currVal_0);
    });
}
function View_AppComponent_Host_0(_l) {
    return core_es5["ɵvid"](0, [(_l()(), core_es5["ɵeld"](0, 0, null, null, 1, 'app-root', [], null, null, null, View_AppComponent_0, RenderType_AppComponent)),
        core_es5["ɵdid"](1, 4440064, null, 0, app_component_AppComponent, [router_es5["a" /* ActivatedRoute */], common_es5["k" /* Location */],
            router_es5["m" /* Router */], auth_service["a" /* AuthService */], feedback_service["a" /* FeedbackService */], log_service["a" /* LogService */], perf_service["a" /* PerfService */],
            tab_service["a" /* TabService */], user_service["a" /* UserService */]], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
var AppComponentNgFactory = core_es5["ɵccf"]('app-root', app_component_AppComponent, View_AppComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,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
//# sourceMappingURL=app.component.ngfactory.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/overlay.es5.js
var overlay_es5 = __webpack_require__("OFGE");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/autocomplete.es5.js
var autocomplete_es5 = __webpack_require__("1ini");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/observers.es5.js
var observers_es5 = __webpack_require__("ppgG");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/dialog.es5.js
var dialog_es5 = __webpack_require__("w24y");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/icon.es5.js
var icon_es5 = __webpack_require__("vgc3");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/datepicker.es5.js
var datepicker_es5 = __webpack_require__("BtE/");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/menu.es5.js
var menu_es5 = __webpack_require__("R1vt");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/select.es5.js
var select_es5 = __webpack_require__("gOiy");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/tooltip.es5.js
var tooltip_es5 = __webpack_require__("jk5D");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/paginator.es5.js
var paginator_es5 = __webpack_require__("i0AX");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/sort.es5.js
var sort_es5 = __webpack_require__("oXAn");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/stepper.es5.js
var stepper_es5 = __webpack_require__("8on4");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/animations/@angular/animations/browser.es5.js
var browser_es5 = __webpack_require__("f9zQ");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/platform-browser/@angular/platform-browser/animations.es5.js
var animations_es5 = __webpack_require__("fL27");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/animations/@angular/animations.es5.js
var _angular_animations_es5 = __webpack_require__("EyWH");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/version.service.ts
var version_service = __webpack_require__("Tlsw");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/auth-exists-guard.service.ts
var auth_exists_guard_service = __webpack_require__("XPX5");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/auto-login.service.ts
var auto_login_service = __webpack_require__("SlU0");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/myindexeddb.service.ts
var myindexeddb_service = __webpack_require__("POd8");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/cache-storage.service.ts
var cache_storage_service = __webpack_require__("a36o");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/communications.service.ts
var communications_service = __webpack_require__("Fqty");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/drag-drop.service.ts
var drag_drop_service = __webpack_require__("j3Eu");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/event.service.ts
var event_service = __webpack_require__("DDzU");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/festival.service.ts
var festival_service = __webpack_require__("Yhac");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/grid.service.ts
var grid_service = __webpack_require__("KEXf");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/reviewer-film.service.ts
var reviewer_film_service = __webpack_require__("N1s2");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/reviewer-image.service.ts
var reviewer_image_service = __webpack_require__("8VUB");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/reviewer-review.service.ts
var reviewer_review_service = __webpack_require__("A9Hf");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/volunteer.service.ts
var volunteer_service = __webpack_require__("poUV");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-events.resolver.ts
var all_events_resolver = __webpack_require__("RsOe");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-events-all-organizations.resolver.ts
var all_events_all_organizations_resolver = __webpack_require__("wi/U");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-films.resolver.ts
var all_films_resolver = __webpack_require__("t7So");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-grids.resolver.ts
var all_grids_resolver = __webpack_require__("Msfd");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-organizations.resolver.ts
var all_organizations_resolver = __webpack_require__("6Aok");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-reviews.resolver.ts
var all_reviews_resolver = __webpack_require__("rEIi");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-users.resolver.ts
var all_users_resolver = __webpack_require__("DJJ2");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/user-films.resolver.ts
var user_films_resolver = __webpack_require__("8K35");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/user-profile.resolver.ts
var user_profile_resolver = __webpack_require__("97bI");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/user-reviews.resolver.ts
var user_reviews_resolver = __webpack_require__("t3bT");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/portal.es5.js
var portal_es5 = __webpack_require__("CZgk");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/button-toggle.es5.js
var button_toggle_es5 = __webpack_require__("k7z1");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/checkbox.es5.js
var checkbox_es5 = __webpack_require__("0cZJ");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/chips.es5.js
var chips_es5 = __webpack_require__("ZYB1");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/table.es5.js
var table_es5 = __webpack_require__("c4k3");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/table.es5.js
var esm5_table_es5 = __webpack_require__("697t");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/expansion.es5.js
var expansion_es5 = __webpack_require__("RXNa");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/grid-list.es5.js
var grid_list_es5 = __webpack_require__("4+t2");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/list.es5.js
var list_es5 = __webpack_require__("dYU3");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/progress-bar.es5.js
var progress_bar_es5 = __webpack_require__("cC+T");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/sidenav.es5.js
var sidenav_es5 = __webpack_require__("e0rv");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/slide-toggle.es5.js
var slide_toggle_es5 = __webpack_require__("3uJi");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/slider.es5.js
var slider_es5 = __webpack_require__("kMVV");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/cdk/esm5/stepper.es5.js
var esm5_stepper_es5 = __webpack_require__("nYcr");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/node_modules/@angular/material/esm5/toolbar.es5.js
var toolbar_es5 = __webpack_require__("YXpL");

// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/all-material.module.ts
var all_material_module = __webpack_require__("/y7+");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/classes/itd-exception.ts

var itd_exception_ItdExceptionHandler = (function () {
    function ItdExceptionHandler(
        // @Inject(LogService) log: LogService
        // @Inject(LogService) logService: LogService
        log) {
        this.log = log;
        // this.log = logService;
    }
    // log: any;
    ItdExceptionHandler.prototype.handleError = function (error) {
        console.log('ItdExceptionHandler about to set needPageReLoad = true');
        console.log('this.log:');
        console.log(this.log);
        console.log('window[\'log\']');
        console.log(window['log']);
        this.log.exception(error); // note - this will redirect after logging exception to db
        // this.log.needPageReLoad = true;
        // this.router.navigate(['common/profile']);
        // window.location.reload(true);
        // this.router.navigate(['profile']);
        // let theLog: any = window['log'];
        // if (theLog) {
        // 	theLog.needPageReLoad = true;
        // 	theLog.exception(error);
        // } else {
        // 	console.log('ItdExceptionHandler - No logger found');
        // }
    };
    ItdExceptionHandler.ctorParameters = function () { return [{ type: log_service["a" /* LogService */] }]; };
    return ItdExceptionHandler;
}());

// https://medium.com/@amcdnl/global-error-handling-with-angular2-6b992bdfb59c#.9zf51xwnw
// https://www.bennadel.com/blog/3138-creating-a-custom-errorhandler-in-angular-2-rc-6.htm
// https://netbasal.com/angular-2-custom-exception-handler-1bcbc45c3230#.bjfz59y8p
// https://dpopescu.me/2016/10/21/catching-global-errors-in-angular-2/
// https://angular.io/docs/ts/latest/api/core/index/ErrorHandler-class.html
// http://stackoverflow.com/questions/38882969/change-in-angular2-rc5-exceptionhandler
// http://stackoverflow.com/a/38883195
// https://angular.io/docs/ts/latest/api/core/index/ErrorHandler-class.html
// http://stackoverflow.com/questions/39355296/custom-exceptionhandler-in-angular-2
// older rc4
// https://angular.io/docs/js/latest/api/core/index/ExceptionHandler-class.html
// http://stackoverflow.com/a/36351195
//# sourceMappingURL=itd-exception.js.map
// EXTERNAL MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/shared.module.ts
var shared_module = __webpack_require__("wFAi");

// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/$$_gendir/app/app.module.ngfactory.ts
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */








































































































var AppModuleNgFactory = core_es5["ɵcmf"](AppModule, [app_component_AppComponent], function (_l) {
    return core_es5["ɵmod"]([core_es5["ɵmpd"](512, core_es5["ComponentFactoryResolver"], core_es5["ɵCodegenComponentFactoryResolver"], [[8, [index_ngfactory["a" /* MatDialogContainerNgFactory */], typings_index_ngfactory["a" /* MatDatepickerContentNgFactory */], tooltip_typings_index_ngfactory["a" /* TooltipComponentNgFactory */],
                    snack_bar_typings_index_ngfactory["a" /* MatSnackBarContainerNgFactory */], snack_bar_typings_index_ngfactory["b" /* SimpleSnackBarNgFactory */], OauthCallbackComponentNgFactory,
                    OauthComponentNgFactory, NonceComponentNgFactory, LandingComponentNgFactory,
                    RedirectComponentNgFactory, AppComponentNgFactory]], [3, core_es5["ComponentFactoryResolver"]],
            core_es5["NgModuleRef"]]), core_es5["ɵmpd"](6144, bidi_es5["b" /* DIR_DOCUMENT */], null, [platform_browser_es5["b" /* DOCUMENT */]]),
        core_es5["ɵmpd"](4608, bidi_es5["c" /* Directionality */], bidi_es5["c" /* Directionality */], [[2, bidi_es5["b" /* DIR_DOCUMENT */]]]),
        core_es5["ɵmpd"](4608, platform_es5["a" /* Platform */], platform_es5["a" /* Platform */], []), core_es5["ɵmpd"](5120, core_es5["LOCALE_ID"], core_es5["ɵm"], [[3, core_es5["LOCALE_ID"]]]), core_es5["ɵmpd"](4608, common_es5["q" /* NgLocalization */], common_es5["p" /* NgLocaleLocalization */], [core_es5["LOCALE_ID"]]), core_es5["ɵmpd"](5120, scrolling_es5["c" /* ScrollDispatcher */], scrolling_es5["a" /* SCROLL_DISPATCHER_PROVIDER_FACTORY */], [[3, scrolling_es5["c" /* ScrollDispatcher */]], core_es5["NgZone"], platform_es5["a" /* Platform */]]), core_es5["ɵmpd"](5120, scrolling_es5["f" /* ViewportRuler */], scrolling_es5["e" /* VIEWPORT_RULER_PROVIDER_FACTORY */], [[3, scrolling_es5["f" /* ViewportRuler */]], platform_es5["a" /* Platform */],
            core_es5["NgZone"], scrolling_es5["c" /* ScrollDispatcher */]]), core_es5["ɵmpd"](4608, overlay_es5["g" /* ScrollStrategyOptions */], overlay_es5["g" /* ScrollStrategyOptions */], [scrolling_es5["c" /* ScrollDispatcher */], scrolling_es5["f" /* ViewportRuler */]]),
        core_es5["ɵmpd"](5120, overlay_es5["d" /* OverlayContainer */], overlay_es5["j" /* ɵa */], [[3, overlay_es5["d" /* OverlayContainer */]]]), core_es5["ɵmpd"](4608, overlay_es5["m" /* ɵf */], overlay_es5["m" /* ɵf */], [scrolling_es5["f" /* ViewportRuler */]]), core_es5["ɵmpd"](4608, overlay_es5["b" /* Overlay */], overlay_es5["b" /* Overlay */], [overlay_es5["g" /* ScrollStrategyOptions */], overlay_es5["d" /* OverlayContainer */], core_es5["ComponentFactoryResolver"],
            overlay_es5["m" /* ɵf */], core_es5["ApplicationRef"], core_es5["Injector"], core_es5["NgZone"]]), core_es5["ɵmpd"](5120, overlay_es5["k" /* ɵc */], overlay_es5["l" /* ɵd */], [overlay_es5["b" /* Overlay */]]), core_es5["ɵmpd"](5120, autocomplete_es5["a" /* MAT_AUTOCOMPLETE_SCROLL_STRATEGY */], autocomplete_es5["b" /* MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER_FACTORY */], [overlay_es5["b" /* Overlay */]]),
        core_es5["ɵmpd"](4608, a11y_es5["l" /* InteractivityChecker */], a11y_es5["l" /* InteractivityChecker */], [platform_es5["a" /* Platform */]]),
        core_es5["ɵmpd"](4608, a11y_es5["k" /* FocusTrapFactory */], a11y_es5["k" /* FocusTrapFactory */], [a11y_es5["l" /* InteractivityChecker */],
            platform_es5["a" /* Platform */], core_es5["NgZone"]]), core_es5["ɵmpd"](136192, a11y_es5["e" /* AriaDescriber */], a11y_es5["c" /* ARIA_DESCRIBER_PROVIDER_FACTORY */], [[3, a11y_es5["e" /* AriaDescriber */]], platform_es5["a" /* Platform */]]), core_es5["ɵmpd"](5120, a11y_es5["p" /* LiveAnnouncer */], a11y_es5["o" /* LIVE_ANNOUNCER_PROVIDER_FACTORY */], [[3, a11y_es5["p" /* LiveAnnouncer */]], [2, a11y_es5["m" /* LIVE_ANNOUNCER_ELEMENT_TOKEN */]],
            platform_es5["a" /* Platform */]]), core_es5["ɵmpd"](5120, a11y_es5["i" /* FocusMonitor */], a11y_es5["g" /* FOCUS_MONITOR_PROVIDER_FACTORY */], [[3, a11y_es5["i" /* FocusMonitor */]], core_es5["NgZone"], platform_es5["a" /* Platform */]]), core_es5["ɵmpd"](5120, collections_es5["c" /* UniqueSelectionDispatcher */], collections_es5["d" /* ɵa */], [[3, collections_es5["c" /* UniqueSelectionDispatcher */]]]), core_es5["ɵmpd"](4608, observers_es5["a" /* MatMutationObserverFactory */], observers_es5["a" /* MatMutationObserverFactory */], []), core_es5["ɵmpd"](5120, dialog_es5["a" /* MAT_DIALOG_SCROLL_STRATEGY */], dialog_es5["b" /* MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY */], [overlay_es5["b" /* Overlay */]]), core_es5["ɵmpd"](4608, dialog_es5["c" /* MatDialog */], dialog_es5["c" /* MatDialog */], [overlay_es5["b" /* Overlay */], core_es5["Injector"], [2, common_es5["k" /* Location */]],
            dialog_es5["a" /* MAT_DIALOG_SCROLL_STRATEGY */], [3, dialog_es5["c" /* MatDialog */]]]), core_es5["ɵmpd"](4608, platform_browser_es5["c" /* DomSanitizer */], platform_browser_es5["s" /* ɵe */], [common_es5["e" /* DOCUMENT */]]), core_es5["ɵmpd"](5120, icon_es5["d" /* MatIconRegistry */], icon_es5["a" /* ICON_REGISTRY_PROVIDER_FACTORY */], [[3, icon_es5["d" /* MatIconRegistry */]], [2, http_es5["Http"]],
            platform_browser_es5["c" /* DomSanitizer */]]), core_es5["ɵmpd"](4608, datepicker_es5["h" /* MatDatepickerIntl */], datepicker_es5["h" /* MatDatepickerIntl */], []), core_es5["ɵmpd"](5120, datepicker_es5["a" /* MAT_DATEPICKER_SCROLL_STRATEGY */], datepicker_es5["b" /* MAT_DATEPICKER_SCROLL_STRATEGY_PROVIDER_FACTORY */], [overlay_es5["b" /* Overlay */]]), core_es5["ɵmpd"](4608, esm5_core_es5["e" /* ErrorStateMatcher */], esm5_core_es5["e" /* ErrorStateMatcher */], []), core_es5["ɵmpd"](5120, menu_es5["b" /* MAT_MENU_SCROLL_STRATEGY */], menu_es5["g" /* ɵc22 */], [overlay_es5["b" /* Overlay */]]),
        core_es5["ɵmpd"](5120, select_es5["a" /* MAT_SELECT_SCROLL_STRATEGY */], select_es5["b" /* MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY */], [overlay_es5["b" /* Overlay */]]), core_es5["ɵmpd"](5120, tooltip_es5["a" /* MAT_TOOLTIP_SCROLL_STRATEGY */], tooltip_es5["b" /* MAT_TOOLTIP_SCROLL_STRATEGY_PROVIDER_FACTORY */], [overlay_es5["b" /* Overlay */]]), core_es5["ɵmpd"](4608, paginator_es5["a" /* MatPaginatorIntl */], paginator_es5["a" /* MatPaginatorIntl */], []), core_es5["ɵmpd"](4608, platform_browser_es5["f" /* HAMMER_GESTURE_CONFIG */], esm5_core_es5["f" /* GestureConfig */], []), core_es5["ɵmpd"](4608, snack_bar_es5["b" /* MatSnackBar */], snack_bar_es5["b" /* MatSnackBar */], [overlay_es5["b" /* Overlay */],
            a11y_es5["p" /* LiveAnnouncer */], core_es5["Injector"], [3, snack_bar_es5["b" /* MatSnackBar */]]]), core_es5["ɵmpd"](4608, sort_es5["a" /* MatSortHeaderIntl */], sort_es5["a" /* MatSortHeaderIntl */], []), core_es5["ɵmpd"](4608, stepper_es5["a" /* MatStepperIntl */], stepper_es5["a" /* MatStepperIntl */], []), core_es5["ɵmpd"](6144, esm5_core_es5["i" /* MAT_DATE_LOCALE */], null, [core_es5["LOCALE_ID"]]), core_es5["ɵmpd"](4608, esm5_core_es5["d" /* DateAdapter */], esm5_core_es5["A" /* NativeDateAdapter */], [[2,
                esm5_core_es5["i" /* MAT_DATE_LOCALE */]]]), core_es5["ɵmpd"](5120, core_es5["APP_ID"], core_es5["ɵf"], []), core_es5["ɵmpd"](5120, core_es5["IterableDiffers"], core_es5["ɵk"], []), core_es5["ɵmpd"](5120, core_es5["KeyValueDiffers"], core_es5["ɵl"], []), core_es5["ɵmpd"](6144, core_es5["Sanitizer"], null, [platform_browser_es5["c" /* DomSanitizer */]]),
        core_es5["ɵmpd"](5120, platform_browser_es5["d" /* EVENT_MANAGER_PLUGINS */], function (p0_0, p1_0, p2_0, p2_1) {
            return [new platform_browser_es5["l" /* ɵDomEventsPlugin */](p0_0), new platform_browser_es5["p" /* ɵKeyEventsPlugin */](p1_0),
                new platform_browser_es5["o" /* ɵHammerGesturesPlugin */](p2_0, p2_1)];
        }, [common_es5["e" /* DOCUMENT */], common_es5["e" /* DOCUMENT */], common_es5["e" /* DOCUMENT */], platform_browser_es5["f" /* HAMMER_GESTURE_CONFIG */]]), core_es5["ɵmpd"](4608, platform_browser_es5["e" /* EventManager */], platform_browser_es5["e" /* EventManager */], [platform_browser_es5["d" /* EVENT_MANAGER_PLUGINS */], core_es5["NgZone"]]),
        core_es5["ɵmpd"](135680, platform_browser_es5["n" /* ɵDomSharedStylesHost */], platform_browser_es5["n" /* ɵDomSharedStylesHost */], [common_es5["e" /* DOCUMENT */]]),
        core_es5["ɵmpd"](4608, platform_browser_es5["m" /* ɵDomRendererFactory2 */], platform_browser_es5["m" /* ɵDomRendererFactory2 */], [platform_browser_es5["e" /* EventManager */],
            platform_browser_es5["n" /* ɵDomSharedStylesHost */]]), core_es5["ɵmpd"](5120, browser_es5["a" /* AnimationDriver */], animations_es5["d" /* ɵc */], []),
        core_es5["ɵmpd"](5120, browser_es5["c" /* ɵAnimationStyleNormalizer */], animations_es5["e" /* ɵd */], []), core_es5["ɵmpd"](4608, browser_es5["b" /* ɵAnimationEngine */], animations_es5["c" /* ɵb */], [browser_es5["a" /* AnimationDriver */], browser_es5["c" /* ɵAnimationStyleNormalizer */]]),
        core_es5["ɵmpd"](5120, core_es5["RendererFactory2"], animations_es5["f" /* ɵe */], [platform_browser_es5["m" /* ɵDomRendererFactory2 */], browser_es5["b" /* ɵAnimationEngine */],
            core_es5["NgZone"]]), core_es5["ɵmpd"](6144, platform_browser_es5["q" /* ɵSharedStylesHost */], null, [platform_browser_es5["n" /* ɵDomSharedStylesHost */]]),
        core_es5["ɵmpd"](4608, core_es5["Testability"], core_es5["Testability"], [core_es5["NgZone"]]), core_es5["ɵmpd"](4608, platform_browser_es5["h" /* Meta */], platform_browser_es5["h" /* Meta */], [common_es5["e" /* DOCUMENT */]]), core_es5["ɵmpd"](4608, platform_browser_es5["j" /* Title */], platform_browser_es5["j" /* Title */], [common_es5["e" /* DOCUMENT */]]),
        core_es5["ɵmpd"](4608, _angular_animations_es5["b" /* AnimationBuilder */], animations_es5["b" /* ɵBrowserAnimationBuilder */], [core_es5["RendererFactory2"],
            platform_browser_es5["b" /* DOCUMENT */]]), core_es5["ɵmpd"](4608, forms_es5["A" /* ɵi */], forms_es5["A" /* ɵi */], []), core_es5["ɵmpd"](4608, forms_es5["g" /* FormBuilder */], forms_es5["g" /* FormBuilder */], []), core_es5["ɵmpd"](5120, router_es5["a" /* ActivatedRoute */], router_es5["z" /* ɵf */], [router_es5["m" /* Router */]]), core_es5["ɵmpd"](4608, router_es5["f" /* NoPreloading */], router_es5["f" /* NoPreloading */], []), core_es5["ɵmpd"](6144, router_es5["h" /* PreloadingStrategy */], null, [router_es5["f" /* NoPreloading */]]),
        core_es5["ɵmpd"](135680, router_es5["q" /* RouterPreloader */], router_es5["q" /* RouterPreloader */], [router_es5["m" /* Router */], core_es5["NgModuleFactoryLoader"],
            core_es5["Compiler"], core_es5["Injector"], router_es5["h" /* PreloadingStrategy */]]), core_es5["ɵmpd"](4608, router_es5["g" /* PreloadAllModules */], router_es5["g" /* PreloadAllModules */], []), core_es5["ɵmpd"](5120, router_es5["j" /* ROUTER_INITIALIZER */], router_es5["C" /* ɵi */], [router_es5["A" /* ɵg */]]), core_es5["ɵmpd"](5120, core_es5["APP_BOOTSTRAP_LISTENER"], function (p0_0) {
            return [p0_0];
        }, [router_es5["j" /* ROUTER_INITIALIZER */]]), core_es5["ɵmpd"](4608, version_service["a" /* VersionService */], version_service["a" /* VersionService */], [http_es5["Http"], config_service["a" /* ConfigService */], log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, auth_service["a" /* AuthService */], auth_service["a" /* AuthService */], [http_es5["Http"], common_es5["k" /* Location */], router_es5["m" /* Router */], config_service["a" /* ConfigService */],
            log_service["a" /* LogService */], version_service["a" /* VersionService */]]), core_es5["ɵmpd"](4608, auth_exists_guard_service["a" /* AuthExistsGuard */], auth_exists_guard_service["a" /* AuthExistsGuard */], [router_es5["m" /* Router */], log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, auto_login_service["a" /* AutoLoginService */], auto_login_service["a" /* AutoLoginService */], [http_es5["Http"], auth_service["a" /* AuthService */], config_service["a" /* ConfigService */], log_service["a" /* LogService */]]),
        core_es5["ɵmpd"](4608, myindexeddb_service["a" /* MyIndexedDbService */], myindexeddb_service["a" /* MyIndexedDbService */], [http_es5["Http"], auth_service["a" /* AuthService */],
            config_service["a" /* ConfigService */], log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, cache_storage_service["a" /* CacheStorageService */], cache_storage_service["a" /* CacheStorageService */], [auth_service["a" /* AuthService */], log_service["a" /* LogService */], myindexeddb_service["a" /* MyIndexedDbService */]]),
        core_es5["ɵmpd"](4608, communications_service["a" /* CommunicationsService */], communications_service["a" /* CommunicationsService */], [log_service["a" /* LogService */],
            config_service["a" /* ConfigService */], http_es5["Http"]]), core_es5["ɵmpd"](4608, drag_drop_service["a" /* DragDropService */], drag_drop_service["a" /* DragDropService */], [log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, email_service["a" /* EmailService */], email_service["a" /* EmailService */], [log_service["a" /* LogService */],
            config_service["a" /* ConfigService */], http_es5["Http"]]), core_es5["ɵmpd"](4608, event_service["a" /* EventService */], event_service["a" /* EventService */], [http_es5["Http"], auth_service["a" /* AuthService */], config_service["a" /* ConfigService */], log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, feedback_service["a" /* FeedbackService */], feedback_service["a" /* FeedbackService */], [http_es5["Http"], auth_service["a" /* AuthService */], config_service["a" /* ConfigService */],
            log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, festival_service["a" /* FestivalService */], festival_service["a" /* FestivalService */], [http_es5["Http"], auth_service["a" /* AuthService */], config_service["a" /* ConfigService */], log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, grid_service["a" /* GridService */], grid_service["a" /* GridService */], [http_es5["Http"], auth_service["a" /* AuthService */], cache_storage_service["a" /* CacheStorageService */],
            config_service["a" /* ConfigService */], log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, oauth_service_OauthService, oauth_service_OauthService, [http_es5["Http"], auth_service["a" /* AuthService */], config_service["a" /* ConfigService */], log_service["a" /* LogService */]]),
        core_es5["ɵmpd"](4608, organization_service["a" /* OrganizationService */], organization_service["a" /* OrganizationService */], [http_es5["Http"], auth_service["a" /* AuthService */],
            config_service["a" /* ConfigService */], log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, perf_service["a" /* PerfService */], perf_service["a" /* PerfService */], [log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, reviewer_film_service["a" /* ReviewerFilmService */], reviewer_film_service["a" /* ReviewerFilmService */], [http_es5["Http"], auth_service["a" /* AuthService */], cache_storage_service["a" /* CacheStorageService */], config_service["a" /* ConfigService */],
            log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, reviewer_image_service["a" /* ReviewerImageService */], reviewer_image_service["a" /* ReviewerImageService */], [http_es5["Http"], config_service["a" /* ConfigService */], log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, reviewer_review_service["a" /* ReviewerReviewService */], reviewer_review_service["a" /* ReviewerReviewService */], [http_es5["Http"], auth_service["a" /* AuthService */], config_service["a" /* ConfigService */],
            log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, tab_service["a" /* TabService */], tab_service["a" /* TabService */], [auth_service["a" /* AuthService */],
            log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, user_service["a" /* UserService */], user_service["a" /* UserService */], [http_es5["Http"],
            auth_service["a" /* AuthService */], cache_storage_service["a" /* CacheStorageService */], config_service["a" /* ConfigService */], log_service["a" /* LogService */]]),
        core_es5["ɵmpd"](4608, volunteer_service["a" /* VolunteerService */], volunteer_service["a" /* VolunteerService */], [http_es5["Http"], auth_service["a" /* AuthService */],
            config_service["a" /* ConfigService */], log_service["a" /* LogService */]]), core_es5["ɵmpd"](4608, all_events_resolver["a" /* AllEventsResolver */], all_events_resolver["a" /* AllEventsResolver */], [event_service["a" /* EventService */]]), core_es5["ɵmpd"](4608, all_events_all_organizations_resolver["a" /* AllEventsAllOrganizationsResolver */], all_events_all_organizations_resolver["a" /* AllEventsAllOrganizationsResolver */], [event_service["a" /* EventService */]]), core_es5["ɵmpd"](4608, all_films_resolver["a" /* AllFilmsResolver */], all_films_resolver["a" /* AllFilmsResolver */], [log_service["a" /* LogService */], reviewer_film_service["a" /* ReviewerFilmService */]]),
        core_es5["ɵmpd"](4608, all_grids_resolver["a" /* AllGridsResolver */], all_grids_resolver["a" /* AllGridsResolver */], [grid_service["a" /* GridService */]]),
        core_es5["ɵmpd"](4608, all_organizations_resolver["a" /* AllOrganizationsResolver */], all_organizations_resolver["a" /* AllOrganizationsResolver */], [organization_service["a" /* OrganizationService */]]),
        core_es5["ɵmpd"](4608, all_reviews_resolver["a" /* AllReviewsResolver */], all_reviews_resolver["a" /* AllReviewsResolver */], [reviewer_review_service["a" /* ReviewerReviewService */]]),
        core_es5["ɵmpd"](4608, all_users_resolver["a" /* AllUsersResolver */], all_users_resolver["a" /* AllUsersResolver */], [user_service["a" /* UserService */]]),
        core_es5["ɵmpd"](4608, user_films_resolver["a" /* UserFilmsResolver */], user_films_resolver["a" /* UserFilmsResolver */], [reviewer_film_service["a" /* ReviewerFilmService */]]),
        core_es5["ɵmpd"](4608, user_profile_resolver["a" /* UserProfileResolver */], user_profile_resolver["a" /* UserProfileResolver */], [user_service["a" /* UserService */]]),
        core_es5["ɵmpd"](4608, user_reviews_resolver["a" /* UserReviewsResolver */], user_reviews_resolver["a" /* UserReviewsResolver */], [reviewer_review_service["a" /* ReviewerReviewService */]]),
        core_es5["ɵmpd"](512, esm5_core_es5["c" /* CompatibilityModule */], esm5_core_es5["c" /* CompatibilityModule */], []),
        core_es5["ɵmpd"](512, bidi_es5["a" /* BidiModule */], bidi_es5["a" /* BidiModule */], []), core_es5["ɵmpd"](256, esm5_core_es5["g" /* MATERIAL_SANITY_CHECKS */], true, []), core_es5["ɵmpd"](512, esm5_core_es5["m" /* MatCommonModule */], esm5_core_es5["m" /* MatCommonModule */], [[2, esm5_core_es5["g" /* MATERIAL_SANITY_CHECKS */]]]), core_es5["ɵmpd"](512, platform_es5["b" /* PlatformModule */], platform_es5["b" /* PlatformModule */], []), core_es5["ɵmpd"](512, esm5_core_es5["z" /* MatRippleModule */], esm5_core_es5["z" /* MatRippleModule */], []),
        core_es5["ɵmpd"](512, common_es5["c" /* CommonModule */], common_es5["c" /* CommonModule */], []), core_es5["ɵmpd"](512, esm5_core_es5["x" /* MatPseudoCheckboxModule */], esm5_core_es5["x" /* MatPseudoCheckboxModule */], []),
        core_es5["ɵmpd"](512, esm5_core_es5["t" /* MatOptionModule */], esm5_core_es5["t" /* MatOptionModule */], []), core_es5["ɵmpd"](512, portal_es5["f" /* PortalModule */], portal_es5["f" /* PortalModule */], []), core_es5["ɵmpd"](512, scrolling_es5["b" /* ScrollDispatchModule */], scrolling_es5["b" /* ScrollDispatchModule */], []), core_es5["ɵmpd"](512, overlay_es5["e" /* OverlayModule */], overlay_es5["e" /* OverlayModule */], []), core_es5["ɵmpd"](512, autocomplete_es5["d" /* MatAutocompleteModule */], autocomplete_es5["d" /* MatAutocompleteModule */], []), core_es5["ɵmpd"](512, a11y_es5["a" /* A11yModule */], a11y_es5["a" /* A11yModule */], []), core_es5["ɵmpd"](512, button_es5["d" /* MatButtonModule */], button_es5["d" /* MatButtonModule */], []), core_es5["ɵmpd"](512, button_toggle_es5["a" /* MatButtonToggleModule */], button_toggle_es5["a" /* MatButtonToggleModule */], []), core_es5["ɵmpd"](512, card_es5["e" /* MatCardModule */], card_es5["e" /* MatCardModule */], []),
        core_es5["ɵmpd"](512, observers_es5["c" /* ObserversModule */], observers_es5["c" /* ObserversModule */], []), core_es5["ɵmpd"](512, checkbox_es5["b" /* MatCheckboxModule */], checkbox_es5["b" /* MatCheckboxModule */], []), core_es5["ɵmpd"](512, chips_es5["c" /* MatChipsModule */], chips_es5["c" /* MatChipsModule */], []), core_es5["ɵmpd"](512, table_es5["m" /* CdkTableModule */], table_es5["m" /* CdkTableModule */], []), core_es5["ɵmpd"](512, esm5_table_es5["a" /* MatTableModule */], esm5_table_es5["a" /* MatTableModule */], []), core_es5["ɵmpd"](512, dialog_es5["e" /* MatDialogModule */], dialog_es5["e" /* MatDialogModule */], []),
        core_es5["ɵmpd"](512, icon_es5["c" /* MatIconModule */], icon_es5["c" /* MatIconModule */], []), core_es5["ɵmpd"](512, datepicker_es5["i" /* MatDatepickerModule */], datepicker_es5["i" /* MatDatepickerModule */], []), core_es5["ɵmpd"](512, expansion_es5["a" /* MatExpansionModule */], expansion_es5["a" /* MatExpansionModule */], []), core_es5["ɵmpd"](512, form_field_es5["d" /* MatFormFieldModule */], form_field_es5["d" /* MatFormFieldModule */], []), core_es5["ɵmpd"](512, esm5_core_es5["o" /* MatLineModule */], esm5_core_es5["o" /* MatLineModule */], []), core_es5["ɵmpd"](512, grid_list_es5["b" /* MatGridListModule */], grid_list_es5["b" /* MatGridListModule */], []), core_es5["ɵmpd"](512, input_es5["b" /* MatInputModule */], input_es5["b" /* MatInputModule */], []), core_es5["ɵmpd"](512, list_es5["e" /* MatListModule */], list_es5["e" /* MatListModule */], []), core_es5["ɵmpd"](512, menu_es5["e" /* MatMenuModule */], menu_es5["e" /* MatMenuModule */], []),
        core_es5["ɵmpd"](512, select_es5["d" /* MatSelectModule */], select_es5["d" /* MatSelectModule */], []), core_es5["ɵmpd"](512, tooltip_es5["d" /* MatTooltipModule */], tooltip_es5["d" /* MatTooltipModule */], []), core_es5["ɵmpd"](512, paginator_es5["b" /* MatPaginatorModule */], paginator_es5["b" /* MatPaginatorModule */], []), core_es5["ɵmpd"](512, progress_bar_es5["a" /* MatProgressBarModule */], progress_bar_es5["a" /* MatProgressBarModule */], []), core_es5["ɵmpd"](512, progress_spinner_es5["b" /* MatProgressSpinnerModule */], progress_spinner_es5["b" /* MatProgressSpinnerModule */], []),
        core_es5["ɵmpd"](512, radio_es5["c" /* MatRadioModule */], radio_es5["c" /* MatRadioModule */], []), core_es5["ɵmpd"](512, sidenav_es5["a" /* MatSidenavModule */], sidenav_es5["a" /* MatSidenavModule */], []), core_es5["ɵmpd"](512, slide_toggle_es5["b" /* MatSlideToggleModule */], slide_toggle_es5["b" /* MatSlideToggleModule */], []), core_es5["ɵmpd"](512, slider_es5["b" /* MatSliderModule */], slider_es5["b" /* MatSliderModule */], []), core_es5["ɵmpd"](512, snack_bar_es5["d" /* MatSnackBarModule */], snack_bar_es5["d" /* MatSnackBarModule */], []), core_es5["ɵmpd"](512, sort_es5["b" /* MatSortModule */], sort_es5["b" /* MatSortModule */], []), core_es5["ɵmpd"](512, esm5_stepper_es5["d" /* CdkStepperModule */], esm5_stepper_es5["d" /* CdkStepperModule */], []), core_es5["ɵmpd"](512, stepper_es5["b" /* MatStepperModule */], stepper_es5["b" /* MatStepperModule */], []), core_es5["ɵmpd"](512, tabs_es5["i" /* MatTabsModule */], tabs_es5["i" /* MatTabsModule */], []),
        core_es5["ɵmpd"](512, toolbar_es5["b" /* MatToolbarModule */], toolbar_es5["b" /* MatToolbarModule */], []), core_es5["ɵmpd"](512, esm5_core_es5["B" /* NativeDateModule */], esm5_core_es5["B" /* NativeDateModule */], []), core_es5["ɵmpd"](512, esm5_core_es5["q" /* MatNativeDateModule */], esm5_core_es5["q" /* MatNativeDateModule */], []), core_es5["ɵmpd"](512, all_material_module["a" /* AllMaterialModule */], all_material_module["a" /* AllMaterialModule */], []), core_es5["ɵmpd"](512, http_es5["BrowserXhr"], http_es5["BrowserXhr"], []), core_es5["ɵmpd"](512, http_es5["ResponseOptions"], http_es5["BaseResponseOptions"], []), core_es5["ɵmpd"](1024, http_es5["XSRFStrategy"], http_es5["ɵb"], []), core_es5["ɵmpd"](512, http_es5["XHRBackend"], http_es5["XHRBackend"], [http_es5["BrowserXhr"],
            http_es5["ResponseOptions"], http_es5["XSRFStrategy"]]), core_es5["ɵmpd"](512, http_es5["RequestOptions"], http_es5["BaseRequestOptions"], []), core_es5["ɵmpd"](1024, http_es5["Http"], http_es5["ɵc"], [http_es5["XHRBackend"],
            http_es5["RequestOptions"]]), core_es5["ɵmpd"](512, config_service["a" /* ConfigService */], config_service["a" /* ConfigService */], []), core_es5["ɵmpd"](512, log_service["a" /* LogService */], log_service["a" /* LogService */], [http_es5["Http"], config_service["a" /* ConfigService */]]),
        core_es5["ɵmpd"](512, core_es5["ErrorHandler"], itd_exception_ItdExceptionHandler, [log_service["a" /* LogService */]]), core_es5["ɵmpd"](1024, core_es5["NgProbeToken"], function () {
            return [router_es5["v" /* ɵb */]()];
        }, []), core_es5["ɵmpd"](512, router_es5["A" /* ɵg */], router_es5["A" /* ɵg */], [core_es5["Injector"]]), core_es5["ɵmpd"](1024, core_es5["APP_INITIALIZER"], function (p0_0, p0_1, p1_0) {
            return [platform_browser_es5["r" /* ɵc */](p0_0, p0_1), router_es5["B" /* ɵh */](p1_0)];
        }, [[2, platform_browser_es5["i" /* NgProbeToken */]], [2, core_es5["NgProbeToken"]], router_es5["A" /* ɵg */]]), core_es5["ɵmpd"](512, core_es5["ApplicationInitStatus"], core_es5["ApplicationInitStatus"], [[2, core_es5["APP_INITIALIZER"]]]), core_es5["ɵmpd"](131584, core_es5["ɵe"], core_es5["ɵe"], [core_es5["NgZone"], core_es5["ɵConsole"], core_es5["Injector"], core_es5["ErrorHandler"], core_es5["ComponentFactoryResolver"],
            core_es5["ApplicationInitStatus"]]), core_es5["ɵmpd"](2048, core_es5["ApplicationRef"], null, [core_es5["ɵe"]]), core_es5["ɵmpd"](512, core_es5["ApplicationModule"], core_es5["ApplicationModule"], [core_es5["ApplicationRef"]]),
        core_es5["ɵmpd"](512, platform_browser_es5["a" /* BrowserModule */], platform_browser_es5["a" /* BrowserModule */], [[3, platform_browser_es5["a" /* BrowserModule */]]]),
        core_es5["ɵmpd"](512, animations_es5["a" /* BrowserAnimationsModule */], animations_es5["a" /* BrowserAnimationsModule */], []),
        core_es5["ɵmpd"](512, forms_es5["x" /* ɵba */], forms_es5["x" /* ɵba */], []), core_es5["ɵmpd"](512, forms_es5["k" /* FormsModule */], forms_es5["k" /* FormsModule */], []), core_es5["ɵmpd"](512, forms_es5["u" /* ReactiveFormsModule */], forms_es5["u" /* ReactiveFormsModule */], []), core_es5["ɵmpd"](512, http_es5["HttpModule"], http_es5["HttpModule"], []),
        core_es5["ɵmpd"](1024, router_es5["u" /* ɵa */], router_es5["x" /* ɵd */], [[3, router_es5["m" /* Router */]]]), core_es5["ɵmpd"](512, router_es5["t" /* UrlSerializer */], router_es5["c" /* DefaultUrlSerializer */], []), core_es5["ɵmpd"](512, router_es5["b" /* ChildrenOutletContexts */], router_es5["b" /* ChildrenOutletContexts */], []), core_es5["ɵmpd"](256, router_es5["i" /* ROUTER_CONFIGURATION */], { useHash: true }, []), core_es5["ɵmpd"](1024, common_es5["l" /* LocationStrategy */], router_es5["w" /* ɵc */], [common_es5["w" /* PlatformLocation */], [2, common_es5["a" /* APP_BASE_HREF */]], router_es5["i" /* ROUTER_CONFIGURATION */]]),
        core_es5["ɵmpd"](512, common_es5["k" /* Location */], common_es5["k" /* Location */], [common_es5["l" /* LocationStrategy */]]), core_es5["ɵmpd"](512, core_es5["Compiler"], core_es5["Compiler"], []), core_es5["ɵmpd"](512, core_es5["NgModuleFactoryLoader"], core_es5["SystemJsNgModuleLoader"], [core_es5["Compiler"], [2, core_es5["SystemJsNgModuleLoaderConfig"]]]),
        core_es5["ɵmpd"](1024, router_es5["k" /* ROUTES */], function () {
            return [[{ path: 'common', loadChildren: './modules/common/common.module#CommonModuleItd' },
                    { path: 'dashboard', loadChildren: './modules/dashboard/dashboard.module#DashboardModule' },
                    { path: 'donation', loadChildren: './modules/donation/donation.module#DonationModule' },
                    { path: 'festival', loadChildren: './modules/festival/festival.module#FestivalModule' },
                    { path: 'organization', loadChildren: './modules/organization/organization.module#OrganizationModule' },
                    { path: 'program', loadChildren: './modules/program/program.module#ProgramModule' },
                    { path: 'reviewer', loadChildren: './modules/reviewer/reviewer.module#ReviewerModule' },
                    { path: 'site', loadChildren: './modules/site/site.module#SiteModule' },
                    { path: 'system', loadChildren: './modules/system/system.module#SystemModule' },
                    { path: 'volunteer', loadChildren: './modules/volunteer/volunteer.module#VolunteerModule' },
                    { path: 'oauth/callback', component: oauth_callback_component_OauthCallbackComponent }, { path: 'oauth',
                        component: oauth_component_OauthComponent }, { path: 'nonce/:userId/:token', component: nonce_component_NonceComponent },
                    { path: '', component: landing_component_LandingComponent }, { path: '**', component: redirect_component_RedirectComponent }]];
        }, []), core_es5["ɵmpd"](1024, router_es5["m" /* Router */], router_es5["y" /* ɵe */], [core_es5["ApplicationRef"], router_es5["t" /* UrlSerializer */],
            router_es5["b" /* ChildrenOutletContexts */], common_es5["k" /* Location */], core_es5["Injector"], core_es5["NgModuleFactoryLoader"],
            core_es5["Compiler"], router_es5["k" /* ROUTES */], router_es5["i" /* ROUTER_CONFIGURATION */], [2, router_es5["s" /* UrlHandlingStrategy */]],
            [2, router_es5["l" /* RouteReuseStrategy */]]]), core_es5["ɵmpd"](512, router_es5["o" /* RouterModule */], router_es5["o" /* RouterModule */], [[2, router_es5["u" /* ɵa */]], [2, router_es5["m" /* Router */]]]), core_es5["ɵmpd"](512, shared_module["a" /* SharedModule */], shared_module["a" /* SharedModule */], []), core_es5["ɵmpd"](512, AppModule, AppModule, []),
        core_es5["ɵmpd"](256, menu_es5["a" /* MAT_MENU_DEFAULT_OPTIONS */], { overlapTrigger: true, xPosition: 'after',
            yPosition: 'below' }, []), core_es5["ɵmpd"](256, esm5_core_es5["h" /* MAT_DATE_FORMATS */], esm5_core_es5["j" /* MAT_NATIVE_DATE_FORMATS */], [])]);
});
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3BhdC9zb3VyY2UvaXRkZXZpY2VzL2dpdGxhYi9vY2VhbmJsdWZmcHJvZHVjdGlvbnMvb2NlYW5ibHVmZnByb2R1Y3Rpb25zLXVpL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9wYXQvc291cmNlL2l0ZGV2aWNlcy9naXRsYWIvb2NlYW5ibHVmZnByb2R1Y3Rpb25zL29jZWFuYmx1ZmZwcm9kdWN0aW9ucy11aS9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9
//# sourceMappingURL=app.module.ngfactory.js.map
// CONCATENATED MODULE: /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/main.ts




if (environment.production) {
    Object(core_es5["enableProdMode"])();
}
Object(platform_browser_es5["k" /* platformBrowser */])().bootstrapModuleFactory(AppModuleNgFactory);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ "egrd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigateComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_log_service__ = __webpack_require__("B1/m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_tab_service__ = __webpack_require__("+eyU");


var NavigateComponent = (function () {
    function NavigateComponent(log, tabService) {
        this.log = log;
        this.tabService = tabService;
        this.tabs = {};
    }
    NavigateComponent.prototype.ngOnInit = function () {
        // TODO!!! - put this back after profile settings, with volunteer application off by default
        // this.tabs = this.tabService.navTabs;
        console.log('NavigateComponent, ngOnInit');
        console.log('this.tabs');
        console.log(this.tabs);
        var tabsWithoutVolunteer = JSON.parse(JSON.stringify(this.tabService.navTabs));
        if (!tabsWithoutVolunteer ||
            !tabsWithoutVolunteer.firstTabs ||
            tabsWithoutVolunteer.firstTabs.length === 0) {
            this.log.error('NavigateComponent, invalid tabs from tabService');
            return;
        }
        // find index of VOLUNTEER module
        var index = tabsWithoutVolunteer.firstTabs.findIndex(function (firstTab) {
            // return (firstTab.name === 'VOLUNTEER');
            if (firstTab.name === 'VOLUNTEER') {
                if (firstTab.secondTab &&
                    firstTab.secondTab.tabs &&
                    firstTab.secondTab.tabs.length === 1 &&
                    firstTab.secondTab.tabs[0].name === 'VOLUNTEER APPLICATION') {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        });
        // then remove it
        if (index !== -1) {
            tabsWithoutVolunteer.firstTabs.splice(index, 1);
        }
        this.tabs = tabsWithoutVolunteer;
    };
    NavigateComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__services_log_service__["a" /* LogService */] }, { type: __WEBPACK_IMPORTED_MODULE_1__services_tab_service__["a" /* TabService */] }]; };
    return NavigateComponent;
}());

//# sourceMappingURL=navigate.component.js.map

/***/ }),

/***/ "emCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cache_storage_service__ = __webpack_require__("a36o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__log_service__ = __webpack_require__("B1/m");





var UserService = (function () {
    function UserService(http, authService, cacheStorage, config, log) {
        this.http = http;
        this.authService = authService;
        this.cacheStorage = cacheStorage;
        this.config = config;
        this.log = log;
        this.allUsers = {};
        this.allUsersWithArray = {};
        this.session = {}; // follows same schema as settings: module.tab.[detail].data
    }
    // settings: any = null;		// note used any more
    UserService.prototype.getUsers = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/users', options)
                .toPromise()
                .then(function (res) {
                resolve(res.json());
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    UserService.prototype.getUserProfile = function () {
        var _this = this;
        // console.log('------------>>>>   about to call getUserProfile');
        // try {
        // 	throw new Error('tell me location!');
        // } catch (err) {
        // 	console.log(err);
        // }
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var userId = _this.authService.userId;
            _this.http.get(_this.config.basePath + '/v0/users/' + userId + '/profile', options)
                .toPromise()
                .then(function (res) {
                var userProfile = res.json();
                // if (userProfile && userProfile.profile && userProfile.profile.settings) {				// note used any more
                // 	this.settings = userProfile.profile.settings;
                // }
                resolve(userProfile);
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    UserService.prototype.createUserzzz = function (payload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/users', body, options)
                .toPromise()
                .then(function (res) {
                // console.log('res');
                // console.log(res);
                resolve();
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    UserService.prototype.sendActivationEmail = function (emailTo, emailSubject, emailTextBody, emailHtmlBody) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Content-Type': 'application/json' });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                emailTo: emailTo,
                emailSubject: emailSubject,
                emailTextBody: emailTextBody,
                emailHtmlBody: emailHtmlBody
            };
            var body = JSON.stringify(payload);
            var userId = _this.authService.userId;
            _this.http.post(_this.config.basePath + '/v0/users/activation/email', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                resolve(result);
            })
                .catch(function (err) {
                _this.log.error(err);
                reject(err);
            });
        });
    };
    UserService.prototype.sendActivationTextMessage = function (countryCode, phoneNumber) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Content-Type': 'application/json' });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var payload = {
                countryCode: countryCode,
                phoneNumber: phoneNumber
            };
            var body = JSON.stringify(payload);
            var userId = _this.authService.userId;
            _this.http.post(_this.config.basePath + '/v0/users/activation/textmessage', body, options)
                .toPromise()
                .then(function (res) {
                var result = res.json();
                resolve(result);
            })
                .catch(function (err) {
                _this.log.error(err);
                reject(err);
            });
        });
    };
    UserService.prototype.updateUser = function (userId, payload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var body = JSON.stringify(payload);
            _this.http.put(_this.config.basePath + '/v0/users/' + userId, body, options)
                .toPromise()
                .then(function (res) {
                resolve();
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    UserService.prototype.deleteUser = function (userId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.delete(_this.config.basePath + '/v0/users/' + userId, options)
                .toPromise()
                .then(function (res) {
                resolve();
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    UserService.prototype.updateUserSettings = function (userId, settings) {
        var _this = this;
        var payload = {
            userId: userId,
            settings: settings
        };
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var body = JSON.stringify(payload);
            _this.http.put(_this.config.basePath + '/v0/users/' + userId, body, options)
                .toPromise()
                .then(function (res) {
                // console.log('res');
                // console.log(res);
                resolve();
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    UserService.prototype.createUser = function (payload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/users', body, options)
                .toPromise()
                .then(function (res) {
                // console.log('res');
                // console.log(res);
                resolve();
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    // //				console.log('<------ createUser -------->');
    // 		// console.log('payload');
    // 		// console.log(payload);
    // 		// call api to save
    // 		var auth = AuthService.getAuth();
    // 		if (!auth) {
    // //					return resolve(null);
    // 			return;
    // 		}
    // 		if (!auth.userId) {
    // //					return resolve(null);
    // 			return;
    // 		}
    // 		var userId = auth.userId;
    // 		var fullUrl = apiHost + '/v0/users';
    // 		ApiQueueService.addQueue('post', fullUrl, payload);
    // 		ApiQueueService.flushQueue();
    // 	},
    UserService.prototype.getRecentUsersIndexedDb = function () {
        var _this = this;
        console.log('getRecentUsersIndexedDb start');
        return new Promise(function (resolve, reject) {
            var start = Date.now();
            // init first time through, if can
            if (!_this.allUsers.users) {
                console.log('** first time through getRecentUsersIndexedDb **');
                _this.cacheStorage.readIndexedDb(_this.cacheStorage.keys.allUsers)
                    .then(function (tempAllUsers) {
                    if (tempAllUsers && tempAllUsers.users) {
                        _this.allUsers = tempAllUsers;
                        _this.allUsersWithArray = {};
                        _this.allUsersWithArray.allUsers = {};
                        _this.allUsersWithArray.allUsers.modfied = _this.allUsers.modified;
                        _this.allUsersWithArray.allUsers.users = [];
                        Object.keys(_this.allUsers.users).forEach(function (userId) {
                            var user = _this.allUsers.users[userId];
                            _this.allUsersWithArray.allUsers.users.push(user);
                        });
                    }
                    var modified = 0;
                    if (_this.allUsers.modified) {
                        modified = _this.allUsers.modified;
                    }
                    // console.log('getRecentUsers modified');
                    // console.log(modified);
                    var accessToken = localStorage.getItem('auth-jwt');
                    var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
                    var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
                    _this.http.get(_this.config.basePath + '/v0/users/date/' + modified, options)
                        .toPromise()
                        .then(function (res) {
                        var foo = res.json();
                        // console.log('foo.allUsers.users.length');
                        // console.log(foo.allUsers.users.length);
                        if (_this.allUsers.users) {
                            console.log('----  test if should update, count = ' + foo.allUsers.users.length);
                            if (foo.allUsers.users.length > 0) {
                                console.log('----  updating, count = ' + foo.allUsers.users.length);
                                foo.allUsers.users.forEach(function (user) {
                                    _this.allUsers.users[user.userId] = user;
                                });
                                _this.allUsers.modified = foo.allUsers.modified;
                                _this.cacheStorage.writeIndexedDb(_this.cacheStorage.keys.allUsers, _this.allUsers)
                                    .then(function () {
                                    _this.allUsersWithArray = {};
                                    _this.allUsersWithArray.allUsers = {};
                                    _this.allUsersWithArray.allUsers.modfied = _this.allUsers.modified;
                                    _this.allUsersWithArray.allUsers.users = [];
                                    Object.keys(_this.allUsers.users).forEach(function (userId) {
                                        var user = _this.allUsers.users[userId];
                                        _this.allUsersWithArray.allUsers.users.push(user);
                                    });
                                    _this.sortTheUsers();
                                    resolve(_this.allUsersWithArray);
                                })
                                    .catch(function (err) {
                                    // TODO - handle errors?
                                    _this.log.error(err);
                                    resolve();
                                });
                            }
                            else {
                                _this.sortTheUsers();
                                resolve(_this.allUsersWithArray);
                            }
                        }
                        else {
                            console.log('----  first time through, count = ' + foo.allUsers.users.length);
                            // convert to object form
                            var objectAllUsers_1 = {};
                            objectAllUsers_1.modified = foo.allUsers.modified;
                            objectAllUsers_1.users = {};
                            foo.allUsers.users.forEach(function (user) {
                                objectAllUsers_1.users[user.userId] = user;
                            });
                            _this.allUsers = objectAllUsers_1;
                            _this.cacheStorage.writeIndexedDb(_this.cacheStorage.keys.allUsers, _this.allUsers)
                                .then(function () {
                                _this.allUsersWithArray = {};
                                _this.allUsersWithArray.allUsers = {};
                                _this.allUsersWithArray.allUsers.modfied = _this.allUsers.modified;
                                _this.allUsersWithArray.allUsers.users = [];
                                Object.keys(_this.allUsers.users).forEach(function (userId) {
                                    var user = _this.allUsers.users[userId];
                                    _this.allUsersWithArray.allUsers.users.push(user);
                                });
                                _this.sortTheUsers();
                                resolve(_this.allUsersWithArray);
                            })
                                .catch(function (err) {
                                // TODO - handle errors?
                                _this.log.error(err);
                                _this.allUsersWithArray = {};
                                _this.allUsersWithArray.allUsers = {};
                                _this.allUsersWithArray.allUsers.modfied = _this.allUsers.modified;
                                _this.allUsersWithArray.allUsers.users = [];
                                Object.keys(_this.allUsers.users).forEach(function (userId) {
                                    var user = _this.allUsers.users[userId];
                                    _this.allUsersWithArray.allUsers.users.push(user);
                                });
                                _this.sortTheUsers();
                                resolve(_this.allUsersWithArray);
                            });
                        }
                    })
                        .catch(function (err) {
                        // TODO - handle errors?
                        _this.log.error(err);
                        // !!! TODO - check that all promise functions resolve or reject
                        resolve();
                    });
                })
                    .catch(function (errz) {
                    // TODO - handle errors?
                    // !!! TODO - should error, but continue
                    _this.log.error(errz);
                    var modified = 0;
                    if (_this.allUsers.modified) {
                        modified = _this.allUsers.modified;
                    }
                    // console.log('getRecentUsers modified');
                    // console.log(modified);
                    var accessToken = localStorage.getItem('auth-jwt');
                    var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
                    var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
                    _this.http.get(_this.config.basePath + '/v0/users/date/' + modified, options)
                        .toPromise()
                        .then(function (res) {
                        var foo = res.json();
                        // console.log('foo.allUsers.users.length');
                        // console.log(foo.allUsers.users.length);
                        if (_this.allUsers.users) {
                            console.log('----  test if should update, count = ' + foo.allUsers.users.length);
                            if (foo.allUsers.users.length > 0) {
                                console.log('----  updating, count = ' + foo.allUsers.users.length);
                                foo.allUsers.users.forEach(function (user) {
                                    _this.allUsers.users[user.userId] = user;
                                });
                                _this.allUsers.modified = foo.allUsers.modified;
                                _this.cacheStorage.writeIndexedDb(_this.cacheStorage.keys.allUsers, _this.allUsers)
                                    .then(function () {
                                    _this.allUsersWithArray = {};
                                    _this.allUsersWithArray.allUsers = {};
                                    _this.allUsersWithArray.allUsers.modfied = _this.allUsers.modified;
                                    _this.allUsersWithArray.allUsers.users = [];
                                    Object.keys(_this.allUsers.users).forEach(function (userId) {
                                        var user = _this.allUsers.users[userId];
                                        _this.allUsersWithArray.allUsers.users.push(user);
                                    });
                                    _this.sortTheUsers();
                                    resolve(_this.allUsersWithArray);
                                })
                                    .catch(function (err) {
                                    // TODO - handle errors?
                                    _this.log.error(err);
                                    resolve();
                                });
                            }
                            else {
                                _this.sortTheUsers();
                                resolve(_this.allUsersWithArray);
                            }
                        }
                        else {
                            console.log('----  first time through, count = ' + foo.allUsers.users.length);
                            // convert to object form
                            var objectAllUsers_2 = {};
                            objectAllUsers_2.modified = foo.allUsers.modified;
                            objectAllUsers_2.users = {};
                            foo.allUsers.users.forEach(function (user) {
                                objectAllUsers_2.users[user.userId] = user;
                            });
                            _this.allUsers = objectAllUsers_2;
                            _this.cacheStorage.writeIndexedDb(_this.cacheStorage.keys.allUsers, _this.allUsers)
                                .then(function () {
                                _this.allUsersWithArray = {};
                                _this.allUsersWithArray.allUsers = {};
                                _this.allUsersWithArray.allUsers.modfied = _this.allUsers.modified;
                                _this.allUsersWithArray.allUsers.users = [];
                                Object.keys(_this.allUsers.users).forEach(function (userId) {
                                    var user = _this.allUsers.users[userId];
                                    _this.allUsersWithArray.allUsers.users.push(user);
                                });
                                _this.sortTheUsers();
                                resolve(_this.allUsersWithArray);
                            })
                                .catch(function (err) {
                                // TODO - handle errors?
                                _this.log.error(err);
                                _this.allUsersWithArray = {};
                                _this.allUsersWithArray.allUsers = {};
                                _this.allUsersWithArray.allUsers.modfied = _this.allUsers.modified;
                                _this.allUsersWithArray.allUsers.users = [];
                                Object.keys(_this.allUsers.users).forEach(function (userId) {
                                    var user = _this.allUsers.users[userId];
                                    _this.allUsersWithArray.allUsers.users.push(user);
                                });
                                _this.sortTheUsers();
                                resolve(_this.allUsersWithArray);
                            });
                        }
                    })
                        .catch(function (err) {
                        // TODO - handle errors?
                        _this.log.error(err);
                        // !!! TODO - check that all promise functions resolve or reject
                        resolve();
                    });
                });
            }
            else {
                console.log('** already been through getRecentUsers **');
                var modified = 0;
                if (_this.allUsers.modified) {
                    modified = _this.allUsers.modified;
                }
                // console.log('getRecentUsers modified');
                // console.log(modified);
                var accessToken = localStorage.getItem('auth-jwt');
                var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
                var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
                _this.http.get(_this.config.basePath + '/v0/users/date/' + modified, options)
                    .toPromise()
                    .then(function (res) {
                    var foo = res.json();
                    // console.log('foo');
                    // console.log(foo);
                    // console.log('foo.allUsers');
                    // console.log(foo.allUsers);
                    // console.log('foo.allUsers.users.length');
                    // console.log(foo.allUsers.users.length);
                    if (_this.allUsers.users) {
                        console.log('----  test if should update, count = ' + foo.allUsers.users.length);
                        if (foo.allUsers.users.length > 0) {
                            console.log('----  updating, count = ' + foo.allUsers.users.length);
                            foo.allUsers.users.forEach(function (user) {
                                _this.allUsers.users[user.userId] = user;
                            });
                            _this.allUsers.modified = foo.allUsers.modified;
                            _this.cacheStorage.writeIndexedDb(_this.cacheStorage.keys.allUsers, _this.allUsers)
                                .then(function () {
                                _this.allUsersWithArray = {};
                                _this.allUsersWithArray.allUsers = {};
                                _this.allUsersWithArray.allUsers.modfied = _this.allUsers.modified;
                                _this.allUsersWithArray.allUsers.users = [];
                                Object.keys(_this.allUsers.users).forEach(function (userId) {
                                    var user = _this.allUsers.users[userId];
                                    _this.allUsersWithArray.allUsers.users.push(user);
                                });
                                _this.sortTheUsers();
                                resolve(_this.allUsersWithArray);
                            })
                                .catch(function (err) {
                                // TODO - handle errors?
                                _this.log.error(err);
                                resolve();
                            });
                        }
                        else {
                            _this.sortTheUsers();
                            resolve(_this.allUsersWithArray);
                        }
                    }
                    else {
                        console.log('----  first time through, count = ' + foo.allUsers.users.length);
                        // convert to object form
                        var objectallUsers_1 = {};
                        objectallUsers_1.modified = foo.allUsers.modified;
                        objectallUsers_1.users = {};
                        foo.allUsers.users.forEach(function (user) {
                            objectallUsers_1.users[user.userId] = user;
                        });
                        _this.allUsers = objectallUsers_1;
                        _this.cacheStorage.writeIndexedDb(_this.cacheStorage.keys.allUsers, _this.allUsers)
                            .then(function () {
                            _this.allUsersWithArray = {};
                            _this.allUsersWithArray.allUsers = {};
                            _this.allUsersWithArray.allUsers.modfied = _this.allUsers.modified;
                            _this.allUsersWithArray.allUsers.users = [];
                            Object.keys(_this.allUsers.users).forEach(function (userId) {
                                var user = _this.allUsers.users[userId];
                                _this.allUsersWithArray.allUsers.users.push(user);
                            });
                            _this.sortTheUsers();
                            resolve(_this.allUsersWithArray);
                        })
                            .catch(function (err) {
                            // TODO - handle errors?
                            _this.log.error(err);
                            _this.allUsersWithArray = {};
                            _this.allUsersWithArray.allUsers = {};
                            _this.allUsersWithArray.allUsers.modfied = _this.allUsers.modified;
                            _this.allUsersWithArray.allUsers.users = [];
                            Object.keys(_this.allUsers.users).forEach(function (userId) {
                                var user = _this.allUsers.users[userId];
                                _this.allUsersWithArray.allUsers.users.push(user);
                            });
                            _this.sortTheUsers();
                            resolve(_this.allUsersWithArray);
                        });
                    }
                })
                    .catch(function (err) {
                    // TODO - handle errors?
                    _this.log.error(err);
                    // !!! TODO - check that all promise functions resolve or reject
                    resolve();
                });
            }
        });
    };
    UserService.prototype.sortTheUsers = function () {
        var sortedUsers = this.allUsersWithArray.allUsers.users.sort(function (a, b) {
            if (a.lastName.toLowerCase() === b.lastName.toLowerCase()) {
                return 0;
            }
            if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
                return -1;
            }
            return 1;
        });
        this.allUsersWithArray.allUsers.users = sortedUsers;
    };
    UserService.prototype.uploadImage = function (fileList, userId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Accept', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var file = fileList[0];
            var formData = new FormData();
            formData.append('imagefile', file, file.name);
            _this.http.post(_this.config.basePath + '/v0/users/' + userId + '/image', formData, options)
                .toPromise()
                .then(function (res) {
                console.log('uploadImage success');
                var foo = res.json();
                resolve(foo);
            })
                .catch(function (err) {
                // TODO - handle errors?
                _this.log.error(err);
                reject();
            });
        });
    };
    UserService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__cache_storage_service__["a" /* CacheStorageService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_4__log_service__["a" /* LogService */] }]; };
    return UserService;
}());

//# sourceMappingURL=user.service.js.map

/***/ }),

/***/ "gFIY":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./modules/common/common.module.ngfactory": [
		"tQFe",
		0,
		10
	],
	"./modules/dashboard/dashboard.module.ngfactory": [
		"4aXi",
		0,
		9
	],
	"./modules/donation/donation.module.ngfactory": [
		"N78F",
		0,
		8
	],
	"./modules/festival/festival.module.ngfactory": [
		"K9vH",
		0,
		7
	],
	"./modules/organization/organization.module.ngfactory": [
		"ZiA4",
		0,
		6
	],
	"./modules/program/program.module.ngfactory": [
		"VTfE",
		0,
		2
	],
	"./modules/reviewer/reviewer.module.ngfactory": [
		"6ImK",
		0,
		5
	],
	"./modules/site/site.module.ngfactory": [
		"giB+",
		1
	],
	"./modules/system/system.module.ngfactory": [
		"RENl",
		0,
		4
	],
	"./modules/volunteer/volunteer.module.ngfactory": [
		"ZwL8",
		0,
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "gFIY";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "j3Eu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragDropService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__log_service__ = __webpack_require__("B1/m");

var DragDropService = (function () {
    function DragDropService(log) {
        this.log = log;
        this.isDragging = false;
        this.isCopying = false;
        this.draggingElement = null;
        this.data = {};
    }
    // http://stackoverflow.com/a/37400131
    // @HostListener('document:mouseup', ['$event'])
    // onDragEnd(event: any) {
    // 	console.log('DragDropService mouseup');
    // 	this.endDrag();
    // }
    DragDropService.prototype.endDrag = function () {
        console.log('DragDropService endDrag');
        window.document.body.classList.remove('dragging');
        window.document.body.classList.remove('dragging-copy');
        window.document.body.classList.remove('dragging-move');
        if (this.draggingElement) {
            this.draggingElement.classList.remove('drag-source');
        }
        this.isDragging = false;
        this.draggingElement = null;
    };
    DragDropService.prototype.escapeKeyPressed = function () {
        if (this.isDragging) {
            console.log('cancelling drag!!');
            this.endDrag();
        }
    };
    DragDropService.prototype.copyKeyPressed = function () {
        if (this.isDragging) {
            console.log('switch to copy!!');
            this.isCopying = true;
            window.document.body.classList.remove('dragging-move');
            window.document.body.classList.add('dragging-copy');
        }
    };
    DragDropService.prototype.copyKeyReleased = function () {
        if (this.isDragging) {
            console.log('switch to move!!');
            this.isCopying = false;
            window.document.body.classList.remove('dragging-copy');
            window.document.body.classList.add('dragging-move');
        }
    };
    DragDropService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__log_service__["a" /* LogService */] }]; };
    return DragDropService;
}());

//# sourceMappingURL=drag-drop.service.js.map

/***/ }),

/***/ "msq6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrganizationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log_service__ = __webpack_require__("B1/m");




var OrganizationService = (function () {
    function OrganizationService(http, authService, config, log) {
        this.http = http;
        this.authService = authService;
        this.config = config;
        this.log = log;
    }
    OrganizationService.prototype.getOrganizations = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            _this.http.get(_this.config.basePath + '/v0/organizations', options)
                .toPromise()
                .then(function (res) {
                resolve(res.json());
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    OrganizationService.prototype.getOrganization = function (organizationId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var userId = _this.authService.userId;
            _this.http.get(_this.config.basePath + '/v0/organizations/' + organizationId, options)
                .toPromise()
                .then(function (res) {
                resolve(res.json());
            })
                .catch(function (err) {
                _this.log.error(err);
                // !!! TODO - make sure should reject, then fix everywhere!!!
                reject(err);
            });
        });
    };
    OrganizationService.prototype.updateOrganization = function (organizationId, payload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var body = JSON.stringify(payload);
            _this.http.put(_this.config.basePath + '/v0/organizations/' + organizationId, body, options)
                .toPromise()
                .then(function (res) {
                // console.log('res');
                // console.log(res);
                resolve();
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    OrganizationService.prototype.createOrganization = function (payload) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/organizations', body, options)
                .toPromise()
                .then(function (res) {
                // console.log('res');
                // console.log(res);
                resolve();
            })
                .catch(function (err) {
                _this.log.error(err);
            });
        });
    };
    OrganizationService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__log_service__["a" /* LogService */] }]; };
    return OrganizationService;
}());

//# sourceMappingURL=organization.service.js.map

/***/ }),

/***/ "poUV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VolunteerService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_http__ = __webpack_require__("CPp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_service__ = __webpack_require__("aZFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_service__ = __webpack_require__("CNKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log_service__ = __webpack_require__("B1/m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid__ = __webpack_require__("aMZo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid__);





var VolunteerService = (function () {
    function VolunteerService(http, authService, config, log) {
        this.http = http;
        this.authService = authService;
        this.config = config;
        this.log = log;
    }
    VolunteerService.prototype.sendApplication = function (application) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var accessToken = localStorage.getItem('auth-jwt');
            var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["Headers"]({ 'Authorization': 'Bearer ' + accessToken });
            headers.append('Content-Type', 'application/json');
            var options = new __WEBPACK_IMPORTED_MODULE_0__angular_http__["RequestOptions"]({ headers: headers });
            var userId = _this.authService.userId;
            var payload = {
                applicationId: __WEBPACK_IMPORTED_MODULE_4_uuid__["v4"]().replace(/-/g, ''),
                application: application
            };
            var body = JSON.stringify(payload);
            _this.http.post(_this.config.basePath + '/v0/volunteers/application', body, options)
                .toPromise()
                .then(function (res) {
                // let foo = res.json();
                // console.log(foo);
                // let bar: any = foo;
                resolve();
            })
                .catch(function (err) {
                _this.log.error(err);
                reject();
            });
        });
    };
    VolunteerService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_http__["Http"] }, { type: __WEBPACK_IMPORTED_MODULE_1__auth_service__["a" /* AuthService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__config_service__["a" /* ConfigService */] }, { type: __WEBPACK_IMPORTED_MODULE_3__log_service__["a" /* LogService */] }]; };
    return VolunteerService;
}());

//# sourceMappingURL=volunteer.service.js.map

/***/ }),

/***/ "rEIi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AllReviewsResolver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("AP4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reviewer_review_service__ = __webpack_require__("A9Hf");


var AllReviewsResolver = (function () {
    function AllReviewsResolver(reviewerReviewService) {
        this.reviewerReviewService = reviewerReviewService;
        this.params = {};
    }
    AllReviewsResolver.prototype.resolve = function (route, state) {
        var _this = this;
        console.log('AllReviewsResolver called    #1');
        this.params = JSON.parse(JSON.stringify(route.params));
        var thePromise = new Promise(function (resolve, reject) {
            _this.reviewerReviewService.getAllReviews()
                .then(function (reviews) {
                console.log('AllReviewsResolver called    #2');
                var allReviewsInfo = {
                    allReviews: reviews,
                    params: _this.params
                };
                resolve(allReviewsInfo);
            })
                .catch(function (err) {
                return reject(err);
            });
        });
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(thePromise);
    };
    AllReviewsResolver.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__reviewer_review_service__["a" /* ReviewerReviewService */] }]; };
    return AllReviewsResolver;
}());

//# sourceMappingURL=all-reviews.resolver.js.map

/***/ }),

/***/ "t3bT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserReviewsResolver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("AP4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reviewer_review_service__ = __webpack_require__("A9Hf");


var UserReviewsResolver = (function () {
    function UserReviewsResolver(reviewerReviewService) {
        this.reviewerReviewService = reviewerReviewService;
        this.params = {};
    }
    UserReviewsResolver.prototype.resolve = function (route, state) {
        var _this = this;
        console.log('UserReviewsResolver called    #1');
        this.params = JSON.parse(JSON.stringify(route.params));
        var thePromise = new Promise(function (resolve, reject) {
            _this.reviewerReviewService.getUserReviews()
                .then(function (reviews) {
                console.log('UserReviewsResolver called    #2');
                var userReviewsInfo = {
                    reviews: reviews,
                    params: _this.params
                };
                resolve(userReviewsInfo);
            })
                .catch(function (err) {
                return reject(err);
            });
        });
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(thePromise);
    };
    UserReviewsResolver.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__reviewer_review_service__["a" /* ReviewerReviewService */] }]; };
    return UserReviewsResolver;
}());

//# sourceMappingURL=user-reviews.resolver.js.map

/***/ }),

/***/ "t7So":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AllFilmsResolver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("AP4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__log_service__ = __webpack_require__("B1/m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reviewer_film_service__ = __webpack_require__("N1s2");



var AllFilmsResolver = (function () {
    function AllFilmsResolver(log, reviewerFilmService) {
        this.log = log;
        this.reviewerFilmService = reviewerFilmService;
        this.params = {};
    }
    AllFilmsResolver.prototype.resolve = function (route, state) {
        // console.log('AllFilmsResolver called    #1');
        // let startResolve = Date.now();
        var _this = this;
        this.loadingFilmTimerId = setTimeout(function () {
            _this.log.showLoadingFilms = true;
        }, 1000);
        this.params = JSON.parse(JSON.stringify(route.params));
        var thePromise = new Promise(function (resolve, reject) {
            // this.reviewerFilmService.getFilms()
            // this.reviewerFilmService.getRecentFilms()
            _this.reviewerFilmService.getRecentFilmsIndexedDb()
                .then(function (films) {
                // let endResolve = Date.now();
                // console.log('AllFilmsResolver called    #2, took ' + (endResolve - startResolve) + ' msec' );
                var allFilmsInfo = {
                    allFilms: films.allFilms.films,
                    params: _this.params
                };
                clearTimeout(_this.loadingFilmTimerId);
                _this.log.showLoadingFilms = false;
                return resolve(allFilmsInfo);
            })
                .catch(function (err) {
                clearTimeout(_this.loadingFilmTimerId);
                _this.log.showLoadingFilms = false;
                return reject(err);
            });
        });
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(thePromise);
    };
    AllFilmsResolver.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__log_service__["a" /* LogService */] }, { type: __WEBPACK_IMPORTED_MODULE_2__reviewer_film_service__["a" /* ReviewerFilmService */] }]; };
    return AllFilmsResolver;
}());

//# sourceMappingURL=all-films.resolver.js.map

/***/ }),

/***/ "wFAi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SharedModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Rx__ = __webpack_require__("U6yM");

// classes
// import {Film} from './classes/film';
// import {User} from './classes/user';
// import {ItdExceptionHandler} from './classes/itd-exception';
var SharedModule = (function () {
    function SharedModule() {
    }
    return SharedModule;
}());

//# sourceMappingURL=shared.module.js.map

/***/ }),

/***/ "wi/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AllEventsAllOrganizationsResolver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("AP4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_service__ = __webpack_require__("DDzU");


var AllEventsAllOrganizationsResolver = (function () {
    function AllEventsAllOrganizationsResolver(eventService) {
        this.eventService = eventService;
        this.params = {};
    }
    AllEventsAllOrganizationsResolver.prototype.resolve = function (route, state) {
        // console.log('AllFilmsResolver called    #1');
        // let startResolve = Date.now();
        var _this = this;
        this.params = JSON.parse(JSON.stringify(route.params));
        var thePromise = new Promise(function (resolve, reject) {
            // this.reviewerFilmService.getFilms()
            _this.eventService.getEventsAllOrganizations()
                .then(function (allEventsAllOrganizations) {
                // let endResolve = Date.now();
                // console.log('AllFilmsResolver called    #2, took ' + (endResolve - startResolve) + ' msec' );
                var allEventsAllOrganizationsInfo = {
                    allEventsAllOrganizations: allEventsAllOrganizations.allEventsAllOrganizations.events,
                    params: _this.params
                };
                resolve(allEventsAllOrganizationsInfo);
            })
                .catch(function (err) {
                return reject(err);
            });
        });
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(thePromise);
    };
    AllEventsAllOrganizationsResolver.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__event_service__["a" /* EventService */] }]; };
    return AllEventsAllOrganizationsResolver;
}());

//# sourceMappingURL=all-events-all-organizations.resolver.js.map

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.17bf409057ef24447149.bundle.js